webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(122);
var hide = __webpack_require__(38);
var redefine = __webpack_require__(62);
var ctx = __webpack_require__(48);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  if (typeof input !== 'string') {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(678);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(209)('wks');
var uid = __webpack_require__(71);
var Symbol = __webpack_require__(14).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(440)

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(304);
var toPrimitive = __webpack_require__(123);
var dP = Object.defineProperty;

exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(73);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lang = __webpack_require__(141);

Object.defineProperty(exports, 'lang', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lang).default;
  }
});

var _genders = __webpack_require__(806);

Object.defineProperty(exports, 'genders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_genders).default;
  }
});
Object.defineProperty(exports, 'ALL_GENDERS_VALUE', {
  enumerable: true,
  get: function get() {
    return _genders.ALL_GENDERS_VALUE;
  }
});
Object.defineProperty(exports, 'ALL_GENDERS_LIST', {
  enumerable: true,
  get: function get() {
    return _genders.ALL_GENDERS_LIST;
  }
});

var _locales = __webpack_require__(807);

Object.defineProperty(exports, 'locales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_locales).default;
  }
});

var _voices = __webpack_require__(808);

Object.defineProperty(exports, 'voices', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_voices).default;
  }
});

var _freetrials = __webpack_require__(809);

Object.defineProperty(exports, 'freetrials', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_freetrials).default;
  }
});
Object.defineProperty(exports, 'FREE_TRIAL_NULL_VALUE', {
  enumerable: true,
  get: function get() {
    return _freetrials.FREE_TRIAL_NULL_VALUE;
  }
});
Object.defineProperty(exports, 'FREE_TRIAL_ELIGIBLE', {
  enumerable: true,
  get: function get() {
    return _freetrials.FREE_TRIAL_ELIGIBLE;
  }
});
Object.defineProperty(exports, 'FREE_TRIAL_INELIGIBLE', {
  enumerable: true,
  get: function get() {
    return _freetrials.FREE_TRIAL_INELIGIBLE;
  }
});

var _flags = __webpack_require__(89);

Object.defineProperty(exports, 'setFlags', {
  enumerable: true,
  get: function get() {
    return _flags.setFlags;
  }
});
Object.defineProperty(exports, 'getFlag', {
  enumerable: true,
  get: function get() {
    return _flags.getFlag;
  }
});

var _platforms = __webpack_require__(810);

Object.defineProperty(exports, 'PLATFORMS', {
  enumerable: true,
  get: function get() {
    return _platforms.PLATFORMS;
  }
});

var _audioTypes = __webpack_require__(485);

Object.defineProperty(exports, 'UPLOADED_AUDIO', {
  enumerable: true,
  get: function get() {
    return _audioTypes.UPLOADED_AUDIO;
  }
});
Object.defineProperty(exports, 'EXISTING_VOICEOVER', {
  enumerable: true,
  get: function get() {
    return _audioTypes.EXISTING_VOICEOVER;
  }
});
Object.defineProperty(exports, 'NEW_VOICEOVER', {
  enumerable: true,
  get: function get() {
    return _audioTypes.NEW_VOICEOVER;
  }
});
Object.defineProperty(exports, 'BG_MUSIC', {
  enumerable: true,
  get: function get() {
    return _audioTypes.BG_MUSIC;
  }
});
Object.defineProperty(exports, 'DEFAULT_AUDIO', {
  enumerable: true,
  get: function get() {
    return _audioTypes.DEFAULT_AUDIO;
  }
});
Object.defineProperty(exports, 'EXISTING_VO_BG_MUSIC', {
  enumerable: true,
  get: function get() {
    return _audioTypes.EXISTING_VO_BG_MUSIC;
  }
});

var _uploadProperties = __webpack_require__(117);

Object.defineProperty(exports, 'UPLOADED_COVER_ART', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.UPLOADED_COVER_ART;
  }
});
Object.defineProperty(exports, 'UPLOADED_STATUS', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.UPLOADED_STATUS;
  }
});
Object.defineProperty(exports, 'UPLOADED_INFO', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.UPLOADED_INFO;
  }
});
Object.defineProperty(exports, 'FILE_PROPERTIES', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.FILE_PROPERTIES;
  }
});
Object.defineProperty(exports, 'FILE_TYPE_PROP', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.FILE_TYPE_PROP;
  }
});
Object.defineProperty(exports, 'FILE_SIZE_PROP', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.FILE_SIZE_PROP;
  }
});
Object.defineProperty(exports, 'FILE_FAIL', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.FILE_FAIL;
  }
});
Object.defineProperty(exports, 'IMAGE_DIMENSIONS', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.IMAGE_DIMENSIONS;
  }
});
Object.defineProperty(exports, 'AUDIO_DURATION', {
  enumerable: true,
  get: function get() {
    return _uploadProperties.AUDIO_DURATION;
  }
});

var _browsers = __webpack_require__(811);

Object.defineProperty(exports, 'SUPPORTED_BROWSER_VERSIONS', {
  enumerable: true,
  get: function get() {
    return _browsers.SUPPORTED_BROWSER_VERSIONS;
  }
});

var _adCreation = __webpack_require__(293);

Object.defineProperty(exports, 'CAMPAIGN_FORM_NAME', {
  enumerable: true,
  get: function get() {
    return _adCreation.CAMPAIGN_FORM_NAME;
  }
});
Object.defineProperty(exports, 'AUDIENCE_FORM_NAME', {
  enumerable: true,
  get: function get() {
    return _adCreation.AUDIENCE_FORM_NAME;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_FILE_SIZE_LIMIT = exports.MAX_FILE_SIZE_LIMIT = 104857600; // 100 mb
var MAX_AUDIO_DURATION = exports.MAX_AUDIO_DURATION = 31;
var CLIENT_AUDIO_TYPES = exports.CLIENT_AUDIO_TYPES = ['audio/ogg', // not supported by safari
'audio/mp3', 'audio/wav', // supported by chrome
'audio/mpeg', 'audio/x-wav'];
var CLIENT_IMAGE_TYPES = exports.CLIENT_IMAGE_TYPES = ['image/jpeg', 'image/png'];

var COVER_ART_IMAGE_DIMENSIONS = exports.COVER_ART_IMAGE_DIMENSIONS = { width: 640, height: 640 };

var TOTAL_BUDGETS = exports.TOTAL_BUDGETS = [500, 1000, 1500];

var MIN_BUDGET = exports.MIN_BUDGET = 250;
var MAX_BUDGET = exports.MAX_BUDGET = 5000;

// Useful for production testing so that we don't have to get charged large amounts
// Note: String to avoid float representation issues
var EASTER_EGG_BUDGET = exports.EASTER_EGG_BUDGET = '0.03';

var WEBGATE_ENDPOINTS = exports.WEBGATE_ENDPOINTS = {
  prod: 'https://spclient.wg.spotify.com',
  dev: 'https://exp.wg.spotify.com'
};

var SPOTIFY_WEB_API = exports.SPOTIFY_WEB_API = 'https://api.spotify.com/v1';

var currencySymbols = exports.currencySymbols = {
  USD: '$'
};

var PAGINATION_PAGE_LIMIT = exports.PAGINATION_PAGE_LIMIT = 20;
var HEADLINE_CHAR_LIMIT = exports.HEADLINE_CHAR_LIMIT = 100;

// This must match backend user groups
var USER_GROUPS = exports.USER_GROUPS = {
  INTERNAL: 'internal',
  PROMOTER: 'promoter',
  ADMIN: 'admin',
  MVP_USER: 'mvp_user'
};

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(23)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserInSupportedRegion = exports.getHasLoginError = exports.getIsAuthorized = exports.getIsWhitelisted = exports.getIsAuthenticated = exports.getWgToken = exports.getAuth = undefined;

var _flags = __webpack_require__(89);

var SUPPORTED_COUNTRIES = ['US'];
var getAuth = exports.getAuth = function getAuth(state) {
  return state.auth;
};
var getWgToken = exports.getWgToken = function getWgToken(state) {
  return getAuth(state).token;
};
var getIsAuthenticated = exports.getIsAuthenticated = function getIsAuthenticated(state) {
  return Boolean(getAuth(state).isAuthenticated);
};
var getIsWhitelisted = exports.getIsWhitelisted = function getIsWhitelisted(state) {
  return Boolean(getAuth(state).isWhitelisted);
};
var getIsAuthorized = exports.getIsAuthorized = function getIsAuthorized(state) {
  return getIsAuthenticated(state) && getIsWhitelisted(state);
};
var getHasLoginError = exports.getHasLoginError = function getHasLoginError(state) {
  return getAuth(state).hasLoginError;
};
var isUserInSupportedRegion = exports.isUserInSupportedRegion = function isUserInSupportedRegion(state) {
  var _getAuth = getAuth(state),
      country = _getAuth.country;

  // dev and local have null as their country because this is provided b


  if ((0, _flags.getFlag)('env') !== 'prod' && country === null) {
    return true;
  }

  return SUPPORTED_COUNTRIES.includes(country);
};

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var createDesc = __webpack_require__(70);
module.exports = __webpack_require__(32) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.noop = noop;
exports.displayAdStatus = displayAdStatus;
exports.appendCachebuster = appendCachebuster;
exports.arrayToObjectByField = arrayToObjectByField;
exports.fuzzyMatch = fuzzyMatch;
exports.fillObject = fillObject;
exports.ageMaxConverter = ageMaxConverter;
exports.unflattenAssign = unflattenAssign;
exports.toTitleCase = toTitleCase;
exports.sortByKeyAsc = sortByKeyAsc;
exports.ballparkNumber = ballparkNumber;
exports.clamp = clamp;
exports.inRange = inRange;
exports.isHostLocal = isHostLocal;

var _escapeStringRegexp = __webpack_require__(817);

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A function which performs no action, named noop to facilitate code search and
 * usage in certain expressions.
 */
function noop() {}
/**
 * Format status string
 * @param {String} status
 * @return {String}
 */
function displayAdStatus(status) {
  return status.replace(/_/g, ' ').replace(/\w\S*/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  });
}

var DEFAULT_GENERATOR = function DEFAULT_GENERATOR() {
  return Date.now();
};

/**
 * Append a parameter to the given url for the purposes of avoiding the local resource cache.
 * @param {String} url The URL to modify
 * @param {String} parameter The name of the cachebusting parameter [default = 'cachebuster']
 * @param {Function} generator A function which will generate a cachebusting value
 */
function appendCachebuster(url) {
  var parameter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cachebuster';
  var generator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_GENERATOR;

  var urlWithSep = url + (url.indexOf('?') === -1 ? '?' : '');
  return urlWithSep + '&' + parameter + '=' + generator();
}

/**
 * Converts an array of Objects to an Object keyed by given fieldName
 * @param {Array} arr
 * @param {String} fieldName
 * @return {Object}
 */
function arrayToObjectByField(arr, fieldName) {
  return arr.reduce(function (obj, i) {
    var field = i[fieldName];
    if (!obj[field]) {
      obj[field] = [];
    }
    obj[field].push(i);
    return obj;
  }, {});
}

// http://codereview.stackexchange.com/questions/23899/faster-javascript-fuzzy-string-matching-function
function fuzzyMatch(str, pattern) {
  if (!pattern) return true;

  var ptn = pattern.split('').reduce(function (a, b) {
    var escaped = (0, _escapeStringRegexp2.default)(b);
    return a + '[^' + escaped + ']*' + escaped;
  });

  return new RegExp(ptn.toLowerCase()).test(str.toLowerCase());
}

/**
 * Populate an object with given keys and initial value
 * @param {Iterator} keys
 * @param {*} initialValue
 * @return {Object}
 */
function fillObject(keys, initialValue) {
  return Array.from(keys).reduce(function (obj, k) {
    obj[k] = initialValue;
    return obj;
  }, {});
}

/**
 * @param {number|string} ageMax
 * @return {number|string}
 */
function ageMaxConverter(ageMax) {
  if (parseInt(ageMax, 10) >= 65) {
    return '65+';
  }
  return ageMax;
}

/**
 * Traverse an object of any depth using a string path
 * i.e. Assign `true` to 'obj.path.to.key' in `obj`
 *
 * @param {string|array} deepKey - Array of keys in order of depth
 *                                 Or '.' separated key path string
 * @param {any} value - Will brute-force override existing value at key path
 * @param {obj|any} state - Existing state at this depth
 * @return {obj} - new state object
 */
function unflattenAssign(deepKey, value) {
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var deepKeys = deepKey.split ? deepKey.split('.') : deepKey;
  var key = deepKeys.shift();
  if (typeof key === 'undefined') {
    return value;
  }
  var deeperState = state.hasOwnProperty(key) ? state[key] : {};

  return _extends({}, state, _defineProperty({}, key, unflattenAssign(deepKeys, value, deeperState)));
}

/**
 * Convert string to title case format
 * @param {string} str - String that will be coverted to title case
 * @return {string} - returns the string in title case format
 */
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function sortByKeyAsc(key, arr) {
  return arr.sort(function (a, b) {
    var aLowercase = a[key].toLowerCase();
    var bLowercase = b[key].toLowerCase();

    if (aLowercase > bLowercase) return 1;
    if (aLowercase < bLowercase) return -1;
    return 0;
  });
}

function ballparkNumber(num) {
  var roundedNum = Math.round(num);
  var length = roundedNum.toString().length;
  var divisor = Math.pow(10, length - (length > 3 ? 2 : 1));
  return Math.round(roundedNum / divisor) * divisor;
}

function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function inRange(num, min, max) {
  var parsedNum = parseInt(num, 10);
  return !isNaN(parsedNum) && num >= min && num <= max;
}

function isHostLocal(hostname) {
  return hostname === 'localhost' || hostname === 'adstudio-local.spotify.com';
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetFields = resetFields;
exports.updateFields = updateFields;
exports.adCreated = adCreated;
exports.createAdFailed = createAdFailed;
exports.populateFields = populateFields;
exports.storeAd = storeAd;
exports.clearSavedAd = clearSavedAd;
exports.restoreAd = restoreAd;
exports.loadAd = loadAd;
exports.resetCreateAd = resetCreateAd;
var AD_CREATED = exports.AD_CREATED = 'AD_CREATED';
var CREATE_AD_FAILED = exports.CREATE_AD_FAILED = 'CREATE_AD_FAILED';

var UPDATE_FIELDS = exports.UPDATE_FIELDS = 'UPDATE_FIELDS';
var RESET_FIELDS = exports.RESET_FIELDS = 'RESET_FIELDS';
var POPULATE_FIELDS = exports.POPULATE_FIELDS = 'POPULATE_FIELDS';

var STORE_AD = exports.STORE_AD = 'STORE_AD';
var LOAD_AD = exports.LOAD_AD = 'LOAD_AD';
var RESTORE_AD = exports.RESTORE_AD = 'RESTORE_AD';
var CLEAR_SAVED_AD = exports.CLEAR_SAVED_AD = 'CLEAR_SAVED_AD';

var RESET_CREATE_AD = exports.RESET_CREATE_AD = 'RESET_CREATE_AD';

function resetFields() {
  return {
    type: RESET_FIELDS
  };
}

function updateFields(field) {
  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: UPDATE_FIELDS,
    field: field,
    groups: groups
  };
}

function adCreated(ad) {
  return {
    type: AD_CREATED,
    name: ad.name
  };
}

function createAdFailed(err) {
  return {
    type: CREATE_AD_FAILED,
    err: err
  };
}

function populateFields(state) {
  return {
    type: POPULATE_FIELDS,
    state: state
  };
}

function storeAd() {
  return {
    type: STORE_AD
  };
}

function clearSavedAd() {
  return {
    type: CLEAR_SAVED_AD
  };
}

function restoreAd() {
  return {
    type: RESTORE_AD
  };
}

function loadAd(ad) {
  return {
    type: LOAD_AD,
    payload: ad
  };
}

function resetCreateAd() {
  return {
    type: RESET_CREATE_AD
  };
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(72);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(206);
var defined = __webpack_require__(74);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(32)) {
  var LIBRARY = __webpack_require__(91);
  var global = __webpack_require__(14);
  var fails = __webpack_require__(23);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(205);
  var $buffer = __webpack_require__(305);
  var ctx = __webpack_require__(48);
  var anInstance = __webpack_require__(93);
  var propertyDesc = __webpack_require__(70);
  var hide = __webpack_require__(38);
  var redefineAll = __webpack_require__(92);
  var toInteger = __webpack_require__(73);
  var toLength = __webpack_require__(27);
  var toIndex = __webpack_require__(306);
  var toAbsoluteIndex = __webpack_require__(95);
  var toPrimitive = __webpack_require__(123);
  var has = __webpack_require__(33);
  var classof = __webpack_require__(213);
  var isObject = __webpack_require__(18);
  var toObject = __webpack_require__(75);
  var isArrayIter = __webpack_require__(214);
  var create = __webpack_require__(125);
  var getPrototypeOf = __webpack_require__(126);
  var gOPN = __webpack_require__(124).f;
  var getIterFn = __webpack_require__(215);
  var uid = __webpack_require__(71);
  var wks = __webpack_require__(21);
  var createArrayMethod = __webpack_require__(127);
  var createArrayIncludes = __webpack_require__(207);
  var speciesConstructor = __webpack_require__(212);
  var ArrayIterators = __webpack_require__(216);
  var Iterators = __webpack_require__(97);
  var $iterDetect = __webpack_require__(155);
  var setSpecies = __webpack_require__(154);
  var arrayFill = __webpack_require__(211);
  var arrayCopyWithin = __webpack_require__(312);
  var $DP = __webpack_require__(26);
  var $GOPD = __webpack_require__(63);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(345);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserPromotingContent = exports.canAccessPricer = exports.isMvpUser = exports.isAdminUser = exports.isInternalUser = exports.isPromoterUser = exports.isUserInGroup = exports.getGroups = exports.getUser = undefined;

var _config = __webpack_require__(30);

var _featureFlags = __webpack_require__(294);

var _featureFlags2 = __webpack_require__(147);

var _Objective = __webpack_require__(499);

var _adCreation = __webpack_require__(87);

var getUser = exports.getUser = function getUser(state) {
  return state.user;
};
var getGroups = exports.getGroups = function getGroups(state) {
  return (getUser(state) || {}).groups;
};
var isUserInGroup = exports.isUserInGroup = function isUserInGroup(state, group) {
  return Boolean((getGroups(state) || {})[group]);
};
var isPromoterUser = exports.isPromoterUser = function isPromoterUser(state) {
  return isUserInGroup(state, _config.USER_GROUPS.PROMOTER);
};
var isInternalUser = exports.isInternalUser = function isInternalUser(state) {
  return isUserInGroup(state, _config.USER_GROUPS.INTERNAL);
};
var isAdminUser = exports.isAdminUser = function isAdminUser(state) {
  return isUserInGroup(state, _config.USER_GROUPS.ADMIN);
};
var isMvpUser = exports.isMvpUser = function isMvpUser(state) {
  return isUserInGroup(state, _config.USER_GROUPS.MVP_USER);
};
var canAccessPricer = exports.canAccessPricer = function canAccessPricer(state) {
  return !!(0, _featureFlags2.getFlagValue)(state, _featureFlags.ADGEN_PRICER);
};
var isUserPromotingContent = exports.isUserPromotingContent = function isUserPromotingContent(state) {
  var values = (0, _adCreation.getCombinedAd)(state);
  return values && values.objective === _Objective.CONTENT_PROMO;
};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(16);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/create-react-class/index.js
var create_react_class = __webpack_require__(54);
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/warning/browser.js
var warning_browser = __webpack_require__(31);
var warning_browser_default = /*#__PURE__*/__webpack_require__.n(warning_browser);

// CONCATENATED MODULE: ./node_modules/react-router/es/routerWarning.js


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  warning_browser_default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}
// CONCATENATED MODULE: ./node_modules/react-router/es/PatternUtils.js


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : browser_default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : browser_default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : browser_default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : browser_default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}
// CONCATENATED MODULE: ./node_modules/react-router/es/computeChangedRoutes.js


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = getParamNames(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ var es_computeChangedRoutes = (computeChangedRoutes);
// CONCATENATED MODULE: ./node_modules/react-router/es/AsyncUtils.js
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}
// CONCATENATED MODULE: ./node_modules/react-router/es/TransitionUtils.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    loopAsync(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}
// CONCATENATED MODULE: ./node_modules/react-router/es/isActive.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = matchPattern(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive_isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
// CONCATENATED MODULE: ./node_modules/react-router/es/PromiseUtils.js
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
// CONCATENATED MODULE: ./node_modules/react-router/es/getComponents.js



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (isPromise(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  mapAsync(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ var es_getComponents = (getComponents);
// CONCATENATED MODULE: ./node_modules/react-router/es/RouteUtils.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || react_default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function RouteUtils_createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  react_default.a.Children.forEach(children, function (element) {
    if (react_default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(RouteUtils_createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}
// CONCATENATED MODULE: ./node_modules/react-router/es/matchRoutes.js
var matchRoutes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && createRoutes(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (isPromise(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, createRoutes(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && createRoutes(indexRoute)[0]);
    });

    if (isPromise(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, createRoutes(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      loopAsync(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = matchPattern(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = matchRoutes__extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  loopAsync(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
// CONCATENATED MODULE: ./node_modules/react-router/es/createTransitionManager.js
var createTransitionManager__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager_createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = getTransitionUtils(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return isActive_isActive(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      matchRoutes(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(createTransitionManager__extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = es_computeChangedRoutes(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      es_getComponents(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = createTransitionManager__extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    matchRoutes(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = createTransitionManager__extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(es_computeChangedRoutes(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}
// CONCATENATED MODULE: ./node_modules/react-router/es/InternalPropTypes.js


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var InternalPropTypes_history = Object(prop_types["shape"])({
  listen: prop_types["func"].isRequired,
  push: prop_types["func"].isRequired,
  replace: prop_types["func"].isRequired,
  go: prop_types["func"].isRequired,
  goBack: prop_types["func"].isRequired,
  goForward: prop_types["func"].isRequired
});

var component = Object(prop_types["oneOfType"])([prop_types["func"], prop_types["string"]]);
var InternalPropTypes_components = Object(prop_types["oneOfType"])([component, prop_types["object"]]);
var InternalPropTypes_route = Object(prop_types["oneOfType"])([prop_types["object"], prop_types["element"]]);
var InternalPropTypes_routes = Object(prop_types["oneOfType"])([InternalPropTypes_route, Object(prop_types["arrayOf"])(InternalPropTypes_route)]);
// CONCATENATED MODULE: ./node_modules/react-router/es/getRouteParams.js


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  getParamNames(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ var es_getRouteParams = (getRouteParams);
// CONCATENATED MODULE: ./node_modules/react-router/es/ContextUtils.js


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = prop_types_default.a.shape({
  subscribe: prop_types_default.a.func.isRequired,
  eventIndex: prop_types_default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}
// CONCATENATED MODULE: ./node_modules/react-router/es/RouterContext.js
var RouterContext__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var RouterContext__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = create_react_class_default()({
  displayName: 'RouterContext',

  mixins: [ContextProvider('router')],

  propTypes: {
    router: prop_types["object"].isRequired,
    location: prop_types["object"].isRequired,
    routes: prop_types["array"].isRequired,
    params: prop_types["object"].isRequired,
    components: prop_types["array"].isRequired,
    createElement: prop_types["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: react_default.a.createElement
    };
  },


  childContextTypes: {
    router: prop_types["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = es_getRouteParams(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (isReactChildren(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : RouterContext__typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], RouterContext__extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || react_default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : browser_default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ var es_RouterContext = (RouterContext);
// CONCATENATED MODULE: ./node_modules/react-router/es/RouterUtils.js
var RouterUtils__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function RouterUtils_createRouterObject(history, transitionManager, state) {
  var router = RouterUtils__extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}
// CONCATENATED MODULE: ./node_modules/react-router/es/Router.js
var Router__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: prop_types["object"],
  children: InternalPropTypes_routes,
  routes: InternalPropTypes_routes, // alias for children
  render: prop_types["func"],
  createElement: prop_types["func"],
  onError: prop_types["func"],
  onUpdate: prop_types["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: prop_types["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = create_react_class_default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return react_default.a.createElement(es_RouterContext, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return RouterUtils_createRouterObject(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : browser_default()(false) : void 0;

    return createTransitionManager_createTransitionManager(history, createRoutes(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        assignRouterState(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(Router__extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ var es_Router = (Router);
// CONCATENATED MODULE: ./node_modules/react-router/es/PropTypes.js


var routerShape = Object(prop_types["shape"])({
  push: prop_types["func"].isRequired,
  replace: prop_types["func"].isRequired,
  go: prop_types["func"].isRequired,
  goBack: prop_types["func"].isRequired,
  goForward: prop_types["func"].isRequired,
  setRouteLeaveHook: prop_types["func"].isRequired,
  isActive: prop_types["func"].isRequired
});

var locationShape = Object(prop_types["shape"])({
  pathname: prop_types["string"].isRequired,
  search: prop_types["string"].isRequired,
  state: prop_types["object"],
  action: prop_types["string"].isRequired,
  key: prop_types["string"]
});
// CONCATENATED MODULE: ./node_modules/react-router/es/Link.js
var Link__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Link__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = create_react_class_default()({
  displayName: 'Link',

  mixins: [ContextSubscriber('router')],

  contextTypes: {
    router: routerShape
  },

  propTypes: {
    to: Object(prop_types["oneOfType"])([prop_types["string"], prop_types["object"], prop_types["func"]]),
    activeStyle: prop_types["object"],
    activeClassName: prop_types["string"],
    onlyActiveOnIndex: prop_types["bool"].isRequired,
    onClick: prop_types["func"],
    target: prop_types["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : browser_default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = Link__objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return react_default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = Link__extends({}, props.style, activeStyle);
        }
      }
    }

    return react_default.a.createElement('a', Link__extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ var es_Link = (Link);
// CONCATENATED MODULE: ./node_modules/react-router/es/IndexLink.js
var IndexLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = create_react_class_default()({
  displayName: 'IndexLink',

  render: function render() {
    return react_default.a.createElement(es_Link, IndexLink__extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ var es_IndexLink = (IndexLink);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__(169);
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// CONCATENATED MODULE: ./node_modules/react-router/es/withRouter.js
var withRouter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = create_react_class_default()({
    displayName: 'WithRouter',

    mixins: [ContextSubscriber('router')],

    contextTypes: { router: routerShape },
    propTypes: { router: routerShape },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : browser_default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return react_default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = withRouter__extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return react_default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return hoist_non_react_statics_default()(WithRouter, WrappedComponent);
}
// CONCATENATED MODULE: ./node_modules/react-router/es/Redirect.js







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = create_react_class_default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = RouteUtils_createRouteFromReactElement(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = formatPattern(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = formatPattern(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: prop_types["string"],
    from: prop_types["string"], // Alias for path
    to: prop_types["string"].isRequired,
    query: prop_types["object"],
    state: prop_types["object"],
    onEnter: falsy,
    children: falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : browser_default()(false) : void 0;
  }
});

/* harmony default export */ var es_Redirect = (Redirect);
// CONCATENATED MODULE: ./node_modules/react-router/es/IndexRedirect.js







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = create_react_class_default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = es_Redirect.createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: prop_types["string"].isRequired,
    query: prop_types["object"],
    state: prop_types["object"],
    onEnter: falsy,
    children: falsy
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : browser_default()(false) : void 0;
  }
});

/* harmony default export */ var es_IndexRedirect = (IndexRedirect);
// CONCATENATED MODULE: ./node_modules/react-router/es/IndexRoute.js







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = create_react_class_default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = RouteUtils_createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: falsy,
    component: component,
    components: InternalPropTypes_components,
    getComponent: prop_types["func"],
    getComponents: prop_types["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : browser_default()(false) : void 0;
  }
});

/* harmony default export */ var es_IndexRoute = (IndexRoute);
// CONCATENATED MODULE: ./node_modules/react-router/es/Route.js






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = create_react_class_default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: RouteUtils_createRouteFromReactElement
  },

  propTypes: {
    path: prop_types["string"],
    component: component,
    components: InternalPropTypes_components,
    getComponent: prop_types["func"],
    getComponents: prop_types["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : browser_default()(false) : void 0;
  }
});

/* harmony default export */ var es_Route = (Route);
// EXTERNAL MODULE: ./node_modules/history/lib/Actions.js
var Actions = __webpack_require__(170);
var Actions_default = /*#__PURE__*/__webpack_require__.n(Actions);

// EXTERNAL MODULE: ./node_modules/history/lib/useQueries.js
var useQueries = __webpack_require__(384);
var useQueries_default = /*#__PURE__*/__webpack_require__.n(useQueries);

// EXTERNAL MODULE: ./node_modules/history/lib/useBasename.js
var useBasename = __webpack_require__(385);
var useBasename_default = /*#__PURE__*/__webpack_require__.n(useBasename);

// EXTERNAL MODULE: ./node_modules/history/lib/createMemoryHistory.js
var createMemoryHistory = __webpack_require__(773);
var createMemoryHistory_default = /*#__PURE__*/__webpack_require__.n(createMemoryHistory);

// CONCATENATED MODULE: ./node_modules/react-router/es/createMemoryHistory.js




function createMemoryHistory_createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = createMemoryHistory_default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = useQueries_default()(useBasename_default()(createHistory))(options);
  return history;
}
// CONCATENATED MODULE: ./node_modules/react-router/es/match.js
var match__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function match__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match_match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = match__objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : browser_default()(false) : void 0;

  history = history ? history : createMemoryHistory_createMemoryHistory(options);
  var transitionManager = createTransitionManager_createTransitionManager(history, createRoutes(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = RouterUtils_createRouterObject(history, transitionManager, nextState);
      renderProps = match__extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, Actions["REPLACE"]), renderProps);
  });
}

/* harmony default export */ var es_match = (match_match);
// CONCATENATED MODULE: ./node_modules/react-router/es/useRouterHistory.js



function useRouterHistory(createHistory) {
  return function (options) {
    var history = useQueries_default()(useBasename_default()(createHistory))(options);
    return history;
  };
}
// CONCATENATED MODULE: ./node_modules/react-router/es/applyRouterMiddleware.js
var applyRouterMiddleware__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ var applyRouterMiddleware = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : react["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, react_default.a.createElement(es_RouterContext, applyRouterMiddleware__extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});
// EXTERNAL MODULE: ./node_modules/history/lib/createBrowserHistory.js
var createBrowserHistory = __webpack_require__(775);
var createBrowserHistory_default = /*#__PURE__*/__webpack_require__.n(createBrowserHistory);

// CONCATENATED MODULE: ./node_modules/react-router/es/createRouterHistory.js


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = useRouterHistory(createHistory)();
  return history;
}
// CONCATENATED MODULE: ./node_modules/react-router/es/browserHistory.js


/* harmony default export */ var browserHistory = (createRouterHistory(createBrowserHistory_default.a));
// EXTERNAL MODULE: ./node_modules/history/lib/createHashHistory.js
var createHashHistory = __webpack_require__(777);
var createHashHistory_default = /*#__PURE__*/__webpack_require__.n(createHashHistory);

// CONCATENATED MODULE: ./node_modules/react-router/es/hashHistory.js


/* harmony default export */ var hashHistory = (createRouterHistory(createHashHistory_default.a));
// CONCATENATED MODULE: ./node_modules/react-router/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Router", function() { return es_Router; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return es_Link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IndexLink", function() { return es_IndexLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withRouter", function() { return withRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return es_IndexRedirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return es_IndexRoute; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Redirect", function() { return es_Redirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Route", function() { return es_Route; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createRoutes", function() { return createRoutes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RouterContext", function() { return es_RouterContext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "locationShape", function() { return locationShape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "routerShape", function() { return routerShape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "match", function() { return es_match; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return useRouterHistory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "formatPattern", function() { return formatPattern; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return applyRouterMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "browserHistory", function() { return browserHistory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "hashHistory", function() { return hashHistory; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory_createMemoryHistory; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(265);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(393);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(823);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(824);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFLINE_ERROR_MESSAGE = exports.NETWORK_ERROR_MESSAGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = callWebGate;

var _config = __webpack_require__(30);

var _flags = __webpack_require__(89);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('callWebGate');

var NETWORK_ERROR_MESSAGE = exports.NETWORK_ERROR_MESSAGE = 'There was a network error. Please try again.';
var OFFLINE_ERROR_MESSAGE = exports.OFFLINE_ERROR_MESSAGE = 'You are currently offline.';

/**
 * Make a call to an endpoint and return a Promise for the fetch() call
 *
 * @param {String} uri A string in the form `${service}/${path}`
 * @param {Object} opts - object containing body and method.
 * @param {String} envOverride - override env to reach services that aren't in exp.wg
 *
 * @return Promise resolving to a fetch Response object.  May resolve to an
 *   error state if an OAuth token cannot be generated.
 */
function callWebGate(uri, wgToken) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$body = _ref.body,
      body = _ref$body === undefined ? '' : _ref$body,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method;

  var envOverride = arguments[3];
  var fetch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.fetch;
  var windowObj = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : window;

  log('%s %s %s', method, uri, body);

  var headers = new Headers();

  if (wgToken) {
    headers.append('Authorization', 'Bearer ' + wgToken);
  }

  var defaultOpts = {
    mode: 'cors',
    method: method,
    headers: headers
  };

  var fetchOpts = method.toUpperCase() === 'GET' ? defaultOpts : _extends({}, defaultOpts, { body: body });

  var WG_URL = _config.WEBGATE_ENDPOINTS[envOverride || (0, _flags.getFlag)('env')];
  var url = WG_URL + '/' + uri;

  return fetch(url, fetchOpts).catch(function (e) {
    var message = e.message;

    if (!windowObj.navigator.onLine) {
      message = OFFLINE_ERROR_MESSAGE;
    } else if (e.message.indexOf('Failed to fetch') !== -1) {
      message = NETWORK_ERROR_MESSAGE;
    }

    var error = new Error(message);

    // Avoids the 'Error:' prefix for the displayed error message
    error.toString = function () {
      return message;
    };

    throw error;
  });
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(38);
var has = __webpack_require__(33);
var SRC = __webpack_require__(71)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(122).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(128);
var createDesc = __webpack_require__(70);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(123);
var has = __webpack_require__(33);
var IE8_DOM_DEFINE = __webpack_require__(304);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guidelinePdfClicked = guidelinePdfClicked;
exports.landingVideoPlayed = landingVideoPlayed;
exports.logUserAction = logUserAction;
exports.setPartnerId = setPartnerId;
exports.fetchPartnerIdFailed = fetchPartnerIdFailed;
var GUIDELINE_PDF_CLICKED = exports.GUIDELINE_PDF_CLICKED = 'GUIDELINE_PDF_CLICKED';
var LANDING_VIDEO_PLAYED = exports.LANDING_VIDEO_PLAYED = 'LANDING_VIDEO_PLAYED';
var LOG_USER_ACTION = exports.LOG_USER_ACTION = 'LOG_USER_ACTION';
var GA_PARTNER_ID_RECEIVED = exports.GA_PARTNER_ID_RECEIVED = 'GA_PARTNER_ID_RECEIVED';
var GA_PARTNER_ID_FETCH_FAILED = exports.GA_PARTNER_ID_FETCH_FAILED = 'GA_PARTNER_ID_FETCH_FAILED';

function guidelinePdfClicked() {
  return {
    type: GUIDELINE_PDF_CLICKED
  };
}

function landingVideoPlayed() {
  return {
    type: LANDING_VIDEO_PLAYED
  };
}

function logUserAction(_ref) {
  var category = _ref.category,
      label = _ref.label,
      params = _ref.params;

  return {
    type: LOG_USER_ACTION,
    payload: {
      category: category,
      label: label,
      params: params
    }
  };
}

function setPartnerId(_ref2) {
  var partnerId = _ref2.partnerId;

  return {
    type: GA_PARTNER_ID_RECEIVED,
    payload: {
      partnerId: partnerId
    }
  };
}

function fetchPartnerIdFailed(err) {
  return {
    type: GA_PARTNER_ID_FETCH_FAILED,
    err: err
  };
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveUserInfo = receiveUserInfo;
exports.setUserAccount = setUserAccount;
var RECEIVE_USER_INFO = exports.RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
var SET_USER_ACCOUNT = exports.SET_USER_ACCOUNT = 'SET_USER_ACCOUNT';

function receiveUserInfo(userInfo) {
  var groupsObj = userInfo.groups.reduce(function (acc, group) {
    acc[group] = true;
    return acc;
  }, {});

  return {
    type: RECEIVE_USER_INFO,
    user: {
      id: userInfo.id,
      imgSrc: userInfo.images && userInfo.images[0] && userInfo.images[0].url,
      displayName: userInfo.display_name,
      groups: groupsObj,
      email: userInfo.email,
      account: userInfo.account
    }
  };
}

function setUserAccount(account) {
  return {
    type: SET_USER_ACCOUNT,
    user: {
      account: account
    }
  };
}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(74);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(785),
    getValue = __webpack_require__(788);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ssoSessionActive = ssoSessionActive;
exports.ssoSessionInactive = ssoSessionInactive;
exports.ssoSessionError = ssoSessionError;
exports.ipCountrySuccess = ipCountrySuccess;
exports.ipCountryFailed = ipCountryFailed;
exports.userLoggedOut = userLoggedOut;
var SSO_SESSION_ACTIVE = exports.SSO_SESSION_ACTIVE = 'SSO_SESSION_ACTIVE';
var SSO_SESSION_INACTIVE = exports.SSO_SESSION_INACTIVE = 'SSO_SESSION_INACTIVE';
var SSO_SESSION_ERROR = exports.SSO_SESSION_ERROR = 'SSO_SESSION_ERROR';
var GEO_IP_SUCCESS = exports.GEO_IP_SUCCESS = 'GEO_IP_SUCCESS';
var GEO_IP_FAILED = exports.GEO_IP_FAILED = 'GEO_IP_FAILED';
var USER_LOGGED_OUT = exports.USER_LOGGED_OUT = 'USER_LOGGED_OUT';

function ssoSessionActive(token) {
  return {
    type: SSO_SESSION_ACTIVE,
    accessToken: token
  };
}

function ssoSessionInactive() {
  return {
    type: SSO_SESSION_INACTIVE
  };
}

function ssoSessionError(e) {
  return {
    type: SSO_SESSION_ERROR,
    err: e
  };
}

function ipCountrySuccess(country) {
  return {
    type: GEO_IP_SUCCESS,
    payload: { country: country }
  };
}

function ipCountryFailed(err) {
  return {
    type: GEO_IP_FAILED,
    err: err
  };
}

function userLoggedOut() {
  return {
    type: USER_LOGGED_OUT
  };
}

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var routes = exports.routes = {
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT: '/account',
  ADCREATION_STEP: '/3',
  AUDIENCE_STEP: '/2',
  BROWSE_ADS: '/browse-ads',
  BROWSE_ADS_ADVIEW: '/ad/:id',
  BUILD_AD: '/build-ad',
  CAMPAIGN_STEP: '/1',
  CREATIVE_GUIDELINES: '/creative-guidelines',
  FAQ: '/faq',
  FEEDBACK: '/feedback',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MAIN: '/',
  NOT_FOUND: '*',
  SIGNUP: '/signup',
  TERMS: '/terms',
  BETA_TERMS: '/beta-terms',
  WAITLIST: '/waitlist',
  REDIRECT: '/redirect'
};

var routeStrings = exports.routeStrings = createRouteStrings();

function createRouteStrings() {
  var newRoutes = {};
  for (var key in routes) {
    if (routes[key].length > 1) {
      newRoutes[key] = routes[key].slice(1, routes[key].length);
    } else {
      newRoutes[key] = routes[key];
    }
  }

  return newRoutes;
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVOName = exports.getBuildAdActiveStep = exports.getAudienceInitialValues = exports.getCampaignInitialValues = exports.getCombinedAd = exports.getAdFromCreateForms = exports.getEditableAd = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getBuildAdValidationResultsByStep = getBuildAdValidationResultsByStep;
exports.getEditableAdValid = getEditableAdValid;
exports.hasFreeTrialTargeting = hasFreeTrialTargeting;
exports.hasCityTargeting = hasCityTargeting;

var _reduxForm = __webpack_require__(67);

var _deepmerge = __webpack_require__(816);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _get = __webpack_require__(193);

var _get2 = _interopRequireDefault(_get);

var _config = __webpack_require__(30);

var _payments = __webpack_require__(467);

var _dateHelper = __webpack_require__(149);

var _utilities = __webpack_require__(46);

var _featureFlags = __webpack_require__(294);

var _featureFlags2 = __webpack_require__(147);

var _reduxForm2 = __webpack_require__(301);

var _user = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEditableAd = exports.getEditableAd = function getEditableAd(state) {
  return state.editableAd;
};

var getAdFromCreateForms = exports.getAdFromCreateForms = function getAdFromCreateForms(state) {
  return _extends({}, (0, _reduxForm.getFormValues)(_config.CAMPAIGN_FORM_NAME)(state) || {}, (0, _reduxForm.getFormValues)(_config.AUDIENCE_FORM_NAME)(state) || {});
};

var getCombinedAd = exports.getCombinedAd = function getCombinedAd(state) {
  return (0, _deepmerge2.default)(getEditableAd(state), getAdFromCreateForms(state));
};

var getCampaignInitialValues = exports.getCampaignInitialValues = function getCampaignInitialValues() {
  return {
    internalName: '',
    objective: ''
  };
};

var getAudienceInitialValues = exports.getAudienceInitialValues = function getAudienceInitialValues(state) {
  return {
    targeting: {
      ageRange: {
        start: '13',
        end: '65'
      },
      fanAudiences: [],
      freeTrial: _config.FREE_TRIAL_NULL_VALUE,
      gender: _config.ALL_GENDERS_VALUE,
      genres: [],
      locations: [],
      moments: [],
      platforms: (0, _utilities.fillObject)(Object.keys(_config.PLATFORMS), true)
    },
    dateRange: {
      begin: (0, _dateHelper.daysFromToday)(2),
      end: (0, _dateHelper.endOfDay)((0, _dateHelper.daysFromToday)(2))
    },
    payments: {
      totalBudget: '',
      currency: (0, _payments.getCurrency)(state)
    },
    paymentsConnected: (0, _payments.getPaymentsErrorMessage)(state)
  };
};

var getBuildAdActiveStep = exports.getBuildAdActiveStep = function getBuildAdActiveStep(state) {
  return getEditableAd(state).activeStep;
};
var getVOName = exports.getVOName = function getVOName(state) {
  return (0, _get2.default)(getEditableAd(state), 'audioSubmission.' + _config.NEW_VOICEOVER + '.name');
};

function getBuildAdValidationResultsByStep(state) {
  var steps = state.validation.steps;

  // overwrite for redux-form validation

  var overrides = {
    1: (0, _reduxForm2.getValidationForReduxForm)(state, _config.CAMPAIGN_FORM_NAME),
    2: (0, _reduxForm2.getValidationForReduxForm)(state, _config.AUDIENCE_FORM_NAME)
  };

  return _extends({}, steps, overrides);
}

function getEditableAdValid(state) {
  var stepValidation = getBuildAdValidationResultsByStep(state);
  return Object.keys(stepValidation).map(function (key) {
    return stepValidation[key];
  }).every(function (_ref) {
    var touched = _ref.touched,
        isStepValid = _ref.isValid;
    return touched && isStepValid;
  });
}

function hasFreeTrialTargeting(state) {
  return (0, _user.isInternalUser)(state);
}

function hasCityTargeting(state) {
  return (0, _featureFlags2.getFlagValue)(state, _featureFlags.CITY_TARGETING) === 'on';
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return _react2['default'].Children.map(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
// TODO: This module should be ElementChildren, and should use named exports.

function forEach(children, func, context) {
  var index = 0;

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = undefined;

  _react2['default'].Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  _react2['default'].Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  _react2['default'].Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  _react2['default'].Children.forEach(children, function (child) {
    if (!_react2['default'].isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

exports['default'] = {
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
};
module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.setFlags = setFlags;
exports.getFlag = getFlag;
var DEV_RECAPTCHA_SITE_KEY = '6LfuPDAUAAAAAB9hPsja-CDKHS0T0bjMX_RmdU7g';
var PROD_RECAPTCHA_SITE_KEY = '6LdKSTAUAAAAAL3G5acAfoHSYguMb3GNWV8CQ3h1';

var ENV_FLAGS = [{
  host: [/dev\.spotify\.(net|com)/],
  flags: {
    env: 'dev',
    recaptchaSiteKey: DEV_RECAPTCHA_SITE_KEY,
    swEnabled: false
  }
}, {
  host: [/localhost/, /adstudio-local\.spotify\.com/],
  flags: {
    env: 'dev',
    recaptchaSiteKey: DEV_RECAPTCHA_SITE_KEY,
    swEnabled: false
  }
}, {
  host: [/(adgen|adstudio)\.spotify\.(net|com)/],
  flags: {
    env: 'prod',
    recaptchaSiteKey: PROD_RECAPTCHA_SITE_KEY,
    swEnabled: false
  }
}];

function confMatches(conf, hostname) {
  if (conf.host) {
    var hostMatches = conf.host.filter(function (h) {
      return h.test(hostname);
    }).length > 0;
    if (!hostMatches) {
      return false;
    }
  }
  return true;
}

var flags = {};
var _flagsSet = false;

function setFlags(hostname) {
  flags = ENV_FLAGS.filter(function (conf) {
    return conf.flags && confMatches(conf, hostname);
  }).map(function (conf) {
    return conf.flags;
  }).reduce(function (merged, _flags) {
    return _extends({}, merged, _flags);
  }, {});
  _flagsSet = true;
}

function getFlag(flagKey) {
  if (!_flagsSet) {
    setFlags(window.location.hostname);
  }

  return flags[flagKey];
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStorage = getStorage;
exports.setStorage = setStorage;
exports.removeStorage = removeStorage;
exports.clearStorage = clearStorage;
exports.jsonParse = jsonParse;
exports.jsonStringify = jsonStringify;
exports.getTimeout = getTimeout;
exports.isKeyExpired = isKeyExpired;

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _moment = __webpack_require__(85);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('sagas:storage-utils');

// storage utils
function getStorage(storage, key) {
  try {
    var result = storage.getItem(key);
    log('successfully retrieved from local storage. key: ' + key);
    return result;
  } catch (e) {
    log('could not retrieve item from local storage. key: ' + key + ' error: ' + e.message);
  }
}

function setStorage(storage, key, value) {
  try {
    var result = storage.setItem(key, value);
    log('successfully saved item in local storage. key: ' + key);
    return result;
  } catch (e) {
    log('could not save item to local storage. key: ' + key + ' error: ' + e.message);
  }
}

function removeStorage(storage, key) {
  try {
    var result = storage.removeItem(key);
    log('successfully cleared from local storage. key: ' + key);
    return result;
  } catch (e) {
    log('could not clear item from local storage. key: ' + key + ' error: ' + e.message);
  }
}

function clearStorage(storage) {
  try {
    var result = storage.clear();
    log('successfully cleared all local storage.');
    return result;
  } catch (e) {
    log('could not clear all from local storage. error: ' + e.message);
  }
}

function jsonParse(string) {
  try {
    return JSON.parse(string);
  } catch (e) {
    log('could not parse the stringified value: ' + e.message);
  }
}

function jsonStringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    log('could not stringify the object: ' + e.message);
  }
}

function getTimeout() {
  return jsonStringify({ timeout: (0, _moment2.default)().add(1, 'day').valueOf() });
}

// for a local storage key, check an expiration key to see if
// the data is expired. returns true if expired.
function isKeyExpired(storage, key) {
  log('checking expiration for key: ' + key);

  var json = getStorage(storage, key);
  var obj = jsonParse(json);

  if (!obj) {
    log('no expiration obj found in storage');
    return false;
  }

  var timeout = obj.timeout;


  if (!timeout) {
    log('no timeout found in storage');
    return false;
  }

  var expirationMoment = (0, _moment2.default)(timeout);
  var hasExpired = expirationMoment.isBefore((0, _moment2.default)());

  log('stored value for ' + key + ' ' + (hasExpired ? 'expired' : 'expires') + ' ' + expirationMoment.fromNow());

  return hasExpired;
}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(62);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(26).f;
var has = __webpack_require__(33);
var TAG = __webpack_require__(21)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(307);
var enumBugKeys = __webpack_require__(210);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(21)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(38)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(66);

var _Actions = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchUserFlagsSuccess = fetchUserFlagsSuccess;
exports.fetchUserFlagsFailed = fetchUserFlagsFailed;
exports.userFlagUpdated = userFlagUpdated;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FETCH_USER_FLAGS_SUCCESS = exports.FETCH_USER_FLAGS_SUCCESS = 'FETCH_USER_FLAGS_SUCCESS';
var FETCH_USER_FLAGS_FAILED = exports.FETCH_USER_FLAGS_FAILED = 'FETCH_USER_FLAGS_FAILED';
var USER_FLAG_UPDATED = exports.USER_FLAG_UPDATED = 'USER_FLAG_UPDATED';

var FF_REGEX = /^ad(gen|studio)-/;

function getAllFlags() {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return flags.reduce(function (obj, _ref) {
    var featureName = _ref.featureName,
        cell = _ref.cell;

    if (FF_REGEX.test(featureName)) {
      return _extends({}, obj, _defineProperty({}, featureName, cell));
    }

    return obj;
  }, {});
}

function fetchUserFlagsSuccess(_ref2) {
  var flags = _ref2.flags;

  return {
    type: FETCH_USER_FLAGS_SUCCESS,
    flags: getAllFlags(flags)
  };
}

function fetchUserFlagsFailed(err) {
  return {
    type: FETCH_USER_FLAGS_FAILED,
    err: err
  };
}

function userFlagUpdated(_ref3) {
  var flag = _ref3.flag,
      value = _ref3.value;

  return {
    type: USER_FLAG_UPDATED,
    flag: flag,
    value: value
  };
}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createDefaultFileProperties = createDefaultFileProperties;
exports.createDefaultImageProperties = createDefaultImageProperties;
exports.createDefaultAudioProperties = createDefaultAudioProperties;
exports.createDefaultUploadObj = createDefaultUploadObj;
exports.createDefaultAudioUploadObj = createDefaultAudioUploadObj;
exports.createDefaultImageUploadObj = createDefaultImageUploadObj;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UPLOADED_COVER_ART = exports.UPLOADED_COVER_ART = 'image';
var UPLOADED_STATUS = exports.UPLOADED_STATUS = 'uploaded';
var UPLOADED_INFO = exports.UPLOADED_INFO = 'uploadInfo';
var FILE_PROPERTIES = exports.FILE_PROPERTIES = 'fileProperties';
var FILE_TYPE_PROP = exports.FILE_TYPE_PROP = 'type';
var FILE_SIZE_PROP = exports.FILE_SIZE_PROP = 'size';
var FILE_FAIL = exports.FILE_FAIL = 'fail';
var IMAGE_DIMENSIONS = exports.IMAGE_DIMENSIONS = 'imageDimensions';
var AUDIO_DURATION = exports.AUDIO_DURATION = 'audioDuration';

function createDefaultFileProperties() {
  var _ref;

  return _ref = {}, _defineProperty(_ref, FILE_TYPE_PROP, ''), _defineProperty(_ref, FILE_SIZE_PROP, 0), _defineProperty(_ref, FILE_FAIL, false), _ref;
}

function createDefaultImageProperties() {
  return _extends({}, createDefaultFileProperties(), _defineProperty({}, IMAGE_DIMENSIONS, ''));
}

function createDefaultAudioProperties() {
  return _extends({}, createDefaultFileProperties(), _defineProperty({}, AUDIO_DURATION, ''));
}

function createDefaultUploadObj() {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, UPLOADED_STATUS, false), _defineProperty(_ref2, UPLOADED_INFO, {
    id: '',
    action: '',
    fields: {},
    uri: ''
  }), _ref2;
}

function createDefaultAudioUploadObj() {
  var audioUpload = createDefaultUploadObj();
  audioUpload[FILE_PROPERTIES] = createDefaultFileProperties();
  return audioUpload;
}

function createDefaultImageUploadObj() {
  var imageUpload = createDefaultUploadObj();
  imageUpload[FILE_PROPERTIES] = createDefaultImageProperties();
  return imageUpload;
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertBar = function AlertBar(_ref) {
  var children = _ref.children,
      alertType = _ref.alertType,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: 'alert alert-' + alertType + ' ' + className + ' alert-dismissible', role: 'alert' },
    _react2.default.createElement(
      'div',
      { className: 'container text-left' },
      children
    )
  );
};

AlertBar.propTypes = {
  children: _propTypes2.default.node,
  alertType: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.default = AlertBar;

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(307);
var hiddenKeys = __webpack_require__(210).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(15);
var dPs = __webpack_require__(516);
var enumBugKeys = __webpack_require__(210);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(204)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(308).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(33);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(48);
var IObject = __webpack_require__(206);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(27);
var asc = __webpack_require__(517);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(71)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(33);
var setDesc = __webpack_require__(26).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(23)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBinding;
exports.setLocale = setLocale;
// TODO(carpita): Select language at run time and integrate with existing Spotify lang frameworks

var bindings = {
  'build-voice-over': 'Build a Voiceover',
  'transcript-placeholder': 'Transcript',
  'name-placeholder': 'Name',
  'instructions-placeholder': 'Instructions',
  'enter-your-script': 'Enter Your Script',
  'enter-your-script-instructions': 'Script of Voiceover: up to 2000 characters.',
  'error-empty-transcript': 'You must enter content for the voice-over transcript.',
  'error-empty-name': 'You must label your voice-over with a name.',
  'server-error': 'A server error occurred while attempting to create a voice-over'
};

function getBinding(key, defaultValue) {
  if (bindings.hasOwnProperty(key)) {
    return bindings[key];
  }
  return defaultValue;
}

function setLocale() /* locale */{
  // ...
}

getBinding.setLocale = setLocale;

/***/ }),
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(433),
    baseAssignValue = __webpack_require__(300);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshAds = refreshAds;
exports.fetchReviewAudioAds = fetchReviewAudioAds;
exports.fetchAds = fetchAds;
exports.fetchAd = fetchAd;
exports.fetchAdFailed = fetchAdFailed;
exports.fetchAdNotFound = fetchAdNotFound;
exports.fetchAdSuccess = fetchAdSuccess;
exports.fetchAdsFailed = fetchAdsFailed;
exports.refreshAdsFailed = refreshAdsFailed;
exports.reviewAudioAdsFailed = reviewAudioAdsFailed;
exports.fetchAdsSuccess = fetchAdsSuccess;
exports.refreshAdsSuccess = refreshAdsSuccess;
exports.reviewAudioAdsSuccess = reviewAudioAdsSuccess;
exports.updatePagingInfo = updatePagingInfo;
exports.updateReviewAudioPagingInfo = updateReviewAudioPagingInfo;
exports.filterAdsByName = filterAdsByName;
exports.approveAd = approveAd;
exports.approveAdSuccess = approveAdSuccess;
exports.approveAdFailed = approveAdFailed;
exports.reviseVO = reviseVO;
exports.reviseBGMusic = reviseBGMusic;
exports.reviseAdSuccess = reviseAdSuccess;
exports.reviseAdFailed = reviseAdFailed;
exports.rejectAd = rejectAd;
exports.rejectAdSuccess = rejectAdSuccess;
exports.rejectAdFailed = rejectAdFailed;
exports.rejectAdPrompted = rejectAdPrompted;
exports.cancelAd = cancelAd;
exports.cancelAdSuccess = cancelAdSuccess;
exports.cancelAdFailed = cancelAdFailed;
exports.kickAd = kickAd;
exports.kickAdSuccess = kickAdSuccess;
exports.kickAdFailed = kickAdFailed;
exports.triggerPrompt = triggerPrompt;
exports.setActiveAdStatus = setActiveAdStatus;
var REFRESH_ADS_REQUESTED = exports.REFRESH_ADS_REQUESTED = 'REFRESH_ADS_REQUESTED';
var REFRESH_ADS_SUCCESS = exports.REFRESH_ADS_SUCCESS = 'REFRESH_ADS_SUCCESS';
var REFRESH_ADS_FAILED = exports.REFRESH_ADS_FAILED = 'REFRESH_ADS_FAILED';
var FETCH_ADS_REQUESTED = exports.FETCH_ADS_REQUESTED = 'FETCH_ADS_REQUESTED';
var FETCH_ADS_SUCCESS = exports.FETCH_ADS_SUCCESS = 'FETCH_ADS_SUCCESS';
var FETCH_ADS_FAILED = exports.FETCH_ADS_FAILED = 'FETCH_ADS_FAILED';

var REVIEW_AUDIO_ADS_REQUESTED = exports.REVIEW_AUDIO_ADS_REQUESTED = 'REVIEW_AUDIO_ADS_REQUESTED';
var REVIEW_AUDIO_ADS_SUCCESS = exports.REVIEW_AUDIO_ADS_SUCCESS = 'REVIEW_AUDIO_ADS_SUCCESS';
var REVIEW_AUDIO_ADS_FAILED = exports.REVIEW_AUDIO_ADS_FAILED = 'REVIEW_AUDIO_ADS_FAILED';

var UPDATE_PAGING_INFO = exports.UPDATE_PAGING_INFO = 'UPDATE_PAGING_INFO';
var UPDATE_REVIEW_AUDIO_PAGING_INFO = exports.UPDATE_REVIEW_AUDIO_PAGING_INFO = 'UPDATE_REVIEW_AUDIO_PAGING_INFO';
var UPDATE_NAME_FILTER = exports.UPDATE_NAME_FILTER = 'UPDATE_NAME_FILTER';

var FETCH_AD_REQUESTED = exports.FETCH_AD_REQUESTED = 'FETCH_AD_REQUESTED';
var FETCH_AD_SUCCESS = exports.FETCH_AD_SUCCESS = 'FETCH_AD_SUCCESS';
var FETCH_AD_FAILED = exports.FETCH_AD_FAILED = 'FETCH_AD_FAILED';
var FETCH_AD_NOT_FOUND = exports.FETCH_AD_NOT_FOUND = 'FETCH_AD_NOT_FOUND';
var ACTIVE_STATUS_FILTER_UPDATED = exports.ACTIVE_STATUS_FILTER_UPDATED = 'ACTIVE_STATUS_FILTER_UPDATED';

var APPROVE_AD_SUBMITTED = exports.APPROVE_AD_SUBMITTED = 'APPROVE_AD_SUBMITTED';
var APPROVE_AD_SUCCEEDED = exports.APPROVE_AD_SUCCEEDED = 'APPROVE_AD_SUCCEEDED';
var APPROVE_AD_FAILED = exports.APPROVE_AD_FAILED = 'APPROVE_AD_FAILED';
var APPROVE_AD_PROMPTED = exports.APPROVE_AD_PROMPTED = 'APPROVE_AD_PROMPTED';

var REJECT_AD_SUBMITTED = exports.REJECT_AD_SUBMITTED = 'REJECT_AD_SUBMITTED';
var REJECT_AD_SUCCEEDED = exports.REJECT_AD_SUCCEEDED = 'REJECT_AD_SUCCEEDED';
var REJECT_AD_FAILED = exports.REJECT_AD_FAILED = 'REJECT_AD_FAILED';
var REJECT_AD_PROMPTED = exports.REJECT_AD_PROMPTED = 'REJECT_AD_PROMPTED';

var REVISE_AD_SUCCEEDED = exports.REVISE_AD_SUCCEEDED = 'REVISE_AD_SUCCEEDED';
var REVISE_AD_FAILED = exports.REVISE_AD_FAILED = 'REVISE_AD_FAILED';
var REVISE_AD_PROMPTED = exports.REVISE_AD_PROMPTED = 'REVISE_AD_PROMPTED';

var REVISE_VO_SUBMITTED = exports.REVISE_VO_SUBMITTED = 'REVISE_VO_SUBMITTED';
var REVISE_BG_SUBMITTED = exports.REVISE_BG_SUBMITTED = 'REVISE_BG_SUBMITTED';

var CANCEL_AD_SUBMITTED = exports.CANCEL_AD_SUBMITTED = 'CANCEL_AD_SUBMITTED';
var CANCEL_AD_SUCCEEDED = exports.CANCEL_AD_SUCCEEDED = 'CANCEL_AD_SUCCEEDED';
var CANCEL_AD_FAILED = exports.CANCEL_AD_FAILED = 'CANCEL_AD_FAILED';

var KICK_AD_SUBMITTED = exports.KICK_AD_SUBMITTED = 'KICK_AD_SUBMITTED';
var KICK_AD_SUCCEEDED = exports.KICK_AD_SUCCEEDED = 'KICK_AD_SUCCEEDED';
var KICK_AD_FAILED = exports.KICK_AD_FAILED = 'KICK_AD_FAILED';

var RECEIVE_AD = exports.RECEIVE_AD = 'RECEIVE_AD';

function refreshAds(params, wgToken) {
  return {
    type: REFRESH_ADS_REQUESTED,
    payload: {
      params: params,
      wgToken: wgToken
    }
  };
}

function fetchReviewAudioAds(params, wgToken) {
  return {
    type: REVIEW_AUDIO_ADS_REQUESTED,
    payload: {
      params: params,
      wgToken: wgToken
    }
  };
}

function fetchAds(offset, limit, wgToken) {
  return {
    type: FETCH_ADS_REQUESTED,
    payload: {
      offset: offset,
      limit: limit,
      wgToken: wgToken
    }
  };
}

function fetchAd(id, wgToken) {
  return {
    type: FETCH_AD_REQUESTED,
    payload: {
      id: id,
      wgToken: wgToken
    }
  };
}

function fetchAdFailed(err) {
  return {
    type: FETCH_AD_FAILED,
    err: err
  };
}

function fetchAdNotFound(err) {
  return {
    type: FETCH_AD_NOT_FOUND,
    err: err
  };
}

function fetchAdSuccess(ad) {
  return {
    type: FETCH_AD_SUCCESS,
    ad: ad
  };
}

function fetchAdsFailed(err) {
  return {
    type: FETCH_ADS_FAILED,
    err: err
  };
}

function refreshAdsFailed(err) {
  return {
    type: REFRESH_ADS_FAILED,
    err: err
  };
}

function reviewAudioAdsFailed(err) {
  return {
    type: REVIEW_AUDIO_ADS_FAILED,
    err: err
  };
}

function fetchAdsSuccess(ads) {
  return {
    type: FETCH_ADS_SUCCESS,
    ads: ads
  };
}

function refreshAdsSuccess(ads) {
  return {
    type: REFRESH_ADS_SUCCESS,
    ads: ads
  };
}

function reviewAudioAdsSuccess(ads) {
  return {
    type: REVIEW_AUDIO_ADS_SUCCESS,
    ads: ads
  };
}

function updatePagingInfo(paging) {
  return {
    type: UPDATE_PAGING_INFO,
    paging: paging
  };
}

function updateReviewAudioPagingInfo(paging) {
  return {
    type: UPDATE_REVIEW_AUDIO_PAGING_INFO,
    paging: paging
  };
}

function filterAdsByName(pattern) {
  return {
    type: UPDATE_NAME_FILTER,
    pattern: pattern
  };
}

function approveAd(id) {
  return {
    type: APPROVE_AD_SUBMITTED,
    id: id
  };
}

function approveAdSuccess(id) {
  return {
    type: APPROVE_AD_SUCCEEDED,
    id: id
  };
}

function approveAdFailed(err, id) {
  return {
    type: APPROVE_AD_FAILED,
    err: err,
    id: id
  };
}

function reviseVO(id, reviseVOInstructions) {
  return {
    type: REVISE_VO_SUBMITTED,
    id: id,
    reviseVOInstructions: reviseVOInstructions
  };
}

function reviseBGMusic(id, bgAssetId) {
  return {
    type: REVISE_BG_SUBMITTED,
    id: id,
    bgAssetId: bgAssetId
  };
}

function reviseAdSuccess(id) {
  return {
    type: REVISE_AD_SUCCEEDED,
    id: id
  };
}

function reviseAdFailed(err, id) {
  return {
    type: REVISE_AD_FAILED,
    err: err,
    id: id
  };
}

function rejectAd(id, reason) {
  return {
    type: REJECT_AD_SUBMITTED,
    id: id,
    reason: reason
  };
}

function rejectAdSuccess(id) {
  return {
    type: REJECT_AD_SUCCEEDED,
    id: id
  };
}

function rejectAdFailed(err, id) {
  return {
    type: REJECT_AD_FAILED,
    err: err,
    id: id
  };
}

function rejectAdPrompted(id) {
  return {
    type: REJECT_AD_PROMPTED,
    id: id
  };
}

function cancelAd(id) {
  return {
    type: CANCEL_AD_SUBMITTED,
    id: id
  };
}

function cancelAdSuccess(id) {
  return {
    type: CANCEL_AD_SUCCEEDED,
    id: id
  };
}

function cancelAdFailed(err, id) {
  return {
    type: CANCEL_AD_FAILED,
    err: err,
    id: id
  };
}

function kickAd(id) {
  return {
    type: KICK_AD_SUBMITTED,
    id: id
  };
}

function kickAdSuccess(id) {
  return {
    type: KICK_AD_SUCCEEDED,
    id: id
  };
}

function kickAdFailed(err, id) {
  return {
    type: KICK_AD_FAILED,
    err: err,
    id: id
  };
}

function triggerPrompt(id, type) {
  return {
    type: type,
    id: id
  };
}

function setActiveAdStatus(status) {
  return {
    type: ACTIVE_STATUS_FILTER_UPDATED,
    status: status
  };
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getFlags = exports.getFlags = function getFlags(state) {
  return state.featureFlags.flags;
};
var getFlagValue = exports.getFlagValue = function getFlagValue(state, flagName) {
  return getFlags(state)[flagName];
};
var areFlagsLoaded = exports.areFlagsLoaded = function areFlagsLoaded(state) {
  return state.featureFlags.loaded;
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.formatDateWithZeros = formatDateWithZeros;
exports.formatDateFullMonth = formatDateFullMonth;
exports.formatDateWithTime = formatDateWithTime;
exports.daysBetweenDates = daysBetweenDates;
exports.daysFromToday = daysFromToday;
exports.endOfDay = endOfDay;

var _moment = __webpack_require__(85);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Format date strings
 * @param {String} isoDate
 */
function formatDate(isoDate) {
  return (0, _moment2.default)(isoDate).format('ll');
}

function formatDateWithZeros(isoDate) {
  return (0, _moment2.default)(isoDate).format('MMM DD, YYYY');
}

function formatDateFullMonth(isoDate) {
  return (0, _moment2.default)(isoDate).format('MMMM DD, YYYY');
}

function formatDateWithTime(isoDate) {
  return (0, _moment2.default)(isoDate).format('LLL');
}

/**
 * Format date strings
 * @param {String} isoDateStart
 * @param {String} isoDateEnd
 */
function daysBetweenDates(isoDateStart, isoDateEnd) {
  var end = (0, _moment2.default)(isoDateEnd);
  var start = (0, _moment2.default)(isoDateStart);
  return Math.ceil(end.diff(start, 'days', true));
}

/**
 * @param  {Number} days
 * @return {Date}
 */
function daysFromToday(days) {
  var today = new Date();
  today.setDate(today.getDate() + days);
  today.setHours(0, 1, 0, 0);
  return today;
}

/**
 * Set inputted date time to be 11:59PM
 * @param  {Date} date
 * @return {Date}
 */
function endOfDay(date) {
  var newDate = new Date(date);
  newDate.setHours(23, 59, 0, 0);
  return newDate;
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  href: _propTypes2['default'].string,
  onClick: _propTypes2['default'].func,
  onKeyDown: _propTypes2['default'].func,
  disabled: _propTypes2['default'].bool,
  role: _propTypes2['default'].string,
  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: _elementType2['default']
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  (0, _inherits3['default'])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    (0, _classCallCheck3['default'])(this, SafeAnchor);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled', 'onKeyDown']);


    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
    }

    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
      onClick: this.handleClick,
      onKeyDown: (0, _createChainedFunction2['default'])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(_react2['default'].Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

exports['default'] = SafeAnchor;
module.exports = exports['default'];

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_FLAGGED_FIELDS_REQUESTED = exports.VALIDATE_STEP_FIELDS = exports.VALIDATE_FIELDS = undefined;
exports.validateFields = validateFields;
exports.validateStepFields = validateStepFields;
exports.resetValidation = resetValidation;

var _adCreation = __webpack_require__(426);

var VALIDATE_FIELDS = exports.VALIDATE_FIELDS = 'VALIDATE_FIELDS';
var VALIDATE_STEP_FIELDS = exports.VALIDATE_STEP_FIELDS = 'VALIDATE_STEP_FIELDS';
var VALIDATE_FLAGGED_FIELDS_REQUESTED = exports.VALIDATE_FLAGGED_FIELDS_REQUESTED = 'VALIDATE_FLAGGED_FIELDS_REQUESTED';

function validateFields(_ref) {
  var fields = _ref.fields,
      _ref$groups = _ref.groups,
      groups = _ref$groups === undefined ? {} : _ref$groups,
      _ref$initialValidatio = _ref.initialValidation,
      initialValidation = _ref$initialValidatio === undefined ? false : _ref$initialValidatio;

  return {
    type: VALIDATE_FIELDS,
    fields: fields,
    groups: groups,
    initialValidation: initialValidation
  };
}

function validateStepFields(_ref2) {
  var step = _ref2.step,
      fields = _ref2.fields,
      _ref2$groups = _ref2.groups,
      groups = _ref2$groups === undefined ? {} : _ref2$groups;

  return {
    type: VALIDATE_STEP_FIELDS,
    step: step,
    fields: fields,
    groups: groups
  };
}

function resetValidation(_ref3) {
  var groups = _ref3.groups;

  return {
    type: VALIDATE_FIELDS,
    fields: _adCreation.initialFieldsState,
    groups: groups,
    initialValidation: true
  };
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var dP = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(32);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(21)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var call = __webpack_require__(314);
var isArrayIter = __webpack_require__(214);
var anObject = __webpack_require__(15);
var toLength = __webpack_require__(27);
var getIterFn = __webpack_require__(215);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(62);
var redefineAll = __webpack_require__(92);
var meta = __webpack_require__(129);
var forOf = __webpack_require__(156);
var anInstance = __webpack_require__(93);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(23);
var $iterDetect = __webpack_require__(155);
var setToStringTag = __webpack_require__(96);
var inheritIfRequired = __webpack_require__(529);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(38);
var redefine = __webpack_require__(62);
var fails = __webpack_require__(23);
var defined = __webpack_require__(74);
var wks = __webpack_require__(21);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(772);
var objectAssign = __webpack_require__(13);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(793),
    listCacheDelete = __webpack_require__(794),
    listCacheGet = __webpack_require__(795),
    listCacheHas = __webpack_require__(796),
    listCacheSet = __webpack_require__(797);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(292);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(799);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(239);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAdStopped = exports.isAdRejected = exports.canKickAd = exports.canEditAd = exports.canCancelAd = exports.canReviewAd = exports.isAdStateOneOf = exports.getAdState = exports.hasEndDatePassed = exports.hasStartDatePassed = exports.errorRefreshingAds = exports.getAdFilters = exports.refreshingAds = exports.fetchingReviewAudioAds = exports.getReviewAudioTotal = exports.getSortedBy = exports.getSearchWord = exports.getStatusFilter = exports.shouldShowOnboarding = exports.getAdById = exports.getAdsById = exports.getPaging = undefined;

var _user = __webpack_require__(57);

var _utils = __webpack_require__(431);

var _adStatusTypes = __webpack_require__(994);

var getPaging = exports.getPaging = function getPaging(state) {
  return state.ads.paging;
};
var getAdsById = exports.getAdsById = function getAdsById(state) {
  return state.ads.byId;
};
var getAdById = exports.getAdById = function getAdById(state, id) {
  return getAdsById(state)[id];
};
var shouldShowOnboarding = exports.shouldShowOnboarding = function shouldShowOnboarding(state) {
  return state.ads.onboarding.show;
};
var getStatusFilter = exports.getStatusFilter = function getStatusFilter(state) {
  return state.ads.adFilters.status;
};
var getSearchWord = exports.getSearchWord = function getSearchWord(state) {
  return state.ads.adFilters.searchWord;
};
var getSortedBy = exports.getSortedBy = function getSortedBy(state) {
  return state.ads.adFilters.orderBy;
};
var getReviewAudioTotal = exports.getReviewAudioTotal = function getReviewAudioTotal(state) {
  return state.ads.reviewAudioPaging.total;
};
var fetchingReviewAudioAds = exports.fetchingReviewAudioAds = function fetchingReviewAudioAds(state) {
  return state.ads.fetchingReviewAudioList;
};
var refreshingAds = exports.refreshingAds = function refreshingAds(state) {
  return state.ads.refreshingAdList;
};
var getAdFilters = exports.getAdFilters = function getAdFilters(state) {
  return state.ads.adFilters;
};
var errorRefreshingAds = exports.errorRefreshingAds = function errorRefreshingAds(state) {
  return state.ads.refreshAdsError;
};

var hasStartDatePassed = exports.hasStartDatePassed = function hasStartDatePassed(ad) {
  return (0, _utils.hasDatePassed)(ad.dateBegin);
};
var hasEndDatePassed = exports.hasEndDatePassed = function hasEndDatePassed(ad) {
  return (0, _utils.hasDatePassed)(ad.dateEnd);
};
var getAdState = exports.getAdState = function getAdState(ad) {
  return ad.adState;
};
var isAdStateOneOf = exports.isAdStateOneOf = function isAdStateOneOf(ad, states) {
  return states.some(function (state) {
    return state === getAdState(ad);
  });
};
var canReviewAd = exports.canReviewAd = function canReviewAd(ad) {
  return isAdStateOneOf(ad, [_adStatusTypes.REVIEW]);
};
var canCancelAd = exports.canCancelAd = function canCancelAd(ad) {
  return !hasEndDatePassed(ad) && isAdStateOneOf(ad, [_adStatusTypes.READY, _adStatusTypes.ACTIVE]);
};
var canEditAd = exports.canEditAd = function canEditAd(ad) {
  return !hasEndDatePassed(ad) && isAdStateOneOf(ad, [_adStatusTypes.READY, _adStatusTypes.ACTIVE, _adStatusTypes.REVIEW]);
};
var canKickAd = exports.canKickAd = function canKickAd(state, ad) {
  return (0, _user.isAdminUser)(state) && ad.processingFailed;
};
var isAdRejected = exports.isAdRejected = function isAdRejected(ad) {
  return isAdStateOneOf(ad, [_adStatusTypes.REJECTED]);
};
var isAdStopped = exports.isAdStopped = function isAdStopped(ad) {
  return isAdStateOneOf(ad, [_adStatusTypes.STOPPED]);
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(479);

var _values2 = _interopRequireDefault(_values);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _bootstrapUtils = __webpack_require__(17);

var _StyleConfig = __webpack_require__(116);

var _SafeAnchor = __webpack_require__(150);

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  active: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  block: _propTypes2['default'].bool,
  onClick: _propTypes2['default'].func,
  componentClass: _elementType2['default'],
  href: _propTypes2['default'].string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: _propTypes2['default'].oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  (0, _inherits3['default'])(Button, _React$Component);

  function Button() {
    (0, _classCallCheck3['default'])(this, Button);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
      active: active
    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
    var fullClassName = (0, _classnames2['default'])(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(_react2['default'].Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTo = scrollTo;
exports.triggerHardRedirect = triggerHardRedirect;
exports.triggerHardReload = triggerHardReload;
var HARD_REDIRECT_TRIGGERED = exports.HARD_REDIRECT_TRIGGERED = 'HARD_REDIRECT_TRIGGERED';
var SCROLL_TO = exports.SCROLL_TO = 'SCROLL_TO';

function scrollTo(x, y) {
  return {
    type: SCROLL_TO,
    payload: [x, y]
  };
}

function triggerHardRedirect(url) {
  return {
    type: HARD_REDIRECT_TRIGGERED,
    url: url
  };
}

function triggerHardReload() {
  return triggerHardRedirect(window.location.href);
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(425),
    baseKeys = __webpack_require__(404),
    isArrayLike = __webpack_require__(197);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILTERS = exports.FILTERS = ['All ads', 'Active', 'Complete', 'Processing', 'Pending approval', 'Ready', 'Rejected', 'Awaiting review', 'Stopped'];

var ORDERS = exports.ORDERS = {
  ASC: 'asc',
  DESC: 'desc'
};

var DEFAULT_PARAMS = exports.DEFAULT_PARAMS = {
  activePage: 1,
  offset: 0,
  orderBy: 'start date',
  order: ORDERS.DESC,
  searchWord: '',
  status: ''
};

var RESET_PARAMS = exports.RESET_PARAMS = {
  activePage: DEFAULT_PARAMS.activePage,
  orderBy: DEFAULT_PARAMS.orderBy,
  order: DEFAULT_PARAMS.order
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(290);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(59),
    isKey = __webpack_require__(480),
    stringToPath = __webpack_require__(780),
    toString = __webpack_require__(481);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(110),
    isObjectLike = __webpack_require__(121);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(857),
    isObjectLike = __webpack_require__(121);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(389),
    isLength = __webpack_require__(297);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41),
    stubFalse = __webpack_require__(858);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LoadingSpinner = __webpack_require__(470);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingPage = function LoadingPage() {
  return _react2.default.createElement(
    'div',
    { className: 'loading-page' },
    _react2.default.createElement(_LoadingSpinner2.default, { diameter: '150px' })
  );
};

exports.default = LoadingPage;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_REDIRECT_FROM_STORAGE = exports.REDIRECT_FROM_STORAGE = exports.STORE_REDIRECT_VALUES = undefined;
exports.storeRedirectValues = storeRedirectValues;
exports.redirectFromStorage = redirectFromStorage;
exports.clearRedirectFromStorage = clearRedirectFromStorage;

var _moment = __webpack_require__(85);

var _moment2 = _interopRequireDefault(_moment);

var _global = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORE_REDIRECT_VALUES = exports.STORE_REDIRECT_VALUES = 'STORE_REDIRECT_VALUES';
var REDIRECT_FROM_STORAGE = exports.REDIRECT_FROM_STORAGE = 'REDIRECT_FROM_STORAGE';
var CLEAR_REDIRECT_FROM_STORAGE = exports.CLEAR_REDIRECT_FROM_STORAGE = 'CLEAR_REDIRECT_FROM_STORAGE';

function storeRedirectValues() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === undefined ? _global.window.location.href.replace(_global.window.location.origin, '') : _ref$url,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === undefined ? (0, _moment2.default)().add(1, 'day').valueOf() : _ref$timeout,
      _ref$preserveUrlParam = _ref.preserveUrlParams,
      preserveUrlParams = _ref$preserveUrlParam === undefined ? false : _ref$preserveUrlParam;

  return {
    type: STORE_REDIRECT_VALUES,
    payload: {
      url: url,
      timeout: timeout,
      preserveUrlParams: preserveUrlParams
    }
  };
}

function redirectFromStorage() {
  return {
    type: REDIRECT_FROM_STORAGE
  };
}

function clearRedirectFromStorage() {
  return {
    type: CLEAR_REDIRECT_FROM_STORAGE
  };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAudienceSize = fetchAudienceSize;
exports.fetchAudienceSizeSuccess = fetchAudienceSizeSuccess;
exports.fetchAudienceSizeFailed = fetchAudienceSizeFailed;
exports.clearEstimate = clearEstimate;
var FETCH_AUDIENCE_SIZE = exports.FETCH_AUDIENCE_SIZE = 'FETCH_AUDIENCE_SIZE';
var FETCH_AUDIENCE_SIZE_SUCCESS = exports.FETCH_AUDIENCE_SIZE_SUCCESS = 'FETCH_AUDIENCE_SIZE_SUCCESS';
var FETCH_AUDIENCE_SIZE_FAILED = exports.FETCH_AUDIENCE_SIZE_FAILED = 'FETCH_AUDIENCE_SIZE_FAILED';
var CLEAR_AUDIENCE_SIZE_ESTIMATE = exports.CLEAR_AUDIENCE_SIZE_ESTIMATE = 'CLEAR_AUDIENCE_SIZE_ESTIMATE';

function fetchAudienceSize() {
  return {
    type: FETCH_AUDIENCE_SIZE
  };
}

function fetchAudienceSizeSuccess(payload) {
  return {
    type: FETCH_AUDIENCE_SIZE_SUCCESS,
    payload: payload
  };
}

function fetchAudienceSizeFailed(e) {
  return {
    type: FETCH_AUDIENCE_SIZE_FAILED,
    err: e
  };
}

function clearEstimate() {
  return {
    type: CLEAR_AUDIENCE_SIZE_ESTIMATE
  };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRecurringDetail = fetchRecurringDetail;
exports.fetchingPaymentInfo = fetchingPaymentInfo;
exports.fetchingPaymentInfoStopped = fetchingPaymentInfoStopped;
exports.paymentInfoFetched = paymentInfoFetched;
exports.allowFetchRetry = allowFetchRetry;
exports.disallowFetchRetry = disallowFetchRetry;
exports.receivedRecurringDetail = receivedRecurringDetail;
exports.receivedHPPFormDetailsFailed = receivedHPPFormDetailsFailed;
exports.receivedRecurringDetailFailed = receivedRecurringDetailFailed;
exports.receivedRecurringDetailFailedSystemError = receivedRecurringDetailFailedSystemError;
exports.pollingForAdyenDetailConfirmation = pollingForAdyenDetailConfirmation;
exports.pollingForAdyenDetailConfirmationStopped = pollingForAdyenDetailConfirmationStopped;
var ADYEN_RECURRING_DETAIL_RECEIVED = exports.ADYEN_RECURRING_DETAIL_RECEIVED = 'ADYEN_RECURRING_DETAIL_RECEIVED';
var ADYEN_RECURRING_DETAIL_RECEIVED_FAILED = exports.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED = 'ADYEN_RECURRING_DETAIL_RECEIVED_FAILED';
var ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR = exports.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR = 'ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR';
var ADYEN_HPP_FORM_DETAILS_FAILED = exports.ADYEN_HPP_FORM_DETAILS_FAILED = 'ADYEN_HPP_FORM_DETAILS_FAILED';
var POLLING_ADYEN_FOR_DETAIL_CONFIRMATION = exports.POLLING_ADYEN_FOR_DETAIL_CONFIRMATION = 'POLLING_ADYEN_FOR_DETAIL_CONFIRMATION';
var POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED = exports.POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED = 'POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED';
var FETCH_ADYEN_RECURRING_DETAIL = exports.FETCH_ADYEN_RECURRING_DETAIL = 'FETCH_ADYEN_RECURRING_DETAIL';
var FETCHING_PAYMENT_INFO = exports.FETCHING_PAYMENT_INFO = 'FETCHING_PAYMENT_INFO';
var FETCHING_PAYMENT_INFO_STOPPED = exports.FETCHING_PAYMENT_INFO_STOPPED = 'FETCHING_PAYMENT_INFO_STOPPED';
var PAYMENT_INFO_FETCHED = exports.PAYMENT_INFO_FETCHED = 'PAYMENT_INFO_FETCHED';
var ALLOW_FETCH_RETRY = exports.ALLOW_FETCH_RETRY = 'ALLOW_FETCH_RETRY';
var DISALLOW_FETCH_RETRY = exports.DISALLOW_FETCH_RETRY = 'DISALLOW_FETCH_RETRY';

function fetchRecurringDetail() {
  return {
    type: FETCH_ADYEN_RECURRING_DETAIL
  };
}

function fetchingPaymentInfo() {
  return {
    type: FETCHING_PAYMENT_INFO
  };
}

function fetchingPaymentInfoStopped() {
  return {
    type: FETCHING_PAYMENT_INFO_STOPPED
  };
}

function paymentInfoFetched() {
  return {
    type: PAYMENT_INFO_FETCHED
  };
}

function allowFetchRetry() {
  return {
    type: ALLOW_FETCH_RETRY
  };
}

function disallowFetchRetry() {
  return {
    type: DISALLOW_FETCH_RETRY
  };
}

function receivedRecurringDetail(recurringDetail) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED,
    payload: recurringDetail
  };
}

function receivedHPPFormDetailsFailed(err) {
  return {
    type: ADYEN_HPP_FORM_DETAILS_FAILED,
    err: err
  };
}

function receivedRecurringDetailFailed(err) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED_FAILED,
    err: err
  };
}

function receivedRecurringDetailFailedSystemError(err) {
  return {
    type: ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR,
    err: err
  };
}

function pollingForAdyenDetailConfirmation() {
  return {
    type: POLLING_ADYEN_FOR_DETAIL_CONFIRMATION
  };
}

function pollingForAdyenDetailConfirmationStopped() {
  return {
    type: POLLING_ADYEN_FOR_DETAIL_CONFIRMATION_STOPPED
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.updateAdFilters = updateAdFilters;
exports.updateSearchWord = updateSearchWord;
exports.checkAdFilters = checkAdFilters;
var UPDATE_AD_FILTERS = exports.UPDATE_AD_FILTERS = 'UPDATE_AD_FILTERS';
var UPDATE_SEARCH_WORD = exports.UPDATE_SEARCH_WORD = 'UPDATE_SEARCH_WORD';
var CHECK_AD_FILTERS = exports.CHECK_AD_FILTERS = 'CHECK_AD_FILTERS';

function updateAdFilters(params) {
  return {
    type: UPDATE_AD_FILTERS,
    payload: _extends({}, params)
  };
}

function updateSearchWord(params) {
  return {
    type: UPDATE_SEARCH_WORD,
    payload: _extends({}, params)
  };
}

function checkAdFilters(prevState, nextState) {
  return {
    type: CHECK_AD_FILTERS,
    payload: {
      prevState: prevState,
      nextState: nextState
    }
  };
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var document = __webpack_require__(14).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(38);
var uid = __webpack_require__(71);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(94);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(49);
var toLength = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(95);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(209)('keys');
var uid = __webpack_require__(71);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(95);
var toLength = __webpack_require__(27);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(15);
var aFunction = __webpack_require__(72);
var SPECIES = __webpack_require__(21)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(94);
var TAG = __webpack_require__(21)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(97);
var ITERATOR = __webpack_require__(21)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(213);
var ITERATOR = __webpack_require__(21)('iterator');
var Iterators = __webpack_require__(97);
module.exports = __webpack_require__(122).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(99);
var step = __webpack_require__(310);
var Iterators = __webpack_require__(97);
var toIObject = __webpack_require__(49);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(311)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(15);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(48)(Function.call, __webpack_require__(63).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var invoke = __webpack_require__(317);
var html = __webpack_require__(308);
var cel = __webpack_require__(204);
var global = __webpack_require__(14);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(94)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(322);
var defined = __webpack_require__(74);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(21)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(26);
var createDesc = __webpack_require__(70);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(774);

var _PathUtils = __webpack_require__(66);

var _runTransitionHook = __webpack_require__(257);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(170);

var _LocationUtils = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(111);

var _DOMUtils = __webpack_require__(172);

var _DOMStateStorage = __webpack_require__(386);

var _PathUtils = __webpack_require__(66);

var _ExecutionEnvironment = __webpack_require__(259);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toDate;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toDate(date) {
  (0, _assertString2.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}
module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = toString;
function toString(input) {
  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }
  return String(input);
}
module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(143);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    if (/[\uff01-\uff5e]/.test(part)) {
      // disallow full-width chars
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(962),
    stubArray = __webpack_require__(424);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(488);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
(function() {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/*** EXPORTS FROM exports-loader ***/
module.exports = global.fetch;
}.call(global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 282 */
/***/ (function(module, exports) {

var replacements = {

  /**
   * Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  between: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },

  /**
   * Required_if replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_if: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: parameters[0],
      value: parameters[1]
    });
  },

  /**
   * Required_unless replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_unless: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: parameters[0],
      value: parameters[1]
    });
  },

  /**
   * Required_with replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: parameters[0]
    });
  },

  /**
   * Required_with_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with_all: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      fields: parameters.join(', ')
    });
  },

  /**
   * Required_without replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: parameters[0]
    });
  },

  /**
   * Required_without_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without_all: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      fields: parameters.join(', ')
    });
  },

 /**
   * After replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before: this._getAttributeName(parameters[0])
    });
  },

  /**
   * After_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before_or_equal: this._getAttributeName(parameters[0])
    });
  },
};

function formatter(attribute) {
  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
}

module.exports = {
  replacements: replacements,
  formatter: formatter
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'The :attribute must be accepted.',
  after: 'The :attribute must be after :after.',
  after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
  alpha: 'The :attribute field must contain only alphabetic characters.',
  alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
  alpha_num: 'The :attribute field must be alphanumeric.',
  before: 'The :attribute must be before :before.',
  before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
  between: 'The :attribute field must be between :min and :max.',
  confirmed: 'The :attribute confirmation does not match.',
  email: 'The :attribute format is invalid.',
  date: 'The :attribute is not a valid date format.',
  def: 'The :attribute attribute has errors.',
  digits: 'The :attribute must be :digits digits.',
  different: 'The :attribute and :different must be different.',
  'in': 'The selected :attribute is invalid.',
  integer: 'The :attribute must be an integer.',
  min: {
    numeric: 'The :attribute must be at least :min.',
    string: 'The :attribute must be at least :min characters.'
  },
  max: {
    numeric: 'The :attribute may not be greater than :max.',
    string: 'The :attribute may not be greater than :max characters.'
  },
  not_in: 'The selected :attribute is invalid.',
  numeric: 'The :attribute must be a number.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'The :attribute field is required.',
  required_if: 'The :attribute field is required when :other is :value.',
  required_unless: 'The :attribute field is required when :other is not :value.',
  required_with: 'The :attribute field is required when :field is not empty.',
  required_with_all: 'The :attribute field is required when :fields are not empty.',
  required_without: 'The :attribute field is required when :field is empty.',
  required_without_all: 'The :attribute field is required when :fields are empty.',
  same: 'The :attribute and :same fields must match.',
  size: {
    numeric: 'The :attribute must be :size.',
    string: 'The :attribute must be :size characters.'
  },
  string: 'The :attribute must be a string.',
  url: 'The :attribute format is invalid.',
  regex: 'The :attribute format is invalid.',
  attributes: {}
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(195);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyContainer = exports.Sticky = undefined;

var _Sticky = __webpack_require__(843);

var _Sticky2 = _interopRequireDefault(_Sticky);

var _Container = __webpack_require__(844);

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Sticky = _Sticky2.default;
exports.StickyContainer = _Container2.default;
exports.default = _Sticky2.default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAYLIST_CAT = exports.GENRE = exports.GEO = undefined;
exports.createPlaceholder = createPlaceholder;
exports.uploadFileToStorage = uploadFileToStorage;
exports.fetchVoiceovers = fetchVoiceovers;
exports.postAd = postAd;
exports.createAd = createAd;
exports.editAd = editAd;
exports.fetchTargeting = fetchTargeting;
exports.fetchStockMusic = fetchStockMusic;
exports.searchGeos = searchGeos;

var _queryString = __webpack_require__(171);

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GEO = exports.GEO = 'geo';
var GENRE = exports.GENRE = 'genre';
var PLAYLIST_CAT = exports.PLAYLIST_CAT = 'moment';

/**
 * @param {String} type
 */
function createPlaceholder(type, mediaType, wgToken) {
  var url = 'adgenerator/v1/fileUpload/' + type + '?mediaType=' + mediaType;
  var opts = { method: 'POST' };
  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    return r.json();
  }).then(function (r) {
    return {
      id: r.id,
      action: r.uploadForm.action,
      fields: r.uploadForm.fields,
      uri: r.uri
    };
  });
}

/**
 * @param {Object} data
 * @param {String} data.url
 * @param {String} data.formData
 * @param {Function} progressCb
 * @return {Promise}
 */
function uploadFileToStorage(data, progressCb) {
  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.upload.addEventListener('progress', function (e) {
      progressCb(100.0 * e.loaded / e.total);
    });
    req.addEventListener('load', resolve);
    req.addEventListener('error', reject);
    req.open('post', data.url);
    req.send(data.formData);
  });
}

/**
 * @param {String} query
 */
function fetchVoiceovers(query, wgToken) {
  var url = 'adgenerator/v1/audiocomponent/voiceover/?name=' + query;
  return (0, _callWebGate2.default)(url, wgToken).then(function (r) {
    if (!r.ok) return r.text().then(function (e) {
      throw Error(e);
    });
    return r.json();
  });
}

/**
 * @param {Object} data
 * @param {String} wgToken
 */
function postAd(data, wgToken, url) {
  var opts = {
    method: 'POST',
    body: JSON.stringify(data)
  };
  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return r.text().then(function (e) {
      throw Error(e);
    });
    return r;
  });
}

function createAd(ad, wgToken) {
  var url = 'adgenerator/v1/ads';
  return postAd(ad, wgToken, url);
}

function editAd(id, ad, wgToken) {
  var url = 'adgenerator/v1/ads/' + id + '/edit';
  return postAd(ad, wgToken, url);
}

function fetchTargeting(field, wgToken) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      envOverride = _ref.envOverride;

  var url = 'adgenerator/v1/targeting/' + field;
  return (0, _callWebGate2.default)(url, wgToken, {}, envOverride).then(function (r) {
    if (!r.ok) return r.json().then(function (e) {
      return Promise.reject(e);
    });
    return r.json();
  });
}

function fetchStockMusic(wgToken) {
  var url = 'adgenerator/v1/audiocomponent/bgmusic/stockmusic';
  return (0, _callWebGate2.default)(url, wgToken).then(function (r) {
    return r.ok ? r.json() : r.json().then(Promise.reject);
  });
}

function searchGeos(query, wgToken) {
  var params = { query: query };
  var url = 'geosearch/v1/search/name?' + (0, _queryString.stringify)(params);
  return (0, _callWebGate2.default)(url, wgToken).then(function (r) {
    return r.ok ? r.json() : r.json().then(Promise.reject);
  });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGenresSuccess = fetchGenresSuccess;
exports.fetchGenresFailed = fetchGenresFailed;
exports.fetchPlaylistCategoriesSuccess = fetchPlaylistCategoriesSuccess;
exports.fetchPlaylistCategoriesFailed = fetchPlaylistCategoriesFailed;
exports.fetchGeosSuccess = fetchGeosSuccess;
exports.fetchGeosFailed = fetchGeosFailed;
exports.fetchStockMusic = fetchStockMusic;
exports.fetchStockMusicSuccess = fetchStockMusicSuccess;
exports.fetchStockMusicFailed = fetchStockMusicFailed;
var FETCH_GENRES_SUCCESS = exports.FETCH_GENRES_SUCCESS = 'FETCH_GENRES_SUCCESS';
var FETCH_GENRES_FAILED = exports.FETCH_GENRES_FAILED = 'FETCH_GENRES_FAILED';
var FETCH_PLAYLIST_CAT_SUCCESS = exports.FETCH_PLAYLIST_CAT_SUCCESS = 'FETCH_PLAYLIST_CAT_SUCCESS';
var FETCH_PLAYLIST_CAT_FAILED = exports.FETCH_PLAYLIST_CAT_FAILED = 'FETCH_PLAYLIST_CAT_FAILED';
var FETCH_GEOS_SUCCESS = exports.FETCH_GEOS_SUCCESS = 'FETCH_GEOS_SUCCESS';
var FETCH_GEOS_FAILED = exports.FETCH_GEOS_FAILED = 'FETCH_GEOS_FAILED';
var FETCH_STOCK_MUSIC_SUCCESS = exports.FETCH_STOCK_MUSIC_SUCCESS = 'FETCH_STOCK_MUSIC_SUCCESS';
var FETCH_STOCK_MUSIC_FAILED = exports.FETCH_STOCK_MUSIC_FAILED = 'FETCH_STOCK_MUSIC_FAILED';
var FETCH_STOCK_MUSIC_REQUESTED = exports.FETCH_STOCK_MUSIC_REQUESTED = 'FETCH_STOCK_MUSIC_REQUESTED';

function fetchGenresSuccess(genres) {
  return {
    type: FETCH_GENRES_SUCCESS,
    genres: genres
  };
}

function fetchGenresFailed(err) {
  return {
    type: FETCH_GENRES_FAILED,
    err: err
  };
}

function fetchPlaylistCategoriesSuccess(categories) {
  return {
    type: FETCH_PLAYLIST_CAT_SUCCESS,
    categories: categories
  };
}

function fetchPlaylistCategoriesFailed(err) {
  return {
    type: FETCH_PLAYLIST_CAT_FAILED,
    err: err
  };
}

function fetchGeosSuccess(geos) {
  return {
    type: FETCH_GEOS_SUCCESS,
    geos: geos
  };
}

function fetchGeosFailed(err) {
  return {
    type: FETCH_GEOS_FAILED,
    err: err
  };
}

function fetchStockMusic() {
  return {
    type: FETCH_STOCK_MUSIC_REQUESTED
  };
}

function fetchStockMusicSuccess(tracks) {
  return {
    type: FETCH_STOCK_MUSIC_SUCCESS,
    tracks: tracks
  };
}

function fetchStockMusicFailed(err) {
  return {
    type: FETCH_STOCK_MUSIC_FAILED,
    err: err
  };
}

/***/ }),
/* 288 */,
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(682)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)os/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/chrome.+? edge/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && !result.msedge && (android || result.silk)) {
      result.android = t
    } else if (!result.windowsphone && !result.msedge && iosdevice) {
      result[iosdevice] = t
      result.ios = t
    } else if (mac) {
      result.mac = t
    } else if (xbox) {
      result.xbox = t
    } else if (windows) {
      result.windows = t
    } else if (linux) {
      result.linux = t
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  return bowser
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(194),
    toKey = __webpack_require__(284);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(782),
    mapCacheDelete = __webpack_require__(798),
    mapCacheGet = __webpack_require__(800),
    mapCacheHas = __webpack_require__(801),
    mapCacheSet = __webpack_require__(802);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAMPAIGN_FORM_NAME = exports.CAMPAIGN_FORM_NAME = 'build-ad-campaign-step';
var AUDIENCE_FORM_NAME = exports.AUDIENCE_FORM_NAME = 'build-ad-audience-step';

var CAMPAIGN_FIELDS = exports.CAMPAIGN_FIELDS = ['objective', 'internalName'];
var AUDIENCE_FIELDS = exports.AUDIENCE_FIELDS = ['targeting', 'dateRange', 'payments', 'paymentsConnected'];

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://abtesting.spotify.net/features/2522
var CITY_TARGETING = exports.CITY_TARGETING = 'adstudio-city-targeting';

// https://abtesting.spotify.net/features/2498
var ADGEN_PRICER = exports.ADGEN_PRICER = 'adgen-pricer';

// https://abtesting.spotify.net/features/2581
var FAN_TARGETING = exports.FAN_TARGETING = 'adstudio-fan-targeting';

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalAlerts = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _bowser = __webpack_require__(289);

var _bowser2 = _interopRequireDefault(_bowser);

var _recompose = __webpack_require__(186);

var _config = __webpack_require__(30);

var _adBlocker = __webpack_require__(847);

var _auth = __webpack_require__(36);

var _network = __webpack_require__(473);

var _OfflineAlert = __webpack_require__(848);

var _OfflineAlert2 = _interopRequireDefault(_OfflineAlert);

var _AdBlockerAlert = __webpack_require__(849);

var _AdBlockerAlert2 = _interopRequireDefault(_AdBlockerAlert);

var _BrowserSupportAlert = __webpack_require__(850);

var _BrowserSupportAlert2 = _interopRequireDefault(_BrowserSupportAlert);

var _RegionSupportAlert = __webpack_require__(851);

var _RegionSupportAlert2 = _interopRequireDefault(_RegionSupportAlert);

var _AlertBar = __webpack_require__(118);

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * IF YOU WANT TO ALERT TO ALL USERS:
 * 1. update our alert.txt file in S3 and set the permissions to allow access:
 *    https://s3.amazonaws.com/voltron-ui/alert/alert.txt.
 *    Instructions: https://confluence.spotify.net/display/CREAM/AdStudio+Admin+Alerting
 * 2. if S3 is down, you can set a value in the ADMIN_ALERT_OVERRIDE constant below to
 *    provide an admin alert from the code.
 * If both an alert.txt and the constant in code are set, the constant will win.
 */

var ADMIN_ALERT_OVERRIDE = null;

var GlobalAlerts = exports.GlobalAlerts = function GlobalAlerts(_ref) {
  var adBlockerDetected = _ref.adBlockerDetected,
      adminAlertText = _ref.adminAlertText,
      isOffline = _ref.isOffline,
      showBrowserSupportAlert = _ref.showBrowserSupportAlert,
      isUnsupportedRegion = _ref.isUnsupportedRegion;
  return _react2.default.createElement(
    'div',
    { className: 'global-alert-container' },
    isOffline && _react2.default.createElement(_OfflineAlert2.default, null),
    adBlockerDetected && _react2.default.createElement(_AdBlockerAlert2.default, null),
    showBrowserSupportAlert && _react2.default.createElement(_BrowserSupportAlert2.default, null),
    isUnsupportedRegion && _react2.default.createElement(_RegionSupportAlert2.default, null),
    !!adminAlertText && _react2.default.createElement(
      _AlertBar2.default,
      { alertType: 'warning' },
      adminAlertText
    )
  );
};

GlobalAlerts.propTypes = {
  adBlockerDetected: _propTypes2.default.bool,
  adminAlertText: _propTypes2.default.string,
  isOffline: _propTypes2.default.bool,
  isUnsupportedRegion: _propTypes2.default.bool,
  showBrowserSupportAlert: _propTypes2.default.bool
};

GlobalAlerts.defaultProps = {
  showBrowserSupportAlert: !_bowser2.default.check(_config.SUPPORTED_BROWSER_VERSIONS) || _bowser2.default.mobile
};

function mapStateToProps(state) {
  return {
    adBlockerDetected: (0, _adBlocker.hasAdBlocker)(state),
    adminAlertText: state.adminAlert.text,
    isOffline: !(0, _network.getIsOnline)(state),
    isUnsupportedRegion: !(0, _auth.isUserInSupportedRegion)(state)
  };
}

exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps),
// if you set ADMIN_ALERT_OVERRIDE above, use the value from it instead of the
// value from alert.txt on S3 to supply an error.
(0, _recompose.branch)(function () {
  return ADMIN_ALERT_OVERRIDE;
}, (0, _recompose.withProps)({ adminAlertText: ADMIN_ALERT_OVERRIDE })))(GlobalAlerts);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(853),
    Map = __webpack_require__(261),
    Promise = __webpack_require__(854),
    Set = __webpack_require__(855),
    WeakMap = __webpack_require__(856),
    baseGetTag = __webpack_require__(110),
    toSource = __webpack_require__(390);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(859),
    baseUnary = __webpack_require__(860),
    nodeUtil = __webpack_require__(861);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(916);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(430);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationForReduxForm = exports.getReduxFormValues = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxForm = __webpack_require__(67);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// combines all redux forms currently into the store into a map by name
var getReduxFormValues = exports.getReduxFormValues = function getReduxFormValues(state) {
  return Object.keys(state.form).reduce(function (result, formName) {
    return _extends({}, result, _defineProperty({}, formName, (0, _reduxForm.getFormValues)(formName)(state)));
  }, {});
};

// returns a validation object matching the old style for a given form name
var getValidationForReduxForm = exports.getValidationForReduxForm = function getValidationForReduxForm(state, formName) {
  return {
    touched: (0, _reduxForm.isDirty)(formName)(state),
    isValid: (0, _reduxForm.isValid)(formName)(state)
  };
};

/***/ }),
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(32) && !__webpack_require__(23)(function () {
  return Object.defineProperty(__webpack_require__(204)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(32);
var LIBRARY = __webpack_require__(91);
var $typed = __webpack_require__(205);
var hide = __webpack_require__(38);
var redefineAll = __webpack_require__(92);
var fails = __webpack_require__(23);
var anInstance = __webpack_require__(93);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(27);
var toIndex = __webpack_require__(306);
var gOPN = __webpack_require__(124).f;
var dP = __webpack_require__(26).f;
var arrayFill = __webpack_require__(211);
var setToStringTag = __webpack_require__(96);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(27);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(33);
var toIObject = __webpack_require__(49);
var arrayIndexOf = __webpack_require__(207)(false);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(14).document;
module.exports = document && document.documentElement;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(94);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(91);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(62);
var hide = __webpack_require__(38);
var has = __webpack_require__(33);
var Iterators = __webpack_require__(97);
var $iterCreate = __webpack_require__(519);
var setToStringTag = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(126);
var ITERATOR = __webpack_require__(21)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(95);
var toLength = __webpack_require__(27);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(26).f;
var create = __webpack_require__(125);
var redefineAll = __webpack_require__(92);
var ctx = __webpack_require__(48);
var anInstance = __webpack_require__(93);
var forOf = __webpack_require__(156);
var $iterDefine = __webpack_require__(311);
var step = __webpack_require__(310);
var setSpecies = __webpack_require__(154);
var DESCRIPTORS = __webpack_require__(32);
var fastKey = __webpack_require__(129).fastKey;
var validate = __webpack_require__(100);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(15);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(98);
var gOPS = __webpack_require__(158);
var pIE = __webpack_require__(128);
var toObject = __webpack_require__(75);
var IObject = __webpack_require__(206);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(23)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(92);
var getWeak = __webpack_require__(129).getWeak;
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(18);
var anInstance = __webpack_require__(93);
var forOf = __webpack_require__(156);
var createArrayMethod = __webpack_require__(127);
var $has = __webpack_require__(33);
var validate = __webpack_require__(100);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(124);
var gOPS = __webpack_require__(158);
var anObject = __webpack_require__(15);
var Reflect = __webpack_require__(14).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(72);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(21);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(74);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(18);
var cof = __webpack_require__(94);
var MATCH = __webpack_require__(21)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(18);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(98);
var toIObject = __webpack_require__(49);
var isEnum = __webpack_require__(128).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(27);
var repeat = __webpack_require__(321);
var defined = __webpack_require__(74);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */
var format = __webpack_require__(672);
var removeLeadingSlash = __webpack_require__(675);
var trim = __webpack_require__(348);

var warn = __webpack_require__(349);
var log = __webpack_require__(676);

var _debug = false;
var _titleCase = true;

var _format = function (s) {
  return format(s, _titleCase);
};

var ReactGA = {
  initialize: function (gaTrackingID, options) {
    if (!gaTrackingID) {
      warn('gaTrackingID is required in initialize()');
      return;
    }

    if (options) {
      if (options.debug && options.debug === true) {
        _debug = true;
      }

      if (options.titleCase === false) {
        _titleCase = false;
      }
    }

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
    // jscs:disable
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o),
          m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    // jscs:enable

    if (options && options.gaOptions) {
      ga('create', gaTrackingID, options.gaOptions);
    } else {
      ga('create', gaTrackingID, 'auto');
    }

  },

  /**
   * set:
   * GA tracker set method
   * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
   */
  set: function (fieldsObject) {
    if (typeof ga === 'function') {
      if (!fieldsObject) {
        warn('`fieldsObject` is required in .set()');
        return;
      }

      if (typeof fieldsObject !== 'object') {
        warn('Expected `fieldsObject` arg to be an Object');
        return;
      }

      if (Object.keys(fieldsObject).length === 0) {
        warn('empty `fieldsObject` given to .set()');
      }

      ga('set', fieldsObject);

      if (_debug) {
        log('called ga(\'set\', fieldsObject);');
        log('with fieldsObject: ' + JSON.stringify(fieldsObject));
      }
    }
  },

  /**
   * send:
   * Clone of the low level `ga.send` method
   * WARNING: No validations will be applied to this
   * @param  {Object} fieldObject - field object for tracking different analytics
   */
  send: function (fieldObject) {
    if (typeof ga === 'function') {
      ga('send', fieldObject);

      if (_debug) {
        log('called ga(\'send\', fieldObject);');
        log('with fieldObject: ' + JSON.stringify(fieldObject));
      }
    }
  },

  /**
   * pageview:
   * Basic GA pageview tracking
   * @param  {String} path - the current page page e.g. '/about'
   */
  pageview: function (path) {
    if (!path) {
      warn('path is required in .pageview()');
      return;
    }

    path = trim(path);
    if (path === '') {
      warn('path cannot be an empty string in .pageview()');
      return;
    }

    if (typeof ga === 'function') {
      ga('send', 'pageview', path);

      if (_debug) {
        log('called ga(\'send\', \'pageview\', path);');
        log('with path: ' + path);
      }
    }
  },

  /**
   * modalview:
   * a proxy to basic GA pageview tracking to consistently track
   * modal views that are an equivalent UX to a traditional pageview
   * @param  {String} modalName e.g. 'add-or-edit-club'
   */
  modalview: function (modalName) {
    if (!modalName) {
      warn('modalName is required in .modalview(modalName)');
      return;
    }

    modalName = trim(modalName);
    modalName = removeLeadingSlash(modalName);

    if (modalName === '') {
      warn('modalName cannot be an empty string or a single / in .modalview()');
      return;
    }

    if (typeof ga === 'function') {
      modalName = trim(modalName);
      var path = '/modal/' + modalName;
      ga('send', 'pageview', path);

      if (_debug) {
        log('called ga(\'send\', \'pageview\', path);');
        log('with path: ' + path);
      }
    }
  },

  /**
   * timing:
   * GA timing
   * @param args.category {String} required
   * @param args.variable {String} required
   * @param args.value  {Int}  required
   * @param args.label  {String} required
   */
  timing: function (args) {
    if (typeof ga === 'function') {
      if (!args || !args.category || !args.variable
          || !args.value || typeof args.value !== 'number') {
        warn('args.category, args.variable ' +
              'AND args.value are required in timing() ' +
              'AND args.value has to be a number');
        return;
      }

      //Required Fields
      var fieldObject = {
        hitType: 'timing',
        timingCategory: _format(args.category),
        timingVar: _format(args.variable),
        timingValue: args.value
      };

      if (args.label) {
        fieldObject.timingLabel = _format(args.label);
      }

      this.send(fieldObject);
    }
  },

  /**
   * event:
   * GA event tracking
   * @param args.category {String} required
   * @param args.action {String} required
   * @param args.label {String} optional
   * @param args.value {Int} optional
   * @param args.nonInteraction {boolean} optional
   */
  event: function (args) {
    if (typeof ga === 'function') {

      // Simple Validation
      if (!args || !args.category || !args.action) {
        warn('args.category AND args.action are required in event()');
        return;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'event',
        eventCategory: _format(args.category),
        eventAction: _format(args.action)
      };

      // Optional Fields
      if (args.label) {
        fieldObject.eventLabel = _format(args.label);
      }

      if (args.value) {
        if (typeof args.value !== 'number') {
          warn('Expected `args.value` arg to be a Number.');
        } else {
          fieldObject.eventValue = args.value;
        }
      }

      if (args.nonInteraction) {
        if (typeof args.nonInteraction !== 'boolean') {
          warn('`args.nonInteraction` must be a boolean.');
        } else {
          fieldObject.nonInteraction = args.nonInteraction;
        }
      }

      // Send to GA
      this.send(fieldObject);
    }
  },

  /**
   * exception:
   * GA exception tracking
   * @param args.description {String} optional
   * @param args.fatal {boolean} optional
   */
  exception: function (args) {
    if (typeof ga === 'function') {

      // Required Fields
      var fieldObject = {
        hitType: 'exception'
      };

      // Optional Fields
      if (args.description) {
        fieldObject.exDescription = _format(args.description);
      }

      if (typeof args.fatal !== 'undefined') {
        if (typeof args.fatal !== 'boolean') {
          warn('`args.fatal` must be a boolean.');
        } else {
          fieldObject.exFatal = args.fatal;
        }
      }

      // Send to GA
      this.send(fieldObject);
    }
  },

  plugin: {
    /**
     * require:
     * GA requires a plugin
     * @param name {String} e.g. 'ecommerce' or 'myplugin'
     * @param options {Object} optional e.g {path: '/log', debug: true}
     */
    require: function (name, options) {
      if (typeof ga === 'function') {

        // Required Fields
        if (!name) {
          warn('`name` is required in .require()');
          return;
        }

        name = trim(name);
        if (name === '') {
          warn('`name` cannot be an empty string in .require()');
          return;
        }

        // Optional Fields
        if (options) {
          if (typeof options !== 'object') {
            warn('Expected `options` arg to be an Object');
            return;
          }

          if (Object.keys(options).length === 0) {
            warn('Empty `options` given to .require()');
          }

          ga('require', name, options);

          if (_debug) {
            log('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options) + ');');
          }

          return;
        } else {
          ga('require', name);

          if (_debug) {
            log('called ga(\'require\', \'' + name + '\');');
          }

          return;
        }
      }
    },

    /**
     * execute:
     * GA execute action for plugin
     * Takes variable number of arguments
     * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
     * @param action {String} e.g. 'addItem' or 'myCustomAction'
     * @param actionType {String} optional e.g. 'detail'
     * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
     */
    execute: function () {
      var args = Array.prototype.slice.call(arguments);

      var pluginName = args[0];
      var action = args[1];
      var payload;
      var actionType;

      if (args.length === 3) {
        payload = args[2];
      } else {
        actionType = args[2];
        payload = args[3];
      }

      if (typeof ga === 'function') {
        if (typeof pluginName !== 'string') {
          warn('Expected `pluginName` arg to be a String.');
        } else if (typeof action !== 'string') {
          warn('Expected `action` arg to be a String.');
        } else {
          var command = pluginName + ':' + action;
          payload = payload || null;
          if (actionType && payload) {
            ga(command, actionType, payload);
            if (_debug) {
              log('called ga(\'' + command + '\');');
              log('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
            }
          } else if (payload) {
            ga(command, payload);
            if (_debug) {
              log('called ga(\'' + command + '\');');
              log('with payload: ' + JSON.stringify(payload));
            }
          } else {
            ga(command);
            if (_debug) {
              log('called ga(\'' + command + '\');');
            }

          }
        }
      }
    }
  },

  /**
   * outboundLink:
   * GA outboundLink tracking
   * @param args.label {String} e.g. url, or 'Create an Account'
   * @param {function} hitCallback - Called after processing a hit.
   */
  outboundLink: function (args, hitCallback) {
    if (typeof hitCallback !== 'function') {
      warn('hitCallback function is required');
      return;
    }

    if (typeof ga === 'function') {

      // Simple Validation
      if (!args || !args.label) {
        warn('args.label is required in outboundLink()');
        return;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'event',
        eventCategory: 'Outbound',
        eventAction: 'Click',
        eventLabel: _format(args.label)
      };

      var safetyCallbackCalled = false;
      var safetyCallback = function () {

        // This prevents a delayed response from GA
        // causing hitCallback from being fired twice
        safetyCallbackCalled = true;

        hitCallback();
      };

      // Using a timeout to ensure the execution of critical application code
      // in the case when the GA server might be down
      // or an ad blocker prevents sending the data

      // register safety net timeout:
      var t = setTimeout(safetyCallback, 250);

      var clearableCallbackForGA = function () {
        clearTimeout(t);
        if (!safetyCallbackCalled) {
          hitCallback();
        }
      };

      fieldObject.hitCallback = clearableCallbackForGA;

      // Send to GA
      this.send(fieldObject);
    } else {
      // if ga is not defined, return the callback so the application
      // continues to work as expected
      setTimeout(hitCallback, 0);
    }
  }
};

var OutboundLink = __webpack_require__(677);
OutboundLink.origTrackLink = OutboundLink.trackLink;
OutboundLink.trackLink = ReactGA.outboundLink.bind(ReactGA);
ReactGA.OutboundLink = OutboundLink;

module.exports = ReactGA;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

module.exports = trim;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

function warn(s) {
  console.warn('[react-ga]', s);
}

module.exports = warn;


/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(171);

var _runTransitionHook = __webpack_require__(257);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(111);

var _PathUtils = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(257);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveCurrentRoute = saveCurrentRoute;
var SAVE_CURRENT_ROUTE = exports.SAVE_CURRENT_ROUTE = 'SAVE_CURRENT_ROUTE';

function saveCurrentRoute(route) {
  return {
    type: SAVE_CURRENT_ROUTE,
    payload: {
      route: route
    }
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getComponentForImport = getComponentForImport;
exports.mapPropsFromRoute = mapPropsFromRoute;

var _get = __webpack_require__(193);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * this method takes a function that returns the import promise,
 * and returns a function to be used as a <Route />'s getComponent prop.
 *
 *   <Route getComponent={getComponentForImport(() => import('whatever'))} />
 *
 * this is written this way to make defining import functions
 * with chunk comments easier, providing a simple way to configure
 * chunk groupings. below this function, you'll see some predefined
 * import functions grouped by chunk.
 **/
function getComponentForImport(promiseFn) {
  // the return value should be used as the getComponent function
  return function (location, cb) {
    return promiseFn().then(function (module) {
      return cb(null, module.default);
    }).catch(function (error) {
      return cb(error);
    });
  };
}

/**
 * use with recompose.withProps to normalize props passed from a react-router route
 * and props directly passed to a component.
 *
 * <MyComponent a="1" />
 * <Route path="/your-route" component={MyComponent} a="1" />
 *
 * usage:
 *   withProps(ownProps => mapPropsFromRoute(ownProps, ['a']))(MyComponent);
 */
function mapPropsFromRoute(ownProps, propNames) {
  return propNames.reduce(function (result, propName) {
    return _extends({}, result, _defineProperty({}, propName, (0, _get2.default)(ownProps, propName) || (0, _get2.default)(ownProps, 'route.' + propName)));
  }, {});
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(110),
    isObject = __webpack_require__(115);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(182),
    nativeKeys = __webpack_require__(852);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toFloat;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toFloat(str) {
  (0, _assertString2.default)(str);
  return parseFloat(str);
}
module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(143);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(407);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(271);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 256 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }
    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::

    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.
    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    }
    // initial or final ::
    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }
        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
        // it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }
    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }
    return blocks.length === expectedNumberOfBlocks;
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alpha = exports.alpha = {
  'en-US': /^[A-Z]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'nl-NL': /^[A-ZÉËÏÓÖÜ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};

var alphanumeric = exports.alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nl-NL': /^[0-9A-ZÉËÏÓÖÜ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};

var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = 'en-' + englishLocales[i];
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
}

alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];

// Source: http://www.localeplanet.com/java/
var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = 'ar-' + arabicLocales[_i];
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullWidth = undefined;
exports.default = isFullWidth;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;

function isFullWidth(str) {
  (0, _assertString2.default)(str);
  return fullWidth.test(str);
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.halfWidth = undefined;
exports.default = isHalfWidth;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;

function isHalfWidth(str) {
  (0, _assertString2.default)(str);
  return halfWidth.test(str);
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexadecimal;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexadecimal = /^[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString2.default)(str);
  return hexadecimal.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iso8601 = undefined;

exports.default = function (str) {
  (0, _assertString2.default)(str);
  return iso8601.test(str);
};

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
// from http://goo.gl/0ejHHW
var iso8601 = exports.iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ltrim;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ltrim(str, chars) {
  (0, _assertString2.default)(str);
  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
  return str.replace(pattern, '');
}
module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rtrim;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rtrim(str, chars) {
  (0, _assertString2.default)(str);
  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;

  var idx = str.length - 1;
  while (idx >= 0 && pattern.test(str[idx])) {
    idx--;
  }

  return idx < str.length ? str.substr(0, idx + 1) : str;
}
module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blacklist;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blacklist(str, chars) {
  (0, _assertString2.default)(str);
  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
}
module.exports = exports['default'];

/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNetworkStatus = updateNetworkStatus;
var NETWORK_STATUS = exports.NETWORK_STATUS = 'NETWORK_STATUS';

function updateNetworkStatus(status) {
  return {
    type: NETWORK_STATUS,
    status: status
  };
}

/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedirectingPage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EmptyPage = __webpack_require__(506);

var _EmptyPage2 = _interopRequireDefault(_EmptyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedirectingPage = exports.RedirectingPage = function RedirectingPage() {
  return _react2.default.createElement(_EmptyPage2.default, { title: 'Redirecting...' });
};

exports.default = RedirectingPage;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(275),
    isArray = __webpack_require__(59);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(963),
    isArguments = __webpack_require__(196),
    isArray = __webpack_require__(59),
    isBuffer = __webpack_require__(198),
    isIndex = __webpack_require__(492),
    isTypedArray = __webpack_require__(298);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialFieldsState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uploads, _audioSubmission;

exports.default = fields;

var _dateHelper = __webpack_require__(149);

var _utilities = __webpack_require__(46);

var _reactRouterRedux = __webpack_require__(60);

var _editableAd = __webpack_require__(47);

var _config = __webpack_require__(30);

var _uploadProperties = __webpack_require__(117);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialFieldsState = exports.initialFieldsState = {
  name: '',
  clickthroughUrl: '',
  internalName: '',
  objective: '',
  uploads: (_uploads = {}, _defineProperty(_uploads, _config.UPLOADED_COVER_ART, (0, _uploadProperties.createDefaultImageUploadObj)()), _defineProperty(_uploads, _config.UPLOADED_AUDIO, (0, _uploadProperties.createDefaultAudioUploadObj)()), _defineProperty(_uploads, _config.BG_MUSIC, (0, _uploadProperties.createDefaultAudioUploadObj)()), _defineProperty(_uploads, _config.EXISTING_VO_BG_MUSIC, (0, _uploadProperties.createDefaultAudioUploadObj)()), _uploads),
  audioSubmission: (_audioSubmission = {
    active: _config.DEFAULT_AUDIO
  }, _defineProperty(_audioSubmission, _config.EXISTING_VOICEOVER, {
    data: {
      id: '',
      uri: '',
      name: ''
    },
    bgMusic: {}
  }), _defineProperty(_audioSubmission, _config.NEW_VOICEOVER, {
    name: '',
    transcript: '',
    instructions: '',
    locale: '',
    voice: '',
    bgMusic: {}
  }), _audioSubmission),
  targeting: {
    locations: [],
    platforms: (0, _utilities.fillObject)(Object.keys(_config.PLATFORMS), true),
    gender: _config.ALL_GENDERS_VALUE,
    ageRange: {
      start: '13',
      end: '65'
    },
    fanAudiences: [],
    moments: [],
    genres: [],
    freeTrial: _config.FREE_TRIAL_NULL_VALUE
  },
  dateRange: {
    begin: (0, _dateHelper.daysFromToday)(2),
    end: (0, _dateHelper.endOfDay)((0, _dateHelper.daysFromToday)(2))
  },
  payments: {},
  activeStep: parseInt(window.location.pathname.split('/')[2], 10) || 1
};

function populateFields(state, action) {
  return _extends({}, state, action.state);
}

function fields() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFieldsState;
  var action = arguments[1];

  var newState = void 0;

  switch (action.type) {
    case _editableAd.UPDATE_FIELDS:
      return (0, _utilities.unflattenAssign)(action.field.key, action.field.value, state);
    case _editableAd.RESET_FIELDS:
      return _extends({}, state, initialFieldsState);
    case _editableAd.POPULATE_FIELDS:
      return populateFields(state, action);
    case _reactRouterRedux.LOCATION_CHANGE:
      return _extends({}, state, {
        activeStep: parseInt(action.payload.pathname.split('/')[2], 10) || 1
      });
    case _editableAd.LOAD_AD:
      {
        newState = _extends({}, state, action.payload);

        var _newState$dateRange = newState.dateRange,
            begin = _newState$dateRange.begin,
            end = _newState$dateRange.end;


        newState.dateRange.begin = new Date(begin);
        newState.dateRange.end = new Date(end);

        return newState;
      }
    default:
      return state;
  }
}

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasDatePassed = exports.getStateTree = undefined;

var _moment = __webpack_require__(85);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateTree = exports.getStateTree = function getStateTree(state) {
  return state;
};
var hasDatePassed = exports.hasDatePassed = function hasDatePassed(date) {
  return (0, _moment2.default)().isAfter((0, _moment2.default)(date).startOf('day'));
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendStartDate = extendStartDate;
exports.extendEndDate = extendEndDate;
var EXTEND_START_DATE = exports.EXTEND_START_DATE = 'EXTEND_START_DATE';
var EXTEND_END_DATE = exports.EXTEND_END_DATE = 'EXTEND_END_DATE';

function extendStartDate(id, newStartDate) {
  return {
    type: EXTEND_START_DATE,
    payload: {
      id: id,
      newStartDate: newStartDate
    }
  };
}

function extendEndDate(id, newEndDate) {
  return {
    type: EXTEND_END_DATE,
    payload: {
      id: id,
      newEndDate: newEndDate
    }
  };
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(300),
    eq = __webpack_require__(292);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(425),
    baseKeysIn = __webpack_require__(999),
    isArrayLike = __webpack_require__(197);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(275),
    getPrototype = __webpack_require__(256),
    getSymbols = __webpack_require__(276),
    stubArray = __webpack_require__(424);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(423),
    getSymbolsIn = __webpack_require__(435),
    keysIn = __webpack_require__(434);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(37)))

/***/ }),
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectAdBlocker = detectAdBlocker;
var DETECT_AD_BLOCKER = exports.DETECT_AD_BLOCKER = 'DETECT_AD_BLOCKER';

function detectAdBlocker(adBlockerDetected) {
  return {
    type: DETECT_AD_BLOCKER,
    adBlockerDetected: adBlockerDetected
  };
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Rules = __webpack_require__(1070);
var Lang = __webpack_require__(1071);
var Errors = __webpack_require__(1074);
var Attributes = __webpack_require__(282);
var AsyncResolvers = __webpack_require__(1075);

var Validator = function (input, rules, customMessages) {
  var lang = Validator.getDefaultLang();
  this.input = input || {};

  this.messages = Lang._make(lang);
  this.messages._setCustom(customMessages);
  this.setAttributeFormatter(Validator.prototype.attributeFormatter);

  this.errors = new Errors();
  this.errorCount = 0;

  this.hasAsync = false;
  this.rules = this._parseRules(rules);
};

Validator.prototype = {

  constructor: Validator,

  /**
   * Default language
   *
   * @type {string}
   */
  lang: 'en',

  /**
   * Numeric based rules
   *
   * @type {array}
   */
  numericRules: ['integer', 'numeric'],

  /**
   * Attribute formatter.
   *
   * @type {function}
   */
  attributeFormatter: Attributes.formatter,

  /**
   * Run validator
   *
   * @return {boolean} Whether it passes; true = passes, false = fails
   */
  check: function () {
    var self = this;

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
        if (!rulePassed) {
          this._addFailure(rule);
        }

        if (this._shouldStopValidating(attribute, rulePassed)) {
          break;
        }
      }
    }

    return this.errorCount === 0;
  },

  /**
   * Run async validator
   *
   * @param {function} passes
   * @param {function} fails
   * @return {void}
   */
  checkAsync: function (passes, fails) {
    var _this = this;
    passes = passes || function () {};
    fails = fails || function () {};

    var failsOne = function (rule, message) {
      _this._addFailure(rule, message);
    };

    var resolvedAll = function (allPassed) {
      if (allPassed) {
        passes();
      } else {
        fails();
      }
    };

    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

    var validateRule = function (inputValue, ruleOptions, attribute, rule) {
      return function () {
        var resolverIndex = asyncResolvers.add(rule);
        rule.validate(inputValue, ruleOptions.value, attribute, function () {
          asyncResolvers.resolve(resolverIndex);
        });
      };
    };

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
        ruleOptions = attributeRules[i];

        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        validateRule(inputValue, ruleOptions, attribute, rule)();
      }
    }

    asyncResolvers.enableFiring();
    asyncResolvers.fire();
  },

  /**
   * Add failure and error message for given rule
   *
   * @param {Rule} rule
   */
  _addFailure: function (rule) {
    var msg = this.messages.render(rule);
    this.errors.add(rule.attribute, msg);
    this.errorCount++;
  },

  /**
   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
   *
   * @param  {object} nested object
   * @return {object} flattened object
   */
  _flattenObject: function (obj) {
    var flattened = {};

    function recurse(current, property) {
      if (!property && Object.getOwnPropertyNames(current).length === 0) {
        return;
      }
      if (Object(current) !== current || Array.isArray(current)) {
        flattened[property] = current;
      } else {
        var isEmpty = true;
        for (var p in current) {
          isEmpty = false;
          recurse(current[p], property ? property + "." + p : p);
        }
        if (isEmpty) {
          flattened[property] = {};
        }
      }
    }
    if (obj) {
      recurse(obj);
    }
    return flattened;
  },

  /**
   * Extract value from nested object using string path with dot notation
   *
   * @param  {object} object to search in
   * @param  {string} path inside object
   * @return {any|void} value under the path
   */
  _objectPath: function (obj, path) {
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }

    var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
    var copy = {};
    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        copy[attr] = obj[attr];
      }
    }

    for (var i = 0, l = keys.length; i < l; i++) {
      if (Object.hasOwnProperty.call(copy, keys[i])) {
        copy = copy[keys[i]];
      } else {
        return;
      }
    }
    return copy;
  },

  /**
   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
   *
   * @param  {object} rules
   * @return {object}
   */
  _parseRules: function (rules) {

    var parsedRules = {};
    rules = this._flattenObject(rules);

    for (var attribute in rules) {

      var rulesArray = rules[attribute];

      this._parseRulesCheck(attribute, rulesArray, parsedRules);
    }
    return parsedRules;


  },

  _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
    if (attribute.indexOf('*') > -1) {
      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
    } else {
      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
    }
  },

  _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);
    var propertyValue = this._objectPath(this.input, parentPath);

    if (propertyValue) {
      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
        var workingValues = wildCardValues ? wildCardValues.slice() : [];
        workingValues.push(propertyNumber);
        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
      }
    }
  },

  _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var attributeRules = [];

    if (rulesArray instanceof Array) {
      rulesArray = this._prepareRulesArray(rulesArray);
    }

    if (typeof rulesArray === 'string') {
      rulesArray = rulesArray.split('|');
    }

    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
      if (rule.value) {
        rule.value = this._replaceWildCards(rule.value, wildCardValues);
        this._replaceWildCardsMessages(wildCardValues);
      }

      if (Rules.isAsync(rule.name)) {
        this.hasAsync = true;
      }
      attributeRules.push(rule);
    }

    parsedRules[attribute] = attributeRules;
  },

  _replaceWildCards: function (path, nums) {

    if (!nums) {
      return path;
    }

    var path2 = path;
    nums.forEach(function (value) {
      var pos = path2.indexOf('*');
      if (pos === -1) {
        return path2;
      }
      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
    });
    return path2;
  },

  _replaceWildCardsMessages: function (nums) {
    var customMessages = this.messages.customMessages;
    var self = this;
    Object.keys(customMessages).forEach(function (key) {
      if (nums) {
        var newKey = self._replaceWildCards(key, nums);
        customMessages[newKey] = customMessages[key];
      }
    });

    this.messages._setCustom(customMessages);
  },
  /**
   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
   *
   * @param  {array} rulesArray
   * @return {array}
   */
  _prepareRulesArray: function (rulesArray) {
    var rules = [];

    for (var i = 0, len = rulesArray.length; i < len; i++) {
      if (typeof rulesArray[i] === 'object') {
        for (var rule in rulesArray[i]) {
          rules.push({
            name: rule,
            value: rulesArray[i][rule]
          });
        }
      } else {
        rules.push(rulesArray[i]);
      }
    }

    return rules;
  },

  /**
   * Determines if the attribute is supplied with the original data object.
   *
   * @param  {array} attribute
   * @return {boolean}
   */
  _suppliedWithData: function (attribute) {
    return this.input.hasOwnProperty(attribute);
  },

  /**
   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
   *
   * @param  {string} ruleString min:3
   * @return {object} object containing the name of the rule and value
   */
  _extractRuleAndRuleValue: function (ruleString) {
    var rule = {},
      ruleArray;

    rule.name = ruleString;

    if (ruleString.indexOf(':') >= 0) {
      ruleArray = ruleString.split(':');
      rule.name = ruleArray[0];
      rule.value = ruleArray.slice(1).join(":");
    }

    return rule;
  },

  /**
   * Determine if attribute has any of the given rules
   *
   * @param  {string}  attribute
   * @param  {array}   findRules
   * @return {boolean}
   */
  _hasRule: function (attribute, findRules) {
    var rules = this.rules[attribute] || [];
    for (var i = 0, len = rules.length; i < len; i++) {
      if (findRules.indexOf(rules[i].name) > -1) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if attribute has any numeric-based rules.
   *
   * @param  {string}  attribute
   * @return {Boolean}
   */
  _hasNumericRule: function (attribute) {
    return this._hasRule(attribute, this.numericRules);
  },

  /**
   * Determine if rule is validatable
   *
   * @param  {Rule}   rule
   * @param  {mixed}  value
   * @return {boolean}
   */
  _isValidatable: function (rule, value) {
    if (Rules.isImplicit(rule.name)) {
      return true;
    }

    return this.getRule('required').validate(value);
  },

  /**
   * Determine if we should stop validating.
   *
   * @param  {string} attribute
   * @param  {boolean} rulePassed
   * @return {boolean}
   */
  _shouldStopValidating: function (attribute, rulePassed) {

    var stopOnAttributes = this.stopOnAttributes;
    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
      return false;
    }

    if (stopOnAttributes instanceof Array) {
      return stopOnAttributes.indexOf(attribute) > -1;
    }

    return true;
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   * @return {void}
   */
  setAttributeNames: function (attributes) {
    this.messages._setAttributeNames(attributes);
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  setAttributeFormatter: function (func) {
    this.messages._setAttributeFormatter(func);
  },

  /**
   * Get validation rule
   *
   * @param  {string} name
   * @return {Rule}
   */
  getRule: function (name) {
    return Rules.make(name, this);
  },

  /**
   * Stop on first error.
   *
   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
   * @return {void}
   */
  stopOnError: function (attributes) {
    this.stopOnAttributes = attributes;
  },

  /**
   * Determine if validation passes
   *
   * @param {function} passes
   * @return {boolean|undefined}
   */
  passes: function (passes) {
    var async = this._checkAsync('passes', passes);
    if (async) {
      return this.checkAsync(passes);
    }
    return this.check();
  },

  /**
   * Determine if validation fails
   *
   * @param {function} fails
   * @return {boolean|undefined}
   */
  fails: function (fails) {
    var async = this._checkAsync('fails', fails);
    if (async) {
      return this.checkAsync(function () {}, fails);
    }
    return !this.check();
  },

  /**
   * Check if validation should be called asynchronously
   *
   * @param  {string}   funcName Name of the caller
   * @param  {function} callback
   * @return {boolean}
   */
  _checkAsync: function (funcName, callback) {
    var hasCallback = typeof callback === 'function';
    if (this.hasAsync && !hasCallback) {
      throw funcName + ' expects a callback when async rules are being tested.';
    }

    return this.hasAsync || hasCallback;
  }

};

/**
 * Set messages for language
 *
 * @param {string} lang
 * @param {object} messages
 * @return {this}
 */
Validator.setMessages = function (lang, messages) {
  Lang._set(lang, messages);
  return this;
};

/**
 * Get messages for given language
 *
 * @param  {string} lang
 * @return {Messages}
 */
Validator.getMessages = function (lang) {
  return Lang._get(lang);
};

/**
 * Set default language to use
 *
 * @param {string} lang
 * @return {void}
 */
Validator.useLang = function (lang) {
  this.prototype.lang = lang;
};

/**
 * Get default language
 *
 * @return {string}
 */
Validator.getDefaultLang = function () {
  return this.prototype.lang;
};

/**
 * Set the attribute formatter.
 *
 * @param {fuction} func
 * @return {void}
 */
Validator.setAttributeFormatter = function (func) {
  this.prototype.attributeFormatter = func;
};

/**
 * Stop on first error.
 *
 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
 * @return {void}
 */
Validator.stopOnError = function (attributes) {
  this.prototype.stopOnAttributes = attributes;
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.register = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.register(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsync = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsync(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsyncImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsyncImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register validator for missed validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerMissedRuleValidator = function(fn, message) {
  Rules.registerMissedRuleValidator(fn, message);
};

module.exports = Validator;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Das :attribute Feld muss akzeptiert werden.',
  after: 'Das :attribute muss ein Datum nach dem :after sein.',
  after_or_equal: 'Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.',
  alpha: 'Das :attribute Feld darf nur aus Buchstaben bestehen.',
  alpha_dash: 'Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.',
  alpha_num: 'Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.',
  before: 'Das :attribute muss ein Datum vor dem :before sein.',
  before_or_equal: 'Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.',
  between: 'Das :attribute Feld muss zwischen :min und :max liegen.',
  confirmed: 'Das :attribute Feld stimmt nicht mit der Bestätigung überein.',
  email: 'Das :attribute Format ist ungültig.',
  date: 'Das :attribute Feld muss ein gültiges Datum sein.',
  def: 'Das :attribute Feld hat Fehler.',
  digits: 'Das :attribute Feld muss :digits Stellen haben.',
  different: 'Die Felder :attribute und :different müssen sich unterscheiden.',
  'in': 'Der gewählte Wert für :attribute ist ungültig.',
  integer: 'Das :attribute Feld muss eine ganze Zahl sein.',
  min: {
    numeric: 'Das :attribute Feld muss mindestens :min sein.',
    string: 'Das :attribute Feld muss mindestens :min Zeichen lang sein.'
  },
  max: {
    numeric: 'Das :attribute Feld darf maximal :max sein.',
    string: 'Das :attribute Feld darf maximal :max Zeichen haben.'
  },
  not_in: 'Der gewählte Wert für :attribute ist ungültig.',
  numeric: 'Das :attribute Feld muss eine Zahl sein.',
  present: 'Das Feld :attribute muss vorhanden sein (kann aber leer sein).',
  required: 'Das :attribute Feld muss ausgefüllt sein.',
  required_if: 'Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.',
  same: 'Die Felder :attribute und :same müssen übereinstimmen.',
  size: {
    numeric: 'Das :attribute Feld muss gleich :size sein.',
    string: 'Das :attribute Feld muss :size Zeichen lang sein.'
  },
  string: 'Das :attribute Feld muss ein Satz sein.',
  url: 'Das Format von :attribute ist ungültig.',
  regex: 'Das :attribute Format ist ungültig.',
  attributes: {}
};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Το πεδίο :attribute πρέπει να γίνει αποδεκτό.',
  after: 'Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.',
  alpha: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.',
  alpha_dash: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.',
  alpha_num: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.',
  between: 'Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.',
  confirmed: 'Η επιβεβαίωση του :attribute δεν ταιριάζει.',
  email: 'Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.',
  date: 'Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.',
  def: 'Το πεδίο :attribute περιέχει σφάλματα.',
  digits: 'Το πεδίο :attribute πρέπει να είναι :digits ψηφία.',
  different: 'Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.',
  'in': 'Το επιλεγμένο :attribute δεν είναι έγκυρο.',
  integer: 'Το πεδίο :attribute πρέπει να είναι ακέραιος.',
  min: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.',
    string: 'Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες.'
  },
  max: {
    numeric: 'Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.',
    string: 'Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες.'
  },
  not_in: 'Το επιλεγμένο :attribute δεν είναι αποδεκτό.',
  numeric: 'Το πεδίο :attribute πρέπει να είναι αριθμός.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'Το πεδίο :attribute είναι απαραίτητο.',
  required_if: 'Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.',
  same: 'Τα πεδία :attribute και :same πρέπει να είναι ίδια.',
  size: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι :size.',
    string: 'Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες.'
  },
  string: 'Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.',
  url: 'Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.',
  regex: 'Η μορφή του :attribute δεν είναι αποδεκτή.',
  attributes: {}
};


/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'El campo :attribute debe ser aceptado.',
  after: 'El campo :attribute debe ser una fecha posterior a :after.',
  alpha: 'El campo :attribute solo debe contener letras.',
  alpha_dash: 'El campo :attribute solo debe contener letras, números y guiones.',
  alpha_num: 'El campo :attribute solo debe contener letras y números.',
  attributes: {},
  between: 'El campo :attribute tiene que estar entre :min - :max.',
  confirmed: 'La confirmación de :attribute no coincide.',
  different: 'El campo :attribute y :other deben ser diferentes.',
  digits: 'El campo :attribute debe tener :digits dígitos.',
  email: 'El campo :attribute no es un correo válido.',
  'in': 'El campo :attribute es inválido.',
  integer: 'El campo :attribute debe ser un número entero.',
  max: {
    numeric: 'El campo :attribute no debe ser mayor a :max.',
    string: 'El campo :attribute no debe ser mayor que :max caracteres.'
  },
  min: {
    numeric: 'El tamaño del campo :attribute debe ser de al menos :min.',
    string: 'El campo :attribute debe contener al menos :min caracteres.'
  },
  not_in: 'El campo :attribute es inválido.',
  numeric: 'El campo :attribute debe ser numérico.',
  present: 'El campo de :attribute debe estar presente (pero puede estar vacío).',
  regex: 'El formato del campo :attribute es inválido.',
  required: 'El campo :attribute es obligatorio.',
  required_if: 'El campo :attribute es obligatorio cuando :other es :value.',
  same: 'El campo :attribute y :other deben coincidir.',
  size: {
    numeric: 'El tamaño del campo :attribute debe ser :size.',
    string: 'El campo :attribute debe contener :size caracteres.'
  },
  url: 'El formato de :attribute es inválido.'
};


/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'فیلد :attribute می بایست تایید شود',
  alpha: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد',
  alpha_dash: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد',
  alpha_num: 'فیلد :attribute می بایست فقط شامل حروف و اعداد باشد',
  between: 'فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد',
  confirmed: 'تطبیق فیلد :attribute صحیح نمی باشد',
  email: 'فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد',
  date: 'تاریخ درج شده در فیلد :attribute صحیح نیست',
  def: 'فیلد :attribute اشکال دارد',
  digits: 'فیلد :attribute می بایست شامل :digits رقم باشد',
  different: 'فیلد :attribute می بایست مقداری غیر از :different داشته باشد',
  'in': 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  integer: 'فیلد :attribute می بایست عددی باشد',
  min: {
    numeric: 'فیلد :attribute می بایست از :min بزرگتر باشد',
    string: 'فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد'
  },
  max: {
    numeric: 'فیلد :attribute می بایست از :max کوچکتر باشد',
    string: 'فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد'
  },
  not_in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  numeric: 'فیلد :attribute می بایست عددی باشد',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'فیلد :attribute الزامی است',
  required_if: 'در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است',
  same: 'فیلد :attribute می بایست با فیلد :same یکی باشد',
  size: {
    numeric: 'فیلد :attribute می بایست :size باشد',
    string: 'فیلد :attribute می بایست :size کاراکتر طول داشته باشد'
  },
  string: 'فیلد :attribute می بایست متنی باشد',
  url: 'آدرس فیلد :attribute صحیح نمی باشد',
  regex: 'فرمت آدرس :attribute صحیح نمی باشد',
  attributes: {}
};


/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Le champ :attribute doit être accepté.',
  alpha: 'Le champ :attribute ne peut contenir que des caractères alphabétiques.',
  alpha_dash: 'Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.',
  alpha_num: 'Le champ :attribute ne peut contenir que des caractères alphanumériques.',
  between: 'La longueur du champ :attribute doit être comprise entre :min and :max.',
  confirmed: 'Le champ :attribute n\'est pas confirmé.',
  email: 'Le champ :attribute contient un format invalide.',
  def: 'Le champ :attribute contient un attribut erroné.',
  digits: 'Le champ :attribute doit être composé de :digits chiffres.',
  different: 'Les champs :attribute et :different doivent être différents.',
  'in': 'Le champ :attribute est invalide.',
  integer: 'Le champ :attribute doit être un entier.',
  min: {
    numeric: 'Le champ :attribute doit être supérieur à :min.',
    string: 'Le champ :attribute doit contenir plus de :min caractères.'
  },
  max: {
    numeric: 'Le champ :attribute doit être inférieur à :max.',
    string: 'Le champ :attribute doit contenir moins de :max caractères.'
  },
  not_in: 'Le champ :attribute est invalide.',
  numeric: 'Le champ :attribute doit être un chiffre.',
  present: 'Le champ :attribute doit être présent (mais peut être vide).',
  required: 'Le champ :attribute est requis.',
  required_if: 'Le champ :attribute est requis quand :other est :value.',
  same: 'Les champs :attribute et :same doivent correspondre.',
  size: {
    numeric: 'Le champ :attribute doit être égal à :size.',
    string: 'Le champ :attribute doit contenir :size caractères.'
  },
  url: 'Le format du champ :attribute est invalide.',
  regex: 'Le format du champ :attribute est invalide.',
  attributes: {}
};


/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Il campo :attribute deve essere accettato.',
  alpha: 'Il campo :attribute deve contenere sono caratteri alfabetici.',
  alpha_dash: 'Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.',
  alpha_num: 'Il campo :attribute deve essere alfanumerico.',
  between: 'Il campo :attribute deve essere compreso tra :min e :max.',
  confirmed: 'Il campo conferma :attribute non è uguale.',
  email: 'Il formato dell\'attributo :attribute non è valido.',
  def: 'Gli attributi del campo :attribute contengono degli errori.',
  digits: 'Il campo :attribute deve essere di :digits cifre.',
  different: 'Il campo :attribute e :different devo essere diversi.',
  'in': 'Il valore del campo :attribute non è valido.',
  integer: 'Il campo :attribute deve essere un valore intero.',
  min: {
    numeric: 'Il campo :attribute deve essere maggiore o uguale di :min.',
    string: 'Il campo :attribute deve essere composto da almeno :min caratteri.'
  },
  max: {
    numeric: 'Il campo :attribute deve essere minore o uguale di :max.',
    string: 'Il campo :attribute deve essere composto da massimo :max caratteri.'
  },
  not_in: 'Il campo :attribute non è valido.',
  numeric: 'Il campo :attribute deve essere un numero.',
  present: 'Il campo :attribute deve essere presente (ma può essere vuoto).',
  required: 'Il campo :attribute è richiesto.',
  required_if: 'Il campo :attribute è richiesto quando il campo :other è uguale a :value.',
  same: 'I campi :attribute e :same devono essere uguali.',
  size: {
    numeric: 'La dimensione del campo :attribute deve essere uguale a :size.',
    string: 'Il campo :attribute deve essere di :size caratteri.'
  },
  string: 'Il campo :attribute deve essere una stringa.',
  url: 'Il formato del campo :attribute non è valido.',
  regex: 'Il formato del campo :attribute non è valido.',
  attributes: {}
};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = {
    accepted: ':attributeを確認してください。',
    alpha: ':attributeは英字のみで入力してください。',
    alpha_dash: ':attributeは英字とダッシュと下線のみで入力してください。',
    alpha_num: ':attributeは英数字のみで入力してください。',
    between: ':attributeは:min〜:max文字で入力してください。',
    confirmed: ':attributeは確認が一致しません。',
    email: ':attributeは正しいメールアドレスを入力してください。',
    date: ':attributeは正しい日付形式を入力してください',
    def: ':attributeは検証エラーが含まれています。',
    digits: ':attributeは:digitsの数字のみで入力してください。',
    different: ':attributeと:differentは同じであってはなりません。',
    'in': '選択された:attributeは無効です。',
    integer: ':attributeは整数で入力してください。',
    min        : {
        numeric : ":attributeは:min以上で入力してください。",
        string  : ":attributeは:min文字以上で入力してください。"
    },
    max : {
        numeric : ":attributeは:max以下で入力してください。",
        string  : ":attributeは:max文字以下で入力してください。"
    },
    not_in      : "選択された:attributeは無効です。",
    numeric     : ":attributeは数値で入力してください。",
    present: 'The :attribute field must be present (but can be empty).',
    required    : ":attributeは必須です。",
    required_if : ":otherは:valueになったら:attributeは必須です。",
    same        : ":attributeと:sameは同じでなければなりません。",
    size        : {
        numeric : ":attributeは:sizeを入力してください。",
        string  : ":attributeは:size文字で入力してください。"
    },
    url        : ":attributeは正しいURIを入力してください。",
    regex      : ":attributeの値 \":value\" はパターンにマッチする必要があります。",
    attributes : {}
};


/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute må være akseptert.',
  alpha: ':attribute feltet kan kun inneholde alfabetiske tegn.',
  alpha_dash: ':attribute feltet kan kun inneholde alfanumeriske tegn, i tillegg til bindestreker og understreker.',
  alpha_num: ':attribute feltet må være alfanumerisk.',
  between: ':attribute feltet må være mellom :min og :max.',
  confirmed: ':attribute feltet stemmer ikke overens med bekreftelsen.',
  email: ':attribute formatet er ugyldig.',
  date: ':attribute er et ugyldig datoformat.',
  def: ':attribute attributtet har feil.',
  digits: ':attribute må være på :digits siffer.',
  different: ':attribute og :different må være forskjellige.',
  'in': 'Den oppgitte verdien for :attribute er ugyldig.',
  integer: ':attribute må være et heltall.',
  min: {
    numeric: ':attribute må minst være :min.',
    string: ':attribute må være på minst :min tegn.'
  },
  max: {
    numeric: ':attribute kan ikke være større enn :max.',
    string: ':attribute kan maks ha :max tegn.'
  },
  'not_in': 'Den oppgitte verdien for :attribute er ugyldig.',
  numeric: ':attribute må være et tall.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute feltet er påkrevd.',
  required_if: ':attribute er påkrevd når :other er :value.',
  same: ':attribute og :same må være like.',
  size: {
    numeric: ':attribute må ha størrelsen :size.',
    string: ':attribute må ha :size tegn.'
  },
  string: ':attribute må være tekst.',
  url: ':attribute formatet er ugyldig.',
  regex: ':attribute formatet er ugyldig.',
  attributes: {}
};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Het :attribute veld moet geaccepteerd worden.',
  after: ':attribute moet een datum na :after zijn.',
  after_or_equal: 'De :attribute datum moet op of na :after_or_equal zijn.',
  alpha: 'Het :attribute veld mag alleen maar letters bevatten.',
  alpha_dash: 'Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.',
  alpha_num: 'Het :attribute veld mag alleen maar letters en cijfers bevatten.',
  before: ':attribute moet vòòr :before zijn.',
  before_or_equal: ':attribute moet vòòr of op :before_or_equal zijn.',
  between: 'Het :attribute veld moet tussen :min en :max liggen.',
  confirmed: 'Het :attribute veld komt niet met de bevestiging overeen.',
  email: 'Het :attribute formaat is ongeldig.',
  date: 'Het :attribute veld moet een geldige datum zijn.',
  def: 'Het :attribute veld bevat fouten.',
  digits: 'Het :attribute veld moet :digits cijfers hebben.',
  different: 'Het :attribute en :different veld moeten verschillend zijn.',
  'in': 'De gekozen waarde voor :attribute is ongeldig.',
  integer: 'Het :attribute veld moet een geheel getal zijn.',
  min: {
    numeric: 'Het :attribute veld moet minstens :min zijn.',
    string: 'Het :attribute veld moet minstens :min karakters bevatten.'
  },
  max: {
    numeric: 'Het :attribute veld mag maximaal :max zijn.',
    string: 'Het :attribute veld mag niet meer dan :max karakters bevatten.'
  },
  not_in: 'De gekozen waarde voor :attribute is ongeldig.',
  numeric: 'Het :attribute veld moet een getal zijn.',
  present: 'Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).',
  required: 'Het :attribute veld moet ingevuld zijn.',
  required_if: 'Het :attribute veld moet ingevuld zijn, wanneer :other :value is.',
  required_unless: 'Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.',
  required_with: 'Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.',
  required_with_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.',
  required_without: 'Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.',
  required_without_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.',
  same: 'De :attribute en :same velden moeten overeenkomen.',
  size: {
    numeric: 'Het :attribute veld moet :size zijn.',
    string: 'Het :attribute veld moet :size karakters bevatten.'
  },
  string: 'Het :attribute veld moet een woord of zin zijn.',
  url: 'Het :attribute veld heeft een ongeldig formaat.',
  regex: 'Het :attribute veld heeft een ongeldig formaat.',
  attributes: {}
};


/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {
    accepted: 'Pole :attribute musi być zaakceptowane.',
    alpha: 'Pole :attribute może zawierać tylko litery.',
    alpha_dash: 'Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.',
    alpha_num: 'Pole :attribute moze zawierac tylko znaki alfanumeryczne.',
    between: 'Pole :attribute musi mieć długość od :min do :max.',
    confirmed: 'Pole :attribute nie spełnia warunku potwierdzenia.',
    email: 'Pole :attribute ma niepoprawny format adresu email.',
    date: 'Pole :attribute musi mieć poprawny format daty.',
    def: 'Pole :attribute zawiera błędy.',
    digits: 'Pole :attribute może zawierać tylko cyfry ze zbioru :digits.',
    different: 'Pola :attribute i :different muszą się różnić.',
    'in': 'Pole :attribute musi należeć do zbioru :in.',
    integer: 'Pole :attribute musi być liczbą całkowitą.',
    min: {
        numeric: 'Pole :attribute musi być równe conajmniej :min.',
        string: 'Pole :attribute musi zawierać conajmniej :min znaków.'
    },
    max: {
        numeric: 'Pole :attribute nie moze być większe :max.',
        string: 'Pole :attribute nie moze być dłuższe niż :max znaków.'
    },
    not_in: 'Pole :attribute nie może należeć do zbioru :not_in.',
    numeric: 'Pole :attribute musi być liczbą.',
    present: 'Polu :attribute musi być obecny (ale może być pusta).',
    required: 'Pole :attribute jest wymagane.',
    required_if: 'Pole :attribute jest wymagane jeśli pole :other jest równe :value.',
    same: 'Pola :attribute i :same muszą być takie same.',
    size: {
        numeric: 'Pole :attribute musi być równe :size.',
        string: 'Pole :attribute musi zawierać :size znaków.'
    },
    string: 'Pole :attribute musi być ciągiem znaków.',
    url: 'Pole :attribute musi być poprawnym adresem URL.',
    regex: 'Pole :attribute nie spełnia warunku.',
    attributes: {}
};


/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'O :attribute precisa ser aceito.',
  alpha: 'O campo :attribute só pode conter letras.',
  alpha_dash: 'O campo :attribute só pode conter letras, números, hífens e sublinha.',
  alpha_num: 'O campo :attribute só pode conter letras e números.',
  between: 'O campo :attribute precisa estar entre :min e :max.',
  confirmed: 'A confirmação de :attribute não coincide.',
  email: 'O formato de :attribute é inválido.',
  date: 'O :attribute não é um formato de data válido',
  def: 'O atributo :attribute contém erros.',
  digits: 'O atributo :attribute precisa ter :digits dígitos.',
  different: 'O :attribute e :different precisam ser diferentes.',
  'in': 'O atributo selecionado :attribute é inválido.',
  integer: 'O :attribute precisa ser um inteiro.',
  min: {
    numeric: 'O :attribute precisa ser no mínimo :min.',
    string: 'O :attribute precisa ter no mínimo :min caracteres.'
  },
  max: {
    numeric: 'O :attribute não pode ser maior que :max.',
    string: 'O :attribute não pode ter mais que :max caracteres.'
  },
  not_in: 'O :attribute selecionado é inválido.',
  numeric: 'O :attribute precisa ser um número.',
  present: 'O campo :attribute deve estar presente (mas pode estar vazio).',
  required: 'O campo :attribute é obrigatório.',
  required_if: 'O campo :attribute é obrigatório quando :other é :value.',
  same: 'Os campos :attribute e :same precisam ser iguais.',
  size: {
    numeric: 'O :attribute precisa ser :size.',
    string: 'O :attribute precisa ter :size caracteres.'
  },
  string: 'O :attribute precisa ser uma palavra.',
  url: 'O formato de :attribute é inválido.',
  regex: 'O formato de :attribute é inválido.',
  attributes: {}
};


/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Вы должны принять :attribute.',
  alpha: 'Поле :attribute может содержать только буквы.',
  alpha_dash: 'Поле :attribute может содержать только буквы, цифры, дефисы и символы подчёркивания.',
  alpha_num: 'Поле :attribute может содержать только буквы и цифры.',
  between: 'Поле :attribute должно быть между :min и :max.',
  confirmed: 'Поле :attribute не совпадает с подтверждением.',
  email: 'Поле :attribute должно быть действительным электронным адресом.',
  def: 'Поле :attribute содержит ошибки.',
  digits: 'Длина цифрового поля :attribute должна быть :digits.',
  different: 'Поля :attribute и :different должны различаться.',
  'in': 'Выбранное значение для :attribute ошибочно.',
  integer: 'Поле :attribute должно быть целым числом.',
  min: {
    numeric: 'Значение поля :attribute должно быть больше или равно :min.',
    string: 'Количество символов в поле :attribute должно быть не менее :min.'
  },
  max: {
    numeric: 'Значение поля :attribute должно быть меньше или равно :max.',
    string: 'Количество символов в поле :attribute не может превышать :max.'
  },
  not_in: 'Выбранное значение для :attribute ошибочно.',
  numeric: 'Поле :attribute должно быть числом.',
  present: 'Поле :attribute должно присутствовать (но может быть пустым).',
  required: 'Поле :attribute обязательно для заполнения.',
  required_if: 'Поле :attribute требуется когда значения поля :other равно :value.',
  same: 'Значение :attribute должно совпадать с :same.',
  size: {
    numeric: 'Значение поля :attribute должно быть равным :size.',
    string: 'Количество символов в поле :attribute должно быть равно :size.'
  },
  url: 'Поле :attribute должно содержать валидный URL.',
  regex: 'Неверный формат поля :attribute.',
  attributes: {}
};


/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute kabul edilmeli.',
  alpha: ':attribute alanı sadece harflerden oluşabilir.',
  alpha_dash: ':attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.',
  alpha_num: ':attribute alanı alfa-nümerik olmalıdır.',
  between: ':attribute alanı :min ile :max arasında olabilir.',
  confirmed: ':attribute uyuşmuyor.',
  email: ':attribute formatı geçersiz.',
  date: ':attribute geöerli bir tarih alanı değil.',
  def: ':attribute hatalar içeriyor.',
  digits: ':attribute sadece rakamlardan oluşabilir.',
  different: ':attribute ve :different farklı olmalı.',
  'in': 'Seçilen :attribute geçerli değil.',
  integer: ':attribute tam sayı olmalı.',
  min: {
    numeric: ':attribute en az :min olmalı.',
    string: ':attribute en az :min karakter uzunluğunda olmalı.'
  },
  max: {
    numeric: ':attribute en çok :max olabilir.',
    string: ':attribute uzunluğu en çok :max karakter uzunluğunda olabilir.'
  },
  not_in: 'Seçilen :attribute geçerli değil.',
  numeric: ':attribute sayı olmalı.',
  present: ':attribute alanı bulunmalıdır (ancak boş olabilir).',
  required: ':attribute alanı gerekli.',
  required_if: ':attribute alanı :other alanı :value olduğunda gerekli.',
  same: ':attribute ve :same aynı olmalı.',
  size: {
    numeric: ':attribute :size olmalı.',
    string: ':attribute :size karakter uzunluğunda olmalı.'
  },
  string: ':attribute alfa-numerik olmalı.',
  url: ':attribute formatı geçersiz.',
  regex: ':attribute formatı geçersiz.',
  attributes: {}
};


/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute phải được chấp nhận.',
  alpha: 'Trường :attribute phải là ký tự',
  alpha_dash: ':attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.',
  alpha_num: ':attribute phải là ký tự chữ cái hoặc chữ số.',
  between: ':attribute phải nằm trong khoảng :min và :max.',
  confirmed: ':attribute xác nhận không trùng khớp.',
  email: ':attribute không phải là email.',
  date: ':attribute không phải là ngày hợp lệ',
  def: 'Thuộc tính :attribute có lỗi.',
  digits: ':attribute phải là số và có chiều dài bằng :digits.',
  different: 'Giá trị của hai trường :attribute và :different phải khác nhau.',
  'in': 'Giá trị được chọn của :attribute không hợp lệ.',
  integer: ':attribute phải là số nguyên.',
  min: {
    numeric: ':attribute phải lớn hơn hoặc bằng :min.',
    string: ':attribute phải có ít nhất :min ký tự.'
  },
  max: {
    numeric: ':attribute phải nhỏ hơn hoặc bằng :max.',
    string: ':attribute phải có ít hơn :max ký tự.'
  },
  not_in: 'Giá trị được chọn của trường :attribute không hợp lệ.',
  numeric: ':attribute phải là số.',
  present: 'Trường :attribute phải có mặt (nhưng có thể để trống).',
  required: ':attribute bắt buộc nhập.',
  required_if: ':attribute là bắt buộc khi :other có giá trị :value.',
  same: 'Giá trị của :attribute và :same phải như nhau.',
  size: {
    numeric: ':attribute phải có chiều dài của bằng :size.',
    string: 'Số ký tự của :attribute phải là :size ký tự.'
  },
  string: ':attribute không phải là một chuỗi',
  url: ':attribute không phải là một Url hợp lệ.',
  regex: ':attribute không đúng định dạng',
  attributes: {}
};


/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必须是可接受的.',
  alpha: ':attribute只能包含字母.',
  alpha_dash: ':attribute只能包含字母,连字符和下划线.',
  alpha_num: ':attribute只能包含字母和数字.',
  between: ':attribute的(大小,长度等)只能在:min和:max之间.',
  confirmed: ':attribute确认不一致.',
  email: ':attribute格式不正确.',
  date: ':attribute日期格式错误.',
  def: ':attribute属性错误.',
  digits: ':attribute必须是:digits位小数.',
  different: ':attribute和:different必须不同.',
  'in': '选择的:attribute无效',
  integer: ':attribute必须是一个整数.',
  min: {
    numeric: ':attribute不能小于:min.',
    string: ':attribute长度不能小于:min.'
  },
  max: {
    numeric: ':attribute不能大于:max.',
    string: ':attribute长度不能大于:max.'
  },
  not_in: '所选的:attribute无效.',
  numeric: ':attribute必须是一个数字.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能为空.',
  required_if: '当:other是:value时,:attribute不能为空.',
  same: ':attribute和:same必须一致.',
  size: {
    numeric: ':attribute必须等于:size.',
    string: ':attribute的长度必须等于:size.'
  },
  string: ':attribute必须是一个字符串.',
  url: ':attribute格式不正确.',
  regex: ':attribute格式不正确.',
  attributes: {}
};


/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必須接受。',
  alpha: ':attribute只能包含字母。',
  alpha_dash: ':attribute只能包含字母，連字符和下划線。',
  alpha_num: ':attribute只能包含字母和數字。',
  between: ':attribute的值只能在:min和:max之間。',
  confirmed: ':attribute與確認輸入不一致。',
  email: ':attribute的格式錯誤。',
  date: ':attribute的日期格式錯誤。',
  def: ':attribute屬性錯誤。',
  digits: ':attribute必須是:digits位小數。',
  different: ':attribute和:different必須不同。',
  'in': '選擇的:attribute無效',
  integer: ':attribute必須是一個整數。',
  min: {
    numeric: ':attribute不能小於:min。',
    string: ':attribute的長度不能小於:min.'
  },
  max: {
    numeric: ':attribute不能大於:max。',
    string: ':attribute的長度不能大於:max.'
  },
  not_in: '所選的:attribute無效。',
  numeric: ':attribute必須是一個數字。',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能空白。',
  required_if: '當:other是:value時,:attribute不能空白。',
  same: ':attribute和:same必須一致。',
  size: {
    numeric: ':attribute必須等於:size。',
    string: ':attribute的長度必須等於:size.'
  },
  string: ':attribute必須是一個字串。',
  url: ':attribute格式不正確。',
  regex: ':attribute格式不正確。',
  attributes: {}
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STEP_RULES = exports.UPLOADED_IMAGE_RULES = exports.ALL_AUDIO_RULES = exports.BG_MUSIC_RULES = exports.EXISTING_VO_BG_RULES = exports.UPLOADED_AUDIO_RULES = exports.GENERIC_AUDIO_RULES = exports.ADCREATION_RULES = undefined;

var _NEW_VOICEOVER_RULES, _UPLOADED_IMAGE_RULES;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.initialState = initialState;
exports.fieldsAreValid = fieldsAreValid;
exports.default = validation;

var _AdValidator = __webpack_require__(1076);

var _AdValidator2 = _interopRequireDefault(_AdValidator);

var _editableAd = __webpack_require__(47);

var _validation = __webpack_require__(153);

var _config = __webpack_require__(30);

var _utilities = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ADCREATION_RULES = exports.ADCREATION_RULES = {
  clickthroughUrl: 'required|url',
  name: 'required',
  'uploads.image.uploaded': 'accepted'
};

var BASE_VALIDATION_RULES = _extends({}, ADCREATION_RULES);

var NEW_VOICEOVER_RULES = (_NEW_VOICEOVER_RULES = {}, _defineProperty(_NEW_VOICEOVER_RULES, 'audioSubmission.' + _config.NEW_VOICEOVER + '.name', 'required'), _defineProperty(_NEW_VOICEOVER_RULES, 'audioSubmission.' + _config.NEW_VOICEOVER + '.instructions', 'required'), _defineProperty(_NEW_VOICEOVER_RULES, 'audioSubmission.' + _config.NEW_VOICEOVER + '.locale', 'required'), _defineProperty(_NEW_VOICEOVER_RULES, 'audioSubmission.' + _config.NEW_VOICEOVER + '.transcript', 'required'), _defineProperty(_NEW_VOICEOVER_RULES, 'audioSubmission.' + _config.NEW_VOICEOVER + '.voice', 'required'), _NEW_VOICEOVER_RULES);

var GENERIC_AUDIO_RULES = exports.GENERIC_AUDIO_RULES = 'file-problem|filetype:' + _config.CLIENT_AUDIO_TYPES.join(',') + '|filesize-max:' + _config.MAX_FILE_SIZE_LIMIT;

function addAudioRules(audioType, rules, maxDuration) {
  rules['uploads.' + audioType + '.uploaded'] = 'accepted';
  rules['uploads.' + audioType + '.' + _config.FILE_PROPERTIES] = '' + GENERIC_AUDIO_RULES + (maxDuration ? '|audio-duration:' + maxDuration : '');
}

var UPLOADED_AUDIO_RULES = exports.UPLOADED_AUDIO_RULES = {};
addAudioRules(_config.UPLOADED_AUDIO, UPLOADED_AUDIO_RULES, _config.MAX_AUDIO_DURATION);

var EXISTING_VO_BG_RULES = exports.EXISTING_VO_BG_RULES = {};
addAudioRules(_config.EXISTING_VO_BG_MUSIC, EXISTING_VO_BG_RULES);

var BG_MUSIC_RULES = exports.BG_MUSIC_RULES = {};
addAudioRules(_config.BG_MUSIC, BG_MUSIC_RULES);

var ALL_AUDIO_RULES = exports.ALL_AUDIO_RULES = _extends({}, UPLOADED_AUDIO_RULES, EXISTING_VO_BG_RULES, BG_MUSIC_RULES);

var EXISTING_VOICEOVER_RULES = _defineProperty({}, 'audioSubmission.' + _config.EXISTING_VOICEOVER + '.data.id', 'required');

function getRulesFromActiveAudioSubmission(activeSubmission) {
  switch (activeSubmission) {
    case _config.UPLOADED_AUDIO:
      return _extends({}, UPLOADED_AUDIO_RULES);
    case _config.EXISTING_VOICEOVER:
      return _extends({}, EXISTING_VOICEOVER_RULES);
    case _config.NEW_VOICEOVER:
      return _extends({}, NEW_VOICEOVER_RULES);
    default:
      return null;
  }
}

var validImageDimensions = _config.COVER_ART_IMAGE_DIMENSIONS.width + 'x' + _config.COVER_ART_IMAGE_DIMENSIONS.height;

var UPLOADED_IMAGE_RULES = exports.UPLOADED_IMAGE_RULES = (_UPLOADED_IMAGE_RULES = {}, _defineProperty(_UPLOADED_IMAGE_RULES, 'uploads.' + _config.UPLOADED_COVER_ART + '.uploaded', 'accepted'), _defineProperty(_UPLOADED_IMAGE_RULES, 'uploads.' + _config.UPLOADED_COVER_ART + '.' + _config.FILE_PROPERTIES, 'file-problem|filetype:' + _config.CLIENT_IMAGE_TYPES.join(',') + '|image-dimensions:' + validImageDimensions), _UPLOADED_IMAGE_RULES);

var STEP_RULES = exports.STEP_RULES = {
  3: function _(fields) {
    return _extends({}, ADCREATION_RULES, getRulesFromActiveAudioSubmission(fields.audioSubmission.active));
  }
};

var TOTAL_VALIDATION_RULES = _extends({}, BASE_VALIDATION_RULES, NEW_VOICEOVER_RULES, EXISTING_VOICEOVER_RULES, UPLOADED_AUDIO_RULES, UPLOADED_IMAGE_RULES, EXISTING_VO_BG_RULES, BG_MUSIC_RULES);

_AdValidator2.default.CUSTOM_ERR_MSGS = {
  'accepted.uploads.image.uploaded': (0, _config.lang)('missing-image-file', 'An image is required.'),
  'required.targeting.locations': (0, _config.lang)('missing-location', 'Please select at least one location.'),
  required: {
    string: (0, _config.lang)('missing-field', 'This field is required.')
  },
  'required.workingFor': {
    string: 'Please select an option.'
  },
  accepted: {
    string: (0, _config.lang)('missing-field', 'This field is required.')
  },
  'required.payments.totalBudget': (0, _config.lang)('missing-required-total-budget', 'A total budget must be selected.'),
  'email.businessEmail': { string: 'Invalid email address.' }
};

var initialValidation = {
  isValid: false,
  errorMsg: '',
  touched: false
};

function initialState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { stepRules: STEP_RULES, totalRules: TOTAL_VALIDATION_RULES },
      stepRules = _ref.stepRules,
      totalRules = _ref.totalRules;

  var state = _extends({
    allFieldsValid: false,
    'audioSubmission.active': _config.DEFAULT_AUDIO
  }, Object.keys(totalRules).reduce(function (result, field) {
    result[field] = initialValidation;
    return result;
  }, {}));

  if (stepRules) {
    state.steps = (0, _utilities.fillObject)(Object.keys(stepRules), {
      isValid: false,
      touched: false
    });
  }

  return state;
}

function validateAllFields(state) {
  var _typeToRule;

  var typeToRule = (_typeToRule = {}, _defineProperty(_typeToRule, _config.NEW_VOICEOVER, NEW_VOICEOVER_RULES), _defineProperty(_typeToRule, _config.EXISTING_VOICEOVER, EXISTING_VOICEOVER_RULES), _defineProperty(_typeToRule, _config.UPLOADED_AUDIO, UPLOADED_AUDIO_RULES), _typeToRule);
  var activeAudioType = state['audioSubmission.active'];

  var activeAudioTypeRulesValid = !Object.keys(state).filter(function (k) {
    return typeToRule[activeAudioType][k] !== undefined;
  }).some(function (x) {
    return state[x].isValid === false;
  });
  var baseRulesValid = !Object.keys(state).filter(function (k) {
    return BASE_VALIDATION_RULES[k] !== undefined;
  }).some(function (x) {
    return state[x].isValid === false;
  });

  return activeAudioTypeRulesValid && baseRulesValid;
}

// Helpers
function fieldsAreValid(step, editableAd, validationFields) {
  var stepRules = STEP_RULES[step](editableAd);
  return Object.keys(stepRules).every(function (k) {
    return validationFields[k].isValid;
  });
}

function validation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments[1];

  var data = void 0;
  var rules = void 0;
  var errors = void 0;
  var validator = void 0;
  var newState = void 0;

  switch (action.type) {
    case _editableAd.UPDATE_FIELDS:
      // Change active audio type
      if (action.field.key === 'audioSubmission.active') {
        newState = _extends({}, state, {
          'audioSubmission.active': action.field.value
        });

        return _extends({}, newState, {
          allFieldsValid: validateAllFields(newState, action.mode)
        });
      }

      if (!action.field.shouldValidate || !TOTAL_VALIDATION_RULES[action.field.key]) {
        return state;
      }

      data = _defineProperty({}, action.field.key, action.field.value);
      rules = _defineProperty({}, action.field.key, TOTAL_VALIDATION_RULES[action.field.key]);
      validator = new _AdValidator2.default(data, rules, action.groups);

      newState = _extends({}, state, _defineProperty({}, action.field.key, {
        isValid: validator.check(),
        errorMsg: validator.fails() ? validator.errors.first(action.field.key) : '',
        touched: true
      }));

      return _extends({}, newState, {
        allFieldsValid: validateAllFields(newState, action.mode)
      });
    case _validation.VALIDATE_STEP_FIELDS:
      rules = STEP_RULES[action.step](action.fields);
      validator = new _AdValidator2.default(action.fields, rules, action.groups);
      validator.check();

      errors = validator.errors.all();

      newState = _extends({}, state, {
        steps: _extends({}, state.steps, _defineProperty({}, action.step, {
          isValid: validator.passes(),
          touched: true
        }))
      }, Object.keys(errors).reduce(function (result, fieldKey) {
        result[fieldKey] = {
          isValid: false,
          errorMsg: errors[fieldKey][0],
          touched: true
        };
        return result;
      }, {}));

      return _extends({}, newState, {
        allFieldsValid: validateAllFields(newState)
      });
    case _validation.VALIDATE_FIELDS:
      rules = _extends({}, BASE_VALIDATION_RULES, getRulesFromActiveAudioSubmission(action.fields.audioSubmission.active));
      validator = new _AdValidator2.default(action.fields, rules, action.groups);
      validator.check();

      errors = validator.errors.all();

      newState = _extends({}, state, {
        'audioSubmission.active': action.fields.audioSubmission.active
      }, Object.keys(TOTAL_VALIDATION_RULES).reduce(function (result, fieldKey) {
        result[fieldKey] = {
          isValid: !errors[fieldKey],
          errorMsg: !!errors[fieldKey] && errors[fieldKey][0] || '',
          touched: !action.initialValidation
        };
        return result;
      }, {}));

      return _extends({}, newState, {
        allFieldsValid: validator.errorCount === 0,
        steps: Object.keys(state.steps).reduce(function (result, stepNumber) {
          result[stepNumber] = {
            isValid: fieldsAreValid(stepNumber, action.fields, newState),
            touched: !action.initialValidation
          };
          return result;
        }, {})
      });
    default:
      return state;
  }
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAdminAlertSuccess = fetchAdminAlertSuccess;
var FETCH_ADMIN_ALERT_SUCCESS = exports.FETCH_ADMIN_ALERT_SUCCESS = 'FETCH_ADMIN_ALERT_SUCCESS';

function fetchAdminAlertSuccess(res) {
  return {
    type: FETCH_ADMIN_ALERT_SUCCESS,
    payload: {
      text: res
    }
  };
}

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationError = function ValidationError(_ref) {
  var errorMsg = _ref.errorMsg,
      fieldName = _ref.fieldName;
  return _react2.default.createElement(
    'label',
    { htmlFor: fieldName,
      className: 'control-label-validation' },
    errorMsg
  );
};

ValidationError.propTypes = {
  errorMsg: _propTypes2.default.string,
  fieldName: _propTypes2.default.string
};

exports.default = ValidationError;

/***/ }),
/* 466 */,
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentsErrorMessage = exports.getPaymentsMethod = exports.arePaymentsLoaded = exports.isPaymentsConnected = exports.isPaymentsLoading = exports.getCurrency = exports.getPayments = undefined;

var _get = __webpack_require__(193);

var _get2 = _interopRequireDefault(_get);

var _user = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPayments = exports.getPayments = function getPayments(state) {
  return state.payments;
};

// return the currency for the users payment profile
var getCurrency = exports.getCurrency = function getCurrency(state) {
  return getPayments(state).currency;
};

// return if the payments have not been fetched yet, or if they are in
// progress for fetching
var isPaymentsLoading = exports.isPaymentsLoading = function isPaymentsLoading(state) {
  var _getPayments = getPayments(state),
      fetched = _getPayments.fetched,
      fetching = _getPayments.fetching;

  return !fetched || fetching;
};

// return true if payments are connected
var isPaymentsConnected = exports.isPaymentsConnected = function isPaymentsConnected(state) {
  return (0, _get2.default)(getPayments(state), 'adyen.isConnected', false);
};

// return if the payments are fetched already and not loading again
var arePaymentsLoaded = exports.arePaymentsLoaded = function arePaymentsLoaded(state) {
  var _getPayments2 = getPayments(state),
      fetched = _getPayments2.fetched,
      fetching = _getPayments2.fetching;

  return fetched && !fetching;
};

// return the payment method for this user based on groups and flags
var getPaymentsMethod = exports.getPaymentsMethod = function getPaymentsMethod(state) {
  if ((0, _user.isInternalUser)(state)) {
    return 'internal';
  }

  return 'adyen';
};

var getPaymentsErrorMessage = exports.getPaymentsErrorMessage = function getPaymentsErrorMessage(state) {
  // don't update the error message if we're still loading
  if (isPaymentsLoading(state)) {
    return;
  }

  // internal users don't have payments
  if (getPaymentsMethod(state) === 'internal') {
    return;
  }

  if (getPaymentsMethod(state) === 'adyen') {
    var _getPayments3 = getPayments(state),
        _getPayments3$adyen = _getPayments3.adyen,
        connectionError = _getPayments3$adyen.connectionError,
        formDetailsError = _getPayments3$adyen.formDetailsError,
        systemError = _getPayments3$adyen.systemError;

    if (formDetailsError) {
      return formDetailsError;
    }

    if (connectionError) {
      return connectionError;
    }

    if (systemError) {
      return 'Contact adstudio@spotify.com if you\'re having trouble.';
    }
  }
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCOUNT_REDUX_FORM_ID = exports.ACCOUNT_REDUX_FORM_ID = 'AccountForm';

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isRequiredForA11y = __webpack_require__(303);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  (0, _inherits3['default'])(Tooltip, _React$Component);

  function Tooltip() {
    (0, _classCallCheck3['default'])(this, Tooltip);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = (0, _extends4['default'])({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return _react2['default'].createElement(
      'div',
      (0, _extends4['default'])({}, elementProps, {
        role: 'tooltip',
        className: (0, _classnames2['default'])(className, classes),
        style: outerStyle
      }),
      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
      _react2['default'].createElement(
        'div',
        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(_react2['default'].Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
module.exports = exports['default'];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingSpinner;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingSpinner(_ref) {
  var diameter = _ref.diameter,
      color = _ref.color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'spinner-indeterminate',
      width: diameter,
      viewBox: '0 0 100 100'
    },
    _react2.default.createElement('circle', {
      className: 'path-indeterminate',
      cx: '50',
      cy: '50',
      r: '25',
      fill: 'none',
      stroke: color,
      strokeLinecap: 'round',
      strokeWidth: '2.5'
    })
  );
}

LoadingSpinner.defaultProps = {
  diameter: '210px',
  color: '#1DB954'
};

LoadingSpinner.propTypes = {
  diameter: _propTypes2.default.string,
  color: _propTypes2.default.string
};

/***/ }),
/* 471 */,
/* 472 */,
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getIsOnline = exports.getIsOnline = function getIsOnline(state) {
  return Boolean(state.network.status);
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(404),
    getTag = __webpack_require__(296),
    isArguments = __webpack_require__(196),
    isArray = __webpack_require__(59),
    isArrayLike = __webpack_require__(197),
    isBuffer = __webpack_require__(198),
    isPrototype = __webpack_require__(182),
    isTypedArray = __webpack_require__(298);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toDate = __webpack_require__(269);

var _toDate2 = _interopRequireDefault(_toDate);

var _toFloat = __webpack_require__(405);

var _toFloat2 = _interopRequireDefault(_toFloat);

var _toInt = __webpack_require__(862);

var _toInt2 = _interopRequireDefault(_toInt);

var _toBoolean = __webpack_require__(863);

var _toBoolean2 = _interopRequireDefault(_toBoolean);

var _equals = __webpack_require__(864);

var _equals2 = _interopRequireDefault(_equals);

var _contains = __webpack_require__(865);

var _contains2 = _interopRequireDefault(_contains);

var _matches = __webpack_require__(866);

var _matches2 = _interopRequireDefault(_matches);

var _isEmail = __webpack_require__(406);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isURL = __webpack_require__(867);

var _isURL2 = _interopRequireDefault(_isURL);

var _isMACAddress = __webpack_require__(868);

var _isMACAddress2 = _interopRequireDefault(_isMACAddress);

var _isIP = __webpack_require__(408);

var _isIP2 = _interopRequireDefault(_isIP);

var _isFQDN = __webpack_require__(271);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

var _isBoolean = __webpack_require__(869);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isAlpha = __webpack_require__(870);

var _isAlpha2 = _interopRequireDefault(_isAlpha);

var _isAlphanumeric = __webpack_require__(871);

var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);

var _isNumeric = __webpack_require__(872);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _isLowercase = __webpack_require__(873);

var _isLowercase2 = _interopRequireDefault(_isLowercase);

var _isUppercase = __webpack_require__(874);

var _isUppercase2 = _interopRequireDefault(_isUppercase);

var _isAscii = __webpack_require__(875);

var _isAscii2 = _interopRequireDefault(_isAscii);

var _isFullWidth = __webpack_require__(410);

var _isFullWidth2 = _interopRequireDefault(_isFullWidth);

var _isHalfWidth = __webpack_require__(411);

var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);

var _isVariableWidth = __webpack_require__(876);

var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);

var _isMultibyte = __webpack_require__(877);

var _isMultibyte2 = _interopRequireDefault(_isMultibyte);

var _isSurrogatePair = __webpack_require__(878);

var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);

var _isInt = __webpack_require__(879);

var _isInt2 = _interopRequireDefault(_isInt);

var _isFloat = __webpack_require__(880);

var _isFloat2 = _interopRequireDefault(_isFloat);

var _isDecimal = __webpack_require__(881);

var _isDecimal2 = _interopRequireDefault(_isDecimal);

var _isHexadecimal = __webpack_require__(412);

var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);

var _isDivisibleBy = __webpack_require__(882);

var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);

var _isHexColor = __webpack_require__(883);

var _isHexColor2 = _interopRequireDefault(_isHexColor);

var _isMD = __webpack_require__(884);

var _isMD2 = _interopRequireDefault(_isMD);

var _isJSON = __webpack_require__(885);

var _isJSON2 = _interopRequireDefault(_isJSON);

var _isNull = __webpack_require__(886);

var _isNull2 = _interopRequireDefault(_isNull);

var _isLength = __webpack_require__(887);

var _isLength2 = _interopRequireDefault(_isLength);

var _isByteLength = __webpack_require__(407);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isUUID = __webpack_require__(888);

var _isUUID2 = _interopRequireDefault(_isUUID);

var _isMongoId = __webpack_require__(889);

var _isMongoId2 = _interopRequireDefault(_isMongoId);

var _isDate = __webpack_require__(890);

var _isDate2 = _interopRequireDefault(_isDate);

var _isAfter = __webpack_require__(891);

var _isAfter2 = _interopRequireDefault(_isAfter);

var _isBefore = __webpack_require__(892);

var _isBefore2 = _interopRequireDefault(_isBefore);

var _isIn = __webpack_require__(893);

var _isIn2 = _interopRequireDefault(_isIn);

var _isCreditCard = __webpack_require__(894);

var _isCreditCard2 = _interopRequireDefault(_isCreditCard);

var _isISIN = __webpack_require__(895);

var _isISIN2 = _interopRequireDefault(_isISIN);

var _isISBN = __webpack_require__(896);

var _isISBN2 = _interopRequireDefault(_isISBN);

var _isMobilePhone = __webpack_require__(897);

var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

var _isCurrency = __webpack_require__(898);

var _isCurrency2 = _interopRequireDefault(_isCurrency);

var _isISO = __webpack_require__(413);

var _isISO2 = _interopRequireDefault(_isISO);

var _isBase = __webpack_require__(899);

var _isBase2 = _interopRequireDefault(_isBase);

var _isDataURI = __webpack_require__(900);

var _isDataURI2 = _interopRequireDefault(_isDataURI);

var _ltrim = __webpack_require__(414);

var _ltrim2 = _interopRequireDefault(_ltrim);

var _rtrim = __webpack_require__(415);

var _rtrim2 = _interopRequireDefault(_rtrim);

var _trim = __webpack_require__(901);

var _trim2 = _interopRequireDefault(_trim);

var _escape = __webpack_require__(902);

var _escape2 = _interopRequireDefault(_escape);

var _unescape = __webpack_require__(903);

var _unescape2 = _interopRequireDefault(_unescape);

var _stripLow = __webpack_require__(904);

var _stripLow2 = _interopRequireDefault(_stripLow);

var _whitelist = __webpack_require__(905);

var _whitelist2 = _interopRequireDefault(_whitelist);

var _blacklist = __webpack_require__(416);

var _blacklist2 = _interopRequireDefault(_blacklist);

var _isWhitelisted = __webpack_require__(906);

var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);

var _normalizeEmail = __webpack_require__(907);

var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);

var _toString = __webpack_require__(270);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '5.7.0';

var validator = {
  version: version,
  toDate: _toDate2.default,
  toFloat: _toFloat2.default, toInt: _toInt2.default,
  toBoolean: _toBoolean2.default,
  equals: _equals2.default, contains: _contains2.default, matches: _matches2.default,
  isEmail: _isEmail2.default, isURL: _isURL2.default, isMACAddress: _isMACAddress2.default, isIP: _isIP2.default, isFQDN: _isFQDN2.default,
  isBoolean: _isBoolean2.default,
  isAlpha: _isAlpha2.default, isAlphanumeric: _isAlphanumeric2.default, isNumeric: _isNumeric2.default, isLowercase: _isLowercase2.default, isUppercase: _isUppercase2.default,
  isAscii: _isAscii2.default, isFullWidth: _isFullWidth2.default, isHalfWidth: _isHalfWidth2.default, isVariableWidth: _isVariableWidth2.default,
  isMultibyte: _isMultibyte2.default, isSurrogatePair: _isSurrogatePair2.default,
  isInt: _isInt2.default, isFloat: _isFloat2.default, isDecimal: _isDecimal2.default, isHexadecimal: _isHexadecimal2.default, isDivisibleBy: _isDivisibleBy2.default,
  isHexColor: _isHexColor2.default,
  isMD5: _isMD2.default,
  isJSON: _isJSON2.default,
  isNull: _isNull2.default,
  isLength: _isLength2.default, isByteLength: _isByteLength2.default,
  isUUID: _isUUID2.default, isMongoId: _isMongoId2.default,
  isDate: _isDate2.default, isAfter: _isAfter2.default, isBefore: _isBefore2.default,
  isIn: _isIn2.default,
  isCreditCard: _isCreditCard2.default,
  isISIN: _isISIN2.default, isISBN: _isISBN2.default,
  isMobilePhone: _isMobilePhone2.default,
  isCurrency: _isCurrency2.default,
  isISO8601: _isISO2.default,
  isBase64: _isBase2.default, isDataURI: _isDataURI2.default,
  ltrim: _ltrim2.default, rtrim: _rtrim2.default, trim: _trim2.default,
  escape: _escape2.default, unescape: _unescape2.default, stripLow: _stripLow2.default,
  whitelist: _whitelist2.default, blacklist: _blacklist2.default,
  isWhitelisted: _isWhitelisted2.default,
  normalizeEmail: _normalizeEmail2.default,
  toString: _toString2.default
};

exports.default = validator;
module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _Overlay = __webpack_require__(908);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = _propTypes2['default'].oneOf(['click', 'hover', 'focus']);

var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {

  /**
  * Specify which action or actions trigger Overlay visibility
  */
  trigger: _propTypes2['default'].oneOfType([triggerType, _propTypes2['default'].arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: _propTypes2['default'].number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: _propTypes2['default'].number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: _propTypes2['default'].number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: _propTypes2['default'].bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: _propTypes2['default'].node.isRequired,

  /**
   * @private
   */
  onBlur: _propTypes2['default'].func,
  /**
   * @private
   */
  onClick: _propTypes2['default'].func,
  /**
   * @private
   */
  onFocus: _propTypes2['default'].func,
  /**
   * @private
   */
  onMouseOut: _propTypes2['default'].func,
  /**
   * @private
   */
  onMouseOver: _propTypes2['default'].func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: _propTypes2['default'].oneOf([null]),
  /**
  * @private
  */
  onHide: _propTypes2['default'].oneOf([null]),
  /**
   * @private
   */
  show: _propTypes2['default'].oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  (0, _inherits3['default'])(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    (0, _classCallCheck3['default'])(this, OverlayTrigger);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this2 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this2._hoverShowDelay = null;
      _this2.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this3 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this3._hoverHideDelay = null;
      _this3.hide();
    }, delay);
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent.toElement;

    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return _react2['default'].createElement(
      _Overlay2['default'],
      (0, _extends3['default'])({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);


    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = _react2['default'].Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return (0, _react.cloneElement)(child, triggerProps);
  };

  return OverlayTrigger;
}(_react2['default'].Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

exports['default'] = OverlayTrigger;
module.exports = exports['default'];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var matches = __webpack_require__(942)

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}


/***/ }),
/* 478 */,
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(618), __esModule: true };

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(59),
    isSymbol = __webpack_require__(195);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(803);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(174),
    stackClear = __webpack_require__(957),
    stackDelete = __webpack_require__(958),
    stackGet = __webpack_require__(959),
    stackHas = __webpack_require__(960),
    stackSet = __webpack_require__(961);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newAdFormatter = newAdFormatter;
exports.platformFill = platformFill;
exports.genderFill = genderFill;
exports.freeTrialFill = freeTrialFill;
exports.getUri = getUri;
exports.editAdFormatter = editAdFormatter;
exports.audienceSizeFormatter = audienceSizeFormatter;

var _moment = __webpack_require__(85);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _uploadProperties = __webpack_require__(117);

var _dateHelper = __webpack_require__(149);

var _utilities = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function newAdFormatter(newAd) {
  var clickthroughUrl = newAd.clickthroughUrl,
      dateRange = newAd.dateRange,
      audioSubmission = newAd.audioSubmission,
      uploads = newAd.uploads,
      name = newAd.name,
      internalName = newAd.internalName,
      objective = newAd.objective;
  var _newAd$targeting = newAd.targeting,
      gender = _newAd$targeting.gender,
      platforms = _newAd$targeting.platforms,
      genres = _newAd$targeting.genres,
      freeTrial = _newAd$targeting.freeTrial,
      ageRange = _newAd$targeting.ageRange,
      locations = _newAd$targeting.locations,
      moments = _newAd$targeting.moments,
      fanAudiences = _newAd$targeting.fanAudiences;
  var totalBudget = newAd.payments.totalBudget;


  var selectedGenres = genres.map(function (genre) {
    return genre.id;
  });
  var selectedPlatforms = Object.keys(platforms).filter(function (k) {
    return platforms[k] === true;
  }).map(function (k) {
    return k.toLowerCase();
  });
  var selectedLocations = locations.map(function (loc) {
    return loc.id;
  });
  var selectedMoments = moments.map(function (m) {
    return m.id;
  });
  var selectedFanAudiences = fanAudiences.map(function (fans) {
    return { artistGid: fans.id, artistName: fans.name };
  });

  var ad = {
    name: name,
    banner: uploads.image.uploadInfo.id,
    genders: gender === _config.ALL_GENDERS_VALUE ? _config.ALL_GENDERS_LIST : [gender],
    geo: selectedLocations,
    genres: selectedGenres,
    platforms: selectedPlatforms,
    moments: selectedMoments,
    audiences: selectedFanAudiences,
    clickthroughUrl: clickthroughUrl,
    dateBegin: (0, _moment2.default)(dateRange.begin).format(),
    dateEnd: (0, _moment2.default)(dateRange.end).format(),
    ageMin: ageRange.start,
    ageMax: ageRange.end,
    totalBudget: totalBudget,
    internalName: internalName,
    objective: objective
  };

  if (freeTrial !== _config.FREE_TRIAL_NULL_VALUE) {
    ad.freeTrialEligible = (freeTrial === _config.FREE_TRIAL_ELIGIBLE).toString();
  }

  switch (audioSubmission.active) {
    case _config.NEW_VOICEOVER:
      if (uploads[_config.BG_MUSIC].uploaded) {
        ad.bgmusicId = uploads[_config.BG_MUSIC].uploadInfo.id;
      }
      if (audioSubmission[_config.NEW_VOICEOVER].bgMusic.id) {
        ad.bgmusicId = audioSubmission[_config.NEW_VOICEOVER].bgMusic.id;
      }

      ad.voiceover = {
        name: audioSubmission[_config.NEW_VOICEOVER].name,
        transcript: audioSubmission[_config.NEW_VOICEOVER].transcript,
        instructions: audioSubmission[_config.NEW_VOICEOVER].instructions,
        locale: audioSubmission[_config.NEW_VOICEOVER].locale,
        voice: audioSubmission[_config.NEW_VOICEOVER].voice
      };
      break;
    case _config.UPLOADED_AUDIO:
      ad.fullmixId = uploads[_config.UPLOADED_AUDIO].uploadInfo.id;
      break;
    case _config.EXISTING_VOICEOVER:
      ad.voiceover = {
        id: audioSubmission[_config.EXISTING_VOICEOVER].data.id
      };
      if (uploads[_config.EXISTING_VO_BG_MUSIC].uploaded) {
        ad.bgmusicId = uploads[_config.EXISTING_VO_BG_MUSIC].uploadInfo.id;
      }
      if (audioSubmission[_config.EXISTING_VOICEOVER].bgMusic.id) {
        ad.bgmusicId = audioSubmission[_config.EXISTING_VOICEOVER].bgMusic.id;
      }
      break;
    default:
  }

  return ad;
}

function platformFill(platforms) {
  return platforms.reduce(function (platformObj, platform) {
    platformObj[platform] = true;
    return platformObj;
  }, { android: false, ios: false, desktop: false });
}

function genderFill(genders) {
  return genders.length === 1 ? genders[0] : _config.ALL_GENDERS_VALUE;
}

function freeTrialFill(freeTrialEligible) {
  var freeTrial = void 0;
  if (freeTrialEligible) {
    freeTrial = _config.FREE_TRIAL_ELIGIBLE;
  } else if (typeof freeTrialEligible === 'boolean') {
    freeTrial = _config.FREE_TRIAL_INELIGIBLE;
  } else {
    freeTrial = _config.FREE_TRIAL_NULL_VALUE;
  }

  return freeTrial;
}

function getUri(id) {
  return 'https://drdxyzdg0sjtu.cloudfront.net/assets/audiocomponent/' + id + '/asset';
}

function editAdFormatter(ad) {
  var _uploads;

  var _ad$bgMusicId = ad.bgMusicId,
      bgMusicId = _ad$bgMusicId === undefined ? '' : _ad$bgMusicId,
      targeting = ad.targeting;


  var editAd = {
    id: ad.id,
    name: ad.name,
    internalName: ad.internalName,
    targeting: {
      locations: targeting.geo,
      platforms: platformFill(targeting.platforms),
      gender: genderFill(targeting.genders),
      ageRange: {
        start: targeting.ageMin.toString(),
        end: targeting.ageMax.toString()
      },
      moments: targeting.moments,
      genres: targeting.genres,
      freeTrial: freeTrialFill(targeting.freeTrialEligible),
      fanAudiences: []
    },
    dateRange: {
      begin: ad.dateBegin,
      end: ad.dateEnd
    },
    payments: {
      totalBudget: ad.totalBudget
    },
    uploads: (_uploads = {}, _defineProperty(_uploads, _config.UPLOADED_COVER_ART, (0, _uploadProperties.createDefaultImageUploadObj)()), _defineProperty(_uploads, _config.UPLOADED_AUDIO, (0, _uploadProperties.createDefaultAudioUploadObj)()), _defineProperty(_uploads, _config.BG_MUSIC, {
      uploadInfo: {
        id: bgMusicId,
        uri: bgMusicId ? getUri(bgMusicId) : ''
      }
    }), _defineProperty(_uploads, _config.EXISTING_VO_BG_MUSIC, (0, _uploadProperties.createDefaultAudioUploadObj)()), _uploads)
  };

  return editAd;
}

function audienceSizeFormatter(ad) {
  var _ad$targeting = ad.targeting,
      _ad$targeting$ageRang = _ad$targeting.ageRange,
      ageMin = _ad$targeting$ageRang.start,
      ageMax = _ad$targeting$ageRang.end,
      gender = _ad$targeting.gender,
      fanAudiences = _ad$targeting.fanAudiences,
      genres = _ad$targeting.genres,
      platforms = _ad$targeting.platforms,
      locations = _ad$targeting.locations,
      moments = _ad$targeting.moments,
      budget = ad.payments.totalBudget,
      _ad$dateRange = ad.dateRange,
      dateStart = _ad$dateRange.begin,
      dateEnd = _ad$dateRange.end;


  var genders = (gender === _config.ALL_GENDERS_VALUE ? _config.ALL_GENDERS_LIST : [gender]).map(function (g) {
    return g.toLowerCase();
  });
  var artists = fanAudiences.map(function (fans) {
    return fans.id;
  });
  var genresList = genres.map(function (genre) {
    return genre.id;
  });
  var playlists = moments.map(function (playlist) {
    return playlist.id.replace('momenttag:', '');
  });

  var payload = {
    ageMin: Number(ageMin),
    ageMax: Number(ageMax),
    numDays: (0, _dateHelper.daysBetweenDates)(dateStart, dateEnd),
    budget: (0, _utilities.clamp)(Number(budget), 250, 5000),
    genders: genders,
    genres: genresList,
    artists: artists,
    platforms: Object.keys(platforms).filter(function (k) {
      return platforms[k] === true;
    }).map(function (k) {
      return k;
    }),
    playlists: playlists,
    geo: locations.map(function (loc) {
      return typeof loc.id === 'number' ? loc.id : Number(loc.id.replace('dfp:', ''));
    })
  };

  return payload;
}

/***/ }),
/* 484 */,
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AUDIO_NAME;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UPLOADED_AUDIO = exports.UPLOADED_AUDIO = 'fullmix';
var EXISTING_VOICEOVER = exports.EXISTING_VOICEOVER = 'existingVO';
var NEW_VOICEOVER = exports.NEW_VOICEOVER = 'newVO';
var BG_MUSIC = exports.BG_MUSIC = 'bgmusic';
var DEFAULT_AUDIO = exports.DEFAULT_AUDIO = UPLOADED_AUDIO;
var EXISTING_VO_BG_MUSIC = exports.EXISTING_VO_BG_MUSIC = 'existingVOBgmusic';

var AUDIO_NAME = exports.AUDIO_NAME = (_AUDIO_NAME = {}, _defineProperty(_AUDIO_NAME, UPLOADED_AUDIO, 'User Uploaded Audio'), _defineProperty(_AUDIO_NAME, EXISTING_VOICEOVER, 'Existing Voiceover'), _defineProperty(_AUDIO_NAME, NEW_VOICEOVER, 'New Voiceover'), _AUDIO_NAME);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAccount = addAccount;
exports.getAccount = getAccount;
exports.updateAccount = updateAccount;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _storageHelpers = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('addAccount');
var url = 'adgenerator/v1/account';

function addAccount(data, accessToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  log('Add account information: %s', data);
  var opts = {
    method: 'POST',
    body: (0, _storageHelpers.jsonStringify)(data)
  };

  return webGate(url, accessToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r);
    return Promise.resolve(r.status);
  });
}

function getAccount(accessToken) {
  var webGate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _callWebGate2.default;

  var opts = {
    method: 'GET'
  };

  return webGate(url, accessToken, opts).then(function (r) {
    switch (r.status) {
      case 200:
        return r.json();
      case 404:
        return Promise.resolve(null);
      default:
        return Promise.reject(new Error(r.statusText));
    }
  });
}

function updateAccount(data, accessToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  log('Update account information: %s', data);
  var opts = {
    method: 'PUT',
    body: (0, _storageHelpers.jsonStringify)(data)
  };

  return webGate(url, accessToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r);
    return Promise.resolve(r.status);
  });
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomePageFooter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _HomePageFooterSvgs = __webpack_require__(947);

var _HomePageFooterSvgs2 = _interopRequireDefault(_HomePageFooterSvgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HomePageFooter() {
  return _react2.default.createElement(
    'footer',
    { className: 'footer footer-default', role: 'contentinfo' },
    _react2.default.createElement(_HomePageFooterSvgs2.default, null),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'nav',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-md-2' },
          _react2.default.createElement(
            'div',
            { className: 'footer-logo' },
            _react2.default.createElement(
              'a',
              { href: 'http://spotifyforbrands.com/us' },
              'Spotify'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-sm-4 col-md-2' },
          _react2.default.createElement(
            'h3',
            { className: 'nav-title' },
            'Company'
          ),
          _react2.default.createElement(
            'ul',
            { className: 'nav' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotify.com/us/about-us/contact/' },
                'About'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotify.com/us/jobs/' },
                'Jobs'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://press.spotify.com/us/' },
                'Press'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://news.spotify.com/us/' },
                'News'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-sm-4 col-md-2' },
          _react2.default.createElement(
            'h3',
            { className: 'nav-title' },
            'Community'
          ),
          _react2.default.createElement(
            'ul',
            { className: 'nav' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotifyartists.com/' },
                'Artists'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://developer.spotify.com/' },
                'Developers'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotify.com/us/brands/' },
                'Brands'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-6 col-sm-4 col-md-2' },
          _react2.default.createElement(
            'h3',
            { className: 'nav-title' },
            'Useful Links'
          ),
          _react2.default.createElement(
            'ul',
            { className: 'nav' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                {
                  className: 'nav-link',
                  href: 'https://support.spotify.com/?utm_source=www.spotify.com&utm_medium=www_footer&_ga=2.179794404.1176359094.1504624428-334658961.1490890546'
                },
                'Help'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotify.com/us/purchase/ecards/' },
                'Gift'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { className: 'nav-link', href: 'https://www.spotify.com/us/redirect/webplayerlink/?utm_medium=www_footer' },
                'Web Player'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-md-4 col-social' },
          _react2.default.createElement(
            'ul',
            { className: 'nav' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'http://instagram.com/spotify' },
                _react2.default.createElement(
                  'svg',
                  { className: 'social-icon' },
                  _react2.default.createElement('use', { xlinkHref: '#instagram-icon' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'social-text' },
                  'Instagram'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://twitter.com/spotify' },
                _react2.default.createElement(
                  'svg',
                  { className: 'social-icon' },
                  _react2.default.createElement('use', { xlinkHref: '#twitter-icon' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'social-text' },
                  'Twitter'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://www.facebook.com/Spotify' },
                _react2.default.createElement(
                  'svg',
                  { className: 'social-icon' },
                  _react2.default.createElement('use', { xlinkHref: '#facebook-icon' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'social-text' },
                  'Facebook'
                )
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        'nav',
        { className: 'row row-small' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-7 col-md-4 col-md-offset-2' },
          _react2.default.createElement(
            'ul',
            { className: 'nav nav-small' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://www.spotify.com/legal/' },
                'Legal'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://www.spotify.com/legal/privacy-policy/#cookies' },
                'Cookies'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-5 col-md-6 text-right' },
          _react2.default.createElement(
            'a',
            { className: 'market', href: 'https://www.spotify.com/select-your-country' },
            _react2.default.createElement(
              'div',
              { className: 'media' },
              _react2.default.createElement(
                'div',
                { className: 'media-body media-middle' },
                'United States'
              ),
              _react2.default.createElement(
                'div',
                { className: 'media-right media-middle' },
                _react2.default.createElement('span', { className: 'media-object flag-icon flag-icon-us' })
              )
            )
          ),
          _react2.default.createElement(
            'small',
            { className: 'copyright' },
            '\xA9 2017 Spotify AB'
          )
        )
      )
    )
  );
}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(423),
    getSymbols = __webpack_require__(276),
    keys = __webpack_require__(190);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 494 */,
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileFieldChanged = fileFieldChanged;
var IMAGE_FILE_SELECTED = exports.IMAGE_FILE_SELECTED = 'IMAGE_FILE_SELECTED';
var AUDIO_FILE_SELECTED = exports.AUDIO_FILE_SELECTED = 'AUDIO_FILE_SELECTED';

function fileFieldChanged(file, component, type) {
  var onComplete = component.onComplete,
      onProgress = component.onProgress,
      onError = component.onError;
  var _component$props = component.props,
      wgToken = _component$props.wgToken,
      placeholderType = _component$props.placeholderType,
      validationKey = _component$props.validationKey;


  return {
    type: type,
    payload: {
      file: file,
      onComplete: onComplete.bind(component),
      onProgress: onProgress.bind(component),
      onError: onError.bind(component),
      wgToken: wgToken,
      placeholderType: placeholderType,
      validationKey: validationKey
    }
  };
}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approvalActionTypeRegex = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.approval = approval;
exports.onboarding = onboarding;
exports.adNotFound = adNotFound;
exports.fetchingAd = fetchingAd;
exports.fetchingAdList = fetchingAdList;
exports.refreshingAdList = refreshingAdList;
exports.fetchingReviewAudioList = fetchingReviewAudioList;
exports.reviewAudioById = reviewAudioById;
exports.byId = byId;
exports.visibleIds = visibleIds;
exports.refreshIds = refreshIds;
exports.adFilters = adFilters;
exports.reviewAudioIds = reviewAudioIds;
exports.filters = filters;
exports.userInputNameSearch = userInputNameSearch;
exports.paging = paging;
exports.reviewAudioPaging = reviewAudioPaging;
exports.refreshAdsError = refreshAdsError;
exports.activeAd = activeAd;
exports.getAds = getAds;
exports.refreshAdsById = refreshAdsById;
exports.reviewAudioAdsById = reviewAudioAdsById;

var _redux = __webpack_require__(53);

var _isEmpty = __webpack_require__(474);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _adReview = __webpack_require__(146);

var adReviewActionTypes = _interopRequireWildcard(_adReview);

var _debug = __webpack_require__(432);

var debug = _interopRequireWildcard(_debug);

var _filterAds = __webpack_require__(203);

var filterAdActionTypes = _interopRequireWildcard(_filterAds);

var _utilities = __webpack_require__(46);

var _config = __webpack_require__(30);

var _BrowseAds = __webpack_require__(192);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var approvalActionTypeRegex = exports.approvalActionTypeRegex = /^(APPROVE|CANCEL|REJECT|REVISE|KICK)_AD_(SUBMITTED|SUCCEEDED|FAILED)$/;

function approval() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (!action.type || !action.type.match(approvalActionTypeRegex)) {
    return state;
  }

  return _extends({}, state, _defineProperty({}, action.id, {
    approvalStatus: action.type,
    errorMsg: action.err || ''
  }));
}

function onboarding() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    shouldCheck: true,
    show: false
  };
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_ADS_SUCCESS:
      // on the first fetch, determine whether the user has any ads.
      // TODO: this should be a flag on the account to avoid any odd cases
      // where the user deep links into a page that has no ads.
      if (state.shouldCheck) {
        return {
          shouldCheck: false,
          show: (0, _isEmpty2.default)(action.ads)
        };
      }

      return state;

    default:
      return state;
  }
}

function adNotFound() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_AD_REQUESTED:
      return false;
    case adReviewActionTypes.FETCH_AD_NOT_FOUND:
      return true;
    case adReviewActionTypes.FETCH_AD_SUCCESS:
      return false;
    case adReviewActionTypes.FETCH_AD_FAILED:
      return false;
    default:
      return state;
  }
}

function fetchingAd() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_AD_REQUESTED:
      return true;
    case adReviewActionTypes.FETCH_AD_NOT_FOUND:
      return false;
    case adReviewActionTypes.FETCH_AD_SUCCESS:
      return false;
    case adReviewActionTypes.FETCH_AD_FAILED:
      return false;
    default:
      return state;
  }
}

function fetchingAdList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_ADS_REQUESTED:
      return true;
    case adReviewActionTypes.FETCH_ADS_SUCCESS:
      return false;
    case adReviewActionTypes.FETCH_ADS_FAILED:
      return false;
    default:
      return state;
  }
}

function refreshingAdList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case filterAdActionTypes.UPDATE_AD_FILTERS:
    case adReviewActionTypes.REFRESH_ADS_REQUESTED:
      return true;
    case adReviewActionTypes.REFRESH_ADS_SUCCESS:
      return false;
    case adReviewActionTypes.REFRESH_ADS_FAILED:
      return false;
    default:
      return state;
  }
}

function fetchingReviewAudioList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.REVIEW_AUDIO_ADS_REQUESTED:
      return true;
    case adReviewActionTypes.REVIEW_AUDIO_ADS_SUCCESS:
    case adReviewActionTypes.REVIEW_AUDIO_ADS_FAILED:
      return false;
    default:
      return state;
  }
}

function reviewAudioById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.REVIEW_AUDIO_ADS_SUCCESS:
      return _extends({}, action.ads.reduce(function (obj, ad) {
        obj[ad.id] = ad;
        return obj;
      }, {}));
    default:
      return state;
  }
}

function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_AD_SUCCESS:
      return _extends({}, state, _defineProperty({}, action.ad.id, action.ad));
    case adReviewActionTypes.FETCH_ADS_SUCCESS:
      return _extends({}, state, action.ads.reduce(function (obj, ad) {
        obj[ad.id] = ad;
        return obj;
      }, {}));
    case adReviewActionTypes.REFRESH_ADS_SUCCESS:
      return _extends({}, action.ads.reduce(function (obj, ad) {
        obj[ad.id] = ad;
        return obj;
      }, {}));
    case debug.EXTEND_START_DATE:
      return _extends({}, state, _defineProperty({}, action.payload.id, _extends({}, state[action.payload.id], {
        dateBegin: action.payload.newStartDate
      })));
    case debug.EXTEND_END_DATE:
      return _extends({}, state, _defineProperty({}, action.payload.id, _extends({}, state[action.payload.id], {
        dateEnd: action.payload.newEndDate
      })));
    default:
      return state;
  }
}

function visibleIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.FETCH_ADS_SUCCESS:
      return state.concat(action.ads.map(function (ad) {
        return ad.id;
      }));
    default:
      return state;
  }
}

function refreshIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.REFRESH_ADS_SUCCESS:
      return action.ads.map(function (ad) {
        return ad.id;
      });
    default:
      return state;
  }
}

function adFilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _BrowseAds.DEFAULT_PARAMS;
  var action = arguments[1];

  switch (action.type) {
    case filterAdActionTypes.UPDATE_AD_FILTERS:
      return _extends({}, state, action.payload);
    case filterAdActionTypes.UPDATE_SEARCH_WORD:
      return _extends({}, state, action.payload);
    default:
      return state;
  }
}

function reviewAudioIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.REVIEW_AUDIO_ADS_SUCCESS:
      return action.ads.map(function (ad) {
        return ad.id;
      });
    default:
      return state;
  }
}

var initialFilterState = {
  activeStatus: [],
  excludedStatus: []
};

function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFilterState;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.ACTIVE_STATUS_FILTER_UPDATED:
      return _extends({}, state, {
        activeStatus: action.status
      });
    default:
      return state;
  }
}

function userInputNameSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.UPDATE_NAME_FILTER:
      return action.pattern;
    default:
      return state;
  }
}

var initialPagingState = {
  limit: _config.PAGINATION_PAGE_LIMIT,
  offset: 0,
  total: 0
};

function paging() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPagingState;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.UPDATE_PAGING_INFO:
      return _extends({}, state, {
        total: action.paging.total,
        offset: state.limit + state.offset
      });
    default:
      return state;
  }
}

function reviewAudioPaging() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPagingState;
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.UPDATE_REVIEW_AUDIO_PAGING_INFO:
      return _extends({}, state, {
        total: action.paging.total,
        offset: state.limit + state.offset
      });
    default:
      return state;
  }
}

function refreshAdsError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.REFRESH_ADS_FAILED:
      return action.err;
    case adReviewActionTypes.REFRESH_ADS_SUCCESS:
      return '';
    default:
      return state;
  }
}

// Currently unused. May be useful when more metadata specific to single ad exists
function activeAd() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case adReviewActionTypes.RECEIVE_AD:
      return _extends({}, action.ad);
    default:
      return state;
  }
}

exports.default = (0, _redux.combineReducers)({
  approval: approval,
  filters: filters,
  byId: byId,
  reviewAudioById: reviewAudioById,
  visibleIds: visibleIds,
  refreshIds: refreshIds,
  reviewAudioIds: reviewAudioIds,
  userInputNameSearch: userInputNameSearch,
  paging: paging,
  reviewAudioPaging: reviewAudioPaging,
  fetchingAd: fetchingAd,
  fetchingAdList: fetchingAdList,
  refreshingAdList: refreshingAdList,
  fetchingReviewAudioList: fetchingReviewAudioList,
  refreshAdsError: refreshAdsError,
  adNotFound: adNotFound,
  adFilters: adFilters,
  onboarding: onboarding
});

// Review Audio Utils

function getReviewAudioAd(state, id) {
  return state.reviewAudioById[id];
}

function reviewAudioExcludedStatus(state, id) {
  var ad = getReviewAudioAd(state, id);
  return !state.filters.excludedStatus.some(function (s) {
    return s === ad.adState;
  });
}

function reviewAudioByUserInputAdName(state, id) {
  var ad = getReviewAudioAd(state, id);
  return (0, _utilities.fuzzyMatch)(ad.internalName, state.userInputNameSearch);
}

// Utils
function getAd(state, id) {
  return state.byId[id];
}

function excludedStatus(state, id) {
  var ad = getAd(state, id);
  return !state.filters.excludedStatus.some(function (s) {
    return s === ad.adState;
  });
}

function byStatus(state, id) {
  if (state.filters.activeStatus.length === 0) return true;

  var ad = getAd(state, id);
  return state.filters.activeStatus.some(function (s) {
    return s === ad.adState;
  });
}

function byUserInputAdName(state, id) {
  var ad = getAd(state, id);
  return (0, _utilities.fuzzyMatch)(ad.internalName, state.userInputNameSearch);
}

function getAds(state) {
  return state.visibleIds.filter(byStatus.bind(null, state)).filter(excludedStatus.bind(null, state)).filter(byUserInputAdName.bind(null, state)).map(function (id) {
    return getAd(state, id);
  });
}

function refreshAdsById(state) {
  return state.refreshIds.filter(byStatus.bind(null, state)).filter(excludedStatus.bind(null, state)).filter(byUserInputAdName.bind(null, state)).map(function (id) {
    return getAd(state, id);
  });
}

function reviewAudioAdsById(state) {
  return state.reviewAudioIds.filter(byStatus.bind(null, state)).filter(reviewAudioExcludedStatus.bind(null, state)).filter(reviewAudioByUserInputAdName.bind(null, state)).map(function (id) {
    return getReviewAudioAd(state, id);
  });
}

/***/ }),
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(291);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Objective = exports.OBJECTIVES = exports.CHAR_LIMIT = exports.CONTENT_PROMO = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationError = __webpack_require__(465);

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Exported for components that should only show
// when a user is promoting content.
var CONTENT_PROMO = exports.CONTENT_PROMO = 'contentpromo';

var CHAR_LIMIT = exports.CHAR_LIMIT = 100;

var OBJECTIVES = exports.OBJECTIVES = _defineProperty({
  businesspromo: 'Raise awareness for a brand, business, or organization'
}, CONTENT_PROMO, 'Promote a concert or music related content');

// TODO: split RadioList to be its own form-common field component
var Objective = exports.Objective = function Objective(_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('form-group', { 'has-error': touched && error }) },
    _react2.default.createElement(
      'label',
      null,
      'Choose your objective'
    ),
    _react2.default.createElement(
      'fieldset',
      { className: 'objective-select' },
      _react2.default.createElement(
        'ul',
        null,
        Object.keys(OBJECTIVES).map(function (k) {
          return _react2.default.createElement(
            'li',
            { key: k },
            _react2.default.createElement(
              'div',
              { className: 'input-group' },
              _react2.default.createElement(
                'span',
                { className: 'input-group-addon' },
                _react2.default.createElement('input', {
                  type: 'radio',
                  value: k,
                  id: 'objective-' + k,
                  checked: value === k,
                  onChange: onChange
                })
              ),
              _react2.default.createElement(
                'label',
                { htmlFor: 'objective-' + k },
                OBJECTIVES[k]
              )
            )
          );
        })
      )
    ),
    touched && error && _react2.default.createElement(_ValidationError2.default, { errorMsg: error })
  );
};

Objective.propTypes = {
  input: _propTypes2.default.shape({
    onChange: _propTypes2.default.func.isRequired
  }),
  meta: _propTypes2.default.shape({
    touched: _propTypes2.default.bool,
    error: _propTypes2.default.string
  })
};

exports.default = Objective;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Passthrough = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Passthrough = exports.Passthrough = function Passthrough(_ref) {
  var children = _ref.children;

  if (Array.isArray(children)) {
    return _react2.default.createElement(
      'div',
      null,
      children
    );
  }

  return children;
};

Passthrough.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.element])
};

exports.default = Passthrough;

/***/ }),
/* 501 */,
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNAL_NAV_TYPE = exports.HOMEPAGE_NAV_TYPE = undefined;
exports.NavigationBar = NavigationBar;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(58);

var _reactRedux = __webpack_require__(22);

var _reactRouterRedux = __webpack_require__(60);

var _Navbar = __webpack_require__(915);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Nav = __webpack_require__(504);

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = __webpack_require__(505);

var _NavItem2 = _interopRequireDefault(_NavItem);

var _NavDropdown = __webpack_require__(924);

var _NavDropdown2 = _interopRequireDefault(_NavDropdown);

var _MenuItem = __webpack_require__(939);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _OverlayTrigger = __webpack_require__(476);

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Tooltip = __webpack_require__(469);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _routes = __webpack_require__(86);

var _auth = __webpack_require__(36);

var _user = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOMEPAGE_NAV_TYPE = exports.HOMEPAGE_NAV_TYPE = 'homepage-nav';
var INTERNAL_NAV_TYPE = exports.INTERNAL_NAV_TYPE = 'internal-nav';

function NavigationBar(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
      userInfo = _ref.userInfo,
      isWhitelisted = _ref.isWhitelisted,
      historyPush = _ref.historyPush,
      navType = _ref.navType,
      hasLoginError = _ref.hasLoginError;

  var fixedTop = navType !== HOMEPAGE_NAV_TYPE;
  var staticTop = navType === HOMEPAGE_NAV_TYPE;
  var fluid = navType !== HOMEPAGE_NAV_TYPE;
  var navigate = function navigate(pathname) {
    return function () {
      return historyPush(pathname);
    };
  };
  var loginErrorTooltip = _react2.default.createElement(
    _Tooltip2.default,
    { id: 'tooltip', className: 'login-error-tooltip' },
    'Sorry, we are having some technical difficulties. Please refresh this page in a few minutes.'
  );

  return _react2.default.createElement(
    _Navbar2.default,
    {
      inverse: false,
      className: navType,
      fixedTop: fixedTop,
      staticTop: staticTop,
      fluid: fluid,
      collapseOnSelect: true
    },
    _react2.default.createElement(
      _Navbar2.default.Header,
      null,
      _react2.default.createElement(
        _Navbar2.default.Brand,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: _routes.routeStrings.MAIN, className: 'navbar-brand' },
          _react2.default.createElement(
            'span',
            { className: 'navbar-logo' },
            'Spotify'
          )
        )
      ),
      _react2.default.createElement(_Navbar2.default.Toggle, null)
    ),
    _react2.default.createElement(
      _Navbar2.default.Collapse,
      null,
      _react2.default.createElement(
        _Nav2.default,
        { pullRight: true },
        isAuthenticated && isWhitelisted && _react2.default.createElement(
          _NavItem2.default,
          { title: 'Spotify Ad Studio Manage Your Ads', onClick: navigate('/' + _routes.routeStrings.BROWSE_ADS) },
          'Manage Ads'
        ),
        (!isWhitelisted || !isAuthenticated) && _react2.default.createElement(
          _NavItem2.default,
          { onClick: navigate(_routes.routeStrings.WAITLIST) },
          'Join Waitlist'
        ),
        _react2.default.createElement(
          _NavItem2.default,
          { title: 'Spotify Ad Studio FAQs page', onClick: navigate('/' + _routes.routeStrings.FAQ) },
          'FAQs'
        ),
        _react2.default.createElement(_NavItem2.default, { role: 'separator', className: 'divider' }),
        !isAuthenticated && hasLoginError && _react2.default.createElement(
          _OverlayTrigger2.default,
          { id: 'login-error-overlay', placement: 'bottom', overlay: loginErrorTooltip },
          _react2.default.createElement(
            _NavItem2.default,
            { title: 'Spotify Ad Studio log in with error', id: 'navbar-login', disabled: true, className: 'login-error' },
            'Log In'
          )
        ),
        !isAuthenticated && !hasLoginError && _react2.default.createElement(
          _NavItem2.default,
          { title: 'Spotify Ad Studio log in page', id: 'navbar-login', onClick: navigate(_routes.routeStrings.LOGIN) },
          'Log In'
        ),
        isAuthenticated && _react2.default.createElement(
          _NavDropdown2.default,
          {
            id: 'user-dropdown',
            className: 'ta-user-badge-toggle user-badge-toggle',
            title: _react2.default.createElement(
              'div',
              { style: { display: 'inline' } },
              userInfo.imgSrc && _react2.default.createElement('img', { alt: 'User', className: 'user-img img-circle navbar-user-img', src: userInfo.imgSrc }),
              userInfo.displayName || userInfo.id
            )
          },
          _react2.default.createElement(
            _MenuItem2.default,
            {
              title: 'Spotify Ad Studio account page',
              onClick: navigate(_routes.routeStrings.ACCOUNT),
              className: 'ta-account'
            },
            'Account'
          ),
          _react2.default.createElement(
            _MenuItem2.default,
            { title: 'Spotify Ad Studio log out', onClick: navigate(_routes.routeStrings.LOGOUT), className: 'ta-logout' },
            'Log out'
          )
        )
      )
    )
  );
}

NavigationBar.defaultProps = {
  navType: HOMEPAGE_NAV_TYPE
};

NavigationBar.propTypes = {
  hasLoginError: _propTypes2.default.bool,
  historyPush: _propTypes2.default.func.isRequired,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  isWhitelisted: _propTypes2.default.bool.isRequired,
  userInfo: _propTypes2.default.object,
  navType: _propTypes2.default.oneOf([HOMEPAGE_NAV_TYPE, INTERNAL_NAV_TYPE])
};

function mapStateToProps(state) {
  return {
    isAuthenticated: (0, _auth.getIsAuthenticated)(state),
    isWhitelisted: (0, _auth.getIsWhitelisted)(state),
    hasLoginError: (0, _auth.getHasLoginError)(state),
    userInfo: (0, _user.getUser)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  historyPush: _reactRouterRedux.push
})(NavigationBar);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _style = __webpack_require__(180);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(268);

var _Transition2 = _interopRequireDefault(_Transition);

var _capitalize = __webpack_require__(921);

var _capitalize2 = _interopRequireDefault(_capitalize);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
}

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  'in': _propTypes2['default'].bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes2['default'].bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: _propTypes2['default'].bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _propTypes2['default'].bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: _propTypes2['default'].number,

  /**
   * Callback fired before the component expands
   */
  onEnter: _propTypes2['default'].func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: _propTypes2['default'].func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: _propTypes2['default'].func,
  /**
   * Callback fired before the component collapses
   */
  onExit: _propTypes2['default'].func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: _propTypes2['default'].func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: _propTypes2['default'].func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['height', 'width']), _propTypes2['default'].func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: _propTypes2['default'].func,

  /**
   * ARIA role of collapsible element
   */
  role: _propTypes2['default'].string
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  (0, _inherits3['default'])(Collapse, _React$Component);

  function Collapse(props, context) {
    (0, _classCallCheck3['default'])(this, Collapse);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleEntered = _this.handleEntered.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleExiting = _this.handleExiting.bind(_this);
    return _this;
  }

  /* -- Expanding -- */


  Collapse.prototype.handleEnter = function handleEnter(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.handleEntering = function handleEntering(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
  };

  Collapse.prototype.handleEntered = function handleEntered(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = null;
  };

  /* -- Collapsing -- */


  Collapse.prototype.handleExit = function handleExit(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
    triggerBrowserReflow(elem);
  };

  Collapse.prototype.handleExiting = function handleExiting(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype._dimension = function _dimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
  };

  Collapse.prototype.render = function render() {
    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);


    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);

    var classes = {
      width: this._dimension() === 'width'
    };

    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
      'aria-expanded': props.role ? props['in'] : null,
      className: (0, _classnames2['default'])(className, classes),
      exitedClassName: 'collapse',
      exitingClassName: 'collapsing',
      enteredClassName: 'collapse in',
      enteringClassName: 'collapsing',
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }));
  };

  return Collapse;
}(_react2['default'].Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

exports['default'] = Collapse;
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(274);

var _keycode2 = _interopRequireDefault(_keycode);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _all = __webpack_require__(183);

var _all2 = _interopRequireDefault(_all);

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _bootstrapUtils = __webpack_require__(17);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = __webpack_require__(88);

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: _propTypes2['default'].any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: _propTypes2['default'].string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: _propTypes2['default'].bool,

  justified: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   */
  onSelect: _propTypes2['default'].func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: _propTypes2['default'].string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: _propTypes2['default'].bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: _propTypes2['default'].bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: _propTypes2['default'].bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string,
    onSelect: _propTypes2['default'].func
  }),

  $bs_tabContainer: _propTypes2['default'].shape({
    activeKey: _propTypes2['default'].any,
    onSelect: _propTypes2['default'].func.isRequired,
    getTabId: _propTypes2['default'].func.isRequired,
    getPaneId: _propTypes2['default'].func.isRequired
  })
};

var Nav = function (_React$Component) {
  (0, _inherits3['default'])(Nav, _React$Component);

  function Nav() {
    (0, _classCallCheck3['default'])(this, Nav);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = _reactDom2['default'].findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case _keycode2['default'].codes.left:
      case _keycode2['default'].codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case _keycode2['default'].codes.right:
      case _keycode2['default'].codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);


    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;

      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return _react2['default'].createElement(
      'ul',
      (0, _extends4['default'])({}, elementProps, {
        role: role,
        className: (0, _classnames2['default'])(className, classes)
      }),
      _ValidComponentChildren2['default'].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(_react2['default'].Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SafeAnchor = __webpack_require__(150);

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  active: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  role: _propTypes2['default'].string,
  href: _propTypes2['default'].string,
  onClick: _propTypes2['default'].func,
  onSelect: _propTypes2['default'].func,
  eventKey: _propTypes2['default'].any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  (0, _inherits3['default'])(NavItem, _React$Component);

  function NavItem(props, context) {
    (0, _classCallCheck3['default'])(this, NavItem);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);


    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return _react2['default'].createElement(
      'li',
      {
        role: 'presentation',
        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
        style: style
      },
      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
        disabled: disabled,
        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(_react2['default'].Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

exports['default'] = NavItem;
module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyPage = function EmptyPage(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'empty-page' },
    title && _react2.default.createElement(
      'h2',
      null,
      title
    ),
    children
  );
};

EmptyPage.propTypes = {
  children: _propTypes2.default.node,
  title: _propTypes2.default.string
};

exports.default = EmptyPage;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitWaitlistFormFailed = submitWaitlistFormFailed;
var SUBMIT_WAITLIST_FORM_FAILED = exports.SUBMIT_WAITLIST_FORM_FAILED = 'SUBMIT_WAITLIST_FORM_FAILED';

function submitWaitlistFormFailed(e) {
  return {
    type: SUBMIT_WAITLIST_FORM_FAILED,
    err: e
  };
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADYEN_INVALID_CARD_ERROR = exports.DEFAULT_ADYEN_HPP_REDIRECT_ERROR = exports.DEFAULT_ADYEN_FETCH_ERROR = undefined;
exports.AdyenRecurringDetailNotFoundError = AdyenRecurringDetailNotFoundError;
exports.AdyenRecurringDetailNotificationPendingError = AdyenRecurringDetailNotificationPendingError;
exports.AdyenRecurringDetailError = AdyenRecurringDetailError;
exports.getAdyenRecurringDetails = getAdyenRecurringDetails;
exports.getAdyenHPPFormDetails = getAdyenHPPFormDetails;
exports.linkCardToAdyenUser = linkCardToAdyenUser;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('api:payments');

var DEFAULT_ADYEN_FETCH_ERROR = exports.DEFAULT_ADYEN_FETCH_ERROR = 'There was a problem fetching your payment information. Contact adstudio@spotify.com if you\'re having trouble.';
var DEFAULT_ADYEN_HPP_REDIRECT_ERROR = exports.DEFAULT_ADYEN_HPP_REDIRECT_ERROR = 'There was a problem processing your payment request. Contact adstudio@spotify.com if you\'re having trouble.';
var ADYEN_INVALID_CARD_ERROR = exports.ADYEN_INVALID_CARD_ERROR = 'Enter a valid credit card number. Contact adstudio@spotify.com if you\'re having trouble.';

function AdyenRecurringDetailNotFoundError() {
  Error.call(this);
}

function AdyenRecurringDetailNotificationPendingError() {
  Error.call(this);
}

function AdyenRecurringDetailError(message) {
  Error.call(this);
  this.message = message;
}

function getAdyenRecurringDetails(accessToken) {
  var webGate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _callWebGate2.default;

  return webGate('adsgtm/v1/adyen/card', accessToken).then(function (r) {
    switch (r.status) {
      case 404:
        return Promise.reject(new AdyenRecurringDetailNotFoundError());
      case 406:
        return r.json().then(function () {
          return Promise.reject(new AdyenRecurringDetailError(ADYEN_INVALID_CARD_ERROR));
        });
      case 204:
        return Promise.reject(new AdyenRecurringDetailNotificationPendingError());
      case 200:
        return r.json();
      default:
        return r.text().then(function (e) {
          var errorMessage = e || DEFAULT_ADYEN_FETCH_ERROR;
          log('getAdyenRecurringDetails response error: %s', errorMessage);
          return Promise.reject(new Error(errorMessage));
        });
    }
  });
}

function getAdyenHPPFormDetails(accessToken) {
  var webGate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _callWebGate2.default;

  return webGate('adsgtm/v2/adyen/hpp', accessToken).then(function (r) {
    switch (r.status) {
      case 200:
        return r.json();
      default:
        return r.text().then(function (e) {
          var errorMessage = e || DEFAULT_ADYEN_HPP_REDIRECT_ERROR;
          log('getAdyenHPPFormDetails response error: %s', errorMessage);
          return Promise.reject(new Error(errorMessage));
        });
    }
  });
}

function linkCardToAdyenUser(accessToken, params) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var opts = {
    method: 'POST',
    body: JSON.stringify(params)
  };
  return webGate('adsgtm/v1/adyen/card/link', accessToken, opts).then(function (r) {
    if (r.ok) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Failed to link card to adyen user.'));
  });
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUS_MAP = exports.STATUS_MAP = {
  pending_approval: 'Pending approval',
  rejected: 'Rejected',
  stopped: 'Stopped',
  active: 'Active',
  ready: 'Ready',
  review_audio: 'Awaiting review',
  complete: 'Complete',
  processing: 'Processing'
};

var FILTER_TO_STATUS = exports.FILTER_TO_STATUS = {
  'All ads': '',
  Active: 'active',
  Complete: 'complete',
  Processing: 'processing',
  'Pending approval': 'pending_approval',
  Ready: 'ready',
  Rejected: 'rejected',
  'Awaiting review': 'review_audio',
  Stopped: 'stopped'
};

var STATUS_DESCRIPTION_MAP = exports.STATUS_DESCRIPTION_MAP = {
  pending_approval: 'Your ad is being reviewed for approval by the Spotify ads team.',
  rejected: 'Your ad has been rejected for reasons detailed in an email sent to you. If you would like to run a rejected ad, please rebuild another compliant ad. Alternatively, if you rejected a voiceover, the ad will also display as a rejected ad.',
  stopped: 'You stopped the ad before its scheduled end date.',
  active: 'Your ad is live. Our ad server will deliver your ad to your available selected audience.',
  ready: 'Your ad has been approved and will go live according to your selected start date.',
  review_audio: 'Your requested voiceover is ready for your review. In the “Review” state, you can approve the voiceover or request revisions. If you uploaded your own audio voiceover, your ad will not pass through this state.',
  complete: 'Your ad is no longer delivering. Final metrics may not be updated until the next day.',
  processing: 'Your audio ad is being mixed. If you requested a voiceover, it will move into "Review" after it is done processing. If you uploaded your own audio voiceover, it will move into "Pending Approval" after it is done processing.'
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(391),
    baseClone = __webpack_require__(995),
    baseUnset = __webpack_require__(1017),
    castPath = __webpack_require__(194),
    copyObject = __webpack_require__(145),
    customOmitClone = __webpack_require__(1021),
    flatRest = __webpack_require__(1022),
    getAllKeysIn = __webpack_require__(436);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mapGenres = mapGenres;
var GENRE_MAP = exports.GENRE_MAP = {
  children: 'children\'s',
  hiphop: 'hip hop',
  rnb: 'r&B',
  spokenandaudio: 'spoken audio'
};

function mapGenres(genres) {
  return genres.map(function (genre) {
    if (GENRE_MAP[genre.name]) {
      return _extends({}, genre, { name: GENRE_MAP[genre.name] });
    }

    return genre;
  });
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(513);


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startupApp;

__webpack_require__(514);

__webpack_require__(515);

__webpack_require__(520);

__webpack_require__(521);

__webpack_require__(522);

__webpack_require__(523);

__webpack_require__(524);

__webpack_require__(525);

__webpack_require__(526);

__webpack_require__(527);

__webpack_require__(528);

__webpack_require__(530);

__webpack_require__(531);

__webpack_require__(532);

__webpack_require__(533);

__webpack_require__(534);

__webpack_require__(536);

__webpack_require__(537);

__webpack_require__(538);

__webpack_require__(539);

__webpack_require__(540);

__webpack_require__(541);

__webpack_require__(542);

__webpack_require__(543);

__webpack_require__(544);

__webpack_require__(545);

__webpack_require__(546);

__webpack_require__(547);

__webpack_require__(551);

__webpack_require__(555);

__webpack_require__(556);

__webpack_require__(558);

__webpack_require__(559);

__webpack_require__(560);

__webpack_require__(561);

__webpack_require__(562);

__webpack_require__(564);

__webpack_require__(565);

__webpack_require__(566);

__webpack_require__(567);

__webpack_require__(568);

__webpack_require__(570);

__webpack_require__(571);

__webpack_require__(572);

__webpack_require__(573);

__webpack_require__(574);

__webpack_require__(575);

__webpack_require__(576);

__webpack_require__(577);

__webpack_require__(578);

__webpack_require__(579);

__webpack_require__(216);

__webpack_require__(580);

__webpack_require__(581);

__webpack_require__(582);

__webpack_require__(583);

__webpack_require__(584);

__webpack_require__(585);

__webpack_require__(586);

__webpack_require__(587);

__webpack_require__(588);

__webpack_require__(589);

__webpack_require__(590);

__webpack_require__(591);

__webpack_require__(592);

__webpack_require__(593);

__webpack_require__(594);

__webpack_require__(596);

__webpack_require__(597);

__webpack_require__(598);

__webpack_require__(599);

__webpack_require__(600);

__webpack_require__(601);

__webpack_require__(602);

__webpack_require__(603);

__webpack_require__(604);

__webpack_require__(605);

__webpack_require__(606);

__webpack_require__(607);

__webpack_require__(608);

__webpack_require__(609);

__webpack_require__(610);

__webpack_require__(611);

__webpack_require__(612);

__webpack_require__(613);

__webpack_require__(614);

__webpack_require__(615);

__webpack_require__(616);

__webpack_require__(617);

__webpack_require__(671);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _runtime = __webpack_require__(762);

var _runtime2 = _interopRequireDefault(_runtime);

var _flags = __webpack_require__(89);

var _Root = __webpack_require__(763);

var _Root2 = _interopRequireDefault(_Root);

var _createStore = __webpack_require__(1032);

var _createStore2 = _interopRequireDefault(_createStore);

var _createHistory = __webpack_require__(1092);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startupApp() {
  var isProd = (0, _flags.getFlag)('env') === 'prod';
  var swEnabled = (0, _flags.getFlag)('swEnabled') === true;

  if (swEnabled) {
    if ('serviceWorker' in navigator) {
      _runtime2.default.register();
    }
  }

  var store = (0, _createStore2.default)();
  var history = (0, _createHistory2.default)(store);
  var root = document.getElementById('root');

  if (isProd) {
    return (0, _reactDom.render)(_react2.default.createElement(_Root2.default, { store: store, history: history }), root);
  }

  // dev rendering

  var _require = __webpack_require__(1093),
      AppContainer = _require.AppContainer;

  (0, _reactDom.render)(_react2.default.createElement(
    AppContainer,
    null,
    _react2.default.createElement(_Root2.default, { store: store, history: history })
  ), root);

  if (false) {
    module.hot.accept('./containers/Root', function () {
      var NextRoot = require('./containers/Root');
      (0, _reactDom.render)(_react2.default.createElement(
        AppContainer,
        null,
        _react2.default.createElement(NextRoot, { store: store, history: history })
      ), root);
    });
  }
}

// kick off startup


// startup scripts


// styles
startupApp();

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(205);
var buffer = __webpack_require__(305);
var anObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(95);
var toLength = __webpack_require__(27);
var isObject = __webpack_require__(18);
var ArrayBuffer = __webpack_require__(14).ArrayBuffer;
var speciesConstructor = __webpack_require__(212);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(23)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(154)(ARRAY_BUFFER);


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var anObject = __webpack_require__(15);
var getKeys = __webpack_require__(98);

module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(518);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var isArray = __webpack_require__(309);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(125);
var descriptor = __webpack_require__(70);
var setToStringTag = __webpack_require__(96);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(38)(IteratorPrototype, __webpack_require__(21)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(313);
var validate = __webpack_require__(100);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(157)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var setPrototypeOf = __webpack_require__(217).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(313);
var validate = __webpack_require__(100);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(157)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(127)(0);
var redefine = __webpack_require__(62);
var meta = __webpack_require__(129);
var assign = __webpack_require__(315);
var weak = __webpack_require__(316);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(23);
var validate = __webpack_require__(100);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(157)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(316);
var validate = __webpack_require__(100);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(157)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(72);
var anObject = __webpack_require__(15);
var rApply = (__webpack_require__(14).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(23)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(125);
var aFunction = __webpack_require__(72);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(23);
var bind = __webpack_require__(535);
var rConstruct = (__webpack_require__(14).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(72);
var isObject = __webpack_require__(18);
var invoke = __webpack_require__(317);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(26);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(123);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(23)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(63).f;
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(126);
var has = __webpack_require__(33);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(15);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(63);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(126);
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(15);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(318) });


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(15);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(26);
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(126);
var has = __webpack_require__(33);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(70);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(18);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(217);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(91);
var global = __webpack_require__(14);
var ctx = __webpack_require__(48);
var classof = __webpack_require__(213);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(18);
var aFunction = __webpack_require__(72);
var anInstance = __webpack_require__(93);
var forOf = __webpack_require__(156);
var speciesConstructor = __webpack_require__(212);
var task = __webpack_require__(218).set;
var microtask = __webpack_require__(548)();
var newPromiseCapabilityModule = __webpack_require__(319);
var perform = __webpack_require__(549);
var promiseResolve = __webpack_require__(550);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(21)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(92)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(96)($Promise, PROMISE);
__webpack_require__(154)(PROMISE);
Wrapper = __webpack_require__(122)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(155)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var macrotask = __webpack_require__(218).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(94)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var isObject = __webpack_require__(18);
var newPromiseCapability = __webpack_require__(319);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(14);
var has = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(32);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(62);
var META = __webpack_require__(129).KEY;
var $fails = __webpack_require__(23);
var shared = __webpack_require__(209);
var setToStringTag = __webpack_require__(96);
var uid = __webpack_require__(71);
var wks = __webpack_require__(21);
var wksExt = __webpack_require__(320);
var wksDefine = __webpack_require__(552);
var enumKeys = __webpack_require__(553);
var isArray = __webpack_require__(309);
var anObject = __webpack_require__(15);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(123);
var createDesc = __webpack_require__(70);
var _create = __webpack_require__(125);
var gOPNExt = __webpack_require__(554);
var $GOPD = __webpack_require__(63);
var $DP = __webpack_require__(26);
var $keys = __webpack_require__(98);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(124).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(128).f = $propertyIsEnumerable;
  __webpack_require__(158).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(91)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(38)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(122);
var LIBRARY = __webpack_require__(91);
var wksExt = __webpack_require__(320);
var defineProperty = __webpack_require__(26).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(98);
var gOPS = __webpack_require__(158);
var pIE = __webpack_require__(128);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(49);
var gOPN = __webpack_require__(124).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(315) });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(557) });


/***/ }),
/* 557 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(217).set });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(32) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(49);
var toLength = __webpack_require__(27);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(95);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(563)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(74);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(321)
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(27);
var context = __webpack_require__(219);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(220)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(27);
var context = __webpack_require__(219);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(220)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(219);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(220)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(32) && /./g.flags != 'g') __webpack_require__(26).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(569)
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(15);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(159)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(159)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(159)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(322);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(159)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(48);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(75);
var call = __webpack_require__(314);
var isArrayIter = __webpack_require__(214);
var toLength = __webpack_require__(27);
var createProperty = __webpack_require__(221);
var getIterFn = __webpack_require__(215);

$export($export.S + $export.F * !__webpack_require__(155)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(221);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(23)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(312) });

__webpack_require__(99)('copyWithin');


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(127)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(99)(KEY);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(127)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(99)(KEY);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(211) });

__webpack_require__(99)('fill');


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(14).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(323) });


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(323);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(324);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(222);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(223);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(595) });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(222);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(23)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(324) });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(222) });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(223);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(23)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(223);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(207)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(99)('includes');


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(325)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(325)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(318);
var toIObject = __webpack_require__(49);
var gOPD = __webpack_require__(63);
var createProperty = __webpack_require__(221);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(326);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(326);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(14);
var $export = __webpack_require__(2);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(218);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(216);
var getKeys = __webpack_require__(98);
var redefine = __webpack_require__(62);
var global = __webpack_require__(14);
var hide = __webpack_require__(38);
var Iterators = __webpack_require__(97);
var wks = __webpack_require__(21);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Button = __webpack_require__(188);

var _Button2 = _interopRequireDefault(_Button);

var _utils = __webpack_require__(670);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_utils.bootstrapUtils.addStyle(_Button2.default, 'azure');
_utils.bootstrapUtils.addStyle(_Button2.default, 'black');
_utils.bootstrapUtils.addStyle(_Button2.default, 'splash-cta');

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(619);
module.exports = __webpack_require__(42).Object.values;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(64);
var $values = __webpack_require__(329)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;

var _bootstrapUtils2 = __webpack_require__(17);

var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);

var _createChainedFunction2 = __webpack_require__(29);

var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);

var _ValidComponentChildren2 = __webpack_require__(88);

var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports.bootstrapUtils = _bootstrapUtils;
exports.createChainedFunction = _createChainedFunction3['default'];
exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactGa = __webpack_require__(347);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _flags = __webpack_require__(89);

var _ga = __webpack_require__(680);

var _loggly = __webpack_require__(681);

var _sentry = __webpack_require__(683);

var _logglyHelper = __webpack_require__(684);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('startup:logging');
var isProd = (0, _flags.getFlag)('env') === 'prod';

/**
 * Sentry
 */
if (window.Raven) {
  window.Raven.config(_sentry.SENTRY_DSN[(0, _flags.getFlag)('env')], {
    ignoreUrls: [/localhost/]
  });

  if (isProd) {
    log('Setting up Sentry');

    // In dev, we don't want errors to be caught for sourcemaps to kick in
    window.Raven.install();
  }
}

/**
 * Loggly
 */
if (isProd) {
  var loggly = window._LTracker || [];
  var logglyKey = _loggly.LOGGLY_KEY;
  var sendConsoleErrors = true;
  var tag = (0, _loggly.getLogglyTags)().join(',');

  log('Setting up Loggly | tags: %s', tag);

  loggly.push({ logglyKey: logglyKey, sendConsoleErrors: sendConsoleErrors, tag: tag });

  // To avoid the color info being added
  // Note: Overriding debug.useColors doesn't work.
  _debug2.default.formatArgs = function () {};
  var oldLog = _debug2.default.log;
  _debug2.default.log = function () {
    oldLog.apply(undefined, arguments);
    var result = _logglyHelper.formatArgs.apply(undefined, arguments);
    loggly.push(result);
  };
}

/**
 * Google Analytics
 */
log('Setting up Google Analytics');
_reactGa2.default.initialize(_ga.GOOGLE_ANALYTICS_ID[(0, _flags.getFlag)('env')], { debug: !isProd });

/**
 * Debug
 */
window.debug = _debug2.default;

if (!isProd) {
  window.debug.enable('*,-sockjs-client:*');
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var mightBeEmail = __webpack_require__(673);
var toTitleCase = __webpack_require__(674);
var warn = __webpack_require__(349);

var _redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if (mightBeEmail(s)) {
    warn('This arg looks like an email address, redacting.');
    return _redacted;
  }

  if (titleCase) {
    return toTitleCase(s);
  }

  return s;
}

module.exports = format;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/).test(s);
}

module.exports = mightBeEmail;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var trim = __webpack_require__(348);

function toTitleCase(s) {
  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  s = trim(s);

  return s.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 &&
        index + match.length !== title.length &&
        match.search(smallWords) > -1 &&
        title.charAt(index - 2) !== ':' &&
        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
        title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

module.exports = toTitleCase;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

function removeLeadingSlash(s) {
  if (s.substring(0, 1) === '/') {
    s = s.substring(1);
  }

  return s;
}

module.exports = removeLeadingSlash;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

function log(s) {
  console.info('[react-ga]', s);
}

module.exports = log;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var assign = __webpack_require__(13);

var NEWTAB = '_blank';

var OutboundLink = React.createClass({
  displayName: 'OutboundLink',
  propTypes: {
    eventLabel: React.PropTypes.string.isRequired
  },
  statics: {
    trackLink: function () {
      console.warn('ga tracking not enabled');
    }
  },
  handleClick: function (e) {
    e.preventDefault();
    var props = this.props;
    var eventMeta = { label: props.eventLabel };
    OutboundLink.trackLink(eventMeta, function () {
      if (props.target === NEWTAB) {
        window.open(props.to, NEWTAB);
      } else {
        window.location.href = props.to;
      }
    });

    if (props.onClick) {
      props.onClick(e);
    }
  },

  render: function () {
    var props = assign({}, this.props, {
      href: this.props.to,
      onClick: this.handleClick
    });
    return React.createElement('a', props);
  }
});

module.exports = OutboundLink;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(679);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 679 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GOOGLE_ANALYTICS_ID = exports.GOOGLE_ANALYTICS_ID = {
  prod: 'UA-5784146-56',
  dev: 'UA-5784146-57'
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGGLY_KEY = undefined;
exports.getLogglyTags = getLogglyTags;

var _bowser = __webpack_require__(289);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BOWSER_FLAG_NAMES = [
// device
'mobile', 'tablet',
// browser
'chrome', 'firefox', 'msie', 'msedge', 'safari', 'opera', 'samsungBrowser', 'phantom',
// os
'mac', 'windows', 'windowsphone', 'android', 'ios', 'chromeos', 'linux'];

var LOGGLY_KEY = exports.LOGGLY_KEY = '5b463cad-fa33-415e-b10f-3ded0c4bd034';

function getLogglyTags() {
  var logglyTags = ['prod', 'voltron-ui'];

  // attach browser, os, and device tags to our log messages
  BOWSER_FLAG_NAMES.forEach(function (flagName) {
    if (_bowser2.default[flagName]) {
      logglyTags.push(flagName);
    }
  });

  return logglyTags;
}

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SENTRY_DSN = exports.SENTRY_DSN = {
  prod: 'https://20ecb81f6087434b81f593319f8c56da@sentry.io/175169',
  dev: 'https://0424650a52004021bb163d82a3de79c0@sentry.io/176302'
};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.formatArgs = formatArgs;

var _formatUtil = __webpack_require__(685);

var _formatUtil2 = _interopRequireDefault(_formatUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function formatArgs() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var firstArg = args[0];

  // Keep a pure object as is
  if (args.length === 1 && (typeof firstArg === 'undefined' ? 'undefined' : _typeof(firstArg)) === 'object' && !(firstArg instanceof Array)) {
    return firstArg;
  }

  var usesStringFormatting = firstArg.indexOf('%') !== -1;
  if (usesStringFormatting) {
    var message = args[0],
        formatData = args.slice(1);


    return _formatUtil2.default.apply(undefined, [message].concat(_toConsumableArray(formatData)));
  }

  var strings = args.map(function (arg) {
    return typeof arg === 'string' ? arg : JSON.stringify(arg);
  });

  return strings.join(' ');
}

/***/ }),
/* 685 */
/***/ (function(module, exports) {

function format(fmt) {
  var re = /(%?)(%([jds]))/g
    , args = Array.prototype.slice.call(arguments, 1);
  if(args.length) {
    fmt = fmt.replace(re, function(match, escaped, ptn, flag) {
      var arg = args.shift();
      switch(flag) {
        case 's':
          arg = '' + arg;
          break;
        case 'd':
          arg = Number(arg);
          break;
        case 'j':
          arg = JSON.stringify(arg);
          break;
      }
      if(!escaped) {
        return arg; 
      }
      args.unshift(arg);
      return match;
    })
  }

  // arguments remain after formatting
  if(args.length) {
    fmt += ' ' + args.join(' ');
  }

  // update escaped %% values
  fmt = fmt.replace(/%{2,2}/g, '%');

  return '' + fmt;
}

module.exports = format;


/***/ }),
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */
/***/ (function(module, exports) {

var serviceWorkerOption = {"scriptURL":"/service-worker.js"};
      "use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable flowtype/require-valid-file-annotation */
/* global serviceWorkerOption */

exports.default = {
  register: function register() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (navigator.serviceWorker) {
      return navigator.serviceWorker.register(serviceWorkerOption.scriptURL, options);
    }

    return false;
  }
};
module.exports = exports["default"];

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _reactRouter = __webpack_require__(58);

var _routes = __webpack_require__(387);

var _window = __webpack_require__(189);

var _routes2 = __webpack_require__(779);

var _routes3 = _interopRequireDefault(_routes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root(props) {
    _classCallCheck(this, Root);

    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

    _this.removeHistoryListener = function () {};
    return _this;
  }

  _createClass(Root, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.removeHistoryListener = this.listenForRouteChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeHistoryListener();
    }
  }, {
    key: 'listenForRouteChange',
    value: function listenForRouteChange() {
      var _props = this.props,
          history = _props.history,
          saveCurrentRoute = _props.saveCurrentRoute,
          scrollTo = _props.scrollTo;
      // history returns a function that unsubscribes the listener later

      return history.listen(function (location) {
        saveCurrentRoute(location.pathname);
        scrollTo(0, 0);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          store = _props2.store,
          history = _props2.history;


      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes3.default })
      );
    }
  }]);

  return Root;
}(_react.Component);

Root.propTypes = {
  store: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired,
  saveCurrentRoute: _propTypes2.default.func.isRequired,
  scrollTo: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
  saveCurrentRoute: _routes.saveCurrentRoute,
  scrollTo: _window.scrollTo
})(Root);

/***/ }),
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(111);

var _PathUtils = __webpack_require__(66);

var _createHistory = __webpack_require__(258);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(259);

var _BrowserProtocol = __webpack_require__(260);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(776);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(172);

var _createHistory = __webpack_require__(258);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(260);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(111);

var _PathUtils = __webpack_require__(66);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(259);

var _DOMUtils = __webpack_require__(172);

var _HashProtocol = __webpack_require__(778);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(258);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(260);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(111);

var _DOMUtils = __webpack_require__(172);

var _DOMStateStorage = __webpack_require__(386);

var _PathUtils = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(58);

var _routes = __webpack_require__(86);

var _routeHelpers = __webpack_require__(388);

var _analytics = __webpack_require__(68);

var _auth = __webpack_require__(82);

var _AccountSetupRequired = __webpack_require__(804);

var _AccountSetupRequired2 = _interopRequireDefault(_AccountSetupRequired);

var _LoginRequired = __webpack_require__(912);

var _LoginRequired2 = _interopRequireDefault(_LoginRequired);

var _MobileOverlay = __webpack_require__(913);

var _MobileOverlay2 = _interopRequireDefault(_MobileOverlay);

var _SidenavContainer = __webpack_require__(940);

var _SidenavContainer2 = _interopRequireDefault(_SidenavContainer);

var _MainComponent = __webpack_require__(943);

var _MainComponent2 = _interopRequireDefault(_MainComponent);

var _TopnavContainer = __webpack_require__(945);

var _TopnavContainer2 = _interopRequireDefault(_TopnavContainer);

var _NotFound = __webpack_require__(946);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _ExternalRedirect = __webpack_require__(955);

var _ExternalRedirect2 = _interopRequireDefault(_ExternalRedirect);

var _RedirectReturn = __webpack_require__(956);

var _RedirectReturn2 = _interopRequireDefault(_RedirectReturn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// chunk: home
var home = function home() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1104));
};

// one-off pages
var terms = function terms() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1105));
};
var waitlist = function waitlist() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1106));
};
var faq = function faq() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1107));
};

// chunk: build-ad
var buildAd = function buildAd() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1108));
};
var campaignStep = function campaignStep() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1109));
};
var audienceStep = function audienceStep() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1110));
};
var adCreationStep = function adCreationStep() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1111));
};

// chunk: browse-ads
var newBrowseAds = function newBrowseAds() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1112));
};
var adDetailView = function adDetailView() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1113));
};

// chunk: account-settings
var accountSettings = function accountSettings() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1114));
};

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { path: _routes.routeStrings.MAIN, component: _MainComponent2.default },
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _LoginRequired2.default },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _MobileOverlay2.default },
      _react2.default.createElement(
        _reactRouter.Route,
        { component: _AccountSetupRequired2.default },
        _react2.default.createElement(
          _reactRouter.Route,
          { component: _SidenavContainer2.default },
          _react2.default.createElement(
            _reactRouter.Route,
            {
              path: _routes.routeStrings.BROWSE_ADS,
              getComponent: (0, _routeHelpers.getComponentForImport)(newBrowseAds)
            },
            _react2.default.createElement(_reactRouter.Route, {
              path: _routes.routeStrings.BROWSE_ADS_ADVIEW,
              getComponent: (0, _routeHelpers.getComponentForImport)(adDetailView)
            })
          ),
          _react2.default.createElement(_reactRouter.Route, {
            path: _routes.routeStrings.ACCOUNT_SETTINGS,
            getComponent: (0, _routeHelpers.getComponentForImport)(accountSettings)
          }),
          _react2.default.createElement(
            _reactRouter.Route,
            {
              path: _routes.routeStrings.BUILD_AD,
              getComponent: (0, _routeHelpers.getComponentForImport)(buildAd)
            },
            _react2.default.createElement(_reactRouter.IndexRoute, {
              getComponent: (0, _routeHelpers.getComponentForImport)(campaignStep)
            }),
            _react2.default.createElement(_reactRouter.Route, {
              path: _routes.routeStrings.CAMPAIGN_STEP,
              getComponent: (0, _routeHelpers.getComponentForImport)(campaignStep)
            }),
            _react2.default.createElement(_reactRouter.Route, {
              path: _routes.routeStrings.AUDIENCE_STEP,
              getComponent: (0, _routeHelpers.getComponentForImport)(audienceStep)
            }),
            _react2.default.createElement(_reactRouter.Route, {
              path: _routes.routeStrings.ADCREATION_STEP,
              getComponent: (0, _routeHelpers.getComponentForImport)(adCreationStep)
            })
          )
        )
      )
    )
  ),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.LOGIN,
    redirectUrl: 'https://accounts.spotify.com/?continue=' + window.location.origin
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.LOGOUT,
    redirectUrl: 'https://accounts.spotify.com/logout?continue=' + window.location.origin,
    onRedirectAction: _auth.userLoggedOut
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.SIGNUP,
    redirectUrl: 'https://spotify.com/signup?forward-url=' + window.location.origin
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.ACCOUNT,
    redirectUrl: 'https://www.spotify.com/us/account/overview'
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.CREATIVE_GUIDELINES,
    redirectUrl: 'https://adstudio.scdn.co/assets/landingpage/ad-studio-guidelines-1-9.pdf',
    onRedirectAction: _analytics.guidelinePdfClicked
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.FEEDBACK,
    redirectUrl: 'https://docs.google.com/a/spotify.com/forms/d/e/1FAIpQLSdNNcS2m7u8VQNsAzAJGIHTS6Z1m38Lw-BFArEt0V8BQooPAA/viewform'
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _ExternalRedirect2.default,
    path: _routes.routeStrings.BETA_TERMS,
    redirectUrl: 'https://www.spotify.com/us/brands/legal/advertiser-terms-and-conditions/'
  }),
  _react2.default.createElement(_reactRouter.Route, {
    component: _RedirectReturn2.default,
    path: _routes.routeStrings.REDIRECT
  }),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _TopnavContainer2.default, navType: _TopnavContainer.INTERNAL_NAV_TYPE },
    _react2.default.createElement(_reactRouter.Route, { path: _routes.routeStrings.WAITLIST, getComponent: (0, _routeHelpers.getComponentForImport)(waitlist) }),
    _react2.default.createElement(_reactRouter.Route, { path: _routes.routeStrings.TERMS, getComponent: (0, _routeHelpers.getComponentForImport)(terms) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _TopnavContainer2.default, navType: _TopnavContainer.HOMEPAGE_NAV_TYPE },
    _react2.default.createElement(_reactRouter.IndexRoute, { getComponent: (0, _routeHelpers.getComponentForImport)(home) }),
    _react2.default.createElement(_reactRouter.Route, { path: _routes.routeStrings.FAQ, getComponent: (0, _routeHelpers.getComponentForImport)(faq) }),
    _react2.default.createElement(_reactRouter.Route, { path: _routes.routeStrings.NOT_FOUND, component: _NotFound2.default })
  )
);

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(781);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(498);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(783),
    ListCache = __webpack_require__(174),
    Map = __webpack_require__(261);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(784),
    hashDelete = __webpack_require__(789),
    hashGet = __webpack_require__(790),
    hashHas = __webpack_require__(791),
    hashSet = __webpack_require__(792);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(389),
    isMasked = __webpack_require__(786),
    isObject = __webpack_require__(115),
    toSource = __webpack_require__(390);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(787);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(41);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 788 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 793 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(175);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(175);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(175);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(175);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(176);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(176);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(176);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(176);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    arrayMap = __webpack_require__(391),
    isArray = __webpack_require__(59),
    isSymbol = __webpack_require__(195);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSetupRequired = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _account = __webpack_require__(805);

var _Passthrough = __webpack_require__(500);

var _Passthrough2 = _interopRequireDefault(_Passthrough);

var _LoadingPage = __webpack_require__(199);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

var _AccountSetup = __webpack_require__(818);

var _AccountSetup2 = _interopRequireDefault(_AccountSetup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountSetupRequired = exports.AccountSetupRequired = function AccountSetupRequired(_ref) {
  var children = _ref.children,
      fetching = _ref.fetching,
      requiresAccountSetup = _ref.requiresAccountSetup;

  // show loader while loading user
  if (fetching) return _react2.default.createElement(_LoadingPage2.default, null);
  // return the AccountSetup component if the user needs it
  if (requiresAccountSetup) return _react2.default.createElement(_AccountSetup2.default, null);
  // passthrough otherwise
  return _react2.default.createElement(
    _Passthrough2.default,
    null,
    children
  );
};

AccountSetupRequired.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.element]),
  fetching: _propTypes2.default.bool,
  requiresAccountSetup: _propTypes2.default.bool
};

function mapStateToProps(state) {
  return {
    fetching: (0, _account.isAccountFetching)(state),
    requiresAccountSetup: (0, _account.userRequiresAccountSetup)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountSetupRequired);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userRequiresAccountSetup = exports.userHasAccount = exports.isAccountFetching = undefined;

var _user = __webpack_require__(57);

var isAccountFetching = exports.isAccountFetching = function isAccountFetching(state) {
  return !(0, _user.getUser)(state).fetched;
};
var userHasAccount = exports.userHasAccount = function userHasAccount(state) {
  return !!(0, _user.getUser)(state).account;
};
var userRequiresAccountSetup = exports.userRequiresAccountSetup = function userRequiresAccountSetup(state) {
  return !isAccountFetching(state) && !userHasAccount(state);
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_GENDERS_LIST = exports.ALL_GENDERS_VALUE = undefined;

var _lang = __webpack_require__(141);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALL_GENDERS_VALUE = exports.ALL_GENDERS_VALUE = 'All';
var ALL_GENDERS_LIST = exports.ALL_GENDERS_LIST = ['Female', 'Male'];

exports.default = new Map([[ALL_GENDERS_VALUE, (0, _lang2.default)('all', 'All')], ['Female', (0, _lang2.default)('female', 'Female')], ['Male', (0, _lang2.default)('male', 'Male')]]);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lang = __webpack_require__(141);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// URL: https://api.voicebunny.com/languages
// Date: 2015-07-27
// Unset caught linting errors since this JSON is automatically generated.

/* eslint quote-props: 0, comma-dangle: 0 */
var languages = [{
  'id': 'afr-za',
  'name': 'Afrikaans - South Africa',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ara',
  'name': 'Arabic',
  'pricingType': 'perWord',
  'rtl': true
}, {
  'id': 'aze',
  'name': 'Azeri',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ben',
  'name': 'Bengali',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'bos-ba',
  'name': 'Bosnian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'bul-bg',
  'name': 'Bulgarian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'cat-es',
  'name': 'Catalan',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ceb',
  'name': 'Cebuano',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ces-cz',
  'name': 'Czech',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'cmn-zh',
  'name': 'Chinese - Mandarin',
  'pricingType': 'perCharacter',
  'rtl': 0
}, {
  'id': 'cym-gb',
  'name': 'Welsh',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'dan-dk',
  'name': 'Danish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'deu-de',
  'name': 'German - Germany',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'deu-au',
  'name': 'German - Austria',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ell-el',
  'name': 'Greek',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-au',
  'name': 'English - Australia',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-ca',
  'name': 'English - Caribbean',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-ie',
  'name': 'English - Ireland',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-nz',
  'name': 'English - New Zealand',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-sco',
  'name': 'English - Scotland',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-uk',
  'name': 'English - England',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-us',
  'name': 'English - North America',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'eng-za',
  'name': 'English - South Africa',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'fas-ir',
  'name': 'Persian (Farsi)',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'fin-fi',
  'name': 'Finnish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'fle-fl',
  'name': 'Flemish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'fra-ca',
  'name': 'French - Canada',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'fra-fr',
  'name': 'French - Europe',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'gbz',
  'name': 'Dari',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'gle',
  'name': 'Irish - Gaelic',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'hau',
  'name': 'Hausa',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'heb-il',
  'name': 'Hebrew',
  'pricingType': 'perWord',
  'rtl': true
}, {
  'id': 'hin-in',
  'name': 'Hindi',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'hrv-hr',
  'name': 'Croatian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'hun-hu',
  'name': 'Hungarian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ibo',
  'name': 'Igbo',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ind-id',
  'name': 'Indonesian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'isl-is',
  'name': 'Icelandic',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ita-it',
  'name': 'Italian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'jav-id',
  'name': 'Javanese',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'jpn-jp',
  'name': 'Japanese',
  'pricingType': 'perCharacter',
  'rtl': 0
}, {
  'id': 'khm-kh',
  'name': 'Cambodian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'kor-ko',
  'name': 'Korean',
  'pricingType': 'perCharacter',
  'rtl': 0
}, {
  'id': 'kur-ir',
  'name': 'Kurdish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'mar-in',
  'name': 'Marathi',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'mkd-mk',
  'name': 'Macedonian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'nep-np',
  'name': 'Nepali',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'nld-de',
  'name': 'Dutch',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'nor-no',
  'name': 'Norwegian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'pan-in',
  'name': 'Punjabi',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'pol-pl',
  'name': 'Polish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'por-br',
  'name': 'Portuguese - Brazil',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'por-pt',
  'name': 'Portuguese - Portugal',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ron-ro',
  'name': 'Romanian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'rus-ru',
  'name': 'Russian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'slk-sk',
  'name': 'Slovak',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'slv-si',
  'name': 'Slovenian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-ar',
  'name': 'Spanish - Argentina',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-cl',
  'name': 'Spanish - Chile',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-co',
  'name': 'Spanish - Colombia',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-es',
  'name': 'Spanish - Castilian (from Spain)',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-latam',
  'name': 'Spanish - Latin American Neutral',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-mx',
  'name': 'Spanish - Mexico',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-pe',
  'name': 'Spanish - Peru',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-pr',
  'name': 'Spanish - Puerto Rico',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-uy',
  'name': 'Spanish - Uruguay',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'spa-ve',
  'name': 'Spanish - Venezuela',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'srp-rs',
  'name': 'Serbian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'swa-ke',
  'name': 'Swahili',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'swe',
  'name': 'Swedish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tam-in',
  'name': 'Tamil',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tel-in',
  'name': 'Telugu',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tgl-ph',
  'name': 'Tagalog',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tha-th',
  'name': 'Thai',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tlh',
  'name': 'Klingon',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'tur-tr',
  'name': 'Turkish',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'ukr-ua',
  'name': 'Ukrainian',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'urd-pk',
  'name': 'Urdu',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'vie-vi',
  'name': 'Vietnamese',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'vlcn',
  'name': 'Vulcan',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'wuu-zh',
  'name': 'Chinese - Wu',
  'pricingType': 'perCharacter',
  'rtl': 0
}, {
  'id': 'yor',
  'name': 'Yoruba',
  'pricingType': 'perWord',
  'rtl': 0
}, {
  'id': 'yue-zh',
  'name': 'Chinese - Cantonese',
  'pricingType': 'perCharacter',
  'rtl': 0
}, {
  'id': 'zsm-my',
  'name': 'Malaysian',
  'pricingType': 'perWord',
  'rtl': 0
}];

function buildLocales() {
  var locales = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var ln = _step.value;

      locales[ln.id] = (0, _lang2.default)(ln.id, ln.name);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return locales;
}

function filterLocales() {
  var allLocales = buildLocales();
  var mvpLanguageOptions = ['eng-au', 'eng-uk', 'eng-us', 'fra-ca', 'fra-fr', 'spa-latam', 'spa-mx'];
  var filteredLocales = mvpLanguageOptions.reduce(function (locales, id) {
    locales[id] = allLocales[id];
    return locales;
  }, {});
  return filteredLocales;
}
exports.default = {
  allAvailableLocales: buildLocales(),
  filteredLocales: filterLocales()
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lang = __webpack_require__(141);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// URL: https://api.voicebunny.com/genderAndAges
// Date: 2015-07-27

// Auto-generated, so eslint should be relaxed
/* eslint comma-dangle:0 */
var voiceBunnyGenderAge = [{
  code: 'childBoy',
  name: 'Male | Child'
}, {
  code: 'teenageBoy',
  name: 'Male | Teenage'
}, {
  code: 'youngAdultMale',
  name: 'Male | Young adult'
}, {
  code: 'middleAgeMale',
  name: 'Male | Middle age'
}, {
  code: 'seniorMale',
  name: 'Male | Senior'
}, {
  code: 'childGirl',
  name: 'Female | Child'
}, {
  code: 'teenageGirl',
  name: 'Female | Teenage'
}, {
  code: 'youngAdultFemale',
  name: 'Female | Young adult'
}, {
  code: 'middleAgeFemale',
  name: 'Female | Middle age'
}, {
  code: 'seniorFemale',
  name: 'Female | Senior'
}];

function buildVoices() {
  var voices = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = voiceBunnyGenderAge[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      voices[item.code] = (0, _lang2.default)(item.code, item.name);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return voices;
}
exports.default = buildVoices();

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FREE_TRIAL_INELIGIBLE = exports.FREE_TRIAL_ELIGIBLE = exports.FREE_TRIAL_NULL_VALUE = undefined;

var _lang = __webpack_require__(141);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FREE_TRIAL_NULL_VALUE = exports.FREE_TRIAL_NULL_VALUE = 'All';
var FREE_TRIAL_ELIGIBLE = exports.FREE_TRIAL_ELIGIBLE = 'Eligible';
var FREE_TRIAL_INELIGIBLE = exports.FREE_TRIAL_INELIGIBLE = 'Ineligible';

exports.default = new Map([[FREE_TRIAL_NULL_VALUE, (0, _lang2.default)('all', 'All')], [FREE_TRIAL_ELIGIBLE, (0, _lang2.default)('eligible', 'Eligible')], [FREE_TRIAL_INELIGIBLE, (0, _lang2.default)('ineligible', 'Ineligible')]]);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PLATFORMS = exports.PLATFORMS = {
  ios: 'iOS (iPhone/iPad)',
  android: 'Android',
  desktop: 'Desktop'
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// see the bowser.js documentation. these values are the minimum version number
// for each browser we support. they are the edge of "last 2 versions"
var SUPPORTED_BROWSER_VERSIONS = exports.SUPPORTED_BROWSER_VERSIONS = {
  chrome: '59',
  firefox: '54',
  msie: '11',
  msedge: '14',
  safari: '7'
};

/***/ }),
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var index$2 = function isMergeableObject(value) {
	return isNonNullObject(value) && isNotSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isNotSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue !== '[object RegExp]'
		&& stringValue !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && index$2(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (index$2(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (index$2(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!index$2(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var index = deepmerge;

module.exports = index;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lazy = __webpack_require__(819);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Lazy).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(191);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _LoadingPage = __webpack_require__(199);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactLoadable2.default)({
  loader: function loader() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1102));
  },
  loading: function loading() {
    return _react2.default.createElement(_LoadingPage2.default, null);
  }
});

/***/ }),
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(265);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(393);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sticky = function (_Component) {
  _inherits(Sticky, _Component);

  function Sticky() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sticky);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSticky: false,
      wasSticky: false,
      style: {}
    }, _this.handleContainerEvent = function (_ref2) {
      var distanceFromTop = _ref2.distanceFromTop,
          distanceFromBottom = _ref2.distanceFromBottom,
          eventSource = _ref2.eventSource;

      var parent = _this.context.getParent();

      var preventingStickyStateChanges = false;
      if (_this.props.relative) {
        preventingStickyStateChanges = eventSource !== parent;
        distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this.placeholder.offsetTop;
      }

      var placeholderClientRect = _this.placeholder.getBoundingClientRect();
      var contentClientRect = _this.content.getBoundingClientRect();
      var calculatedHeight = contentClientRect.height;

      var bottomDifference = distanceFromBottom - _this.props.bottomOffset - calculatedHeight;

      var wasSticky = !!_this.state.isSticky;
      var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this.props.topOffset && distanceFromBottom > -_this.props.bottomOffset;

      distanceFromBottom = (_this.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;

      var style = !isSticky ? {} : {
        position: 'fixed',
        top: bottomDifference > 0 ? _this.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference,
        left: placeholderClientRect.left,
        width: placeholderClientRect.width
      };

      if (!_this.props.disableHardwareAcceleration) {
        style.transform = 'translateZ(0)';
      }

      _this.setState({
        isSticky: isSticky,
        wasSticky: wasSticky,
        distanceFromTop: distanceFromTop,
        distanceFromBottom: distanceFromBottom,
        calculatedHeight: calculatedHeight,
        style: style
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sticky, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");

      this.context.subscribe(this.handleContainerEvent);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.unsubscribe(this.handleContainerEvent);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var element = _react2.default.cloneElement(this.props.children({
        isSticky: this.state.isSticky,
        wasSticky: this.state.wasSticky,
        distanceFromTop: this.state.distanceFromTop,
        distanceFromBottom: this.state.distanceFromBottom,
        calculatedHeight: this.state.calculatedHeight,
        style: this.state.style
      }), { ref: function ref(content) {
          _this2.content = _reactDom2.default.findDOMNode(content);
        } });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { ref: function ref(placeholder) {
            return _this2.placeholder = placeholder;
          } }),
        element
      );
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.propTypes = {
  topOffset: _propTypes2.default.number,
  bottomOffset: _propTypes2.default.number,
  relative: _propTypes2.default.bool,
  children: _propTypes2.default.func.isRequired
};
Sticky.defaultProps = {
  relative: false,
  topOffset: 0,
  bottomOffset: 0,
  disableCompensation: false,
  disableHardwareAcceleration: false
};
Sticky.contextTypes = {
  subscribe: _propTypes2.default.func,
  unsubscribe: _propTypes2.default.func,
  getParent: _propTypes2.default.func
};
exports.default = Sticky;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _raf = __webpack_require__(845);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_PureComponent) {
  _inherits(Container, _PureComponent);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], _this.subscribers = [], _this.subscribe = function (handler) {
      _this.subscribers = _this.subscribers.concat(handler);
    }, _this.unsubscribe = function (handler) {
      _this.subscribers = _this.subscribers.filter(function (current) {
        return current !== handler;
      });
    }, _this.notifySubscribers = function (evt) {
      if (!_this.framePending) {
        var currentTarget = evt.currentTarget;


        (0, _raf2.default)(function () {
          if (_this.node) {
            var _this$node$getBoundin = _this.node.getBoundingClientRect(),
                top = _this$node$getBoundin.top,
                bottom = _this$node$getBoundin.bottom;

            _this.subscribers.forEach(function (handler) {
              return handler({
                distanceFromTop: top,
                distanceFromBottom: bottom,
                eventSource: currentTarget === window ? document.body : _this.node
              });
            });
          }
          _this.framePending = false;
        });
        _this.framePending = true;
      }
    }, _this.getParent = function () {
      return _this.node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
        getParent: this.getParent
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.events.forEach(function (event) {
        return window.addEventListener(event, _this2.notifySubscribers);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.events.forEach(function (event) {
        return window.removeEventListener(event, _this3.notifySubscribers);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement('div', _extends({}, this.props, {
        ref: function ref(node) {
          return _this4.node = node;
        },
        onScroll: this.notifySubscribers,
        onTouchStart: this.notifySubscribers,
        onTouchMove: this.notifySubscribers,
        onTouchEnd: this.notifySubscribers
      }));
    }
  }]);

  return Container;
}(_react.PureComponent);

Container.childContextTypes = {
  subscribe: _propTypes2.default.func,
  unsubscribe: _propTypes2.default.func,
  getParent: _propTypes2.default.func
};
exports.default = Container;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(846)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAdBlockerStatus = exports.getAdBlockerStatus = function getAdBlockerStatus(state) {
  return state.adBlocker;
};
var hasAdBlocker = exports.hasAdBlocker = function hasAdBlocker(state) {
  return getAdBlockerStatus(state).adBlockerDetected;
};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AlertBar = __webpack_require__(118);

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OfflineAlert = function OfflineAlert() {
  return _react2.default.createElement(
    _AlertBar2.default,
    { alertType: 'warning' },
    _react2.default.createElement(
      'strong',
      null,
      'Computer Offline'
    ),
    ' Please connect to the internet to load the latest data.'
  );
};

exports.default = OfflineAlert;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AlertBar = __webpack_require__(118);

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdBlockerAlert = function AdBlockerAlert() {
  return _react2.default.createElement(
    _AlertBar2.default,
    { alertType: 'warning' },
    _react2.default.createElement(
      'strong',
      null,
      'Ad Blocker Detected.'
    ),
    ' Please disable any ad blocking software as it interferes with our ad creation system.'
  );
};

exports.default = AdBlockerAlert;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AlertBar = __webpack_require__(118);

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserSupportAlert = function BrowserSupportAlert() {
  return _react2.default.createElement(
    _AlertBar2.default,
    { alertType: 'warning' },
    'Your browser is currently not yet fully supported. We recommend using Chrome on a desktop computer for a better experience.'
  );
};

exports.default = BrowserSupportAlert;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AlertBar = __webpack_require__(118);

var _AlertBar2 = _interopRequireDefault(_AlertBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegionSupportAlert = function RegionSupportAlert() {
  return _react2.default.createElement(
    _AlertBar2.default,
    { className: 'region-support-alert', alertType: 'warning' },
    _react2.default.createElement(
      'strong',
      null,
      'Ad Studio is US-only'
    ),
    '. We\'re currently testing Ad Studio with US advertisers. We will be adding more countries soon!'
  );
};

exports.default = RegionSupportAlert;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(383);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(81),
    root = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(110),
    isObjectLike = __webpack_require__(121);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 858 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(110),
    isLength = __webpack_require__(297),
    isObjectLike = __webpack_require__(121);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(382);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toInt;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toInt(str, radix) {
  (0, _assertString2.default)(str);
  return parseInt(str, radix || 10);
}
module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toBoolean;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBoolean(str, strict) {
  (0, _assertString2.default)(str);
  if (strict) {
    return str === '1' || str === 'true';
  }
  return str !== '0' && str !== 'false' && str !== '';
}
module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equals;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function equals(str, comparison) {
  (0, _assertString2.default)(str);
  return str === comparison;
}
module.exports = exports['default'];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contains;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _toString = __webpack_require__(270);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function contains(str, elem) {
  (0, _assertString2.default)(str);
  return str.indexOf((0, _toString2.default)(elem)) >= 0;
}
module.exports = exports['default'];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString2.default)(str);
  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }
  return pattern.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _isFQDN = __webpack_require__(271);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

var _isIP = __webpack_require__(408);

var _isIP2 = _interopRequireDefault(_isIP);

var _merge = __webpack_require__(143);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};

var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }
  return false;
}

function isURL(url, options) {
  (0, _assertString2.default)(url);
  if (!url || url.length >= 2083 || /\s/.test(url)) {
    return false;
  }
  if (url.indexOf('mailto:') === 0) {
    return false;
  }
  options = (0, _merge2.default)(options, default_url_options);
  var protocol = void 0,
      auth = void 0,
      host = void 0,
      hostname = void 0,
      port = void 0,
      port_str = void 0,
      split = void 0,
      ipv6 = void 0;

  split = url.split('#');
  url = split.shift();

  split = url.split('?');
  url = split.shift();

  split = url.split('://');
  if (split.length > 1) {
    protocol = split.shift();
    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
    split[0] = url.substr(2);
  }
  url = split.join('://');

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');
  if (split.length > 1) {
    auth = split.shift();
    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }
  hostname = split.join('@');

  port_str = ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);
  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();
    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);
    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6)) && host !== 'localhost') {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }
  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMACAddress;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;

function isMACAddress(str) {
  (0, _assertString2.default)(str);
  return macAddress.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBoolean(str) {
  (0, _assertString2.default)(str);
  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
}
module.exports = exports['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlpha;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlpha(str) {
  var locale = arguments.length <= 1 || arguments[1] === undefined ? 'en-US' : arguments[1];

  (0, _assertString2.default)(str);
  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlphanumeric;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlphanumeric(str) {
  var locale = arguments.length <= 1 || arguments[1] === undefined ? 'en-US' : arguments[1];

  (0, _assertString2.default)(str);
  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumeric;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeric = /^[-+]?[0-9]+$/;

function isNumeric(str) {
  (0, _assertString2.default)(str);
  return numeric.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowercase;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLowercase(str) {
  (0, _assertString2.default)(str);
  return str === str.toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUppercase;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString2.default)(str);
  return str === str.toUpperCase();
}
module.exports = exports['default'];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAscii;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString2.default)(str);
  return ascii.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVariableWidth;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _isFullWidth = __webpack_require__(410);

var _isHalfWidth = __webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isVariableWidth(str) {
  (0, _assertString2.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMultibyte;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString2.default)(str);
  return multibyte.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSurrogatePair;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString2.default)(str);
  return surrogatePair.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInt;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString2.default)(str);
  options = options || {};

  // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.
  var regex = options.hasOwnProperty('allow_leading_zeroes') && options.allow_leading_zeroes ? intLeadingZeroes : int;

  // Check min/max
  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;

  return regex.test(str) && minCheckPassed && maxCheckPassed;
}
module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFloat;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var float = /^(?:[-+]?(?:[0-9]+))?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/;

function isFloat(str, options) {
  (0, _assertString2.default)(str);
  options = options || {};
  if (str === '' || str === '.') {
    return false;
  }
  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max);
}
module.exports = exports['default'];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDecimal;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decimal = /^[-+]?([0-9]+|\.[0-9]+|[0-9]+\.[0-9]+)$/;

function isDecimal(str) {
  (0, _assertString2.default)(str);
  return str !== '' && decimal.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDivisibleBy;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _toFloat = __webpack_require__(405);

var _toFloat2 = _interopRequireDefault(_toFloat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDivisibleBy(str, num) {
  (0, _assertString2.default)(str);
  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
}
module.exports = exports['default'];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexColor;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

function isHexColor(str) {
  (0, _assertString2.default)(str);
  return hexcolor.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMD5;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString2.default)(str);
  return md5.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isJSON;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isJSON(str) {
  (0, _assertString2.default)(str);
  try {
    var obj = JSON.parse(str);
    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  } catch (e) {/* ignore */}
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNull;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isNull(str) {
  (0, _assertString2.default)(str);
  return str.length === 0;
}
module.exports = exports['default'];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isLength;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUUID;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = {
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str) {
  var version = arguments.length <= 1 || arguments[1] === undefined ? 'all' : arguments[1];

  (0, _assertString2.default)(str);
  var pattern = uuid[version];
  return pattern && pattern.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMongoId;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _isHexadecimal = __webpack_require__(412);

var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMongoId(str) {
  (0, _assertString2.default)(str);
  return (0, _isHexadecimal2.default)(str) && str.length === 24;
}
module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDate;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _isISO = __webpack_require__(413);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTimezoneOffset(str) {
  var iso8601Parts = str.match(_isISO.iso8601);
  var timezone = void 0,
      sign = void 0,
      hours = void 0,
      minutes = void 0;
  if (!iso8601Parts) {
    str = str.toLowerCase();
    timezone = str.match(/(?:\s|gmt\s*)(-|\+)(\d{1,4})(\s|$)/);
    if (!timezone) {
      return str.indexOf('gmt') !== -1 ? 0 : null;
    }
    sign = timezone[1];
    var offset = timezone[2];
    if (offset.length === 3) {
      offset = '0' + offset;
    }
    if (offset.length <= 2) {
      hours = 0;
      minutes = parseInt(offset, 10);
    } else {
      hours = parseInt(offset.slice(0, 2), 10);
      minutes = parseInt(offset.slice(2, 4), 10);
    }
  } else {
    timezone = iso8601Parts[21];
    if (!timezone) {
      // if no hour/minute was provided, the date is GMT
      return !iso8601Parts[12] ? 0 : null;
    }
    if (timezone === 'z' || timezone === 'Z') {
      return 0;
    }
    sign = iso8601Parts[22];
    if (timezone.indexOf(':') !== -1) {
      hours = parseInt(iso8601Parts[23], 10);
      minutes = parseInt(iso8601Parts[24], 10);
    } else {
      hours = 0;
      minutes = parseInt(iso8601Parts[23], 10);
    }
  }
  return (hours * 60 + minutes) * (sign === '-' ? 1 : -1);
}

function isDate(str) {
  (0, _assertString2.default)(str);
  var normalizedDate = new Date(Date.parse(str));
  if (isNaN(normalizedDate)) {
    return false;
  }

  // normalizedDate is in the user's timezone. Apply the input
  // timezone offset to the date so that the year and day match
  // the input
  var timezoneOffset = getTimezoneOffset(str);
  if (timezoneOffset !== null) {
    var timezoneDifference = normalizedDate.getTimezoneOffset() - timezoneOffset;
    normalizedDate = new Date(normalizedDate.getTime() + 60000 * timezoneDifference);
  }

  var day = String(normalizedDate.getDate());
  var dayOrYear = void 0,
      dayOrYearMatches = void 0,
      year = void 0;
  // check for valid double digits that could be late days
  // check for all matches since a string like '12/23' is a valid date
  // ignore everything with nearby colons
  dayOrYearMatches = str.match(/(^|[^:\d])[23]\d([^T:\d]|$)/g);
  if (!dayOrYearMatches) {
    return true;
  }
  dayOrYear = dayOrYearMatches.map(function (digitString) {
    return digitString.match(/\d+/g)[0];
  }).join('/');

  year = String(normalizedDate.getFullYear()).slice(-2);
  if (dayOrYear === day || dayOrYear === year) {
    return true;
  } else if (dayOrYear === '' + day / year || dayOrYear === '' + year / day) {
    return true;
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAfter;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _toDate = __webpack_require__(269);

var _toDate2 = _interopRequireDefault(_toDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAfter(str) {
  var date = arguments.length <= 1 || arguments[1] === undefined ? String(new Date()) : arguments[1];

  (0, _assertString2.default)(str);
  var comparison = (0, _toDate2.default)(date);
  var original = (0, _toDate2.default)(str);
  return !!(original && comparison && original > comparison);
}
module.exports = exports['default'];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBefore;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _toDate = __webpack_require__(269);

var _toDate2 = _interopRequireDefault(_toDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBefore(str) {
  var date = arguments.length <= 1 || arguments[1] === undefined ? String(new Date()) : arguments[1];

  (0, _assertString2.default)(str);
  var comparison = (0, _toDate2.default)(date);
  var original = (0, _toDate2.default)(str);
  return !!(original && comparison && original < comparison);
}
module.exports = exports['default'];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = isIn;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _toString = __webpack_require__(270);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIn(str, options) {
  (0, _assertString2.default)(str);
  var i = void 0;
  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];
    for (i in options) {
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString2.default)(options[i]);
      }
    }
    return array.indexOf(str) >= 0;
  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})|62[0-9]{14}$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString2.default)(str);
  var sanitized = str.replace(/[^0-9]+/g, '');
  if (!creditCard.test(sanitized)) {
    return false;
  }
  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = void 0;
  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }
  return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISIN;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;

function isISIN(str) {
  (0, _assertString2.default)(str);
  if (!isin.test(str)) {
    return false;
  }

  var checksumStr = str.replace(/[A-Z]/g, function (character) {
    return parseInt(character, 36);
  });

  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = true;
  for (var i = checksumStr.length - 2; i >= 0; i--) {
    digit = checksumStr.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }

  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
}
module.exports = exports['default'];

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISBN;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }
  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i = void 0;
  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }
    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }
    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }
    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }
    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }
    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  'da-DK': /^(\+?45)?(\d{8})$/,
  'el-GR': /^(\+?30)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-HK': /^(\+?852\-?)?[569]\d{3}\-?\d{4}$/,
  'en-IN': /^(\+?91|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/,
  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  'zh-CN': /^(\+?0?86\-?)?1[345789]\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */

// aliases
phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];

function isMobilePhone(str, locale) {
  (0, _assertString2.default)(str);
  if (locale in phones) {
    return phones[locale].test(str);
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCurrency;

var _merge = __webpack_require__(143);

var _merge2 = _interopRequireDefault(_merge);

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencyRegex(options) {
  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
      decimal_amount = '(\\' + options.decimal_separator + '\\d{2})?';
  var pattern = whole_dollar_amount + decimal_amount;

  // default is negative sign before symbol, but there are two other options (besides parens)
  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  }

  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
  if (options.allow_negative_sign_placeholder) {
    pattern = '( (?!\\-))?' + pattern;
  } else if (options.allow_space_after_symbol) {
    pattern = ' ?' + pattern;
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  }

  /* eslint-disable prefer-template */
  return new RegExp('^' +
  // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space
  '(?!-? )(?=.*\\d)' + pattern + '$');
  /* eslint-enable prefer-template */
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}
module.exports = exports['default'];

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBase64;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notBase64 = /[^A-Z0-9+\/=]/i;

function isBase64(str) {
  (0, _assertString2.default)(str);
  var len = str.length;
  if (!len || len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }
  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}
module.exports = exports['default'];

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDataURI;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataURI = /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9!\$&',\(\)\*\+,;=\-\._~:@\/\?%\s]*\s*$/i; // eslint-disable-line max-len

function isDataURI(str) {
  (0, _assertString2.default)(str);
  return dataURI.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;

var _rtrim = __webpack_require__(415);

var _rtrim2 = _interopRequireDefault(_rtrim);

var _ltrim = __webpack_require__(414);

var _ltrim2 = _interopRequireDefault(_ltrim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(str, chars) {
  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
}
module.exports = exports['default'];

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
      value: true
});
exports.default = escape;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escape(str) {
      (0, _assertString2.default)(str);
      return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/`/g, '&#96;');
}
module.exports = exports['default'];

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
      value: true
});
exports.default = unescape;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unescape(str) {
      (0, _assertString2.default)(str);
      return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#96;/g, '`');
}
module.exports = exports['default'];

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripLow;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

var _blacklist = __webpack_require__(416);

var _blacklist2 = _interopRequireDefault(_blacklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stripLow(str, keep_new_lines) {
  (0, _assertString2.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist2.default)(str, chars);
}
module.exports = exports['default'];

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = whitelist;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whitelist(str, chars) {
  (0, _assertString2.default)(str);
  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
}
module.exports = exports['default'];

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWhitelisted;

var _assertString = __webpack_require__(3);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWhitelisted(str, chars) {
  (0, _assertString2.default)(str);
  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeEmail;

var _isEmail = __webpack_require__(406);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _merge = __webpack_require__(143);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_normalize_email_options = {
  lowercase: true,
  remove_dots: true,
  remove_extension: true
};

function normalizeEmail(email, options) {
  options = (0, _merge2.default)(options, default_normalize_email_options);
  if (!(0, _isEmail2.default)(email)) {
    return false;
  }
  var parts = email.split('@', 2);
  parts[1] = parts[1].toLowerCase();
  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    if (options.remove_extension) {
      parts[0] = parts[0].split('+')[0];
    }
    if (options.remove_dots) {
      parts[0] = parts[0].replace(/\./g, '');
    }
    if (!parts[0].length) {
      return false;
    }
    parts[0] = parts[0].toLowerCase();
    parts[1] = 'gmail.com';
  } else if (options.lowercase) {
    parts[0] = parts[0].toLowerCase();
  }
  return parts.join('@');
}
module.exports = exports['default'];

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Overlay = __webpack_require__(417);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _Fade = __webpack_require__(302);

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2['default'].bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: _propTypes2['default'].bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: _propTypes2['default'].func,

  /**
   * Use animation
   */
  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _elementType2['default']]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2['default'].func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2['default'].func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2['default'].func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2['default'].func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2['default'].func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2['default'].func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: _Fade2['default'],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  (0, _inherits3['default'])(Overlay, _React$Component);

  function Overlay() {
    (0, _classCallCheck3['default'])(this, Overlay);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);


    var transition = animation === true ? _Fade2['default'] : animation || null;

    var child = void 0;

    if (!transition) {
      child = (0, _react.cloneElement)(children, {
        className: (0, _classnames2['default'])(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return _react2['default'].createElement(
      _Overlay2['default'],
      (0, _extends3['default'])({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(_react2['default'].Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

exports['default'] = Overlay;
module.exports = exports['default'];

/***/ }),
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _reactRouterRedux = __webpack_require__(60);

var _routes = __webpack_require__(86);

var _auth = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginRequired = function (_Component) {
  _inherits(LoginRequired, _Component);

  function LoginRequired() {
    _classCallCheck(this, LoginRequired);

    return _possibleConstructorReturn(this, (LoginRequired.__proto__ || Object.getPrototypeOf(LoginRequired)).apply(this, arguments));
  }

  _createClass(LoginRequired, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.redirectUnauthorizedUsers();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.redirectUnauthorizedUsers();
    }
  }, {
    key: 'redirectUnauthorizedUsers',
    value: function redirectUnauthorizedUsers() {
      var _props = this.props,
          isAuthorized = _props.isAuthorized,
          replace = _props.replace;


      if (!isAuthorized) {
        replace(_routes.routes.MAIN);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          isAuthorized = _props2.isAuthorized;

      return _react2.default.createElement(
        'div',
        null,
        isAuthorized && children
      );
    }
  }]);

  return LoginRequired;
}(_react.Component);

LoginRequired.propTypes = {
  children: _propTypes2.default.node,
  isAuthorized: _propTypes2.default.bool.isRequired,
  replace: _propTypes2.default.func.isRequired
};

function mapStateToProps(state) {
  return {
    isAuthorized: (0, _auth.getIsAuthorized)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, { replace: _reactRouterRedux.replace })(LoginRequired);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lazy = __webpack_require__(914);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Lazy).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = __webpack_require__(191);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactLoadable2.default)({
  loader: function loader() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1103));
  },
  loading: function loading() {
    return _react2.default.createElement('div', null);
  }
});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _uncontrollable = __webpack_require__(299);

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

var _Grid = __webpack_require__(918);

var _Grid2 = _interopRequireDefault(_Grid);

var _NavbarBrand = __webpack_require__(919);

var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);

var _NavbarCollapse = __webpack_require__(920);

var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);

var _NavbarHeader = __webpack_require__(922);

var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);

var _NavbarToggle = __webpack_require__(923);

var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);

var _bootstrapUtils = __webpack_require__(17);

var _StyleConfig = __webpack_require__(116);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: _propTypes2['default'].bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: _propTypes2['default'].bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: _propTypes2['default'].bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: _propTypes2['default'].bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: _propTypes2['default'].bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: _elementType2['default'],
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
   * boolean value.
   *
   * @controllable navExpanded
   */
  onToggle: _propTypes2['default'].func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: _propTypes2['default'].func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: _propTypes2['default'].bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: _propTypes2['default'].bool,

  role: _propTypes2['default'].string
}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string,
    expanded: _propTypes2['default'].bool,
    onToggle: _propTypes2['default'].func.isRequired,
    onSelect: _propTypes2['default'].func
  })
};

var Navbar = function (_React$Component) {
  (0, _inherits3['default'])(Navbar, _React$Component);

  function Navbar(props, context) {
    (0, _classCallCheck3['default'])(this, Navbar);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: (0, _createChainedFunction2['default'])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = (0, _objectWithoutProperties3['default'])(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
    }

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));

    return _react2['default'].createElement(
      Component,
      (0, _extends4['default'])({}, elementProps, {
        className: (0, _classnames2['default'])(className, classes)
      }),
      _react2['default'].createElement(
        _Grid2['default'],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(_react2['default'].Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

(0, _bootstrapUtils.bsClass)('navbar', Navbar);

var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: _elementType2['default'],
    pullRight: _propTypes2['default'].bool,
    pullLeft: _propTypes2['default'].bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: _propTypes2['default'].shape({
      bsClass: _propTypes2['default'].string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = _NavbarBrand2['default'];
UncontrollableNavbar.Header = _NavbarHeader2['default'];
UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(917);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: _propTypes2['default'].bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: _elementType2['default']
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  (0, _inherits3['default'])(Grid, _React$Component);

  function Grid() {
    (0, _classCallCheck3['default'])(this, Grid);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');

    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return Grid;
}(_react2['default'].Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
module.exports = exports['default'];

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var contextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string
  })
};

var NavbarBrand = function (_React$Component) {
  (0, _inherits3['default'])(NavbarBrand, _React$Component);

  function NavbarBrand() {
    (0, _classCallCheck3['default'])(this, NavbarBrand);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');

    if (_react2['default'].isValidElement(children)) {
      return _react2['default'].cloneElement(children, {
        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
      });
    }

    return _react2['default'].createElement(
      'span',
      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(_react2['default'].Component);

NavbarBrand.contextTypes = contextTypes;

exports['default'] = NavbarBrand;
module.exports = exports['default'];

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__(503);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var contextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string,
    expanded: _propTypes2['default'].bool
  })
};

var NavbarCollapse = function (_React$Component) {
  (0, _inherits3['default'])(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    (0, _classCallCheck3['default'])(this, NavbarCollapse);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');

    return _react2['default'].createElement(
      _Collapse2['default'],
      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
      _react2['default'].createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(_react2['default'].Component);

NavbarCollapse.contextTypes = contextTypes;

exports['default'] = NavbarCollapse;
module.exports = exports['default'];

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var contextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string
  })
};

var NavbarHeader = function (_React$Component) {
  (0, _inherits3['default'])(NavbarHeader, _React$Component);

  function NavbarHeader() {
    (0, _classCallCheck3['default'])(this, NavbarHeader);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');

    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
  };

  return NavbarHeader;
}(_react2['default'].Component);

NavbarHeader.contextTypes = contextTypes;

exports['default'] = NavbarHeader;
module.exports = exports['default'];

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bootstrapUtils = __webpack_require__(17);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  onClick: _propTypes2['default'].func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: _propTypes2['default'].node
};

var contextTypes = {
  $bs_navbar: _propTypes2['default'].shape({
    bsClass: _propTypes2['default'].string,
    expanded: _propTypes2['default'].bool,
    onToggle: _propTypes2['default'].func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  (0, _inherits3['default'])(NavbarToggle, _React$Component);

  function NavbarToggle() {
    (0, _classCallCheck3['default'])(this, NavbarToggle);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = (0, _extends3['default'])({
      type: 'button'
    }, props, {
      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return _react2['default'].createElement(
        'button',
        buttonProps,
        children
      );
    }

    return _react2['default'].createElement(
      'button',
      buttonProps,
      _react2['default'].createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      _react2['default'].createElement('span', { className: 'icon-bar' }),
      _react2['default'].createElement('span', { className: 'icon-bar' }),
      _react2['default'].createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(_react2['default'].Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

exports['default'] = NavbarToggle;
module.exports = exports['default'];

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dropdown = __webpack_require__(925);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _splitComponentProps2 = __webpack_require__(403);

var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);

var _ValidComponentChildren = __webpack_require__(88);

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {

  // Toggle props.
  title: _propTypes2['default'].node.isRequired,
  noCaret: _propTypes2['default'].bool,
  active: _propTypes2['default'].bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: _propTypes2['default'].node
});

var NavDropdown = function (_React$Component) {
  (0, _inherits3['default'])(NavDropdown, _React$Component);

  function NavDropdown() {
    (0, _classCallCheck3['default'])(this, NavDropdown);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (_ValidComponentChildren2['default'].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);


    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return _react2['default'].createElement(
      _Dropdown2['default'],
      (0, _extends3['default'])({}, dropdownProps, {
        componentClass: 'li',
        className: (0, _classnames2['default'])(className, { active: active }),
        style: style
      }),
      _react2['default'].createElement(
        _Dropdown2['default'].Toggle,
        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
        title
      ),
      _react2['default'].createElement(
        _Dropdown2['default'].Menu,
        null,
        _ValidComponentChildren2['default'].map(children, function (child) {
          return _react2['default'].cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(_react2['default'].Component);

NavDropdown.propTypes = propTypes;

exports['default'] = NavDropdown;
module.exports = exports['default'];

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _activeElement = __webpack_require__(402);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(112);

var _contains2 = _interopRequireDefault(_contains);

var _keycode = __webpack_require__(274);

var _keycode2 = _interopRequireDefault(_keycode);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _all = __webpack_require__(183);

var _all2 = _interopRequireDefault(_all);

var _elementType = __webpack_require__(40);

var _elementType2 = _interopRequireDefault(_elementType);

var _isRequiredForA11y = __webpack_require__(303);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _uncontrollable = __webpack_require__(299);

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

var _warning = __webpack_require__(31);

var _warning2 = _interopRequireDefault(_warning);

var _ButtonGroup = __webpack_require__(926);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _DropdownMenu = __webpack_require__(927);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _DropdownToggle = __webpack_require__(937);

var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);

var _bootstrapUtils = __webpack_require__(17);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _PropTypes = __webpack_require__(938);

var _ValidComponentChildren = __webpack_require__(88);

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: _propTypes2['default'].bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: (0, _isRequiredForA11y2['default'])(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),

  componentClass: _elementType2['default'],

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: _propTypes2['default'].bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: _propTypes2['default'].bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: _propTypes2['default'].bool,

  defaultOpen: _propTypes2['default'].bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: _propTypes2['default'].func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: _propTypes2['default'].func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: _propTypes2['default'].string,

  /**
   * Which event when fired outside the component will cause it to be closed
   */
  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: _propTypes2['default'].func,
  /**
   * @private
   */
  onMouseLeave: _propTypes2['default'].func
};

var defaultProps = {
  componentClass: _ButtonGroup2['default']
};

var Dropdown = function (_React$Component) {
  (0, _inherits3['default'])(Dropdown, _React$Component);

  function Dropdown(props, context) {
    (0, _classCallCheck3['default'])(this, Dropdown);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case _keycode2['default'].codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case _keycode2['default'].codes.esc:
      case _keycode2['default'].codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = _reactDom2['default'].findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this2 = this;

    var ref = function ref(c) {
      _this2.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
    }

    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
      ref: ref,
      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this3 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this3.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
    }

    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, this.handleClose),
      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, function (key, event) {
        return _this3.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);


    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return _react2['default'].createElement(
      Component,
      (0, _extends3['default'])({}, props, {
        className: (0, _classnames2['default'])(className, classes)
      }),
      _ValidComponentChildren2['default'].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(_react2['default'].Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);

var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
UncontrolledDropdown.Menu = _DropdownMenu2['default'];

exports['default'] = UncontrolledDropdown;
module.exports = exports['default'];

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _all = __webpack_require__(183);

var _all2 = _interopRequireDefault(_all);

var _Button = __webpack_require__(188);

var _Button2 = _interopRequireDefault(_Button);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  vertical: _propTypes2['default'].bool,
  justified: _propTypes2['default'].bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  (0, _inherits3['default'])(ButtonGroup, _React$Component);

  function ButtonGroup() {
    (0, _classCallCheck3['default'])(this, ButtonGroup);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));

    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
      className: (0, _classnames2['default'])(className, classes)
    }));
  };

  return ButtonGroup;
}(_react2['default'].Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
module.exports = exports['default'];

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _from = __webpack_require__(928);

var _from2 = _interopRequireDefault(_from);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(274);

var _keycode2 = _interopRequireDefault(_keycode);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(24);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _RootCloseWrapper = __webpack_require__(273);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

var _bootstrapUtils = __webpack_require__(17);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = __webpack_require__(88);

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  open: _propTypes2['default'].bool,
  pullRight: _propTypes2['default'].bool,
  onClose: _propTypes2['default'].func,
  labelledBy: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
  onSelect: _propTypes2['default'].func,
  rootCloseEvent: _propTypes2['default'].oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  (0, _inherits3['default'])(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    (0, _classCallCheck3['default'])(this, DropdownMenu);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case _keycode2['default'].codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case _keycode2['default'].codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case _keycode2['default'].codes.esc:
      case _keycode2['default'].codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = _reactDom2['default'].findDOMNode(this);
    if (!node) {
      return [];
    }

    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));

    return _react2['default'].createElement(
      _RootCloseWrapper2['default'],
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      _react2['default'].createElement(
        'ul',
        (0, _extends4['default'])({}, elementProps, {
          role: 'menu',
          className: (0, _classnames2['default'])(className, classes),
          'aria-labelledby': labelledBy
        }),
        _ValidComponentChildren2['default'].map(children, function (child) {
          return _react2['default'].cloneElement(child, {
            onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(_react2['default'].Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
module.exports = exports['default'];

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(929), __esModule: true };

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(334);
__webpack_require__(930);
module.exports = __webpack_require__(42).Array.from;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(224);
var $export = __webpack_require__(64);
var toObject = __webpack_require__(233);
var call = __webpack_require__(931);
var isArrayIter = __webpack_require__(932);
var toLength = __webpack_require__(332);
var createProperty = __webpack_require__(933);
var getIterFn = __webpack_require__(934);

$export($export.S + $export.F * !__webpack_require__(936)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(102);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(135);
var ITERATOR = __webpack_require__(43)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(76);
var createDesc = __webpack_require__(132);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(935);
var ITERATOR = __webpack_require__(43)('iterator');
var Iterators = __webpack_require__(135);
module.exports = __webpack_require__(42).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(226);
var TAG = __webpack_require__(43)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(43)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(188);

var _Button2 = _interopRequireDefault(_Button);

var _SafeAnchor = __webpack_require__(150);

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

var _bootstrapUtils = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  noCaret: _propTypes2['default'].bool,
  open: _propTypes2['default'].bool,
  title: _propTypes2['default'].string,
  useAnchor: _propTypes2['default'].bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  (0, _inherits3['default'])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    (0, _classCallCheck3['default'])(this, DropdownToggle);
    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);


    delete props.bsRole;

    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return _react2['default'].createElement(
      Component,
      (0, _extends3['default'])({}, props, {
        role: 'button',
        className: (0, _classnames2['default'])(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && _react2['default'].createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(_react2['default'].Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
module.exports = exports['default'];

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.requiredRoles = requiredRoles;
exports.exclusiveRoles = exclusiveRoles;

var _createChainableTypeChecker = __webpack_require__(239);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

var _ValidComponentChildren = __webpack_require__(88);

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function requiredRoles() {
  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(12);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(8);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(9);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _all = __webpack_require__(183);

var _all2 = _interopRequireDefault(_all);

var _SafeAnchor = __webpack_require__(150);

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

var _bootstrapUtils = __webpack_require__(17);

var _createChainedFunction = __webpack_require__(29);

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: _propTypes2['default'].bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: _propTypes2['default'].bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: (0, _all2['default'])(_propTypes2['default'].bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: _propTypes2['default'].any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: _propTypes2['default'].bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: _propTypes2['default'].string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: _propTypes2['default'].func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: _propTypes2['default'].func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  (0, _inherits3['default'])(MenuItem, _React$Component);

  function MenuItem(props, context) {
    (0, _classCallCheck3['default'])(this, MenuItem);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
        role: 'separator',
        className: (0, _classnames2['default'])(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
        role: 'heading',
        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
        style: style
      }));
    }

    return _react2['default'].createElement(
      'li',
      {
        role: 'presentation',
        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
        style: style
      },
      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(_react2['default'].Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
module.exports = exports['default'];

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidenavContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _spReactSticky = __webpack_require__(285);

var _featureFlags = __webpack_require__(147);

var _LoadingPage = __webpack_require__(199);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

var _GlobalAlerts = __webpack_require__(295);

var _GlobalAlerts2 = _interopRequireDefault(_GlobalAlerts);

var _SideGlobalNavigation = __webpack_require__(941);

var _SideGlobalNavigation2 = _interopRequireDefault(_SideGlobalNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidenavContainer = exports.SidenavContainer = function SidenavContainer(_ref) {
  var children = _ref.children,
      hasLoadedFlags = _ref.hasLoadedFlags;

  // load to make sure not to flash
  if (!hasLoadedFlags) {
    return _react2.default.createElement(_LoadingPage2.default, null);
  }

  return _react2.default.createElement(
    'div',
    { className: 'app-container' },
    _react2.default.createElement(_SideGlobalNavigation2.default, null),
    _react2.default.createElement(
      _spReactSticky.StickyContainer,
      { className: 'main-container' },
      _react2.default.createElement(_GlobalAlerts2.default, null),
      _react2.default.createElement(
        'div',
        { className: 'content-container' },
        children
      )
    )
  );
};

SidenavContainer.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.element]),
  hasLoadedFlags: _propTypes2.default.bool
};

function mapStateToProps(state) {
  return {
    hasLoadedFlags: (0, _featureFlags.areFlagsLoaded)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SidenavContainer);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideGlobalNavigation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = __webpack_require__(58);

var _reactRedux = __webpack_require__(22);

var _closest = __webpack_require__(477);

var _closest2 = _interopRequireDefault(_closest);

var _routes = __webpack_require__(86);

var _auth = __webpack_require__(36);

var _user = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIDE_NAV_AUTH_MENU = 'side-nav-auth-menu';

var SideGlobalNavigation = exports.SideGlobalNavigation = function (_Component) {
  _inherits(SideGlobalNavigation, _Component);

  function SideGlobalNavigation(props) {
    _classCallCheck(this, SideGlobalNavigation);

    var _this = _possibleConstructorReturn(this, (SideGlobalNavigation.__proto__ || Object.getPrototypeOf(SideGlobalNavigation)).call(this, props));

    _this.state = {
      toggleAuthMenuVisible: true
    };

    _this.onClickAuthMenuToggle = _this.onClickAuthMenuToggle.bind(_this);
    _this.onWindowClick = _this.onWindowClick.bind(_this);
    return _this;
  }

  _createClass(SideGlobalNavigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('click', this.onWindowClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onWindowClick);
    }
  }, {
    key: 'onClickAuthMenuToggle',
    value: function onClickAuthMenuToggle(e) {
      e.stopPropagation(); // to prevent window listener from grabbing
      this.setState(function (state) {
        return {
          toggleAuthMenuVisible: !state.toggleAuthMenuVisible
        };
      });
    }
  }, {
    key: 'onWindowClick',
    value: function onWindowClick(e) {
      var authMenuVisible = !this.state.toggleAuthMenuVisible;
      var clickWasInsideAuthMenu = !!(0, _closest2.default)(e.target, '#' + SIDE_NAV_AUTH_MENU, true);

      // if the auth menu is visible, and the click was outside it, hide
      // the auth menu
      if (authMenuVisible && !clickWasInsideAuthMenu) {
        this.setState(function () {
          return {
            toggleAuthMenuVisible: true
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement;

      var _props = this.props,
          isAuthenticated = _props.isAuthenticated,
          userInfo = _props.userInfo,
          isWhitelisted = _props.isWhitelisted;

      var firstName = (userInfo.displayName || '').split(' ')[0] || userInfo.id;

      return _react2.default.createElement(
        'nav',
        { className: 'side-global-nav' },
        _react2.default.createElement(
          _reactRouter.Link,
          { title: 'Spotify Ad Studio homepage', to: _routes.routes.BROWSE_ADS, className: 'navbar-brand' },
          _react2.default.createElement(
            'span',
            { className: 'navbar-logo' },
            'Spotify Ad Studio'
          )
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            title: 'Spotify Ad Studio build ad page',
            id: 'create-ad-link',
            to: _routes.routes.BUILD_AD,
            className: 'create-ad-btn btn btn-azure btn-sm center-block ta-build-ad-button'
          },
          'Create Ad'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'side-nav-top' },
          isAuthenticated && isWhitelisted && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              {
                title: 'Spotify Ad Studio browse ads page',
                id: 'browse-ads-link',
                activeClassName: 'active',
                to: _routes.routes.BROWSE_ADS
              },
              'My ads'
            )
          ),
          isAuthenticated && isWhitelisted && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              {
                title: 'Spotify Ad Studio account settings',
                id: 'account-settings-link',
                to: _routes.routes.ACCOUNT_SETTINGS,
                activeClassName: 'active'
              },
              'My account'
            )
          ),
          (!isWhitelisted || !isAuthenticated) && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { title: 'Spotify Ad Studio get access page', id: 'get-access-link', to: _routes.routes.WAITLIST },
              'Join Waitlist'
            )
          ),
          !isAuthenticated && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { title: 'Spotify Ad Studio log in page', id: 'navbar-login', to: _routes.routes.LOGIN },
              'Log In'
            )
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'side-nav-footer' },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { title: 'Spotify Ad Studio FAQ and help page', id: 'faq-help-link', to: _routes.routes.FAQ },
              'FAQ & Help'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { title: 'Spotify Ad Studio Terms and Conditions page', id: 'terms-conditions-link', to: _routes.routes.BETA_TERMS },
              'Terms and Conditions'
            )
          ),
          _react2.default.createElement(
            'li',
            { className: 'beta-wrapper' },
            _react2.default.createElement(
              'svg',
              { role: 'img', className: 'beta-logo', width: '42', height: '22', viewBox: '0 0 42 22', xmlns: 'http://www.w3.org/2000/svg' },
              _react2.default.createElement(
                'title',
                null,
                'Spotify Ad Studio beta'
              ),
              _react2.default.createElement(
                'desc',
                null,
                'This application is currently in beta.'
              ),
              _react2.default.createElement(
                'g',
                { fillRule: 'nonzero', fill: 'none' },
                _react2.default.createElement('path', { d: 'M39 22H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h36c1.657 0 3 1.343 3 3v16c0 1.657-1.343 3-3 3zM3 2c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1h36c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H3z', fill: '#414141' }),
                _react2.default.createElement('path', { d: 'M10.91 7.46c.548-.072 1.1.096 1.515.463.415.366.65.894.645 1.447.024.668-.377 1.278-1 1.52.76.197 1.28.896 1.25 1.68.003.565-.234 1.105-.65 1.486-.42.38-.977.568-1.54.514H8.36V7.46h2.55zm-.21 2.93c.254.032.51-.048.702-.218.19-.17.3-.416.298-.672 0-.54-.35-.88-1-.88h-1v1.77h1zm.14 3c.67 0 1.07-.35 1.07-.92.01-.264-.094-.52-.286-.7-.19-.182-.45-.273-.714-.25H9.72v1.87h1.12zM15.06 14.54V7.46h4.44v1.3h-3.06v1.62h2.77v1.22h-2.77v1.64h3.06v1.3M24.31 8.77v5.78h-1.39V8.77h-2.24V7.46h5.87v1.31M31.55 12.92h-2.88l-.59 1.62h-1.46l2.72-7.09h1.6l2.7 7.09h-1.5l-.59-1.62zm-2.42-1.26h2L30.11 9l-.98 2.66z', fill: '#A2A5A7' })
              )
            )
          ),
          isAuthenticated && _react2.default.createElement(
            'li',
            { className: 'user-profile' },
            _react2.default.createElement(
              'a',
              (_React$createElement = {
                title: 'Spotify Ad Studio user profile',
                id: 'user-profile',
                className: 'user-profile-btn',
                role: 'button',
                'aria-controls': SIDE_NAV_AUTH_MENU,
                href: '#',
                onClick: this.onClickAuthMenuToggle
              }, _defineProperty(_React$createElement, 'title', firstName), _defineProperty(_React$createElement, 'tabIndex', '0'), _React$createElement),
              userInfo.imgSrc && _react2.default.createElement('img', { alt: 'user-profile', className: 'user-img img-circle navbar-user-img', src: userInfo.imgSrc }),
              firstName,
              _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)('dropdown-arrow', {
                    'dropdown-arrow-active': !this.state.toggleAuthMenuVisible
                  }) },
                _react2.default.createElement(
                  'svg',
                  { width: '24', height: '23', viewBox: '0 0 24 23', xmlns: 'http://www.w3.org/2000/svg' },
                  _react2.default.createElement('path', {
                    d: 'M12.023 13.688L8.12 9.174l-.753.653 4.656 5.44 4.67-5.44-.752-.653-3.917 4.514zm0 8.313c-5.764 0-10.45-4.71-10.45-10.5S6.258 1 12.022 1c5.76 0 10.448 4.71 10.448 10.5S17.785 22 12.023 22zm0-22C5.7 0 .576 5.148.576 11.5.577 17.85 5.7 23 12.022 23c6.32 0 11.445-5.15 11.445-11.5 0-6.352-5.125-11.5-11.445-11.5z',
                    fillRule: 'evenodd'
                  })
                )
              )
            )
          ),
          isAuthenticated && _react2.default.createElement(
            'div',
            {
              id: SIDE_NAV_AUTH_MENU,
              role: 'menu',
              className: (0, _classnames2.default)('carat-toggle', {
                hide: this.state.toggleAuthMenuVisible,
                show: !this.state.toggleAuthMenuVisible
              })
            },
            _react2.default.createElement(
              _reactRouter.Link,
              { title: 'Spotify Ad Studio Log out', id: 'log-out-link', role: 'menuitem', to: _routes.routes.LOGOUT },
              'Log Out'
            )
          )
        )
      );
    }
  }]);

  return SideGlobalNavigation;
}(_react.Component);

SideGlobalNavigation.propTypes = {
  isAuthenticated: _propTypes2.default.bool.isRequired,
  isWhitelisted: _propTypes2.default.bool.isRequired,
  userInfo: _propTypes2.default.object
};

function mapStateToProps(state) {
  return {
    isAuthenticated: (0, _auth.getIsAuthenticated)(state),
    isWhitelisted: (0, _auth.getIsWhitelisted)(state),
    userInfo: (0, _user.getUser)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SideGlobalNavigation);

/***/ }),
/* 942 */
/***/ (function(module, exports) {


/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainComponent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OnlineEventDetector = __webpack_require__(944);

var _OnlineEventDetector2 = _interopRequireDefault(_OnlineEventDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainComponent = exports.MainComponent = function MainComponent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_OnlineEventDetector2.default, null),
    children
  );
};

MainComponent.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.element])
};

exports.default = MainComponent;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlineEventDetector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _global = __webpack_require__(148);

var _network = __webpack_require__(420);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineEventDetector = exports.OnlineEventDetector = function (_Component) {
  _inherits(OnlineEventDetector, _Component);

  function OnlineEventDetector(props) {
    _classCallCheck(this, OnlineEventDetector);

    var _this = _possibleConstructorReturn(this, (OnlineEventDetector.__proto__ || Object.getPrototypeOf(OnlineEventDetector)).call(this, props));

    _this.updateOnlineStatus = _this.updateOnlineStatus.bind(_this);
    return _this;
  }

  _createClass(OnlineEventDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _global.window.addEventListener('online', this.updateOnlineStatus);
      _global.window.addEventListener('offline', this.updateOnlineStatus);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _global.window.removeEventListener('online', this.updateOnlineStatus);
      _global.window.removeEventListener('offline', this.updateOnlineStatus);
    }
  }, {
    key: 'updateOnlineStatus',
    value: function updateOnlineStatus() {
      var dispatchUpdateNetworkStatus = this.props.dispatchUpdateNetworkStatus;

      dispatchUpdateNetworkStatus(_global.navigator.onLine);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return OnlineEventDetector;
}(_react.Component);

OnlineEventDetector.propTypes = {
  dispatchUpdateNetworkStatus: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
  dispatchUpdateNetworkStatus: _network.updateNetworkStatus
})(OnlineEventDetector);

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERNAL_NAV_TYPE = exports.HOMEPAGE_NAV_TYPE = exports.TopnavContainer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spReactSticky = __webpack_require__(285);

var _GlobalAlerts = __webpack_require__(295);

var _GlobalAlerts2 = _interopRequireDefault(_GlobalAlerts);

var _NavigationBar = __webpack_require__(502);

var _NavigationBar2 = _interopRequireDefault(_NavigationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopnavContainer = exports.TopnavContainer = function TopnavContainer(_ref) {
  var children = _ref.children,
      navType = _ref.route.navType;
  return _react2.default.createElement(
    'main',
    { role: 'main' },
    _react2.default.createElement(_NavigationBar2.default, { navType: navType }),
    _react2.default.createElement(
      _spReactSticky.StickyContainer,
      { className: 'main' },
      navType !== _NavigationBar.HOMEPAGE_NAV_TYPE && _react2.default.createElement(_GlobalAlerts2.default, { showBrowserSupportAlert: false }),
      _react2.default.createElement(
        'div',
        { className: 'content' },
        children
      )
    )
  );
};

TopnavContainer.defaultProps = {
  route: {}
};

TopnavContainer.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.element]),
  route: _propTypes2.default.shape({
    navType: _propTypes2.default.string
  }).isRequired
};

exports.HOMEPAGE_NAV_TYPE = _NavigationBar.HOMEPAGE_NAV_TYPE;
exports.INTERNAL_NAV_TYPE = _NavigationBar.INTERNAL_NAV_TYPE;
exports.default = TopnavContainer;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MarketingPageFooter = __webpack_require__(487);

var _MarketingPageFooter2 = _interopRequireDefault(_MarketingPageFooter);

var _reactRouter = __webpack_require__(58);

var _reactHelmet = __webpack_require__(288);

var _routes = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mainContainerStyles = '.main{padding-top:0; margin-top:0;}';

var NotFound = function NotFound() {
  return _react2.default.createElement(
    'div',
    { className: 'not-found-wrapper' },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'style',
        null,
        mainContainerStyles
      )
    ),
    _react2.default.createElement(
      'section',
      { className: 'container container-info' },
      _react2.default.createElement(
        'div',
        { className: 'row not-found-container' },
        _react2.default.createElement(
          'div',
          { className: 'not-found-message' },
          _react2.default.createElement(
            'h3',
            null,
            'Darn!'
          ),
          _react2.default.createElement(
            'p',
            { className: 'not-found-text' },
            'We couldn\'t find the page you were looking for. ',
            'Maybe our',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: _routes.routes.FAQ, className: 'faq-link' },
              'FAQ'
            ),
            'or',
            _react2.default.createElement(
              _reactRouter.Link,
              { to: _routes.routes.MAIN, className: 'faq-link' },
              'homepage'
            ),
            'can help?'
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            {
              to: _routes.routes.MAIN,
              className: 'main-link'
            },
            'Go Back'
          )
        ),
        _react2.default.createElement(
          'figure',
          { className: 'not-found-illustration' },
          _react2.default.createElement(
            'picture',
            null,
            _react2.default.createElement('source', {
              srcSet: 'https://adstudio.scdn.co/assets/landingpage/404_Illustration.svg',
              media: '(max-width: 768px)'
            }),
            _react2.default.createElement('img', {
              src: 'https://adstudio.scdn.co/assets/landingpage/404_Illustration.svg',
              alt: '404 Error Art Work',
              className: 'center-block'
            })
          )
        )
      )
    ),
    _react2.default.createElement(_MarketingPageFooter2.default, null)
  );
};

exports.default = NotFound;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomePageFooterSvgs;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HomePageFooterSvgs() {
  var svgStyle = {
    display: 'none'
  };
  return _react2.default.createElement(
    'svg',
    { className: 'homepage-svgs', xmlns: 'http://www.w3.org/2000/svg', style: svgStyle },
    _react2.default.createElement(
      'symbol',
      { id: 'facebook-icon', viewBox: '0 0 448 448' },
      _react2.default.createElement('path', { d: 'm119.75 242.25v-74h63.75v-54.5q0-46.5 26-72.125t69.25-25.625q36.75 0 57 3v66h-39.25q-21.5 0-29 9t-7.5 27v47.25h73.25l-9.75 74h-63.5v189.75h-76.5v-189.75h-63.75z' })
    ),
    _react2.default.createElement(
      'symbol',
      { id: 'twitter-icon', viewBox: '0 0 448 448' },
      _react2.default.createElement('path', { d: 'm27 347.75q8.75 1 19.5 1 56.25 0 100.25-34.5-26.25-0.5-47-16.125t-28.5-39.875q8.25 1.25 15.25 1.25 10.75 0 21.25-2.75-28-5.75-46.375-27.875t-18.375-51.375v-1q17 9.5 36.5 10.25-16.5-11-26.25-28.75t-9.75-38.5q0-22 11-40.75 30.25 37.25 73.625 59.625t92.875 24.875q-2-9.5-2-18.5 0-33.5 23.625-57.125t57.125-23.625q35 0 59 25.5 27.25-5.25 51.25-19.5-9.25 28.75-35.5 44.5 23.25-2.5 46.5-12.5-16.75 24.5-40.5 41.75 0.25 3.5 0.25 10.5 0 32.5-9.5 64.875t-28.875 62.125-46.125 52.625-64.5 36.5-80.75 13.625q-67.75 0-124-36.25z' })
    ),
    _react2.default.createElement(
      'symbol',
      { id: 'instagram-icon', viewBox: '0 0 448 448' },
      _react2.default.createElement('path', { d: 'm32 366.75v-285.5q0-20.25 14.5-34.75t34.75-14.5h285.5q20.25 0 34.75 14.5t14.5 34.75v285.5q0 20.25-14.5 34.75t-34.75 14.5h-285.5q-20.25 0-34.75-14.5t-14.5-34.75zm42.749-10.25q0 6.5 4.375 10.875t10.875 4.375h267.25q6.25 0 10.75-4.375t4.5-10.875v-162h-33.75q5 15.75 5 32.75 0 31.5-16 58.125t-43.5 42.125-60 15.5q-49.25 0-84.25-33.875t-35-81.875q0-17 5-32.75h-35.25v162zm72.501-133.25q0 31 22.625 52.875t54.375 21.875q32 0 54.625-21.875t22.625-52.875-22.625-52.875-54.625-21.875q-31.75 0-54.375 21.875t-22.625 52.875zm147.25-90q0 7.25 5 12.25t12.25 5h43.5q7.25 0 12.25-5t5-12.25v-41.25q0-7-5-12.125t-12.25-5.125h-43.5q-7.25 0-12.25 5.125t-5 12.125v41.25z' })
    )
  );
}

/***/ }),
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalRedirect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(186);

var _redux = __webpack_require__(53);

var _reactRedux = __webpack_require__(22);

var _reactRouter = __webpack_require__(58);

var _reactRouterRedux = __webpack_require__(60);

var _redirect = __webpack_require__(200);

var _window = __webpack_require__(189);

var _routes = __webpack_require__(86);

var _routeHelpers = __webpack_require__(388);

var _RedirectingPage = __webpack_require__(422);

var _RedirectingPage2 = _interopRequireDefault(_RedirectingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExternalRedirect = exports.ExternalRedirect = function (_Component) {
  _inherits(ExternalRedirect, _Component);

  function ExternalRedirect() {
    _classCallCheck(this, ExternalRedirect);

    return _possibleConstructorReturn(this, (ExternalRedirect.__proto__ || Object.getPrototypeOf(ExternalRedirect)).apply(this, arguments));
  }

  _createClass(ExternalRedirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dispatchReplace = _props.dispatchReplace,
          dispatchStoreRedirectValues = _props.dispatchStoreRedirectValues,
          dispatchTriggerHardRedirect = _props.dispatchTriggerHardRedirect,
          location = _props.location,
          dispatch = _props.dispatch,
          redirectUrl = _props.redirectUrl,
          onRedirectAction = _props.onRedirectAction;

      // follow-up action if you've used an action creator in your

      if (typeof onRedirectAction === 'function') {
        dispatch(onRedirectAction());
      }

      // TODO figure out a way to store the previous path here
      dispatchStoreRedirectValues({
        url: '/',
        preserveUrlParams: false
      });

      // dispatch a silent replace
      dispatchReplace({
        pathname: _routes.routes.REDIRECT,
        state: location.state
      });

      // hard redirect to the real path.
      dispatchTriggerHardRedirect(redirectUrl);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_RedirectingPage2.default, null);
    }
  }]);

  return ExternalRedirect;
}(_react.Component);

ExternalRedirect.defaultProps = {
  route: {}
};

ExternalRedirect.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  dispatchReplace: _propTypes2.default.func.isRequired,
  dispatchStoreRedirectValues: _propTypes2.default.func.isRequired,
  dispatchTriggerHardRedirect: _propTypes2.default.func.isRequired,
  redirectUrl: _propTypes2.default.string.isRequired,
  onRedirectAction: _propTypes2.default.func,
  route: _propTypes2.default.object,
  location: _propTypes2.default.shape({
    state: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(null, function (dispatch) {
  return _extends({
    dispatch: dispatch
  }, (0, _redux.bindActionCreators)({
    dispatchReplace: _reactRouterRedux.replace,
    dispatchStoreRedirectValues: _redirect.storeRedirectValues,
    dispatchTriggerHardRedirect: _window.triggerHardRedirect
  }, dispatch));
}),

// guarantees location will be present
_reactRouter.withRouter,

// pull props off of the route to the main props.
// this makes the component embeddable more easily.
(0, _recompose.withProps)(function (props) {
  return (0, _routeHelpers.mapPropsFromRoute)(props, ['redirectUrl', 'onRedirectAction']);
}))(ExternalRedirect);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedirectReturn = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(22);

var _redirect = __webpack_require__(200);

var _RedirectingPage = __webpack_require__(422);

var _RedirectingPage2 = _interopRequireDefault(_RedirectingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RedirectReturn = exports.RedirectReturn = function (_Component) {
  _inherits(RedirectReturn, _Component);

  function RedirectReturn() {
    _classCallCheck(this, RedirectReturn);

    return _possibleConstructorReturn(this, (RedirectReturn.__proto__ || Object.getPrototypeOf(RedirectReturn)).apply(this, arguments));
  }

  _createClass(RedirectReturn, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatchRedirectFromStorage();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_RedirectingPage2.default, null);
    }
  }]);

  return RedirectReturn;
}(_react.Component);

RedirectReturn.propTypes = {
  dispatchRedirectFromStorage: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactRedux.connect)(null, {
  dispatchRedirectFromStorage: _redirect.redirectFromStorage
})(RedirectReturn);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(174);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 959 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(174),
    Map = __webpack_require__(261),
    MapCache = __webpack_require__(291);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UNAPPROVED_STATUS_TY, _APPROVED_STATUS_TYPE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AWAITING_VOICEOVER_CHECK = exports.AWAITING_VOICEOVER_CHECK = 'awaiting_voiceover_check';
var CHECKING_VOICEOVER = exports.CHECKING_VOICEOVER = 'checking_voiceover';
var MIXING = exports.MIXING = 'mixing';
var TRANSCODING = exports.TRANSCODING = 'transcoding';
var PENDING_APPROVAL = exports.PENDING_APPROVAL = 'pending_approval';
var REVIEW = exports.REVIEW = 'review_audio';

var PROCESSING = exports.PROCESSING = 'processing';

var ACTIVE = exports.ACTIVE = 'active';
var READY = exports.READY = 'ready';
var COMPLETE = exports.COMPLETE = 'complete';
var STOPPED = exports.STOPPED = 'stopped';
var REJECTED = exports.REJECTED = 'rejected';

var UNAPPROVED_STATUS_TYPES = exports.UNAPPROVED_STATUS_TYPES = (_UNAPPROVED_STATUS_TY = {}, _defineProperty(_UNAPPROVED_STATUS_TY, AWAITING_VOICEOVER_CHECK, 'Awaiting Voiceover'), _defineProperty(_UNAPPROVED_STATUS_TY, CHECKING_VOICEOVER, 'Checking Voiceover'), _defineProperty(_UNAPPROVED_STATUS_TY, MIXING, 'Mixing'), _defineProperty(_UNAPPROVED_STATUS_TY, TRANSCODING, 'Transcoding'), _defineProperty(_UNAPPROVED_STATUS_TY, REVIEW, 'Review Audio'), _defineProperty(_UNAPPROVED_STATUS_TY, PENDING_APPROVAL, 'Pending Approval'), _UNAPPROVED_STATUS_TY);

var APPROVED_STATUS_TYPES = exports.APPROVED_STATUS_TYPES = (_APPROVED_STATUS_TYPE = {}, _defineProperty(_APPROVED_STATUS_TYPE, READY, 'Ready'), _defineProperty(_APPROVED_STATUS_TYPE, ACTIVE, 'Active'), _defineProperty(_APPROVED_STATUS_TYPE, COMPLETE, 'Complete'), _defineProperty(_APPROVED_STATUS_TYPE, STOPPED, 'Stopped'), _APPROVED_STATUS_TYPE);

var processingTypes = Object.keys(UNAPPROVED_STATUS_TYPES).filter(function (s) {
  return s !== PENDING_APPROVAL && s !== REVIEW;
}).join('.');

var PROCESSING_STATUS_TYPES = exports.PROCESSING_STATUS_TYPES = _defineProperty({}, processingTypes, 'Processing');

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(482),
    arrayEach = __webpack_require__(996),
    assignValue = __webpack_require__(433),
    baseAssign = __webpack_require__(997),
    baseAssignIn = __webpack_require__(998),
    cloneBuffer = __webpack_require__(1001),
    copyArray = __webpack_require__(1002),
    copySymbols = __webpack_require__(1003),
    copySymbolsIn = __webpack_require__(1004),
    getAllKeys = __webpack_require__(491),
    getAllKeysIn = __webpack_require__(436),
    getTag = __webpack_require__(296),
    initCloneArray = __webpack_require__(1005),
    initCloneByTag = __webpack_require__(1006),
    initCloneObject = __webpack_require__(1015),
    isArray = __webpack_require__(59),
    isBuffer = __webpack_require__(198),
    isObject = __webpack_require__(115),
    keys = __webpack_require__(190);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 996 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(145),
    keys = __webpack_require__(190);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(145),
    keysIn = __webpack_require__(434);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(115),
    isPrototype = __webpack_require__(182),
    nativeKeysIn = __webpack_require__(1000);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(145),
    getSymbols = __webpack_require__(276);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(145),
    getSymbolsIn = __webpack_require__(435);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(279),
    cloneDataView = __webpack_require__(1007),
    cloneMap = __webpack_require__(1008),
    cloneRegExp = __webpack_require__(1010),
    cloneSet = __webpack_require__(1011),
    cloneSymbol = __webpack_require__(1013),
    cloneTypedArray = __webpack_require__(1014);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(279);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1009),
    arrayReduce = __webpack_require__(437),
    mapToArray = __webpack_require__(489);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1012),
    arrayReduce = __webpack_require__(437),
    setToArray = __webpack_require__(490);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(279);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1016),
    getPrototype = __webpack_require__(256),
    isPrototype = __webpack_require__(182);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(115);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(194),
    last = __webpack_require__(1018),
    parent = __webpack_require__(1019),
    toKey = __webpack_require__(284);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1018 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(290),
    baseSlice = __webpack_require__(1020);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(381);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1023),
    overRest = __webpack_require__(1026),
    setToString = __webpack_require__(1028);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1024);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(275),
    isFlattenable = __webpack_require__(1025);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(120),
    isArguments = __webpack_require__(196),
    isArray = __webpack_require__(59);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1027);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1029),
    shortOut = __webpack_require__(1031);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1030),
    defineProperty = __webpack_require__(430),
    identity = __webpack_require__(493);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;

var _redux = __webpack_require__(53);

var _reduxPersist = __webpack_require__(1033);

var _reactRouter = __webpack_require__(58);

var _reactRouterRedux = __webpack_require__(60);

var _reduxLogger = __webpack_require__(1035);

var _global = __webpack_require__(148);

var _reactGa = __webpack_require__(347);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reduxSaga = __webpack_require__(35);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _flags = __webpack_require__(89);

var _debug = __webpack_require__(1041);

var _debug2 = _interopRequireDefault(_debug);

var _googleAnalytics = __webpack_require__(1043);

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

var _unhandledError = __webpack_require__(1044);

var _unhandledError2 = _interopRequireDefault(_unhandledError);

var _window = __webpack_require__(1046);

var _window2 = _interopRequireDefault(_window);

var _sagas = __webpack_require__(1047);

var _sagas2 = _interopRequireDefault(_sagas);

var _reducers = __webpack_require__(1081);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore() {
  var isProd = (0, _flags.getFlag)('env') === 'prod';
  var swEnabled = (0, _flags.getFlag)('swEnabled') === true;

  var sagaMiddleware = (0, _reduxSaga2.default)();

  var middleware = [(0, _unhandledError2.default)(_global.window), (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), sagaMiddleware, (0, _googleAnalytics2.default)(_reactGa2.default), (0, _window2.default)(_global.window)];

  if (!isProd) {
    middleware.push(_reduxLogger.logger);
  }

  var enhancers = [_redux.applyMiddleware.apply(undefined, middleware)];

  if (swEnabled) {
    enhancers.push((0, _reduxPersist.autoRehydrate)({ log: true }));
  }

  var store = (0, _redux.createStore)(_reducers2.default, undefined, _redux.compose.apply(undefined, enhancers));

  if (swEnabled) {
    (0, _reduxPersist.persistStore)(store, { whitelist: ['auth', 'user'] });
  }

  // must be run after middleware has been applied
  sagaMiddleware.run(_sagas2.default);

  // attach ag to the window
  _global.window.ag = (0, _debug2.default)(store, _global.window);

  return store;
}

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';
// EXTERNAL MODULE: ./node_modules/lodash-es/isPlainObject.js
var isPlainObject = __webpack_require__(167);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/utils/isStatePlainEnough.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(isPlainObject["a" /* default */])(a)) return false;
  return true;
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/autoRehydrate.js
var autoRehydrate__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== REHYDRATE) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (autoRehydrate__typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (isStatePlainEnough(inboundState[key]) && isStatePlainEnough(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}
// EXTERNAL MODULE: ./node_modules/redux-persist/es/utils/setImmediate.js
var setImmediate = __webpack_require__(438);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/defaults/asyncLocalStorage.js
var asyncLocalStorage__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : asyncLocalStorage__typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ var asyncLocalStorage = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});
// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}
// EXTERNAL MODULE: ./node_modules/json-stringify-safe/stringify.js
var stringify = __webpack_require__(1034);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistor.js





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || asyncLocalStorage('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return purgeStoredState({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return stringify_default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: REHYDRATE,
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/createTransform.js
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ var es_createTransform = (createTransform);
// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js
var getStoredState__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || asyncLocalStorage('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : getStoredState_defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = getStoredState__extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function getStoredState_defaultDeserializer(serial) {
  return JSON.parse(serial);
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
var persistStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = createPersistor(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(setImmediate["a" /* default */])(function () {
      getStoredState(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }

        store.dispatch(persistStore_rehydrateAction(restoredState, err));
        complete(err, restoredState);
      });
    });
  } else Object(setImmediate["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return persistStore__extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function persistStore_rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: REHYDRATE,
    payload: payload,
    error: error
  };
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return autoRehydrate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createPersistor", function() { return createPersistor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createTransform", function() { return es_createTransform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getStoredState", function() { return getStoredState; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "persistStore", function() { return persistStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return purgeStoredState; });







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};



/***/ }),
/* 1034 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPULATED_ACCOUNT = exports.POPULATED_STATE = exports.FORM_DEFS = undefined;

var _FORM_DEFS, _uploads, _audioSubmission;

exports.default = debug;

var _reduxForm = __webpack_require__(67);

var _config = __webpack_require__(30);

var _adCreation = __webpack_require__(293);

var _account = __webpack_require__(468);

var _editableAd = __webpack_require__(47);

var _validation = __webpack_require__(153);

var _dateHelper = __webpack_require__(149);

var _uploadProperties = __webpack_require__(117);

var _debug = __webpack_require__(432);

var debugActions = _interopRequireWildcard(_debug);

var _featureFlags = __webpack_require__(114);

var _user = __webpack_require__(69);

var _debug2 = __webpack_require__(1042);

var _auth = __webpack_require__(36);

var _adCreation2 = __webpack_require__(87);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // --- Create Ad ---


var FORM_DEFS = exports.FORM_DEFS = (_FORM_DEFS = {}, _defineProperty(_FORM_DEFS, _config.CAMPAIGN_FORM_NAME, {
  fields: _adCreation.CAMPAIGN_FIELDS,
  initialValuesSelector: _adCreation2.getCampaignInitialValues
}), _defineProperty(_FORM_DEFS, _config.AUDIENCE_FORM_NAME, {
  fields: _adCreation.AUDIENCE_FIELDS,
  initialValuesSelector: _adCreation2.getAudienceInitialValues
}), _FORM_DEFS);

var POPULATED_STATE = exports.POPULATED_STATE = {
  name: 'Get Spotify Premium',
  clickthroughUrl: 'https://www.spotify.com/watch-now/learn-more/',
  internalName: 'Test-Reject',
  objective: 'businesspromo',
  uploads: (_uploads = {
    image: {
      uploaded: true,
      uploadInfo: {
        id: '5b6983a9-d6f6-4ff2-b9ce-a54a5bd37289',
        action: 'https://cream-adgen.s3.amazonaws.com/',
        fields: {},
        uri: 'https://cream-adgen.s3.amazonaws.com/assets/image/5b6983a9-d6f6-4ff2-b9ce-a54a5bd37289/asset?&cachebuster=1464017380754'
      }
    }
  }, _defineProperty(_uploads, _config.UPLOADED_AUDIO, {
    uploaded: true,
    uploadInfo: {
      id: '123ad0a4-8b6c-4964-a1ba-c75d27cade3c',
      action: 'https://cream-adgen.s3.amazonaws.com/',
      fields: {},
      uri: 'https://cream-adgen.s3.amazonaws.com/assets/audiocomponent/123ad0a4-8b6c-4964-a1ba-c75d27cade3c/asset'
    }
  }), _defineProperty(_uploads, _config.BG_MUSIC, (0, _uploadProperties.createDefaultAudioUploadObj)()), _defineProperty(_uploads, _config.EXISTING_VO_BG_MUSIC, (0, _uploadProperties.createDefaultAudioUploadObj)()), _uploads),
  audioSubmission: (_audioSubmission = {
    active: _config.UPLOADED_AUDIO
  }, _defineProperty(_audioSubmission, _config.EXISTING_VOICEOVER, {
    data: {
      id: '0e45c5b3-2804-4d63-9325-24dc8ae06a9a',
      name: 'ExistingVOTestName',
      uri: 'https://drdxyzdg0sjtu.cloudfront.net/assets/audiocomponent/0e45c5b3-2804-4d63-9325-24dc8ae06a9a/asset'
    },
    bgMusic: {}
  }), _defineProperty(_audioSubmission, _config.NEW_VOICEOVER, {
    name: '',
    transcript: '',
    instructions: '',
    locale: '',
    voice: '',
    bgMusic: {}
  }), _audioSubmission),
  targeting: {
    locations: [{
      countryCode: 'US',
      id: 'dfp:2840',
      name: 'United States',
      parentId: '',
      type: 'country'
    }],
    platforms: {
      desktop: true,
      ios: false,
      android: false
    },
    gender: _config.ALL_GENDERS_VALUE,
    ageRange: {
      start: '13',
      end: '65'
    },
    fanAudiences: [],
    moments: [],
    genres: [],
    freeTrial: _config.FREE_TRIAL_NULL_VALUE
  },
  dateRange: {
    begin: (0, _dateHelper.daysFromToday)(2),
    end: (0, _dateHelper.endOfDay)((0, _dateHelper.daysFromToday)(2))
  },
  payments: {
    totalBudget: '0.03'
  }
};

var POPULATED_ACCOUNT = exports.POPULATED_ACCOUNT = {
  country: 'United States',
  firstName: 'Buddy',
  lastName: 'The Elf',
  jobTitle: 'Account Filler Fairy',
  businessName: 'All About That Form Life',
  businessWebsite: 'http://buddytheelfformlife.com',
  industry: 'Automotive',
  adStudioLead: 'UI Team Rules!'
};

var KEY_F6 = 117;
var KEY_F7 = 118;

function debug(store, windowObj) {
  function debugPopulateFields() {
    store.dispatch((0, _editableAd.populateFields)(POPULATED_STATE));
    store.dispatch((0, _validation.validateFields)({
      fields: POPULATED_STATE,
      groups: store.getState().user.groups
    }));

    // add the values to the redux forms as well
    // TODO consolidate this with the restore logic
    Object.keys(FORM_DEFS).forEach(function (formName) {
      var _FORM_DEFS$formName = FORM_DEFS[formName],
          fields = _FORM_DEFS$formName.fields,
          initialValuesSelector = _FORM_DEFS$formName.initialValuesSelector;

      store.dispatch((0, _reduxForm.initialize)(formName, initialValuesSelector(store.getState())));
      fields.forEach(function (fieldName) {
        return store.dispatch((0, _reduxForm.change)(formName, fieldName, POPULATED_STATE[fieldName]));
      });
    });
  }

  function populateAccountFields() {
    Object.keys(POPULATED_ACCOUNT).forEach(function (fieldName) {
      return store.dispatch((0, _reduxForm.change)(_account.ACCOUNT_REDUX_FORM_ID, fieldName, POPULATED_ACCOUNT[fieldName]));
    });
  }

  function forceAccountSetup() {
    store.dispatch((0, _user.setUserAccount)(null));
  }

  function getWgToken() {
    return (0, _auth.getWgToken)(store.getState());
  }

  // Add debug keyboard shortcuts
  windowObj.onkeyup = function (e) {
    switch (e.keyCode) {
      case KEY_F6:
        debugPopulateFields();
        break;
      case KEY_F7:
        populateAccountFields();
        break;
      default:
    }
  };

  function setFeatureFlag(flag, value) {
    store.dispatch((0, _featureFlags.userFlagUpdated)({ value: value, flag: flag }));
  }

  function updateField(key, value) {
    store.dispatch((0, _editableAd.updateFields)({ key: key, value: value }));
    store.dispatch((0, _validation.validateFields)({
      fields: POPULATED_STATE,
      groups: store.getState().user.groups
    }));
  }

  function triggerAction(actionType, payload) {
    store.dispatch({
      type: actionType,
      payload: payload
    });
  }

  function extendStartDate(adId) {
    var numDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

    store.dispatch(debugActions.extendStartDate(adId, (0, _dateHelper.daysFromToday)(numDays)));
  }

  function extendEndDate(adId) {
    var numDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

    store.dispatch(debugActions.extendEndDate(adId, (0, _dateHelper.daysFromToday)(numDays)));
  }

  function fakeUploadFullMix() {
    updateField('uploads.fullmix.uploaded', true);
    updateField('uploads.fullmix.uploadInfo.id', '123ad0a4-8b6c-4964-a1ba-c75d27cade3c');
    updateField('uploads.fullmix.uploadInfo.uri', 'https://cream-adgen.s3.amazonaws.com/assets/audiocomponent/123ad0a4-8b6c-4964-a1ba-c75d27cade3c/asset');
  }

  function fakeUploadCompanionImage() {
    updateField('uploads.image.uploaded', true);
    updateField('uploads.image.uploadInfo.id', '566359fc-fcd5-46f2-bc1e-8a1a84762a4a');
    updateField('uploads.image.uploadInfo.uri', 'https://cream-adgen.s3.amazonaws.com/assets/image/566359fc-fcd5-46f2-bc1e-8a1a84762a4a/asset?&cachebuster=1464017380754');
  }

  return {
    populateFields: debugPopulateFields,
    populateAccount: populateAccountFields,
    forceAccountSetup: forceAccountSetup,
    store: store,
    env: function env() {
      return "production";
    },
    setFeatureFlag: setFeatureFlag,
    updateField: updateField,
    triggerAction: triggerAction,
    resetAdToPending: function resetAdToPending(adId) {
      return (0, _debug2.resetAdToPending)(store.getState().auth.token, adId);
    },
    fakeUploadFullMix: fakeUploadFullMix,
    fakeUploadCompanionImage: fakeUploadCompanionImage,
    extendStartDate: extendStartDate,
    extendEndDate: extendEndDate,
    getWgToken: getWgToken
  };
}

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetAdToPending = resetAdToPending;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resetAdToPending(wgToken, adId) {
  var url = 'adgenerator/v1/testing/' + adId + '/pendingReset';
  var opts = { method: 'POST' };
  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return r.text().then(function (e) {
      throw Error(e);
    });
    return r;
  });
}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = googleAnalytics;

var _editableAd = __webpack_require__(47);

var _analytics = __webpack_require__(68);

var _reducer = __webpack_require__(265);

function googleAnalytics(ga) {
  return function () {
    return function (next) {
      return function (action) {
        switch (action.type) {
          case _reducer.LOCATION_CHANGE:
            ga.pageview(action.payload.pathname);
            break;
          case _analytics.LOG_USER_ACTION:
            {
              var _action$payload = action.payload,
                  category = _action$payload.category,
                  label = _action$payload.label,
                  params = _action$payload.params;

              ga.event({ category: category, action: label, label: params && JSON.stringify(params) });
              break;
            }
          // TODO: If we opt to store certain build_ad fields as dimensions:
          // case UPDATE_FIELDS: {
          //   if (fieldsToStore.includes(fieldName)) {
          //     ga('set', fieldName, value);
          //   }
          //   break;
          // }
          case _editableAd.AD_CREATED:
            ga.event({
              category: 'Ad Creation',
              action: 'Created',
              label: action.name
            });
            // TODO: If we opt to store certain build_ad fields as dimensions:
            // clear build_ad dimensions
            // ga('set', fieldsToStore.reduce(result, fieldName => ({...result, [fieldName]: null}), {}));
            break;
          case _analytics.GUIDELINE_PDF_CLICKED:
            ga.event({
              category: 'File',
              action: 'download',
              label: 'Creative Audio Guidelines'
            });
            break;
          case _analytics.LANDING_VIDEO_PLAYED:
            ga.event({
              category: 'Video',
              action: 'play',
              label: 'Audio Impact Video'
            });
            break;
          case _analytics.GA_PARTNER_ID_RECEIVED:
            ga.set({
              userId: action.payload.partnerId,
              dimension1: action.payload.partnerId
            });
            break;
          default:
        }

        return next(action);
      };
    };
  };
}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorHandler = undefined;

var _reduxCatch = __webpack_require__(1045);

var _reduxCatch2 = _interopRequireDefault(_reduxCatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorHandler = exports.errorHandler = function errorHandler(windowObj) {
  return function (error, getState, action) {
    // directly log the error to the console in ALL cases,
    // not just via a debug log. this will help us debug
    // production errors for users.
    if (windowObj.console && windowObj.console.error) {
      windowObj.console.error(error);
    }

    // dispatch the error to Sentry, sending the current
    // redux state and the action that failed as we go.
    if (windowObj.Raven) {
      windowObj.Raven.context({ state: getState(), action: action });
      windowObj.Raven.captureException(error);
    }

    // Log the error to Loggly as well.
    if (windowObj._LTracker) {
      var errorToSend = { type: 'UnhandledReduxError', error: error };

      if (windowObj.Raven) {
        errorToSend.context = windowObj.Raven.getContext();
      }

      windowObj._LTracker.push(errorToSend);
    }
  };
};

exports.default = function (windowObj) {
  return (0, _reduxCatch2.default)(errorHandler(windowObj));
};

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

function middlewareFactory(errorHandler) {
  return function (store) {
    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          errorHandler(err, store.getState, action, store.dispatch);
          return err;
        }
      };
    };
  };
}

module.exports = middlewareFactory;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = windowMiddleware;

var _window = __webpack_require__(189);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// action effects that relate to the window.
function windowMiddleware(window) {
  return function () {
    return function (next) {
      return function (action) {
        switch (action.type) {
          case _window.HARD_REDIRECT_TRIGGERED:
            window.location = action.url;
            break;
          case _window.SCROLL_TO:
            window.scrollTo.apply(window, _toConsumableArray(action.payload));
            break;
          default:
            break;
        }

        next(action);
      };
    };
  };
}

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;

var _auth = __webpack_require__(1048);

var _adBlocker = __webpack_require__(1050);

var _adCreation = __webpack_require__(1051);

var _adFilters = __webpack_require__(1053);

var _adReview = __webpack_require__(1055);

var _adStorage = __webpack_require__(1058);

var _targeting = __webpack_require__(1059);

var _user = __webpack_require__(1061);

var _featureFlags = __webpack_require__(1063);

var _payments = __webpack_require__(1065);

var _redirect = __webpack_require__(1066);

var _sentry = __webpack_require__(1067);

var _validation = __webpack_require__(1068);

var _uploader = __webpack_require__(1069);

var _adminAlert = __webpack_require__(1077);

var _audienceSizer = __webpack_require__(1079);

var _marked = /*#__PURE__*/regeneratorRuntime.mark(root);

function root() {
  return regeneratorRuntime.wrap(function root$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return [(0, _auth.watchForLogOut)(), (0, _adBlocker.loadAdBlockDetector)(), (0, _auth.fetchAccessTokenFetchAds)(), (0, _user.fetchUserInfo)(), (0, _user.fetchPartnerId)(), (0, _targeting.fetchTargetingItems)(), (0, _featureFlags.fetchUserAbbaFlags)(), (0, _auth.fetchIpCountry)(), (0, _adminAlert.fetchAdminAlert)(), (0, _payments.waitToFetchPaymentInfo)(), (0, _payments.watchFetchRecurringDetail)(), (0, _adStorage.watchAdStored)(), (0, _adStorage.watchAdCreated)(), (0, _adCreation.watchAdCreated)(), (0, _adStorage.watchAdRestore)(), (0, _adStorage.watchLoadAd)(), (0, _redirect.watchForRedirect)(), (0, _redirect.watchForRedirectStored)(), (0, _redirect.watchForRedirectCleared)(), (0, _adCreation.watchForResetCreateAd)(),
          // Note: checking for the ad to restore must come after watching for restore actions
          (0, _adStorage.checkForAdRestoreFlag)(), (0, _payments.checkForHPPAdRestore)(), (0, _adStorage.watchClearSavedAd)(), (0, _sentry.watchForLoggableErrors)(), (0, _auth.watchSsoSessionState)(), (0, _adReview.watchAdReviewActions)(), (0, _sentry.watchUserLoginForSentry)(), (0, _sentry.watchActionsForSentryStateLogging)(), (0, _validation.watchUserGroupValidation)(), (0, _uploader.watchFileSelected)(), (0, _targeting.watchStockMusicFetch)(), (0, _audienceSizer.watchForFetchAudienceSize)(), (0, _adFilters.watchAdFilters)()];

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localStorage = exports.WEBGATE_TOKEN_STORAGE_KEY = undefined;
exports.clearServiceWorkerStorage = clearServiceWorkerStorage;
exports.fetchAccessToken = fetchAccessToken;
exports.watchForLogOut = watchForLogOut;
exports.checkSessionState = checkSessionState;
exports.watchSsoSessionState = watchSsoSessionState;
exports.fetchAccessTokenFetchAds = fetchAccessTokenFetchAds;
exports.fetchIpCountry = fetchIpCountry;

var _effects = __webpack_require__(25);

var _reduxSaga = __webpack_require__(35);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _auth = __webpack_require__(1049);

var _auth2 = __webpack_require__(82);

var actions = _interopRequireWildcard(_auth2);

var _adReview = __webpack_require__(146);

var _ads = __webpack_require__(187);

var _storageHelpers = __webpack_require__(90);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchAccessToken),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForLogOut),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(checkSessionState),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchSsoSessionState),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchAccessTokenFetchAds),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchIpCountry);

var log = (0, _debug2.default)('sagas:auth');

var ONE_MINUTE = 60000;

var WEBGATE_TOKEN_STORAGE_KEY = exports.WEBGATE_TOKEN_STORAGE_KEY = 'spWgToken';

var localStorage = exports.localStorage = window.localStorage || global.localStorage;

/*
 * @param {localStorage} storage
 */
function clearServiceWorkerStorage(storage) {
  (0, _storageHelpers.clearStorage)(storage);

  if ('caches' in window) {
    try {
      caches.delete('data-cache');
      log('deleted data cache');
    } catch (e) {
      log('could not delete data cache');
    }
  }
}

function fetchAccessToken() {
  var token;
  return regeneratorRuntime.wrap(function fetchAccessToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_auth.retrieveToken);

        case 3:
          token = _context.sent;
          _context.next = 6;
          return (0, _effects.put)(actions.ssoSessionActive(token));

        case 6:
          _context.next = 8;
          return (0, _effects.call)(_storageHelpers.setStorage, localStorage, WEBGATE_TOKEN_STORAGE_KEY, token);

        case 8:
          log('access token fetched');
          return _context.abrupt('return', token);

        case 12:
          _context.prev = 12;
          _context.t0 = _context['catch'](0);

          if (!(_context.t0 instanceof _auth.AuthSystemError)) {
            _context.next = 20;
            break;
          }

          _context.next = 17;
          return (0, _effects.put)(actions.ssoSessionError(_context.t0));

        case 17:
          log('login error' + _context.t0.message);
          _context.next = 23;
          break;

        case 20:
          _context.next = 22;
          return (0, _effects.put)(actions.ssoSessionInactive());

        case 22:
          log('access token revoked');

        case 23:
          _context.next = 25;
          return (0, _effects.call)(_storageHelpers.removeStorage, localStorage, WEBGATE_TOKEN_STORAGE_KEY);

        case 25:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 12]]);
}

function watchForLogOut() {
  return regeneratorRuntime.wrap(function watchForLogOut$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.take)(actions.USER_LOGGED_OUT);

        case 2:
          _context2.next = 4;
          return (0, _effects.call)(clearServiceWorkerStorage, localStorage);

        case 4:
          log('User logged out. Access token revoked');

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/* eslint-disable no-constant-condition */
function checkSessionState() {
  return regeneratorRuntime.wrap(function checkSessionState$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (false) {
            _context3.next = 7;
            break;
          }

          _context3.next = 3;
          return (0, _effects.call)(_reduxSaga.delay, ONE_MINUTE * 30);

        case 3:
          _context3.next = 5;
          return (0, _effects.call)(fetchAccessToken);

        case 5:
          _context3.next = 0;
          break;

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
/* eslint-enable no-constant-condition */

function watchSsoSessionState() {
  return regeneratorRuntime.wrap(function watchSsoSessionState$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.take)(actions.SSO_SESSION_ACTIVE);

        case 2:
          _context4.next = 4;
          return (0, _effects.race)({
            task: (0, _effects.call)(checkSessionState),
            cancel: (0, _effects.take)(actions.SSO_SESSION_INACTIVE)
          });

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function fetchAccessTokenFetchAds() {
  var token, _ref, offset, limit;

  return regeneratorRuntime.wrap(function fetchAccessTokenFetchAds$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.call)(fetchAccessToken);

        case 2:
          token = _context5.sent;

          if (!token) {
            _context5.next = 11;
            break;
          }

          _context5.next = 6;
          return (0, _effects.select)(_ads.getPaging);

        case 6:
          _ref = _context5.sent;
          offset = _ref.offset;
          limit = _ref.limit;
          _context5.next = 11;
          return (0, _effects.put)((0, _adReview.fetchAds)(offset, limit, token));

        case 11:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function fetchIpCountry() {
  var country;
  return regeneratorRuntime.wrap(function fetchIpCountry$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_auth.getIpCountry);

        case 3:
          country = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)(actions.ipCountrySuccess(country));

        case 6:
          _context6.next = 12;
          break;

        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 12;
          return (0, _effects.put)(actions.ipCountryFailed());

        case 12:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 8]]);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedOutError = LoggedOutError;
exports.AuthSystemError = AuthSystemError;
exports.retrieveToken = retrieveToken;
exports.getIpCountry = getIpCountry;

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _utilities = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('api:auth');

function authUri() {
  return (0, _utilities.isHostLocal)(window.location.hostname) ? 'https://adgen-dev.spotify.com/auth/' : '/auth/';
}

function LoggedOutError() {
  Error.call(this);
}
LoggedOutError.prototype = Object.create(Error.prototype);

function AuthSystemError(message) {
  Error.call(this);
  this.message = message;
}
AuthSystemError.prototype = Object.create(Error.prototype);

function retrieveToken() {
  log('retrieving token from: %s', authUri());

  return fetch(authUri(), { credentials: 'include' }).then(function (res) {
    switch (res.status) {
      case 200:
        return res.json();
      case 400: // sso cookie is invalid/expired
      case 401:
        return Promise.reject(new LoggedOutError());
      default:
        return Promise.reject(new AuthSystemError(res.statusText));
    }
  }).then(function (auth) {
    return auth.accessToken;
  });
}

/*
 * Detect what country user is visiting from
 * x-geo-country header is provided by weblb
 * @returns {String} Country code
 */
function getIpCountry() {
  var url = document.location.origin + '/ip';
  return fetch(url).then(function (r) {
    return r.headers.get('x-geo-country');
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)))

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAdblockDetector = undefined;
exports.initAdblockDetector = initAdblockDetector;
exports.loadAdBlockDetector = loadAdBlockDetector;

var _effects = __webpack_require__(25);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _adBlocker = __webpack_require__(441);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadAdBlockDetector);

var log = (0, _debug2.default)('sagas:adblocker');

// lazy-loaded import to defer loading this until we need it
var fetchAdblockDetector = exports.fetchAdblockDetector = function fetchAdblockDetector() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1115));
};

function initAdblockDetector(adblockDetector) {
  log('using adblockDetector to determine adblocker status');
  return new Promise(function (resolve) {
    return adblockDetector.init({ complete: resolve });
  });
}

function loadAdBlockDetector() {
  var adblockDetector, adBlockerDetected;
  return regeneratorRuntime.wrap(function loadAdBlockDetector$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          log('loading adblock detector module');
          _context.next = 3;
          return (0, _effects.call)(fetchAdblockDetector);

        case 3:
          adblockDetector = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(initAdblockDetector, adblockDetector);

        case 6:
          adBlockerDetected = _context.sent;

          log('adBlockerDetected result recieved', adBlockerDetected);
          _context.next = 10;
          return (0, _effects.put)((0, _adBlocker.detectAdBlocker)(adBlockerDetected));

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.handleResetCreateAd = handleResetCreateAd;
exports.watchForResetCreateAd = watchForResetCreateAd;
exports.handleAdCreated = handleAdCreated;
exports.watchAdCreated = watchAdCreated;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _reduxForm = __webpack_require__(67);

var _editableAd = __webpack_require__(47);

var _analytics = __webpack_require__(68);

var _config = __webpack_require__(30);

var _audienceSizer = __webpack_require__(1052);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleResetCreateAd),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForResetCreateAd),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(handleAdCreated),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchAdCreated);

var log = (0, _debug2.default)('sagas:adCreation');

function handleResetCreateAd() {
  return regeneratorRuntime.wrap(function handleResetCreateAd$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _editableAd.resetFields)());

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _reduxForm.reset)(_config.CAMPAIGN_FORM_NAME));

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _reduxForm.reset)(_config.AUDIENCE_FORM_NAME));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchForResetCreateAd() {
  return regeneratorRuntime.wrap(function watchForResetCreateAd$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_reduxSaga.takeEvery, _editableAd.RESET_CREATE_AD, handleResetCreateAd);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function handleAdCreated() {
  var rateCardId, priceData;
  return regeneratorRuntime.wrap(function handleAdCreated$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          log('detected that an ad was created');

          _context3.next = 3;
          return (0, _effects.select)(_audienceSizer.getRateCardId);

        case 3:
          rateCardId = _context3.sent;

          if (!rateCardId) {
            _context3.next = 12;
            break;
          }

          _context3.next = 7;
          return (0, _effects.select)(_audienceSizer.getPriceData);

        case 7:
          priceData = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)((0, _analytics.logUserAction)({
            category: 'create_ad_flow',
            label: 'rate_card_for_user',
            params: _extends({
              id: rateCardId
            }, priceData)
          }));

        case 10:
          _context3.next = 13;
          break;

        case 12:
          log('no rate card found for the ad');

        case 13:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function watchAdCreated() {
  return regeneratorRuntime.wrap(function watchAdCreated$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.call)(_reduxSaga.takeEvery, _editableAd.AD_CREATED, handleAdCreated);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRateCardId = getRateCardId;
exports.getPriceData = getPriceData;
function getRateCardId(state) {
  var _state$audienceSizer$ = state.audienceSizer.price;
  _state$audienceSizer$ = _state$audienceSizer$ === undefined ? {} : _state$audienceSizer$;
  var _state$audienceSizer$2 = _state$audienceSizer$.rateCardId,
      rateCardId = _state$audienceSizer$2 === undefined ? '' : _state$audienceSizer$2;

  return rateCardId;
}

function getPriceData(state) {
  var _state$audienceSizer$3 = state.audienceSizer.price,
      price = _state$audienceSizer$3 === undefined ? {} : _state$audienceSizer$3;

  return price;
}

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AD_FILTER_STORAGE_KEY = undefined;
exports.isReturningFromAdDetails = isReturningFromAdDetails;
exports.checkRestoreAdFilters = checkRestoreAdFilters;
exports.watchAdFilters = watchAdFilters;

var _effects = __webpack_require__(25);

var _reduxSaga = __webpack_require__(35);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _filterAds = __webpack_require__(203);

var actions = _interopRequireWildcard(_filterAds);

var _routes = __webpack_require__(1054);

var _ads = __webpack_require__(187);

var _BrowseAds = __webpack_require__(192);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(isReturningFromAdDetails),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(checkRestoreAdFilters),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchAdFilters);

var log = (0, _debug2.default)('sagas:adFilters');

var AD_FILTER_STORAGE_KEY = exports.AD_FILTER_STORAGE_KEY = 'adgen-ad-filters';

function isReturningFromAdDetails() {
  var prevRoute;
  return regeneratorRuntime.wrap(function isReturningFromAdDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_routes.getPrevRoute);

        case 2:
          prevRoute = _context.sent;
          return _context.abrupt('return', prevRoute && prevRoute.match('/ad/') ? true : false);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function checkRestoreAdFilters() {
  var isAdDetails, currentFilters;
  return regeneratorRuntime.wrap(function checkRestoreAdFilters$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          log('checking if ad filters should be preserved');
          _context2.next = 3;
          return (0, _effects.call)(isReturningFromAdDetails);

        case 3:
          isAdDetails = _context2.sent;

          if (isAdDetails) {
            _context2.next = 9;
            break;
          }

          log('resetting ad filters');
          _context2.next = 8;
          return (0, _effects.put)(actions.updateAdFilters(_BrowseAds.DEFAULT_PARAMS));

        case 8:
          return _context2.abrupt('return');

        case 9:
          _context2.next = 11;
          return (0, _effects.select)(_ads.getAdFilters);

        case 11:
          currentFilters = _context2.sent;
          _context2.next = 14;
          return (0, _effects.put)(actions.updateAdFilters(currentFilters));

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchAdFilters() {
  return regeneratorRuntime.wrap(function watchAdFilters$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _reduxSaga.takeEvery)(actions.CHECK_AD_FILTERS, checkRestoreAdFilters);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getPrevRoute = exports.getPrevRoute = function getPrevRoute(state) {
  return state.routes.prevRoute;
};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.refreshAds = refreshAds;
exports.filterAds = filterAds;
exports.fetchReviewAudioAds = fetchReviewAudioAds;
exports.fetchAds = fetchAds;
exports.fetchAd = fetchAd;
exports.approveAd = approveAd;
exports.reviseVO = reviseVO;
exports.reviseBGMusic = reviseBGMusic;
exports.rejectAd = rejectAd;
exports.cancelAd = cancelAd;
exports.kickAd = kickAd;
exports.watchAdReviewActions = watchAdReviewActions;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _adReview = __webpack_require__(146);

var actions = _interopRequireWildcard(_adReview);

var _ads = __webpack_require__(1056);

var adsApi = _interopRequireWildcard(_ads);

var _filterAds = __webpack_require__(203);

var _auth = __webpack_require__(36);

var _ads2 = __webpack_require__(187);

var _BrowseAds = __webpack_require__(192);

var _status = __webpack_require__(509);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(refreshAds),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(filterAds),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fetchReviewAudioAds),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchAds),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchAd),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(approveAd),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(reviseVO),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(reviseBGMusic),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(rejectAd),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(cancelAd),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(kickAd),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchAd),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchAds),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(watchRefreshAds),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(watchFilterAds),
    _marked16 = /*#__PURE__*/regeneratorRuntime.mark(watchReviewAudioAds),
    _marked17 = /*#__PURE__*/regeneratorRuntime.mark(watchApproveAd),
    _marked18 = /*#__PURE__*/regeneratorRuntime.mark(watchReviseVO),
    _marked19 = /*#__PURE__*/regeneratorRuntime.mark(watchReviseBG),
    _marked20 = /*#__PURE__*/regeneratorRuntime.mark(watchRejectAd),
    _marked21 = /*#__PURE__*/regeneratorRuntime.mark(watchCancelAd),
    _marked22 = /*#__PURE__*/regeneratorRuntime.mark(watchKickAd),
    _marked23 = /*#__PURE__*/regeneratorRuntime.mark(watchAdReviewActions);

var log = (0, _debug2.default)('sagas:adReview');

var FETCH_ADS_REQUESTED = actions.FETCH_ADS_REQUESTED,
    REFRESH_ADS_REQUESTED = actions.REFRESH_ADS_REQUESTED,
    REVIEW_AUDIO_ADS_REQUESTED = actions.REVIEW_AUDIO_ADS_REQUESTED,
    APPROVE_AD_SUBMITTED = actions.APPROVE_AD_SUBMITTED,
    REJECT_AD_SUBMITTED = actions.REJECT_AD_SUBMITTED,
    CANCEL_AD_SUBMITTED = actions.CANCEL_AD_SUBMITTED,
    KICK_AD_SUBMITTED = actions.KICK_AD_SUBMITTED,
    REVISE_VO_SUBMITTED = actions.REVISE_VO_SUBMITTED,
    REVISE_BG_SUBMITTED = actions.REVISE_BG_SUBMITTED,
    FETCH_AD_REQUESTED = actions.FETCH_AD_REQUESTED;
function refreshAds(action) {
  var _action$payload, params, wgToken, ads;

  return regeneratorRuntime.wrap(function refreshAds$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, params = _action$payload.params, wgToken = _action$payload.wgToken;
          _context.prev = 1;
          _context.next = 4;
          return (0, _effects.call)(adsApi.refreshAds, params, wgToken);

        case 4:
          ads = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(actions.refreshAdsSuccess(ads.items));

        case 7:
          _context.next = 9;
          return (0, _effects.put)(actions.updatePagingInfo(ads.paging));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](1);
          _context.next = 15;
          return (0, _effects.put)(actions.refreshAdsFailed(_context.t0));

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 11]]);
}

function filterAds(action) {
  var wgToken, searchText, statusFilter, sortedBy, paging, _action$payload2, _action$payload2$filt, filter, _action$payload2$acti, activePage, _action$payload2$orde, orderBy, _action$payload2$orde2, order, _action$payload2$sear, searchWord, status, offset, params;

  return regeneratorRuntime.wrap(function filterAds$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_auth.getWgToken);

        case 2:
          wgToken = _context2.sent;
          _context2.next = 5;
          return (0, _effects.select)(_ads2.getSearchWord);

        case 5:
          searchText = _context2.sent;
          _context2.next = 8;
          return (0, _effects.select)(_ads2.getStatusFilter);

        case 8:
          statusFilter = _context2.sent;
          _context2.next = 11;
          return (0, _effects.select)(_ads2.getSortedBy);

        case 11:
          sortedBy = _context2.sent;
          _context2.next = 14;
          return (0, _effects.select)(_ads2.getPaging);

        case 14:
          paging = _context2.sent;
          _action$payload2 = action.payload, _action$payload2$filt = _action$payload2.filter, filter = _action$payload2$filt === undefined ? statusFilter : _action$payload2$filt, _action$payload2$acti = _action$payload2.activePage, activePage = _action$payload2$acti === undefined ? _BrowseAds.DEFAULT_PARAMS.activePage : _action$payload2$acti, _action$payload2$orde = _action$payload2.orderBy, orderBy = _action$payload2$orde === undefined ? sortedBy : _action$payload2$orde, _action$payload2$orde2 = _action$payload2.order, order = _action$payload2$orde2 === undefined ? _BrowseAds.DEFAULT_PARAMS.order : _action$payload2$orde2, _action$payload2$sear = _action$payload2.searchWord, searchWord = _action$payload2$sear === undefined ? searchText : _action$payload2$sear;
          status = _status.FILTER_TO_STATUS[filter];
          offset = (activePage - 1) * paging.limit;
          params = _extends({}, _BrowseAds.DEFAULT_PARAMS, {
            status: status,
            offset: offset,
            activePage: activePage,
            orderBy: orderBy,
            order: order,
            searchWord: searchWord
          });
          _context2.prev = 19;
          _context2.next = 22;
          return (0, _effects.put)(actions.refreshAds(params, wgToken));

        case 22:
          _context2.next = 29;
          break;

        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2['catch'](19);

          log('filtering ads failed. Params: ' + params.toString());
          _context2.next = 29;
          return (0, _effects.put)(actions.refreshAdsFailed(_context2.t0));

        case 29:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[19, 24]]);
}

function fetchReviewAudioAds(action) {
  var _action$payload3, params, wgToken, ads;

  return regeneratorRuntime.wrap(function fetchReviewAudioAds$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, params = _action$payload3.params, wgToken = _action$payload3.wgToken;
          _context3.prev = 1;
          _context3.next = 4;
          return (0, _effects.call)(adsApi.refreshAds, params, wgToken);

        case 4:
          ads = _context3.sent;
          _context3.next = 7;
          return (0, _effects.put)(actions.reviewAudioAdsSuccess(ads.items));

        case 7:
          _context3.next = 9;
          return (0, _effects.put)(actions.updateReviewAudioPagingInfo(ads.paging));

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3['catch'](1);
          _context3.next = 15;
          return (0, _effects.put)(actions.reviewAudioAdsFailed(_context3.t0));

        case 15:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[1, 11]]);
}

function fetchAds(action) {
  var _action$payload4, offset, limit, wgToken, ads;

  return regeneratorRuntime.wrap(function fetchAds$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload4 = action.payload, offset = _action$payload4.offset, limit = _action$payload4.limit, wgToken = _action$payload4.wgToken;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _effects.call)(adsApi.getAds, offset, limit, wgToken);

        case 4:
          ads = _context4.sent;
          _context4.next = 7;
          return (0, _effects.put)(actions.fetchAdsSuccess(ads.items));

        case 7:
          _context4.next = 9;
          return (0, _effects.put)(actions.updatePagingInfo(ads.paging));

        case 9:
          _context4.next = 15;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](1);
          _context4.next = 15;
          return (0, _effects.put)(actions.fetchAdsFailed(_context4.t0));

        case 15:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[1, 11]]);
}

function fetchAd(action) {
  var _action$payload5, id, wgToken, ad;

  return regeneratorRuntime.wrap(function fetchAd$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload5 = action.payload, id = _action$payload5.id, wgToken = _action$payload5.wgToken;
          _context5.prev = 1;
          _context5.next = 4;
          return (0, _effects.call)(adsApi.getAd, id, wgToken);

        case 4:
          ad = _context5.sent;
          _context5.next = 7;
          return (0, _effects.put)(actions.fetchAdSuccess(ad.items[0]));

        case 7:
          _context5.next = 17;
          break;

        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5['catch'](1);

          if (!(_context5.t0 instanceof adsApi.AdNotFoundError)) {
            _context5.next = 15;
            break;
          }

          _context5.next = 14;
          return (0, _effects.put)(actions.fetchAdNotFound(_context5.t0));

        case 14:
          return _context5.abrupt('return');

        case 15:
          _context5.next = 17;
          return (0, _effects.put)(actions.fetchAdFailed(_context5.t0));

        case 17:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[1, 9]]);
}

function approveAd(action) {
  var id, wgToken;
  return regeneratorRuntime.wrap(function approveAd$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          id = action.id;
          _context6.next = 3;
          return (0, _effects.select)(_auth.getWgToken);

        case 3:
          wgToken = _context6.sent;
          _context6.prev = 4;
          _context6.next = 7;
          return (0, _effects.call)(adsApi.approveAd, id, wgToken);

        case 7:
          _context6.next = 9;
          return (0, _effects.put)(actions.approveAdSuccess(id));

        case 9:
          _context6.next = 15;
          break;

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6['catch'](4);
          _context6.next = 15;
          return (0, _effects.put)(actions.approveAdFailed(_context6.t0, id));

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[4, 11]]);
}

function reviseVO(action) {
  var reviseVOInstructions, id, wgToken;
  return regeneratorRuntime.wrap(function reviseVO$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          reviseVOInstructions = action.reviseVOInstructions, id = action.id;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.select)(_auth.getWgToken);

        case 4:
          wgToken = _context7.sent;
          _context7.next = 7;
          return (0, _effects.call)(adsApi.reviseVO, id, reviseVOInstructions, wgToken);

        case 7:
          _context7.next = 9;
          return (0, _effects.put)(actions.reviseAdSuccess(id));

        case 9:
          _context7.next = 15;
          break;

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7['catch'](1);
          _context7.next = 15;
          return (0, _effects.put)(actions.reviseAdFailed(_context7.t0, id));

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[1, 11]]);
}

function reviseBGMusic(action) {
  var bgAssetId, id, wgToken;
  return regeneratorRuntime.wrap(function reviseBGMusic$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          bgAssetId = action.bgAssetId, id = action.id;
          _context8.prev = 1;
          _context8.next = 4;
          return (0, _effects.select)(_auth.getWgToken);

        case 4:
          wgToken = _context8.sent;
          _context8.next = 7;
          return (0, _effects.call)(adsApi.reviseBGMusic, id, bgAssetId, wgToken);

        case 7:
          _context8.next = 9;
          return (0, _effects.put)(actions.reviseAdSuccess(id));

        case 9:
          _context8.next = 15;
          break;

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8['catch'](1);
          _context8.next = 15;
          return (0, _effects.put)(actions.reviseAdFailed(_context8.t0, id));

        case 15:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[1, 11]]);
}

function rejectAd(action) {
  var reason, id, wgToken;
  return regeneratorRuntime.wrap(function rejectAd$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          reason = action.reason, id = action.id;

          if (reason) {
            _context9.next = 5;
            break;
          }

          _context9.next = 4;
          return (0, _effects.put)(actions.rejectAdPrompted(id));

        case 4:
          return _context9.abrupt('return');

        case 5:
          _context9.prev = 5;
          _context9.next = 8;
          return (0, _effects.select)(_auth.getWgToken);

        case 8:
          wgToken = _context9.sent;
          _context9.next = 11;
          return (0, _effects.call)(adsApi.rejectAd, id, reason, wgToken);

        case 11:
          _context9.next = 13;
          return (0, _effects.put)(actions.rejectAdSuccess(id));

        case 13:
          _context9.next = 19;
          break;

        case 15:
          _context9.prev = 15;
          _context9.t0 = _context9['catch'](5);
          _context9.next = 19;
          return (0, _effects.put)(actions.rejectAdFailed(_context9.t0, id));

        case 19:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[5, 15]]);
}

function cancelAd(action) {
  var id, wgToken;
  return regeneratorRuntime.wrap(function cancelAd$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          id = action.id;
          _context10.next = 3;
          return (0, _effects.select)(_auth.getWgToken);

        case 3:
          wgToken = _context10.sent;
          _context10.prev = 4;
          _context10.next = 7;
          return (0, _effects.call)(adsApi.cancelAd, id, wgToken);

        case 7:
          _context10.next = 9;
          return (0, _effects.put)(actions.cancelAdSuccess(id));

        case 9:
          _context10.next = 15;
          break;

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10['catch'](4);
          _context10.next = 15;
          return (0, _effects.put)(actions.cancelAdFailed(_context10.t0, id));

        case 15:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this, [[4, 11]]);
}

function kickAd(action) {
  var id, wgToken;
  return regeneratorRuntime.wrap(function kickAd$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          id = action.id;
          _context11.next = 3;
          return (0, _effects.select)(_auth.getWgToken);

        case 3:
          wgToken = _context11.sent;
          _context11.prev = 4;
          _context11.next = 7;
          return (0, _effects.call)(adsApi.kickAd, id, wgToken);

        case 7:
          _context11.next = 9;
          return (0, _effects.put)(actions.kickAdSuccess(id));

        case 9:
          _context11.next = 15;
          break;

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11['catch'](4);
          _context11.next = 15;
          return (0, _effects.put)(actions.kickAdFailed(_context11.t0, id));

        case 15:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this, [[4, 11]]);
}

function watchFetchAd() {
  return regeneratorRuntime.wrap(function watchFetchAd$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _reduxSaga.takeLatest)(FETCH_AD_REQUESTED, fetchAd);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function watchFetchAds() {
  return regeneratorRuntime.wrap(function watchFetchAds$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _reduxSaga.takeEvery)(FETCH_ADS_REQUESTED, fetchAds);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function watchRefreshAds() {
  return regeneratorRuntime.wrap(function watchRefreshAds$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _reduxSaga.takeEvery)(REFRESH_ADS_REQUESTED, refreshAds);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function watchFilterAds() {
  return regeneratorRuntime.wrap(function watchFilterAds$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _reduxSaga.takeEvery)(_filterAds.UPDATE_AD_FILTERS, filterAds);

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

function watchReviewAudioAds() {
  return regeneratorRuntime.wrap(function watchReviewAudioAds$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _reduxSaga.takeEvery)(REVIEW_AUDIO_ADS_REQUESTED, fetchReviewAudioAds);

        case 2:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function watchApproveAd() {
  return regeneratorRuntime.wrap(function watchApproveAd$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _reduxSaga.takeEvery)(APPROVE_AD_SUBMITTED, approveAd);

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function watchReviseVO() {
  return regeneratorRuntime.wrap(function watchReviseVO$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _reduxSaga.takeEvery)(REVISE_VO_SUBMITTED, reviseVO);

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function watchReviseBG() {
  return regeneratorRuntime.wrap(function watchReviseBG$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _reduxSaga.takeEvery)(REVISE_BG_SUBMITTED, reviseBGMusic);

        case 2:
        case 'end':
          return _context19.stop();
      }
    }
  }, _marked19, this);
}

function watchRejectAd() {
  return regeneratorRuntime.wrap(function watchRejectAd$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _reduxSaga.takeEvery)(REJECT_AD_SUBMITTED, rejectAd);

        case 2:
        case 'end':
          return _context20.stop();
      }
    }
  }, _marked20, this);
}

function watchCancelAd() {
  return regeneratorRuntime.wrap(function watchCancelAd$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return (0, _reduxSaga.takeEvery)(CANCEL_AD_SUBMITTED, cancelAd);

        case 2:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked21, this);
}

function watchKickAd() {
  return regeneratorRuntime.wrap(function watchKickAd$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return (0, _reduxSaga.takeEvery)(KICK_AD_SUBMITTED, kickAd);

        case 2:
        case 'end':
          return _context22.stop();
      }
    }
  }, _marked22, this);
}

function watchAdReviewActions() {
  return regeneratorRuntime.wrap(function watchAdReviewActions$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return [watchFetchAds(), watchRefreshAds(), watchFilterAds(), watchReviewAudioAds(), watchFetchAd(), watchApproveAd(), watchReviseVO(), watchReviseBG(), watchRejectAd(), watchCancelAd(), watchKickAd()];

        case 2:
        case 'end':
          return _context23.stop();
      }
    }
  }, _marked23, this);
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdNotFoundError = AdNotFoundError;
exports.getAds = getAds;
exports.refreshAds = refreshAds;
exports.getAd = getAd;
exports.approveAd = approveAd;
exports.rejectAd = rejectAd;
exports.reviseVO = reviseVO;
exports.reviseBGMusic = reviseBGMusic;
exports.cancelAd = cancelAd;
exports.kickAd = kickAd;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

var _queryString = __webpack_require__(171);

var _queryString2 = _interopRequireDefault(_queryString);

var _sort = __webpack_require__(1057);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AdNotFoundError(message) {
  this.name = 'AdNotFoundError';
  this.message = message;
}

AdNotFoundError.prototype = Object.create(Error.prototype);

function getAds(offset, limit, wgToken) {
  var url = 'adgenerator/v1/ads?limit=' + limit + '&offset=' + offset;
  return (0, _callWebGate2.default)(url, wgToken).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

function refreshAds(params, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = getAdsUrl(params);
  return webGate(url, wgToken).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

function getAdsUrl(params) {
  var _params$limit = params.limit,
      limit = _params$limit === undefined ? 20 : _params$limit,
      _params$offset = params.offset,
      offset = _params$offset === undefined ? 0 : _params$offset,
      orderBy = params.orderBy,
      _params$order = params.order,
      order = _params$order === undefined ? 'asc' : _params$order,
      status = params.status,
      searchWord = params.searchWord;

  var sortField = _sort.SORT_FIELDS[orderBy];
  var queryParams = _queryString2.default.stringify({
    limit: limit,
    offset: offset,
    orderBy: sortField,
    order: order,
    status: status || undefined,
    searchWord: searchWord || undefined
  });
  var url = 'adgenerator/v1/ads?' + queryParams;
  return url;
}

function getAd(id, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = 'adgenerator/v1/ads/' + id;
  return webGate(url, wgToken).then(function (r) {
    if (r.status === 404) {
      return Promise.reject(new AdNotFoundError(r.statusText));
    }
    if (!r.ok) return Promise.reject(new Error(r.statusText));
    return r.json();
  });
}

function approveAd(id, wgToken) {
  var url = 'adgenerator/v2/ads/' + id + '/approve';
  var opts = { method: 'POST' };

  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

function rejectAd(id, reason, wgToken) {
  var url = 'adgenerator/v1/ads/' + id + '/reject';
  var opts = Object.assign({
    method: 'POST',
    body: JSON.stringify({
      reason: reason
    })
  });

  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

function reviseVO(id, reviseVOInstructions, wgToken) {
  var url = 'adgenerator/v1/ads/' + id + '/audio/revise-vo';
  var opts = {
    method: 'POST',
    body: JSON.stringify({
      reviseVOInstructions: reviseVOInstructions
    })
  };

  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

function reviseBGMusic(id, bgAssetId, wgToken) {
  var url = 'adgenerator/v1/ads/' + id + '/audio/revise-bg';
  var opts = {
    method: 'POST',
    body: JSON.stringify({
      bgAssetId: bgAssetId
    })
  };

  return (0, _callWebGate2.default)(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

function cancelAd(id, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = 'adgenerator/v1/ads/' + id + '/cancel';
  var opts = { method: 'POST' };

  return webGate(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

function kickAd(id, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = 'adgenerator/v1/ads/' + id + '/kick';
  var opts = { method: 'POST' };

  return webGate(url, wgToken, opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r;
  });
}

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SORT_FIELDS = exports.SORT_FIELDS = {
  'campaign name': 'adname',
  status: 'status',
  'start date': 'startdate',
  'end date': 'enddate',
  budget: 'budget',
  reach: 'reach',
  'ads served': 'impressions'
};

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUX_FORM_STORAGE_KEY = exports.AD_STORAGE_KEY = exports.SHOULD_RESTORE_FLAG = undefined;
exports.saveEditableAd = saveEditableAd;
exports.restoreEditableAd = restoreEditableAd;
exports.saveReduxForms = saveReduxForms;
exports.restoreReduxForms = restoreReduxForms;
exports.watchAdStored = watchAdStored;
exports.watchAdRestore = watchAdRestore;
exports.watchClearSavedAd = watchClearSavedAd;
exports.watchAdCreated = watchAdCreated;
exports.watchLoadAd = watchLoadAd;
exports.checkForAdRestoreFlag = checkForAdRestoreFlag;

var _effects = __webpack_require__(25);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _omit = __webpack_require__(510);

var _omit2 = _interopRequireDefault(_omit);

var _reduxForm = __webpack_require__(67);

var _editableAd = __webpack_require__(47);

var _validation = __webpack_require__(153);

var _adCreation = __webpack_require__(87);

var _reduxForm2 = __webpack_require__(301);

var _storageHelpers = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(saveEditableAd),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(restoreEditableAd),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(saveReduxForms),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(restoreReduxForms),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchAdStored),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(watchAdRestore),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(watchClearSavedAd),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchAdCreated),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchLoadAd),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(checkForAdRestoreFlag);

var log = (0, _debug2.default)('sagas:adStorage');

var SHOULD_RESTORE_FLAG = exports.SHOULD_RESTORE_FLAG = 'should-restore-ad-state';
var AD_STORAGE_KEY = exports.AD_STORAGE_KEY = 'adgen-ad-state';
var REDUX_FORM_STORAGE_KEY = exports.REDUX_FORM_STORAGE_KEY = 'adgen-redux-form-state';

// TODO kill this method once redux-form is 100%
function saveEditableAd(storage) {
  var data, stringifiedData;
  return regeneratorRuntime.wrap(function saveEditableAd$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          log('saving the ad');
          _context.next = 3;
          return (0, _effects.select)(_adCreation.getCombinedAd);

        case 3:
          data = _context.sent;
          stringifiedData = (0, _storageHelpers.jsonStringify)((0, _omit2.default)(data, 'activeStep'));
          _context.next = 7;
          return (0, _effects.call)(_storageHelpers.setStorage, storage, AD_STORAGE_KEY, stringifiedData);

        case 7:
          log('saved the ad');

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// TODO kill this method once redux-form is 100%
function restoreEditableAd(storage) {
  var adToRestore;
  return regeneratorRuntime.wrap(function restoreEditableAd$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          log('restoring ad data into editableAd');

          _context2.next = 3;
          return (0, _effects.call)(_storageHelpers.getStorage, storage, AD_STORAGE_KEY);

        case 3:
          adToRestore = _context2.sent;

          if (adToRestore) {
            _context2.next = 7;
            break;
          }

          log('no ad found to restore');
          return _context2.abrupt('return');

        case 7:
          _context2.next = 9;
          return (0, _effects.put)((0, _editableAd.loadAd)((0, _storageHelpers.jsonParse)(adToRestore)));

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function saveReduxForms(storage) {
  var data, stringifiedData;
  return regeneratorRuntime.wrap(function saveReduxForms$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_reduxForm2.getReduxFormValues);

        case 2:
          data = _context3.sent;
          stringifiedData = (0, _storageHelpers.jsonStringify)(data);
          _context3.next = 6;
          return (0, _effects.call)(_storageHelpers.setStorage, storage, REDUX_FORM_STORAGE_KEY, stringifiedData);

        case 6:
          log('saved the redux forms');

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function restoreReduxForms(storage) {
  var formsToRestore, reduxFormsObj, formName, values, fieldName, value;
  return regeneratorRuntime.wrap(function restoreReduxForms$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          log('restoring ad data into redux-forms');

          _context4.next = 3;
          return (0, _effects.call)(_storageHelpers.getStorage, storage, REDUX_FORM_STORAGE_KEY);

        case 3:
          formsToRestore = _context4.sent;

          if (formsToRestore) {
            _context4.next = 7;
            break;
          }

          log('no redux forms found to restore');
          return _context4.abrupt('return');

        case 7:
          _context4.next = 9;
          return (0, _effects.call)(_storageHelpers.jsonParse, formsToRestore);

        case 9:
          reduxFormsObj = _context4.sent;
          _context4.t0 = regeneratorRuntime.keys(reduxFormsObj);

        case 11:
          if ((_context4.t1 = _context4.t0()).done) {
            _context4.next = 28;
            break;
          }

          formName = _context4.t1.value;

          if (!Object.prototype.hasOwnProperty.call(reduxFormsObj, formName)) {
            _context4.next = 26;
            break;
          }

          _context4.next = 16;
          return (0, _effects.put)((0, _reduxForm.initialize)(formName, {}));

        case 16:

          // iterate through the values and set them as changes.
          values = reduxFormsObj[formName];
          _context4.t2 = regeneratorRuntime.keys(values);

        case 18:
          if ((_context4.t3 = _context4.t2()).done) {
            _context4.next = 26;
            break;
          }

          fieldName = _context4.t3.value;

          if (!Object.prototype.hasOwnProperty.call(values, fieldName)) {
            _context4.next = 24;
            break;
          }

          value = values[fieldName];
          _context4.next = 24;
          return (0, _effects.put)((0, _reduxForm.change)(formName, fieldName, value));

        case 24:
          _context4.next = 18;
          break;

        case 26:
          _context4.next = 11;
          break;

        case 28:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchAdStored() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  var restoreJson;
  return regeneratorRuntime.wrap(function watchAdStored$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.take)(_editableAd.STORE_AD);

        case 2:

          log('detected a request to save an ad');

          _context5.next = 5;
          return saveEditableAd(storage);

        case 5:
          _context5.next = 7;
          return saveReduxForms(storage);

        case 7:
          _context5.next = 9;
          return (0, _effects.call)(_storageHelpers.getTimeout);

        case 9:
          restoreJson = _context5.sent;
          _context5.next = 12;
          return (0, _effects.call)(_storageHelpers.setStorage, storage, SHOULD_RESTORE_FLAG, restoreJson);

        case 12:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchAdRestore() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  return regeneratorRuntime.wrap(function watchAdRestore$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.take)(_editableAd.RESTORE_AD);

        case 2:

          log('detected a request to restore an ad');

          _context6.next = 5;
          return restoreEditableAd(storage);

        case 5:
          _context6.next = 7;
          return restoreReduxForms(storage);

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchClearSavedAd() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  return regeneratorRuntime.wrap(function watchClearSavedAd$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.take)(_editableAd.CLEAR_SAVED_AD);

        case 2:

          log('detected a request to clear a saved ad');

          _context7.next = 5;
          return (0, _effects.call)(_storageHelpers.removeStorage, storage, AD_STORAGE_KEY);

        case 5:
          _context7.next = 7;
          return (0, _effects.call)(_storageHelpers.removeStorage, storage, REDUX_FORM_STORAGE_KEY);

        case 7:
          _context7.next = 9;
          return (0, _effects.call)(_storageHelpers.removeStorage, storage, SHOULD_RESTORE_FLAG);

        case 9:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function watchAdCreated() {
  return regeneratorRuntime.wrap(function watchAdCreated$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.take)(_editableAd.AD_CREATED);

        case 2:

          log('detected that an ad was created');

          _context8.next = 5;
          return (0, _effects.put)((0, _editableAd.clearSavedAd)());

        case 5:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

// TODO clear this watcher and remove the listener in the main saga file
// when redux-form is 100%
function watchLoadAd() {
  var fields;
  return regeneratorRuntime.wrap(function watchLoadAd$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.take)(_editableAd.LOAD_AD);

        case 2:

          log('validating the loaded ad');

          _context9.next = 5;
          return (0, _effects.select)(_adCreation.getCombinedAd);

        case 5:
          fields = _context9.sent;
          _context9.next = 8;
          return (0, _effects.put)((0, _validation.validateFields)({ fields: fields }));

        case 8:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function checkForAdRestoreFlag() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  var restoreJSON, hasExpired;
  return regeneratorRuntime.wrap(function checkForAdRestoreFlag$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.call)(_storageHelpers.getStorage, storage, SHOULD_RESTORE_FLAG);

        case 2:
          restoreJSON = _context10.sent;

          if (!restoreJSON) {
            _context10.next = 14;
            break;
          }

          _context10.next = 6;
          return (0, _effects.call)(_storageHelpers.isKeyExpired, storage, SHOULD_RESTORE_FLAG);

        case 6:
          hasExpired = _context10.sent;

          if (hasExpired) {
            _context10.next = 12;
            break;
          }

          _context10.next = 10;
          return (0, _effects.put)((0, _editableAd.restoreAd)());

        case 10:
          _context10.next = 14;
          break;

        case 12:
          _context10.next = 14;
          return (0, _effects.put)((0, _editableAd.clearSavedAd)());

        case 14:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGenres = fetchGenres;
exports.fetchPlaylistCategories = fetchPlaylistCategories;
exports.fetchGeos = fetchGeos;
exports.fetchStockMusic = fetchStockMusic;
exports.watchStockMusicFetch = watchStockMusicFetch;
exports.fetchTargetingItems = fetchTargetingItems;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _adCreation = __webpack_require__(286);

var api = _interopRequireWildcard(_adCreation);

var _bgStockMusic = __webpack_require__(1060);

var _bgStockMusic2 = _interopRequireDefault(_bgStockMusic);

var _targeting = __webpack_require__(287);

var actions = _interopRequireWildcard(_targeting);

var _auth = __webpack_require__(82);

var _auth2 = __webpack_require__(36);

var _utilities = __webpack_require__(46);

var _genres = __webpack_require__(511);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchGenres),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchPlaylistCategories),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(fetchGeos),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchStockMusic),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchStockMusicFetch),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchTargetingItems);

function fetchGenres() {
  var _ref, accessToken, genres, mappedGenres;

  return regeneratorRuntime.wrap(function fetchGenres$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref = _context.sent;
          accessToken = _ref.accessToken;
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(api.fetchTargeting, api.GENRE, accessToken);

        case 7:
          genres = _context.sent;
          mappedGenres = (0, _genres.mapGenres)((0, _utilities.sortByKeyAsc)('name', genres));
          _context.next = 11;
          return (0, _effects.put)(actions.fetchGenresSuccess(mappedGenres));

        case 11:
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context['catch'](4);
          _context.next = 17;
          return (0, _effects.put)(actions.fetchGenresFailed(_context.t0));

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 13]]);
}

function fetchPlaylistCategories() {
  var _ref2, accessToken, categories;

  return regeneratorRuntime.wrap(function fetchPlaylistCategories$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref2 = _context2.sent;
          accessToken = _ref2.accessToken;
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(api.fetchTargeting, api.PLAYLIST_CAT, accessToken);

        case 7:
          categories = _context2.sent;
          _context2.next = 10;
          return (0, _effects.put)(actions.fetchPlaylistCategoriesSuccess((0, _utilities.sortByKeyAsc)('name', categories)));

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](4);
          _context2.next = 16;
          return (0, _effects.put)(actions.fetchPlaylistCategoriesFailed(_context2.t0));

        case 16:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[4, 12]]);
}

function fetchGeos() {
  var _ref3, accessToken, geos;

  return regeneratorRuntime.wrap(function fetchGeos$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref3 = _context3.sent;
          accessToken = _ref3.accessToken;
          _context3.prev = 4;
          _context3.next = 7;
          return (0, _effects.call)(api.fetchTargeting, api.GEO, accessToken);

        case 7:
          geos = _context3.sent;
          _context3.next = 10;
          return (0, _effects.put)(actions.fetchGeosSuccess((0, _utilities.sortByKeyAsc)('name', geos)));

        case 10:
          _context3.next = 16;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3['catch'](4);
          _context3.next = 16;
          return (0, _effects.put)(actions.fetchGeosFailed(_context3.t0));

        case 16:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[4, 12]]);
}

function fetchStockMusic() {
  var wgToken, tracks;
  return regeneratorRuntime.wrap(function fetchStockMusic$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_auth2.getWgToken);

        case 2:
          wgToken = _context4.sent;
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _effects.call)(api.fetchStockMusic, wgToken);

        case 6:
          tracks = _context4.sent;
          _context4.next = 9;
          return (0, _effects.put)(actions.fetchStockMusicSuccess((0, _utilities.sortByKeyAsc)('name', tracks.map(_bgStockMusic2.default))));

        case 9:
          _context4.next = 15;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](3);
          _context4.next = 15;
          return (0, _effects.put)(actions.fetchStockMusicFailed(_context4.t0));

        case 15:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[3, 11]]);
}

function watchStockMusicFetch() {
  return regeneratorRuntime.wrap(function watchStockMusicFetch$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _reduxSaga.takeEvery)(actions.FETCH_STOCK_MUSIC_REQUESTED, fetchStockMusic);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function fetchTargetingItems() {
  return regeneratorRuntime.wrap(function fetchTargetingItems$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return [fetchGenres(), fetchPlaylistCategories(), fetchGeos()];

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseBgStockMusic;
function parseBgStockMusic(t) {
  return {
    id: t.id,
    uri: t.previewUri,
    name: t.name
  };
}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITELIST_STORAGE_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.fetchUserInfo = fetchUserInfo;
exports.fetchPartnerId = fetchPartnerId;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _user = __webpack_require__(69);

var actions = _interopRequireWildcard(_user);

var _auth = __webpack_require__(82);

var _analytics = __webpack_require__(68);

var _user2 = __webpack_require__(1062);

var _account = __webpack_require__(486);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _auth2 = __webpack_require__(36);

var _storageHelpers = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchUserInfo),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchPartnerId);

var log = (0, _debug2.default)('sagas:user');

var WHITELIST_STORAGE_KEY = exports.WHITELIST_STORAGE_KEY = 'adgen-whitelisted';

function fetchUserInfo() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var retryTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var _ref, accessToken, error, i, _ref2, _ref3, userInfo, groups, userData, account, consolidatedInfo, _ref4, isWhitelisted;

  return regeneratorRuntime.wrap(function fetchUserInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref = _context.sent;
          accessToken = _ref.accessToken;
          error = void 0;
          i = 0;

        case 6:
          if (!(i < retryTimes)) {
            _context.next = 43;
            break;
          }

          _context.prev = 7;

          log('fetching user info and groups');

          _context.next = 11;
          return [(0, _effects.call)(_user2.getUserInfo, accessToken), (0, _effects.call)(_user2.getUserGroups, accessToken), (0, _effects.call)(_user2.getUserData, accessToken), (0, _effects.call)(_account.getAccount, accessToken)];

        case 11:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 4);
          userInfo = _ref3[0];
          groups = _ref3[1];
          userData = _ref3[2];
          account = _ref3[3];


          log('finished fetching user info');

          consolidatedInfo = _extends({}, userInfo, {
            groups: groups,
            email: userData.email || '',
            account: account
          });


          log('generated user info data: ', consolidatedInfo);

          _context.next = 22;
          return (0, _effects.put)(actions.receiveUserInfo(consolidatedInfo));

        case 22:
          _context.next = 24;
          return (0, _effects.select)(_auth2.getAuth);

        case 24:
          _ref4 = _context.sent;
          isWhitelisted = _ref4.isWhitelisted;

          log('is user whitelisted? ' + isWhitelisted);
          _context.next = 29;
          return (0, _effects.call)(_storageHelpers.setStorage, window.localStorage, WHITELIST_STORAGE_KEY, isWhitelisted);

        case 29:
          return _context.abrupt('return');

        case 32:
          _context.prev = 32;
          _context.t0 = _context['catch'](7);

          log('error retrieving user info: ' + _context.t0.message);

          if (!(i < retryTimes)) {
            _context.next = 40;
            break;
          }

          error = _context.t0;
          log('delaying then retrying');
          _context.next = 40;
          return (0, _effects.call)(_reduxSaga.delay, 2000);

        case 40:
          i++;
          _context.next = 6;
          break;

        case 43:

          log('could not fetch user info');
          windowObj.Raven.captureException(error);

        case 45:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[7, 32]]);
}

function fetchPartnerId() {
  var _ref5, accessToken, partnerId;

  return regeneratorRuntime.wrap(function fetchPartnerId$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref5 = _context2.sent;
          accessToken = _ref5.accessToken;
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(_user2.getGAPartnerUserId, accessToken);

        case 7:
          partnerId = _context2.sent;
          _context2.next = 10;
          return (0, _effects.put)((0, _analytics.setPartnerId)({ partnerId: partnerId }));

        case 10:
          _context2.next = 17;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2['catch'](4);

          log('Failed to fetch partner id', _context2.t0);
          _context2.next = 17;
          return (0, _effects.put)((0, _analytics.fetchPartnerIdFailed)(_context2.t0));

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[4, 12]]);
}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = getUserInfo;
exports.getUserGroups = getUserGroups;
exports.getUserData = getUserData;
exports.getGAPartnerUserId = getGAPartnerUserId;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPOTIFY_WEB_API = 'https://api.spotify.com/v1';

function getUserInfo(accessToken) {
  var headers = new Headers();
  headers.append('Authorization', 'Bearer ' + accessToken);

  var opts = {
    headers: headers
  };

  return fetch(SPOTIFY_WEB_API + '/me', opts).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

function getUserGroups(accessToken) {
  var webGate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _callWebGate2.default;

  var url = 'adgenerator/v1/usergroups';
  return webGate(url, accessToken).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

function getUserData(accessToken) {
  var url = 'adgenerator/v1/account/userdata';
  return (0, _callWebGate2.default)(url, accessToken).then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

function getGAPartnerUserId(accessToken) {
  var url = 'partner-userid/encrypted/googleanalytics-adstudio';
  return (0, _callWebGate2.default)(url, accessToken, undefined, 'prod').then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.text();
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)))

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserAbbaFlags = fetchUserAbbaFlags;

var _effects = __webpack_require__(25);

var _auth = __webpack_require__(82);

var _featureFlags = __webpack_require__(1064);

var _featureFlags2 = __webpack_require__(114);

var actions = _interopRequireWildcard(_featureFlags2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchUserAbbaFlags);

function fetchUserAbbaFlags() {
  var _ref, accessToken, flags;

  return regeneratorRuntime.wrap(function fetchUserAbbaFlags$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(_auth.SSO_SESSION_ACTIVE);

        case 2:
          _ref = _context.sent;
          accessToken = _ref.accessToken;
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(_featureFlags.getUserAbbaFlags, accessToken);

        case 7:
          flags = _context.sent;
          _context.next = 10;
          return (0, _effects.put)(actions.fetchUserFlagsSuccess(flags));

        case 10:
          _context.next = 16;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context['catch'](4);
          _context.next = 16;
          return (0, _effects.put)(actions.fetchUserFlagsFailed(_context.t0));

        case 16:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 12]]);
}

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserAbbaFlags = getUserAbbaFlags;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

var _utilities = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserAbbaFlags(wgToken) {
  var url = 'abba-service/v1/resolve?format=json';

  return (0, _callWebGate2.default)((0, _utilities.appendCachebuster)(url), wgToken, undefined, 'prod').then(function (r) {
    if (!r.ok) return Promise.reject(r.statusText);
    return r.json();
  });
}

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_POLL_ATTEMPTS = exports.POLL_INTERVAL_MS = undefined;
exports.waitToFetchPaymentInfo = waitToFetchPaymentInfo;
exports.fetchPaymentInfo = fetchPaymentInfo;
exports.getAdyenAuthResult = getAdyenAuthResult;
exports.handleAdyenFetch = handleAdyenFetch;
exports.handleAdyenAuthResult = handleAdyenAuthResult;
exports.linkCardToAdyenUser = linkCardToAdyenUser;
exports.pollForAdyenRecurringDetails = pollForAdyenRecurringDetails;
exports.poll = poll;
exports.fetchAdyenRecurringDetail = fetchAdyenRecurringDetail;
exports.watchFetchRecurringDetail = watchFetchRecurringDetail;
exports.checkForHPPAdRestore = checkForHPPAdRestore;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _queryString = __webpack_require__(171);

var _payments = __webpack_require__(508);

var api = _interopRequireWildcard(_payments);

var _payments2 = __webpack_require__(202);

var actions = _interopRequireWildcard(_payments2);

var _analytics = __webpack_require__(68);

var _featureFlags = __webpack_require__(114);

var _editableAd = __webpack_require__(47);

var _user = __webpack_require__(69);

var _auth = __webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(waitToFetchPaymentInfo),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchPaymentInfo),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(handleAdyenFetch),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(handleAdyenAuthResult),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(linkCardToAdyenUser),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(pollForAdyenRecurringDetails),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(poll),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(fetchAdyenRecurringDetail),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(watchFetchRecurringDetail),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(checkForHPPAdRestore);

var log = (0, _debug2.default)('sagas:payments');

var MAX_POLL_TIME_SECONDS = 30;
// Note: if you want to increase/decrease how often we poll, change this value
var POLL_INTERVAL_SECONDS = 5;
var POLL_INTERVAL_MS = exports.POLL_INTERVAL_MS = POLL_INTERVAL_SECONDS * 1000;
var MAX_POLL_ATTEMPTS = exports.MAX_POLL_ATTEMPTS = parseInt(MAX_POLL_TIME_SECONDS / POLL_INTERVAL_SECONDS, 10);

function waitToFetchPaymentInfo() {
  var groups, flags, result;
  return regeneratorRuntime.wrap(function waitToFetchPaymentInfo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          groups = null;
          flags = null;

        case 2:
          if (!(groups === null || flags === null)) {
            _context.next = 15;
            break;
          }

          _context.next = 5;
          return (0, _effects.take)([_featureFlags.FETCH_USER_FLAGS_SUCCESS, _user.RECEIVE_USER_INFO]);

        case 5:
          result = _context.sent;
          _context.t0 = result.type;
          _context.next = _context.t0 === _featureFlags.FETCH_USER_FLAGS_SUCCESS ? 9 : _context.t0 === _user.RECEIVE_USER_INFO ? 11 : 13;
          break;

        case 9:
          flags = result.flags;
          return _context.abrupt('break', 13);

        case 11:
          groups = result.user.groups;
          return _context.abrupt('break', 13);

        case 13:
          _context.next = 2;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.call)(fetchPaymentInfo);

        case 17:
          _context.next = 19;
          return (0, _effects.put)(actions.paymentInfoFetched());

        case 19:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchPaymentInfo() {
  return regeneratorRuntime.wrap(function fetchPaymentInfo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.disallowFetchRetry());

        case 2:
          _context2.next = 4;
          return (0, _effects.put)(actions.fetchingPaymentInfo());

        case 4:
          _context2.next = 6;
          return (0, _effects.call)(handleAdyenFetch);

        case 6:
          _context2.next = 8;
          return (0, _effects.put)(actions.fetchingPaymentInfoStopped());

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// Adyen
function getAdyenAuthResult(windowObj) {
  var params = getURLParams(windowObj);
  return params.authResult;
}

function getURLParams(windowObj) {
  var params = windowObj.location.search ? (0, _queryString.parse)(windowObj.location.search) : {};
  // Stringify to avoid debug#log error in prod
  log('parsed url params: ' + JSON.stringify(params));
  return params;
}

function handleAdyenFetch() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var authResult;
  return regeneratorRuntime.wrap(function handleAdyenFetch$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(getAdyenAuthResult, windowObj);

        case 2:
          authResult = _context3.sent;

          if (!authResult) {
            _context3.next = 8;
            break;
          }

          log('user is coming back from the adyen hpp');
          _context3.next = 7;
          return (0, _effects.call)(handleAdyenAuthResult, authResult);

        case 7:
          return _context3.abrupt('return');

        case 8:

          log('user is NOT coming back from the adyen hpp');

          _context3.prev = 9;
          _context3.next = 12;
          return (0, _effects.call)(fetchAdyenRecurringDetail);

        case 12:
          _context3.next = 17;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3['catch'](9);

          if (_context3.t0 instanceof api.AdyenRecurringDetailNotificationPendingError) {
            log('user not coming back from adyen and seeing a 204');
          }

        case 17:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[9, 14]]);
}

function handleAdyenAuthResult(authResult) {
  return regeneratorRuntime.wrap(function handleAdyenAuthResult$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!(authResult === 'AUTHORISED' || authResult === 'REFUSED')) {
            _context4.next = 18;
            break;
          }

          log('turning on adyen polling indication');
          _context4.prev = 2;
          _context4.next = 5;
          return (0, _effects.call)(linkCardToAdyenUser);

        case 5:
          _context4.next = 13;
          break;

        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4['catch'](2);

          log('failed to link card to user');
          _context4.next = 12;
          return (0, _effects.put)(actions.allowFetchRetry());

        case 12:
          return _context4.abrupt('return');

        case 13:
          _context4.next = 15;
          return (0, _effects.call)(pollForAdyenRecurringDetails);

        case 15:
          (0, _effects.put)((0, _analytics.logUserAction)({
            category: 'create_ad_flow',
            label: 'adyen_auth_completed'
          }));
          _context4.next = 22;
          break;

        case 18:
          log('in a failed authResult state: ' + authResult);
          (0, _effects.put)((0, _analytics.logUserAction)({
            category: 'create_ad_flow',
            label: 'adyen_auth_errored'
          }));
          _context4.next = 22;
          return (0, _effects.put)(actions.receivedRecurringDetailFailed(new Error(api.DEFAULT_ADYEN_FETCH_ERROR)));

        case 22:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[2, 7]]);
}

function linkCardToAdyenUser() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var params, wgToken;
  return regeneratorRuntime.wrap(function linkCardToAdyenUser$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          log('linking card to user');
          params = getURLParams(windowObj);
          _context5.next = 4;
          return (0, _effects.select)(_auth.getWgToken);

        case 4:
          wgToken = _context5.sent;
          _context5.next = 7;
          return (0, _effects.call)(poll, api.linkCardToAdyenUser, wgToken, params);

        case 7:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function pollForAdyenRecurringDetails() {
  return regeneratorRuntime.wrap(function pollForAdyenRecurringDetails$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(poll, fetchAdyenRecurringDetail);

        case 3:
          _context6.next = 10;
          break;

        case 5:
          _context6.prev = 5;
          _context6.t0 = _context6['catch'](0);

          log('failed to get card details');
          _context6.next = 10;
          return (0, _effects.put)(actions.allowFetchRetry());

        case 10:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 5]]);
}

function poll(method) {
  for (var _len = arguments.length, methodArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    methodArgs[_key - 1] = arguments[_key];
  }

  var methodName, i;
  return regeneratorRuntime.wrap(function poll$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          methodName = method.name || 'DAMN YOU IE';

          log('initiating poll to backend, ' + methodName);
          log('MAX polling attempts: ', MAX_POLL_ATTEMPTS);

          i = 0;

        case 4:
          if (!(i < MAX_POLL_ATTEMPTS)) {
            _context7.next = 21;
            break;
          }

          _context7.prev = 5;
          _context7.next = 8;
          return _effects.call.apply(undefined, [method].concat(methodArgs));

        case 8:
          log(methodName + ' call succeeded.');
          return _context7.abrupt('return');

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7['catch'](5);

          log('awaiting response for ' + methodName + '; should retry: ' + _context7.t0.message);
          // No need to delay on the last failed iteration

          if (!(i !== MAX_POLL_ATTEMPTS - 1)) {
            _context7.next = 18;
            break;
          }

          _context7.next = 18;
          return (0, _effects.call)(_reduxSaga.delay, POLL_INTERVAL_MS);

        case 18:
          i++;
          _context7.next = 4;
          break;

        case 21:

          log('exceeded the maximum number of ' + methodName + ' poll attempts');
          throw new Error('exceeded the maximum number of ' + methodName + ' poll attempts');

        case 23:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[5, 12]]);
}

function fetchAdyenRecurringDetail() {
  var wgToken, recurringDetail;
  return regeneratorRuntime.wrap(function fetchAdyenRecurringDetail$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(_auth.getWgToken);

        case 2:
          wgToken = _context8.sent;
          _context8.prev = 3;

          log('fetching adyen recurring detail');
          _context8.next = 7;
          return (0, _effects.call)(api.getAdyenRecurringDetails, wgToken);

        case 7:
          recurringDetail = _context8.sent;


          log('recurring detail information: ', recurringDetail);
          _context8.next = 11;
          return (0, _effects.put)(actions.receivedRecurringDetail(recurringDetail));

        case 11:
          _context8.next = 33;
          break;

        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8['catch'](3);

          if (!(_context8.t0 instanceof api.AdyenRecurringDetailNotFoundError)) {
            _context8.next = 19;
            break;
          }

          log('recurring detail not found');
          _context8.next = 33;
          break;

        case 19:
          if (!(_context8.t0 instanceof api.AdyenRecurringDetailNotificationPendingError)) {
            _context8.next = 24;
            break;
          }

          log('recurring detail notification pending');
          throw _context8.t0;

        case 24:
          if (!(_context8.t0 instanceof api.AdyenRecurringDetailError)) {
            _context8.next = 30;
            break;
          }

          log('recurring detail error: ' + _context8.t0.message);
          _context8.next = 28;
          return (0, _effects.put)(actions.receivedRecurringDetailFailed(_context8.t0));

        case 28:
          _context8.next = 33;
          break;

        case 30:
          log('Unable to retrieve recurring detail information: ' + _context8.t0.message);
          _context8.next = 33;
          return (0, _effects.put)(actions.receivedRecurringDetailFailedSystemError(_context8.t0));

        case 33:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[3, 13]]);
}

function watchFetchRecurringDetail() {
  return regeneratorRuntime.wrap(function watchFetchRecurringDetail$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          log('watching for a FETCH_ADYEN_RECURRING_DETAIL event');
          _context9.next = 3;
          return (0, _effects.call)(_reduxSaga.takeEvery, actions.FETCH_ADYEN_RECURRING_DETAIL, fetchPaymentInfo);

        case 3:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function checkForHPPAdRestore() {
  var windowObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var authResult;
  return regeneratorRuntime.wrap(function checkForHPPAdRestore$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.call)(getAdyenAuthResult, windowObj);

        case 2:
          authResult = _context10.sent;

          if (!authResult) {
            _context10.next = 7;
            break;
          }

          log('user came back from the adyen hpp; restoring saved ad');
          _context10.next = 7;
          return (0, _effects.put)((0, _editableAd.restoreAd)());

        case 7:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_KEY = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.handleStoreRedirect = handleStoreRedirect;
exports.handleRedirect = handleRedirect;
exports.watchForRedirectStored = watchForRedirectStored;
exports.watchForRedirect = watchForRedirect;
exports.watchForRedirectCleared = watchForRedirectCleared;

var _effects = __webpack_require__(25);

var _reactRouterRedux = __webpack_require__(60);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _redirect = __webpack_require__(200);

var _editableAd = __webpack_require__(47);

var _storageHelpers = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleStoreRedirect),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(handleRedirect),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchForRedirectStored),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(watchForRedirect),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchForRedirectCleared);

var log = (0, _debug2.default)('sagas:redirect');

var REDIRECT_KEY = exports.REDIRECT_KEY = 'redirect-url';

function handleStoreRedirect(storage, redirect) {
  var redirectJSON;
  return regeneratorRuntime.wrap(function handleStoreRedirect$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_storageHelpers.jsonStringify, redirect);

        case 2:
          redirectJSON = _context.sent;

          if (redirectJSON) {
            _context.next = 6;
            break;
          }

          log('redirect values failed to serialize');
          return _context.abrupt('return');

        case 6:

          log('storing redirect URL and timer values');
          _context.next = 9;
          return (0, _effects.call)(_storageHelpers.setStorage, storage, REDIRECT_KEY, redirectJSON);

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function handleRedirect(storage, windowObj) {
  var redirectJson, hasExpired, redirectObj, _redirectObj$preserve, preserveUrlParams, url, newUrlParams, _url$split, _url$split2, mainUrl, storedUrlParams;

  return regeneratorRuntime.wrap(function handleRedirect$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          log('checking for redirect in storage');

          _context2.next = 3;
          return (0, _effects.call)(_storageHelpers.getStorage, storage, REDIRECT_KEY);

        case 3:
          redirectJson = _context2.sent;

          if (redirectJson) {
            _context2.next = 10;
            break;
          }

          log('no redirect found in storage');
          log('redirecting to the homepage');
          _context2.next = 9;
          return (0, _effects.put)((0, _reactRouterRedux.replace)('/'));

        case 9:
          return _context2.abrupt('return');

        case 10:
          _context2.next = 12;
          return (0, _effects.call)(_storageHelpers.isKeyExpired, storage, REDIRECT_KEY);

        case 12:
          hasExpired = _context2.sent;

          if (!hasExpired) {
            _context2.next = 18;
            break;
          }

          log('redirect expired, clearing stored ad');
          _context2.next = 17;
          return (0, _effects.put)((0, _editableAd.clearSavedAd)());

        case 17:
          return _context2.abrupt('return');

        case 18:
          redirectObj = (0, _storageHelpers.jsonParse)(redirectJson);
          _redirectObj$preserve = redirectObj.preserveUrlParams, preserveUrlParams = _redirectObj$preserve === undefined ? false : _redirectObj$preserve;
          url = redirectObj.url;

          if (url) {
            _context2.next = 24;
            break;
          }

          log('url not found in redirect');
          return _context2.abrupt('return');

        case 24:

          if (preserveUrlParams) {
            newUrlParams = windowObj.location.search;

            log('copying current url params: ' + newUrlParams);

            _url$split = url.split('?'), _url$split2 = _slicedToArray(_url$split, 2), mainUrl = _url$split2[0], storedUrlParams = _url$split2[1];

            if (storedUrlParams) {
              log('dropping stored url params: ' + storedUrlParams);
            }

            url = [mainUrl, newUrlParams].join('');
          }

          log('redirecting to ' + url);
          _context2.next = 28;
          return (0, _effects.put)((0, _reactRouterRedux.replace)(url));

        case 28:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchForRedirectStored() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;

  var _ref, payload;

  return regeneratorRuntime.wrap(function watchForRedirectStored$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.take)(_redirect.STORE_REDIRECT_VALUES);

        case 2:
          _ref = _context3.sent;
          payload = _ref.payload;
          _context3.next = 6;
          return handleStoreRedirect(storage, payload);

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function watchForRedirect() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  var windowObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  return regeneratorRuntime.wrap(function watchForRedirect$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.take)(_redirect.REDIRECT_FROM_STORAGE);

        case 2:
          _context4.next = 4;
          return handleRedirect(storage, windowObj);

        case 4:
          _context4.next = 6;
          return (0, _effects.put)((0, _redirect.clearRedirectFromStorage)());

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchForRedirectCleared() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.localStorage;
  return regeneratorRuntime.wrap(function watchForRedirectCleared$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.take)(_redirect.CLEAR_REDIRECT_FROM_STORAGE);

        case 2:
          log('clearing redirect from storage');
          _context5.next = 5;
          return (0, _effects.call)(_storageHelpers.removeStorage, storage, REDIRECT_KEY);

        case 5:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchUserLoginForSentry = watchUserLoginForSentry;
exports.updateStateTreeContext = updateStateTreeContext;
exports.watchActionsForSentryStateLogging = watchActionsForSentryStateLogging;
exports.logException = logException;
exports.watchForLoggableErrors = watchForLoggableErrors;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _user = __webpack_require__(69);

var actions = _interopRequireWildcard(_user);

var _adReview = __webpack_require__(146);

var adReview = _interopRequireWildcard(_adReview);

var _editableAd = __webpack_require__(47);

var editableAd = _interopRequireWildcard(_editableAd);

var _payments = __webpack_require__(202);

var payments = _interopRequireWildcard(_payments);

var _featureFlags = __webpack_require__(114);

var featureFlags = _interopRequireWildcard(_featureFlags);

var _auth = __webpack_require__(82);

var auth = _interopRequireWildcard(_auth);

var _audienceSizer = __webpack_require__(201);

var audienceSizer = _interopRequireWildcard(_audienceSizer);

var _waitlist = __webpack_require__(507);

var waitlist = _interopRequireWildcard(_waitlist);

var _analytics = __webpack_require__(68);

var analytics = _interopRequireWildcard(_analytics);

var _adCreation = __webpack_require__(87);

var _auth2 = __webpack_require__(36);

var _featureFlags2 = __webpack_require__(147);

var _user2 = __webpack_require__(57);

var _utils = __webpack_require__(431);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchUserLoginForSentry),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(updateStateTreeContext),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(watchActionsForSentryStateLogging),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(logException),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchForLoggableErrors);

var log = (0, _debug2.default)('sagas:sentry');

function watchUserLoginForSentry() {
  var _ref, _ref$user, id, displayName;

  return regeneratorRuntime.wrap(function watchUserLoginForSentry$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(actions.RECEIVE_USER_INFO);

        case 2:
          _ref = _context.sent;
          _ref$user = _ref.user;
          id = _ref$user.id;
          displayName = _ref$user.displayName;


          log('setting up the Raven client with the user id: ' + id);

          window.Raven.setUserContext({
            id: id,
            username: displayName
          });

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function updateStateTreeContext(action) {
  var state;
  return regeneratorRuntime.wrap(function updateStateTreeContext$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_utils.getStateTree);

        case 2:
          state = _context2.sent;


          window.Raven.setExtraContext({
            state: {
              flags: (0, _featureFlags2.getFlags)(state),
              editableAd: (0, _adCreation.getEditableAd)(state),
              reduxForm: (0, _adCreation.getAdFromCreateForms)(state),
              auth: {
                isAuthenticated: (0, _auth2.getIsAuthenticated)(state)
              },
              user: (0, _user2.getUser)(state),
              validation: state.validation
            },
            lastActionType: action.type
          });

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchActionsForSentryStateLogging() {
  return regeneratorRuntime.wrap(function watchActionsForSentryStateLogging$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.take)(actions.RECEIVE_USER_INFO);

        case 2:

          log('watching every event to update the state tree context');

          _context3.next = 5;
          return (0, _effects.call)(_reduxSaga.takeEvery, '*', updateStateTreeContext);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function logException(_ref2) {
  var err = _ref2.err;
  var windowObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var error, _windowObj$_LTracker, loggly;

  return regeneratorRuntime.wrap(function logException$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          error = err;
          _windowObj$_LTracker = windowObj._LTracker, loggly = _windowObj$_LTracker === undefined ? [] : _windowObj$_LTracker;

          log('reporting the exception: ', error);

          if (!(err instanceof Error)) {
            log('received a non-error object');
            error = new Error(err);
          }

          _context4.next = 6;
          return (0, _effects.apply)(windowObj.Raven, windowObj.Raven.captureException, [error]);

        case 6:
          _context4.next = 8;
          return (0, _effects.apply)(loggly, loggly.push, {
            type: 'NetworkError',
            context: windowObj.Raven.getContext(),
            error: error
          });

        case 8:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchForLoggableErrors() {
  var errorActions;
  return regeneratorRuntime.wrap(function watchForLoggableErrors$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          errorActions = [adReview.FETCH_ADS_FAILED, adReview.APPROVE_AD_FAILED, adReview.REVISE_AD_FAILED, adReview.REJECT_AD_FAILED, adReview.FETCH_AD_FAILED, adReview.CANCEL_AD_FAILED, adReview.REFRESH_ADS_FAILED, adReview.REVIEW_AUDIO_ADS_FAILED, editableAd.CREATE_AD_FAILED, payments.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR, featureFlags.FETCH_USER_FLAGS_FAILED, auth.SSO_SESSION_ERROR, audienceSizer.FETCH_AUDIENCE_SIZE_FAILED, waitlist.SUBMIT_WAITLIST_FORM_FAILED, analytics.GA_PARTNER_ID_FETCH_FAILED];


          log('watching for all of the following error actions: ', errorActions);
          _context5.next = 4;
          return (0, _effects.call)(_reduxSaga.takeEvery, errorActions, logException);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchFeatureFlaggedValidation = watchFeatureFlaggedValidation;
exports.watchUserGroupValidation = watchUserGroupValidation;

var _effects = __webpack_require__(25);

var _adCreation = __webpack_require__(87);

var _featureFlags = __webpack_require__(114);

var _user = __webpack_require__(69);

var _validation = __webpack_require__(153);

var actions = _interopRequireWildcard(_validation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(watchFeatureFlaggedValidation),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchUserGroupValidation);

/**
 * The presence of some fields are determined by feature flags, which
 * has to be fetched after the initial field validation takes place.
 * This saga waits for the flags to return to trigger another
 * validation for the feature flagged fields.
 */
// Not needed anymore, but keeping in case another flag is tied with validation
function watchFeatureFlaggedValidation() {
  var _ref, flags, fields;

  return regeneratorRuntime.wrap(function watchFeatureFlaggedValidation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.take)(_featureFlags.FETCH_USER_FLAGS_SUCCESS);

        case 2:
          _ref = _context.sent;
          flags = _ref.flags;
          _context.next = 6;
          return (0, _effects.select)(_adCreation.getEditableAd);

        case 6:
          fields = _context.sent;
          _context.next = 9;
          return (0, _effects.put)(actions.validateFields({ groups: flags, fields: fields, initialValidation: true }));

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/*
 * Some fields (totalBudget) are determined by user groups, which
 * has to be fetched after initial field validation takes place.
 * This saga waits for user groups to return to trigger another
 * validation.
 */
function watchUserGroupValidation() {
  var _ref2, groups, fields;

  return regeneratorRuntime.wrap(function watchUserGroupValidation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.take)(_user.RECEIVE_USER_INFO);

        case 2:
          _ref2 = _context2.sent;
          groups = _ref2.user.groups;
          _context2.next = 6;
          return (0, _effects.select)(_adCreation.getEditableAd);

        case 6:
          fields = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)(actions.validateFields({ groups: groups, fields: fields, initialValidation: true }));

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileIsValid = fileIsValid;
exports.buildFileProperties = buildFileProperties;
exports.getDataUri = getDataUri;
exports.getImageFromUri = getImageFromUri;
exports.getAudioFromUri = getAudioFromUri;
exports.buildImageFileProperties = buildImageFileProperties;
exports.buildAudioFileProperties = buildAudioFileProperties;
exports.buildFormData = buildFormData;
exports.uploadFile = uploadFile;
exports.validateAndUploadFile = validateAndUploadFile;
exports.watchFileSelected = watchFileSelected;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _validatorjs = __webpack_require__(442);

var _validatorjs2 = _interopRequireDefault(_validatorjs);

var _validation = __webpack_require__(459);

var _config = __webpack_require__(30);

var _uploader = __webpack_require__(495);

var actions = _interopRequireWildcard(_uploader);

var _uploadProperties = __webpack_require__(117);

var properties = _interopRequireWildcard(_uploadProperties);

var _adCreation = __webpack_require__(286);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(buildImageFileProperties),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(buildAudioFileProperties),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(uploadFile),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(validateAndUploadFile),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(watchFileSelected);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var log = (0, _debug2.default)('sagas:coverArtUploader');

function fileIsValid(fileProperties, validationKey) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$partial = _ref.partial,
      partial = _ref$partial === undefined ? false : _ref$partial;

  var rules = void 0;
  var fileIsImage = _validation.UPLOADED_IMAGE_RULES[validationKey];
  var fileIsAudio = _validation.ALL_AUDIO_RULES[validationKey];

  if (fileIsAudio) {
    if (partial && validationKey === 'uploads.' + _config.UPLOADED_AUDIO + '.' + _config.FILE_PROPERTIES) {
      rules = _defineProperty({}, validationKey, _validation.UPLOADED_AUDIO_RULES[validationKey].replace('audio-duration', 'noop'));
    }
    rules = _defineProperty({}, validationKey, _validation.ALL_AUDIO_RULES[validationKey]);
  } else if (fileIsImage) {
    if (partial) {
      rules = _defineProperty({}, validationKey, _validation.UPLOADED_IMAGE_RULES[validationKey].replace('image-dimensions', 'noop'));
    } else {
      rules = _defineProperty({}, validationKey, _validation.UPLOADED_IMAGE_RULES[validationKey]);
    }
  }
  var validator = new _validatorjs2.default(_defineProperty({}, validationKey, fileProperties), rules);
  validator.check();
  return validator.errorCount === 0;
}

function buildFileProperties(action, fileProperties) {
  var file = action.payload.file;


  if (!file) {
    // Some browser extensions can mess with inputs in
    // interesting ways. If a change event gets triggered
    // without a file, we don't want this saga to break.
    fileProperties[properties.FILE_FAIL] = true;
  }

  fileProperties[properties.FILE_TYPE_PROP] = file.type;
  fileProperties[properties.FILE_SIZE_PROP] = file.size;

  return fileProperties;
}

function getDataUri(file) {
  return new Promise(function (resolve, reject) {
    var fileReader = new FileReader();
    fileReader.addEventListener('load', function () {
      resolve(fileReader.result);
    });
    fileReader.addEventListener('error', function (err) {
      reject(err);
    });
    fileReader.readAsDataURL(file);
  });
}

// Refactor this to be more generic with it's elements
function getImageFromUri(uri) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function (err) {
      reject(err);
    };
    img.src = uri;
  });
}

function getAudioFromUri(uri) {
  return new Promise(function (resolve, reject) {
    var audio = new Audio();
    audio.oncanplaythrough = function () {
      resolve(audio);
    };
    audio.onerror = function (err) {
      reject(err);
    };
    audio.src = uri;
  });
}

function buildImageFileProperties(action, fileProperties) {
  var _action$payload, file, validationKey, imageUri, image;

  return regeneratorRuntime.wrap(function buildImageFileProperties$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, file = _action$payload.file, validationKey = _action$payload.validationKey;

          buildFileProperties(action, fileProperties);

          if (!fileIsValid(fileProperties, validationKey, { partial: true })) {
            _context.next = 27;
            break;
          }

          imageUri = void 0;
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(getDataUri, file);

        case 7:
          imageUri = _context.sent;
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](4);

          log('File read did not work: ' + _context.t0);
          fileProperties[properties.FILE_FAIL] = true;

        case 14:
          image = void 0;
          _context.prev = 15;
          _context.next = 18;
          return (0, _effects.call)(getImageFromUri, imageUri);

        case 18:
          image = _context.sent;
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t1 = _context['catch'](15);

          log('Image load did not work: ' + _context.t1);
          fileProperties[properties.FILE_FAIL] = true;

        case 25:

          image = image || {
            naturalWidth: 0,
            naturalHeight: 0
          };

          fileProperties[properties.IMAGE_DIMENSIONS] = image.naturalWidth + 'x' + image.naturalHeight;

        case 27:
          return _context.abrupt('return', fileProperties);

        case 28:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 10], [15, 21]]);
}

function buildAudioFileProperties(action, fileProperties) {
  var _action$payload2, file, validationKey, audioUri, audio;

  return regeneratorRuntime.wrap(function buildAudioFileProperties$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload2 = action.payload, file = _action$payload2.file, validationKey = _action$payload2.validationKey;

          buildFileProperties(action, fileProperties);

          if (!fileIsValid(fileProperties, validationKey, { partial: true })) {
            _context2.next = 28;
            break;
          }

          audioUri = void 0;
          _context2.prev = 4;
          _context2.next = 7;
          return (0, _effects.call)(getDataUri, file);

        case 7:
          audioUri = _context2.sent;
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](4);

          log('File read did not work: ' + _context2.t0);
          fileProperties[properties.FILE_FAIL] = true;

        case 14:
          audio = void 0;
          _context2.prev = 15;
          _context2.next = 18;
          return (0, _effects.call)(getAudioFromUri, audioUri);

        case 18:
          audio = _context2.sent;
          _context2.next = 25;
          break;

        case 21:
          _context2.prev = 21;
          _context2.t1 = _context2['catch'](15);

          log('Image load did not work: ' + _context2.t1);
          fileProperties[properties.FILE_FAIL] = true;

        case 25:

          audio = audio || {
            duration: NaN
          };

          fileProperties[properties.AUDIO_DURATION] = audio.duration;

          return _context2.abrupt('return', fileProperties);

        case 28:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[4, 10], [15, 21]]);
}

function buildFormData(file, placeholderData) {
  var fields = placeholderData.fields;


  var formData = new FormData();
  Object.keys(fields).forEach(function (k) {
    return formData.append(k, fields[k]);
  });

  formData.append('Content-Type', file.type);
  formData.append('file', file, file.name);

  return {
    formData: formData,
    placeholderData: placeholderData
  };
}

function uploadFile(action, fileProperties) {
  var _action$payload3, file, placeholderType, wgToken, onComplete, onProgress, onError, placeholderData, res;

  return regeneratorRuntime.wrap(function uploadFile$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload3 = action.payload, file = _action$payload3.file, placeholderType = _action$payload3.placeholderType, wgToken = _action$payload3.wgToken, onComplete = _action$payload3.onComplete, onProgress = _action$payload3.onProgress, onError = _action$payload3.onError;
          _context3.next = 3;
          return (0, _effects.call)(_adCreation.createPlaceholder, placeholderType, file.type, wgToken);

        case 3:
          placeholderData = _context3.sent;
          res = buildFormData(file, placeholderData);
          _context3.prev = 5;
          _context3.next = 8;
          return (0, _effects.call)(_adCreation.uploadFileToStorage, {
            url: res.placeholderData.action,
            formData: res.formData
          }, onProgress);

        case 8:
          _context3.next = 13;
          break;

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3['catch'](5);

          onError(_context3.t0, fileProperties);

        case 13:

          onComplete(res.placeholderData, fileProperties);

        case 14:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[5, 10]]);
}

function validateAndUploadFile(action) {
  var type, _action$payload4, onError, validationKey, fileProperties;

  return regeneratorRuntime.wrap(function validateAndUploadFile$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          type = action.type, _action$payload4 = action.payload, onError = _action$payload4.onError, validationKey = _action$payload4.validationKey;
          fileProperties = void 0;

          if (!(type === actions.AUDIO_FILE_SELECTED)) {
            _context4.next = 8;
            break;
          }

          _context4.next = 5;
          return (0, _effects.call)(buildAudioFileProperties, action, properties.createDefaultAudioProperties());

        case 5:
          fileProperties = _context4.sent;
          _context4.next = 12;
          break;

        case 8:
          if (!(type === actions.IMAGE_FILE_SELECTED)) {
            _context4.next = 12;
            break;
          }

          _context4.next = 11;
          return (0, _effects.call)(buildImageFileProperties, action, properties.createDefaultImageProperties());

        case 11:
          fileProperties = _context4.sent;

        case 12:
          if (!fileIsValid(fileProperties, validationKey)) {
            _context4.next = 17;
            break;
          }

          _context4.next = 15;
          return (0, _effects.call)(uploadFile, action, fileProperties);

        case 15:
          _context4.next = 19;
          break;

        case 17:
          onError('invalid', fileProperties);
          log(fileProperties);

        case 19:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchFileSelected() {
  return regeneratorRuntime.wrap(function watchFileSelected$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _reduxSaga.takeEvery)([actions.IMAGE_FILE_SELECTED, actions.AUDIO_FILE_SELECTED], validateAndUploadFile);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

function leapYear(year) {
  return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}

function isValidDate(inDate) {
    var valid = true;

    // reformat if supplied as mm.dd.yyyy (period delimiter)
    if (typeof inDate === 'string') {
      var pos = inDate.indexOf('.');
      if ((pos > 0 && pos <= 6)) {
        inDate = inDate.replace(/\./g, '-');
      }
    }

    var testDate = new Date(inDate);
    var yr = testDate.getFullYear();
    var mo = testDate.getMonth();
    var day = testDate.getDate();

    var daysInMonth = [31, (leapYear(yr) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (yr < 1000) { return false; }
    if (isNaN(mo)) { return false; }
    if (mo + 1 > 12) { return false; }
    if (isNaN(day)) { return false; }
    if (day > daysInMonth[mo]) { return false; }

    return valid;
}

var rules = {

  required: function(val) {
    var str;

    if (val === undefined || val === null) {
      return false;
    }

    str = String(val).replace(/\s/g, "");
    return str.length > 0 ? true : false;
  },

  required_if: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_unless: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with: function(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (!this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without: function(val, req, attribute) {

    if (this.validator._objectPath(this.validator.input, req)) {
      return true;
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  'boolean': function (val) {
    return (
      val === true ||
      val === false ||
      val === 0 ||
      val === 1 ||
      val === '0' ||
      val === '1' ||
      val === 'true' ||
      val === 'false'
    );
  },

  // compares the size of strings
  // with numbers, compares the value
  size: function(val, req, attribute) {
    if (val) {
      req = parseFloat(req);

      var size = this.getSize();

      return size === req;
    }

    return true;
  },

  string: function(val, req, attribute) {
    return typeof val === 'string';
  },

  sometimes: function(val) {
    return true;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  min: function(val, req, attribute) {
    var size = this.getSize();
    return size >= req;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  max: function(val, req, attribute) {
    var size = this.getSize();
    return size <= req;
  },

  between: function(val, req, attribute) {
    req = this.getParameters();
    var size = this.getSize();
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    return size >= min && size <= max;
  },

  email: function(val) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(val);
  },

  numeric: function(val) {
    var num;

    num = Number(val); // tries to convert value to a number. useful if value is coming from form element

    if (typeof num === 'number' && !isNaN(num) && typeof val !== 'boolean') {
      return true;
    } else {
      return false;
    }
  },

  array: function(val) {
    return val instanceof Array;
  },

  url: function(url) {
    return (/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i).test(url);
  },

  alpha: function(val) {
    return (/^[a-zA-Z]+$/).test(val);
  },

  alpha_dash: function(val) {
    return (/^[a-zA-Z0-9_\-]+$/).test(val);
  },

  alpha_num: function(val) {
    return (/^[a-zA-Z0-9]+$/).test(val);
  },

  same: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 === val2) {
      return true;
    }

    return false;
  },

  different: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 !== val2) {
      return true;
    }

    return false;
  },

  "in": function(val, req) {
    var list, i;

    if (val) {
      list = this.getParameters();
    }

    if (val && !(val instanceof Array)) {
      var localValue = val;

      for (i = 0; i < list.length; i++) {
        if (typeof list[i] === 'string') {
          localValue = String(val);
        }

        if (localValue === list[i]) {
          return true;
        }
      }

      return false;
    }

    if (val && val instanceof Array) {
      for (i = 0; i < val.length; i++) {
        if (list.indexOf(val[i]) < 0) {
          return false;
        }
      }
    }

    return true;
  },

  not_in: function(val, req) {
    var list = this.getParameters();
    var len = list.length;
    var returnVal = true;

    for (var i = 0; i < len; i++) {
      var localValue = val;

      if (typeof list[i] === 'string') {
        localValue = String(val);
      }

      if (localValue === list[i]) {
        returnVal = false;
        break;
      }
    }

    return returnVal;
  },

  accepted: function(val) {
    if (val === 'on' || val === 'yes' || val === 1 || val === '1' || val === true) {
      return true;
    }

    return false;
  },

  confirmed: function(val, req, key) {
    var confirmedKey = key + '_confirmation';

    if (this.validator.input[confirmedKey] === val) {
      return true;
    }

    return false;
  },

  integer: function(val) {
    return String(parseInt(val, 10)) === String(val);
  },

  digits: function(val, req) {
    var numericRule = this.validator.getRule('numeric');
    if (numericRule.validate(val) && String(val).length === parseInt(req)) {
      return true;
    }

    return false;
  },

  regex: function(val, req) {
    var mod = /[g|i|m]{1,3}$/;
    var flag = req.match(mod);
    flag = flag ? flag[0] : "";
    req = req.replace(mod, "").slice(1, -1);
    req = new RegExp(req, flag);
    return !!val.match(req);
  },

  date: function(val, format) {
    return isValidDate(val);
  },

  present: function(val) {
    return typeof val !== 'undefined';
  },

  after: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() < new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   after_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

  before: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() > new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   before_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
      return true;
    }

    return false;
  }


};

var missedRuleValidator = function() {
  throw new Error('Validator `' + this.name + '` is not defined!');
};
var missedRuleMessage;

function Rule(name, fn, async) {
  this.name = name;
  this.fn = fn;
  this.passes = null;
  this._customMessage = undefined;
  this.async = async;
}

Rule.prototype = {

  /**
   * Validate rule
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  validate: function(inputValue, ruleValue, attribute, callback) {
    var _this = this;
    this._setValidatingData(attribute, inputValue, ruleValue);
    if (typeof callback === 'function') {
      this.callback = callback;
      var handleResponse = function(passes, message) {
        _this.response(passes, message);
      };

      if (this.async) {
        return this._apply(inputValue, ruleValue, attribute, handleResponse);
      } else {
        return handleResponse(this._apply(inputValue, ruleValue, attribute));
      }
    }
    return this._apply(inputValue, ruleValue, attribute);
  },

  /**
   * Apply validation function
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  _apply: function(inputValue, ruleValue, attribute, callback) {
    var fn = this.isMissed() ? missedRuleValidator : this.fn;

    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
  },

  /**
   * Set validating data
   *
   * @param {string} attribute
   * @param {mixed} inputValue
   * @param {mixed} ruleValue
   * @return {void}
   */
  _setValidatingData: function(attribute, inputValue, ruleValue) {
    this.attribute = attribute;
    this.inputValue = inputValue;
    this.ruleValue = ruleValue;
  },

  /**
   * Get parameters
   *
   * @return {array}
   */
  getParameters: function() {
    var value = [];

    if (typeof this.ruleValue === 'string') {
      value = this.ruleValue.split(',');
    }

    if (typeof this.ruleValue === 'number') {
      value.push(this.ruleValue);
    }

    if (this.ruleValue instanceof Array) {
      value = this.ruleValue;
    }

    return value;
  },

  /**
   * Get true size of value
   *
   * @return {integer|float}
   */
  getSize: function() {
    var value = this.inputValue;

    if (value instanceof Array) {
      return value.length;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (this.validator._hasNumericRule(this.attribute)) {
      return parseFloat(value, 10);
    }

    return value.length;
  },

  /**
   * Get the type of value being checked; numeric or string.
   *
   * @return {string}
   */
  _getValueType: function() {

    if (typeof this.inputValue === 'number' || this.validator._hasNumericRule(this.attribute)) {
      return 'numeric';
    }

    return 'string';
  },

  /**
   * Set the async callback response
   *
   * @param  {boolean|undefined} passes  Whether validation passed
   * @param  {string|undefined} message Custom error message
   * @return {void}
   */
  response: function(passes, message) {
    this.passes = (passes === undefined || passes === true);
    this._customMessage = message;
    this.callback(this.passes, message);
  },

  /**
   * Set validator instance
   *
   * @param {Validator} validator
   * @return {void}
   */
  setValidator: function(validator) {
    this.validator = validator;
  },

  /**
   * Check if rule is missed
   *
   * @return {boolean}
   */
  isMissed: function() {
    return typeof this.fn !== 'function';
  },

  get customMessage() {
    return this.isMissed() ? missedRuleMessage : this._customMessage;
  }
};

var manager = {

  /**
   * List of async rule names
   *
   * @type {Array}
   */
  asyncRules: [],

  /**
   * Implicit rules (rules to always validate)
   *
   * @type {Array}
   */
  implicitRules: ['required', 'required_if', 'required_unless', 'required_with', 'required_with_all', 'required_without', 'required_without_all', 'accepted', 'present'],

  /**
   * Get rule by name
   *
   * @param  {string} name
   * @param {Validator}
   * @return {Rule}
   */
  make: function(name, validator) {
    var async = this.isAsync(name);
    var rule = new Rule(name, rules[name], async);
    rule.setValidator(validator);
    return rule;
  },

  /**
   * Determine if given rule is async
   *
   * @param  {string}  name
   * @return {boolean}
   */
  isAsync: function(name) {
    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
      if (this.asyncRules[i] === name) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if rule is implicit (should always validate)
   *
   * @param {string} name
   * @return {boolean}
   */
  isImplicit: function(name) {
    return this.implicitRules.indexOf(name) > -1;
  },

  /**
   * Register new rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  register: function(name, fn) {
    rules[name] = fn;
  },

    /**
   * Register new implicit rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerImplicit: function(name, fn) {
    this.register(name, fn);
    this.implicitRules.push(name);
  },

  /**
   * Register async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsync: function(name, fn) {
    this.register(name, fn);
    this.asyncRules.push(name);
  },

  /**
   * Register implicit async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsyncImplicit: function(name, fn) {
    this.registerImplicit(name, fn);
    this.asyncRules.push(name);
  },

  registerMissedRuleValidator: function(fn, message) {
    missedRuleValidator = fn;
    missedRuleMessage = message;
  }
};



module.exports = manager;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var Messages = __webpack_require__(1072);

__webpack_require__(283);

var container = {

  messages: {},

  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function(lang, rawMessages) {
    this.messages[lang] = rawMessages;
  },

  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function(lang, attribute, message) {
    this._load(lang);
    if (message === undefined) {
      message = this.messages[lang].def;
    }

    this.messages[lang][attribute] = message;
  },

  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function(lang) {
    if (!this.messages[lang]) {
      var rawMessages = __webpack_require__(1073)("./" + lang);
      this._set(lang, rawMessages);
    }
  },

  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function(lang) {
    this._load(lang);
    return this.messages[lang];
  },

  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function(lang) {
    this._load(lang);
    return new Messages(lang, this.messages[lang]);
  }

};

module.exports = container;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Attributes = __webpack_require__(282);

var Messages = function(lang, messages) {
  this.lang = lang;
  this.messages = messages;
  this.customMessages = {};
  this.attributeNames = {};
};

Messages.prototype = {
  constructor: Messages,

  /**
   * Set custom messages
   *
   * @param {object} customMessages
   * @return {void}
   */
  _setCustom: function(customMessages) {
    this.customMessages = customMessages || {};
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   */
  _setAttributeNames: function(attributes) {
    this.attributeNames = attributes;
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  _setAttributeFormatter: function(func) {
    this.attributeFormatter = func;
  },

  /**
   * Get attribute name to display.
   *
   * @param  {string} attribute
   * @return {string}
   */
  _getAttributeName: function(attribute) {
    var name = attribute;
    if (this.attributeNames.hasOwnProperty(attribute)) {
      return this.attributeNames[attribute];
    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
      name = this.messages.attributes[attribute];
    }

    if (this.attributeFormatter) {
      name = this.attributeFormatter(name);
    }

    return name;
  },

  /**
   * Get all messages
   *
   * @return {object}
   */
  all: function() {
    return this.messages;
  },

  /**
   * Render message
   *
   * @param  {Rule} rule
   * @return {string}
   */
  render: function(rule) {
    if (rule.customMessage) {
      return rule.customMessage;
    }
    var template = this._getTemplate(rule);

    var message;
    if (Attributes.replacements[rule.name]) {
      message = Attributes.replacements[rule.name].apply(this, [template, rule]);
    } else {
      message = this._replacePlaceholders(rule, template, {});
    }

    return message;
  },

  /**
   * Get the template to use for given rule
   *
   * @param  {Rule} rule
   * @return {string}
   */
  _getTemplate: function(rule) {

    var messages = this.messages;
    var template = messages.def;
    var customMessages = this.customMessages;
    var formats = [rule.name + '.' + rule.attribute, rule.name];

    for (var i = 0, format; i < formats.length; i++) {
      format = formats[i];
      if (customMessages.hasOwnProperty(format)) {
        template = customMessages[format];
        break;
      } else if (messages.hasOwnProperty(format)) {
        template = messages[format];
        break;
      }
    }

    if (typeof template === 'object') {
      template = template[rule._getValueType()];
    }

    return template;
  },

  /**
   * Replace placeholders in the template using the data object
   *
   * @param  {Rule} rule
   * @param  {string} template
   * @param  {object} data
   * @return {string}
   */
  _replacePlaceholders: function(rule, template, data) {
    var message, attribute;

    data.attribute = this._getAttributeName(rule.attribute);
    data[rule.name] = data[rule.name] || rule.getParameters().join(',');

    if (typeof template === 'string' && typeof data === 'object') {
      message = template;

      for (attribute in data) {
        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
      }
    }

    return message;
  }

};

module.exports = Messages;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": 443,
	"./de.js": 443,
	"./el": 444,
	"./el.js": 444,
	"./en": 283,
	"./en.js": 283,
	"./es": 445,
	"./es.js": 445,
	"./fa": 446,
	"./fa.js": 446,
	"./fr": 447,
	"./fr.js": 447,
	"./it": 448,
	"./it.js": 448,
	"./ja": 449,
	"./ja.js": 449,
	"./nb_NO": 450,
	"./nb_NO.js": 450,
	"./nl": 451,
	"./nl.js": 451,
	"./pl": 452,
	"./pl.js": 452,
	"./pt": 453,
	"./pt.js": 453,
	"./ru": 454,
	"./ru.js": 454,
	"./tr": 455,
	"./tr.js": 455,
	"./vi": 456,
	"./vi.js": 456,
	"./zh": 457,
	"./zh.js": 457,
	"./zh_TW": 458,
	"./zh_TW.js": 458
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1073;

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

var Errors = function() {
  this.errors = {};
};

Errors.prototype = {
  constructor: Errors,

  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }

    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },

  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }

    return [];
  },

  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }

    return false;
  },

  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function() {
    return this.errors;
  },

  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }

    return false;
  }
};

module.exports = Errors;


/***/ }),
/* 1075 */
/***/ (function(module, exports) {

function AsyncResolvers(onFailedOne, onResolvedAll) {
  this.onResolvedAll = onResolvedAll;
  this.onFailedOne = onFailedOne;
  this.resolvers = {};
  this.resolversCount = 0;
  this.passed = [];
  this.failed = [];
  this.firing = false;
}

AsyncResolvers.prototype = {

  /**
   * Add resolver
   *
   * @param {Rule} rule
   * @return {integer}
   */
  add: function(rule) {
    var index = this.resolversCount;
    this.resolvers[index] = rule;
    this.resolversCount++;
    return index;
  },

  /**
   * Resolve given index
   *
   * @param  {integer} index
   * @return {void}
   */
  resolve: function(index) {
    var rule = this.resolvers[index];
    if (rule.passes === true) {
      this.passed.push(rule);
    } else if (rule.passes === false) {
      this.failed.push(rule);
      this.onFailedOne(rule);
    }

    this.fire();
  },

  /**
   * Determine if all have been resolved
   *
   * @return {boolean}
   */
  isAllResolved: function() {
    return (this.passed.length + this.failed.length) === this.resolversCount;
  },

  /**
   * Attempt to fire final all resolved callback if completed
   *
   * @return {void}
   */
  fire: function() {

    if (!this.firing) {
      return;
    }

    if (this.isAllResolved()) {
      this.onResolvedAll(this.failed.length === 0);
    }

  },

  /**
   * Enable firing
   *
   * @return {void}
   */
  enableFiring: function() {
    this.firing = true;
  }

};

module.exports = AsyncResolvers;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _validator = __webpack_require__(442);

var _validator2 = _interopRequireDefault(_validator);

var _attributes = __webpack_require__(282);

var _attributes2 = _interopRequireDefault(_attributes);

var _validator3 = __webpack_require__(475);

var _config = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_validator2.default.register('url', function (url) {
  return (0, _validator3.isURL)(url, { require_protocol: true, protocols: ['http', 'https'] });
}, (0, _config.lang)('invalid-url-format', 'The url format is invalid.'));

_validator2.default.register('valid-dollar-amount', function (totalBudget) {
  return (0, _validator3.isCurrency)(totalBudget);
}, 'Your input is invalid. Please enter a valid dollar amount.');

_validator2.default.register('total-budget-range', function (totalBudget) {
  var strippedBudget = totalBudget.replace(',', '');
  var dollarAmount = parseFloat(strippedBudget);
  var budgetWithinRange = dollarAmount >= _config.MIN_BUDGET && dollarAmount <= _config.MAX_BUDGET;

  return budgetWithinRange || totalBudget === _config.EASTER_EGG_BUDGET;
}, 'Please enter an amount between $' + _config.MIN_BUDGET + '-$' + _config.MAX_BUDGET + '.');

_validator2.default.register('any-true-values', function (obj) {
  return Object.keys(obj).some(function (k) {
    return obj[k] === true;
  });
}, (0, _config.lang)('at-least-one-platform', 'Please select at least one platform.'));

_validator2.default.register('file-problem', function (fileProperties) {
  var _fileProperties$fail = fileProperties.fail,
      fail = _fileProperties$fail === undefined ? true : _fileProperties$fail;

  return !fail;
}, (0, _config.lang)('file-problem', 'Looks like something went wrong. Please try again.'));

_validator2.default.register('filesize-max', function (fileProperties, requirement) {
  var maxSize = parseInt(requirement, 10);
  var fileSize = parseInt(fileProperties.size, 10);

  return fileSize < maxSize;
}, (0, _config.lang)('file-size-over-limit', 'Your image is too large for our upload service. Please upload an image less than :maxSize.'));

_attributes2.default.replacements['filesize-max'] = function (template, rule) {
  var _rule$getParameters = rule.getParameters(),
      _rule$getParameters2 = _slicedToArray(_rule$getParameters, 1),
      maxSize = _rule$getParameters2[0];

  maxSize = Math.ceil(parseInt(maxSize, 10) / 1024 / 1024);
  return template.replace(/:maxSize/, maxSize + 'MB');
};

// Filetype's error message will be difficult to translate, as
// images have only two supported types but audio has three.
// Let's readdress this when we start translating, since we have
// the supported filetypes listed in the <label> already.
_validator2.default.register('filetype', function (fileProperties, requirement) {
  var type = fileProperties.type;

  var acceptedFormats = requirement.split(',');

  return acceptedFormats.indexOf(type) > -1;
}, (0, _config.lang)('unacceptable-file-extension', 'Invalid file extension. Please upload a :file1 or :file2 file.'));

_attributes2.default.replacements.filetype = function (template, rule) {
  var audioFiles = ['.OGG, .MP3,', '.WAV'];
  var imageFiles = ['.JPG', '.PNG'];
  var files = void 0;

  var _rule$getParameters3 = rule.getParameters(),
      _rule$getParameters4 = _slicedToArray(_rule$getParameters3, 1),
      testType = _rule$getParameters4[0];

  if (_config.CLIENT_AUDIO_TYPES.indexOf(testType) > -1) {
    files = audioFiles;
  } else {
    files = imageFiles;
  }
  return template.replace(/:file1/, files[0]).replace(/:file2/, files[1]);
};

_validator2.default.register('image-dimensions', function (fileProperties, requirement) {
  return fileProperties.imageDimensions === requirement;
}, (0, _config.lang)('image-wrong-dimensions', 'Your image is :imageDimensions pixels. Please upload a :acceptedDimensions image.'));

_attributes2.default.replacements['image-dimensions'] = function (template, rule) {
  var _rule$getParameters5 = rule.getParameters(),
      _rule$getParameters6 = _slicedToArray(_rule$getParameters5, 1),
      acceptedDimensions = _rule$getParameters6[0];

  var imageDimensions = rule.inputValue.imageDimensions;

  return template.replace(/:acceptedDimensions/, acceptedDimensions).replace(/:imageDimensions/, imageDimensions);
};

_validator2.default.register('audio-duration', function (fileProperties, requirement) {
  return fileProperties.audioDuration <= requirement;
}, 'Your uploaded audio is too long. Only 15 or 30 second files are accepted.');

_validator2.default.register('account-setup-country', function (countrySelection) {
  return countrySelection === 'United States';
}, 'We are only accepting US advertisers at this time.');

_validator2.default.register('noop', function () {
  return true;
});

// Registers dummy callbacks since these rules are processed pre-validation and not within the normal validatorjs flow
_validator2.default.register('feature-flag', function () {
  return true;
});
_validator2.default.register('exclude-feature-flag', function () {
  return true;
});
_validator2.default.register('exclude-criteria-for-feature-flag', function () {
  return true;
});

// Everyone within this feature flag should NOT have this validation rule applied
var excludeFeatureFlagPattern = /^exclude-feature-flag:([^|]*)/;
// Everyone within this feature flag should have the validation rule applied
var featureFlagPattern = /^feature-flag:([^|]*)/;
// The following rule criteria should not be applied for members within this feature flag
var excludeCriteriaForFeatureFlagPattern = /^exclude-criteria-for-feature-flag:([^|]*)/;

var AdValidator = function AdValidator(data, rules) {
  var groups = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _classCallCheck(this, AdValidator);

  for (var field in rules) {
    if (!rules.hasOwnProperty(field)) {
      continue;
    }

    var rule = rules[field];

    var criteria = rule.split('|');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = criteria[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var criterion = _step.value;

        if (excludeFeatureFlagPattern.test(criterion)) {
          var _excludeFeatureFlagPa = excludeFeatureFlagPattern.exec(criterion),
              _excludeFeatureFlagPa2 = _slicedToArray(_excludeFeatureFlagPa, 2),
              group = _excludeFeatureFlagPa2[1];

          if (groups[group]) {
            delete rules[field];
          }
          break;
        }

        if (featureFlagPattern.test(criterion)) {
          var _featureFlagPattern$e = featureFlagPattern.exec(criterion),
              _featureFlagPattern$e2 = _slicedToArray(_featureFlagPattern$e, 2),
              _group = _featureFlagPattern$e2[1];

          if (!groups[_group]) {
            delete rules[field];
          }
          break;
        }

        if (excludeCriteriaForFeatureFlagPattern.test(criterion)) {
          var _excludeCriteriaForFe = excludeCriteriaForFeatureFlagPattern.exec(criterion),
              _excludeCriteriaForFe2 = _slicedToArray(_excludeCriteriaForFe, 2),
              definition = _excludeCriteriaForFe2[1];

          var _definition$split = definition.split(','),
              _definition$split2 = _toArray(_definition$split),
              _group2 = _definition$split2[0],
              criteriaToIncludeForNonMembers = _definition$split2.slice(1);

          if (!groups[_group2]) {
            rules[field] += '|' + criteriaToIncludeForNonMembers.join('|');
          }
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return new AdValidator.Validator(data, rules, AdValidator.CUSTOM_ERR_MSGS);
};

/**
 * Dangled for test mocking
 * @type {Validator}
 */


exports.default = AdValidator;
AdValidator.Validator = _validator2.default;

AdValidator.CUSTOM_ERR_MSGS = {};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAdminAlert = fetchAdminAlert;

var _effects = __webpack_require__(25);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

var _adminAlert = __webpack_require__(1078);

var _adminAlert2 = __webpack_require__(460);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchAdminAlert);

var log = (0, _debug2.default)('sagas:realtimealert');

function fetchAdminAlert() {
  var alertObj;
  return regeneratorRuntime.wrap(function fetchAdminAlert$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_adminAlert.getAdminAlert);

        case 3:
          alertObj = _context.sent;
          _context.next = 6;
          return (0, _effects.put)((0, _adminAlert2.fetchAdminAlertSuccess)(alertObj));

        case 6:
          _context.next = 11;
          break;

        case 8:
          _context.prev = 8;
          _context.t0 = _context['catch'](0);

          log('failed to fetch realtime alert', _context.t0);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 8]]);
}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdminAlert = getAdminAlert;
function getAdminAlert() {
  var S3_ALERT_URL = 'https://s3.amazonaws.com/voltron-ui/alert/alert.txt';
  return fetch(S3_ALERT_URL).then(function (res) {
    if (!res.ok) return Promise.reject(res.statusText);
    return res.text();
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)))

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFetchAudienceSize = handleFetchAudienceSize;
exports.watchForFetchAudienceSize = watchForFetchAudienceSize;

var _reduxSaga = __webpack_require__(35);

var _effects = __webpack_require__(25);

var _adCreation = __webpack_require__(87);

var _user = __webpack_require__(57);

var _auth = __webpack_require__(36);

var _audienceSizer = __webpack_require__(201);

var actions = _interopRequireWildcard(_audienceSizer);

var _analytics = __webpack_require__(68);

var _audienceSizer2 = __webpack_require__(1080);

var _formatter = __webpack_require__(483);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleFetchAudienceSize),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(watchForFetchAudienceSize);

var log = (0, _debug2.default)('sagas:audience-sizer');

function handleFetchAudienceSize() {
  var wgToken, userCanAccessPricer, ad, payload, fetcher, sizerData;
  return regeneratorRuntime.wrap(function handleFetchAudienceSize$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_auth.getWgToken);

        case 2:
          wgToken = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(_user.canAccessPricer);

        case 5:
          userCanAccessPricer = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(_adCreation.getCombinedAd);

        case 8:
          ad = _context.sent;
          payload = JSON.stringify((0, _formatter.audienceSizeFormatter)(ad));
          fetcher = userCanAccessPricer ? _audienceSizer2.fetchAudienceSizeV2 : _audienceSizer2.fetchAudienceSize;
          sizerData = void 0;
          _context.prev = 12;
          _context.next = 15;
          return (0, _effects.call)(fetcher, payload, wgToken);

        case 15:
          sizerData = _context.sent;
          _context.next = 18;
          return (0, _effects.put)(actions.fetchAudienceSizeSuccess(sizerData));

        case 18:
          _context.next = 25;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context['catch'](12);

          log('fetching the audience failed: ' + _context.t0.message);
          _context.next = 25;
          return (0, _effects.put)(actions.fetchAudienceSizeFailed(_context.t0));

        case 25:
          if (!sizerData) {
            _context.next = 30;
            break;
          }

          _context.next = 28;
          return (0, _effects.put)((0, _analytics.logUserAction)({
            category: 'create_ad_flow',
            label: 'audience_sizer_shown',
            params: {
              request: ad,
              response: sizerData
            }
          }));

        case 28:
          _context.next = 32;
          break;

        case 30:
          _context.next = 32;
          return (0, _effects.put)((0, _analytics.logUserAction)({
            category: 'create_ad_flow',
            label: 'audience_sizer_errored',
            params: {
              request: ad
            }
          }));

        case 32:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[12, 20]]);
}

function watchForFetchAudienceSize() {
  return regeneratorRuntime.wrap(function watchForFetchAudienceSize$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_reduxSaga.takeLatest, actions.FETCH_AUDIENCE_SIZE, handleFetchAudienceSize);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAudienceSize = fetchAudienceSize;
exports.fetchAudienceSizeV2 = fetchAudienceSizeV2;

var _callWebGate = __webpack_require__(61);

var _callWebGate2 = _interopRequireDefault(_callWebGate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAudienceSize(targeting, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = 'audience-proxy/v1/query';
  return webGate(url, wgToken, { method: 'POST', body: targeting }).then(function (r) {
    return r.ok ? r.json() : r.json().then(function (errorMessage) {
      return Promise.reject(errorMessage);
    });
  });
}

function fetchAudienceSizeV2(targeting, wgToken) {
  var webGate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _callWebGate2.default;

  var url = 'audience-proxy/v2/query';
  return webGate(url, wgToken, { method: 'POST', body: targeting }).then(function (r) {
    return r.ok ? r.json() : r.json().then(function (errorMessage) {
      return Promise.reject(errorMessage);
    });
  });
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(53);

var _reactRouterRedux = __webpack_require__(60);

var _adBlocker = __webpack_require__(1082);

var _adBlocker2 = _interopRequireDefault(_adBlocker);

var _ads = __webpack_require__(496);

var _ads2 = _interopRequireDefault(_ads);

var _adCreation = __webpack_require__(426);

var _adCreation2 = _interopRequireDefault(_adCreation);

var _auth = __webpack_require__(1083);

var _auth2 = _interopRequireDefault(_auth);

var _user = __webpack_require__(1084);

var _user2 = _interopRequireDefault(_user);

var _targeting = __webpack_require__(1085);

var _targeting2 = _interopRequireDefault(_targeting);

var _network = __webpack_require__(1086);

var _network2 = _interopRequireDefault(_network);

var _validation = __webpack_require__(459);

var _validation2 = _interopRequireDefault(_validation);

var _featureFlags = __webpack_require__(1087);

var _featureFlags2 = _interopRequireDefault(_featureFlags);

var _reduxForm = __webpack_require__(67);

var _payments = __webpack_require__(1088);

var _payments2 = _interopRequireDefault(_payments);

var _adminAlert = __webpack_require__(1089);

var _adminAlert2 = _interopRequireDefault(_adminAlert);

var _audienceSizer = __webpack_require__(1090);

var _audienceSizer2 = _interopRequireDefault(_audienceSizer);

var _routes = __webpack_require__(1091);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  adBlocker: _adBlocker2.default,
  adminAlert: _adminAlert2.default,
  ads: _ads2.default,
  editableAd: _adCreation2.default,
  auth: _auth2.default,
  user: _user2.default,
  targeting: _targeting2.default,
  network: _network2.default,
  validation: _validation2.default,
  featureFlags: _featureFlags2.default,
  routing: _reactRouterRedux.routerReducer,
  form: _reduxForm.reducer,
  payments: _payments2.default,
  audienceSizer: _audienceSizer2.default,
  routes: _routes2.default
});

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = adBlocker;

var _adBlocker = __webpack_require__(441);

var initialState = {
  adBlockerDetected: false
};

function adBlocker() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _adBlocker.DETECT_AD_BLOCKER:
      return _extends({}, state, {
        adBlockerDetected: action.adBlockerDetected
      });
    default:
      return state;
  }
}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = auth;

var _auth = __webpack_require__(82);

var _user = __webpack_require__(69);

var userActions = _interopRequireWildcard(_user);

var _storageHelpers = __webpack_require__(90);

var _debug = __webpack_require__(20);

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var log = (0, _debug2.default)('sagas:auth');
var cachedToken = (0, _storageHelpers.getStorage)(window.localStorage, 'spWgToken');

// Note that booleans are stored as strings in localStorage
var cachedIsWhitelisted = (0, _storageHelpers.getStorage)(window.localStorage, 'adgen-whitelisted');
var visitedBeforeCacheInPlace = cachedIsWhitelisted === null;
log('cache is whitelisted', cachedIsWhitelisted);

var initialState = {
  // Ensures that folks deep linking in (before the cache was in place) have deep links preserved
  isWhitelisted: visitedBeforeCacheInPlace || cachedIsWhitelisted !== 'false',
  isAuthenticated: !!cachedToken,
  token: cachedToken,
  country: null,
  errorMessage: '',
  hasLoginError: false
};

log('user has local storage?', !!window.localStorage);
log('user initial auth state', initialState);

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _auth.SSO_SESSION_ACTIVE:
      return _extends({}, state, {
        isAuthenticated: true,
        token: action.accessToken,
        errorMessage: '',
        hasLoginError: false
      });
    case _auth.SSO_SESSION_INACTIVE:
      return _extends({}, state, {
        isAuthenticated: false,
        errorMessage: '',
        hasLoginError: false
      });
    case _auth.SSO_SESSION_ERROR:
      return _extends({}, state, {
        isAuthenticated: false,
        errorMessage: action.err.message,
        hasLoginError: true
      });
    case userActions.RECEIVE_USER_INFO:
      return _extends({}, state, {
        isWhitelisted: !!Object.keys(action.user.groups).length
      });
    case _auth.GEO_IP_SUCCESS:
      return _extends({}, state, {
        country: action.payload.country
      });
    case _auth.GEO_IP_FAILED:
      return _extends({}, state, {
        country: null
      });
    case _auth.USER_LOGGED_OUT:
      return _extends({}, state);
    default:
      return state;
  }
}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = user;

var _user = __webpack_require__(69);

var userActions = _interopRequireWildcard(_user);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  id: '',
  imgSrc: '',
  displayName: '',
  groups: {},
  email: '',
  account: null,
  fetched: false
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case userActions.RECEIVE_USER_INFO:
      return _extends({}, state, action.user, {
        fetched: true
      });

    case userActions.SET_USER_ACCOUNT:
      return _extends({}, state, action.user);

    default:
      return state;
  }
}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = targeting;

var _targeting = __webpack_require__(287);

var initialState = exports.initialState = {
  availableGenres: [],
  availableGeos: [],
  availablePlaylistCategories: [],
  availableStockMusicTracks: []
};

function targeting() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _targeting.FETCH_GENRES_SUCCESS:
      return _extends({}, state, {
        availableGenres: action.genres
      });
    case _targeting.FETCH_PLAYLIST_CAT_SUCCESS:
      return _extends({}, state, {
        availablePlaylistCategories: action.categories
      });
    case _targeting.FETCH_GEOS_SUCCESS:
      return _extends({}, state, {
        availableGeos: action.geos
      });
    case _targeting.FETCH_STOCK_MUSIC_SUCCESS:
      return _extends({}, state, {
        availableStockMusicTracks: action.tracks
      });
    default:
      return state;
  }
}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = network;

var _global = __webpack_require__(148);

var _network = __webpack_require__(420);

var initialState = {
  status: _global.navigator.onLine
};

function network() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _network.NETWORK_STATUS:
      return _extends({}, state, {
        status: action.status
      });
    default:
      return state;
  }
}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.flags = flags;
exports.loaded = loaded;

var _redux = __webpack_require__(53);

var _featureFlags = __webpack_require__(114);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _featureFlags.FETCH_USER_FLAGS_SUCCESS:
      return _extends({}, state, action.flags);
    case _featureFlags.USER_FLAG_UPDATED:
      return _extends({}, state, _defineProperty({}, action.flag, action.value));
    default:
      return state;
  }
}

function loaded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case _featureFlags.FETCH_USER_FLAGS_SUCCESS:
      return true;
    default:
      return state;
  }
}

exports.default = (0, _redux.combineReducers)({
  flags: flags,
  loaded: loaded
});

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = payments;

var _utilities = __webpack_require__(46);

var _payments = __webpack_require__(202);

var actions = _interopRequireWildcard(_payments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
  invoiced: false,
  currency: 'USD',
  fetching: false,
  fetched: false,
  allowFetchRetry: false,
  adyen: {
    isConnected: false,
    connectionError: '',
    currency: 'USD',
    formDetailsError: '',
    pollingForDetailConfirmation: false,
    type: '',
    detail: {
      paymentMethod: '',
      cardNumber: ''
    }
  }
};

var ADYEN_INVOICE_KEY = 'INVOICE';

function payments() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.PAYMENT_INFO_FETCHED:
      return (0, _utilities.unflattenAssign)('fetched', true, state);

    case actions.FETCHING_PAYMENT_INFO:
      return (0, _utilities.unflattenAssign)('fetching', true, state);

    case actions.FETCHING_PAYMENT_INFO_STOPPED:
      return (0, _utilities.unflattenAssign)('fetching', false, state);

    case actions.ALLOW_FETCH_RETRY:
      return (0, _utilities.unflattenAssign)('allowFetchRetry', true, state);

    case actions.DISALLOW_FETCH_RETRY:
      return (0, _utilities.unflattenAssign)('allowFetchRetry', false, state);

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED:
      return _extends({}, state, {
        invoiced: action.payload.type === ADYEN_INVOICE_KEY,
        adyen: _extends({}, state.adyen, {
          isConnected: true,
          // In case we had a previous connection error and we retried fetching
          connectionError: '',
          type: action.payload.type,
          detail: _extends({}, state.adyen.detail, action.payload.detail)
        })
      });

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED:
      return _extends({}, state, {
        adyen: _extends({}, state.adyen, {
          isConnected: false,
          connectionError: action.err.message
        })
      });

    case actions.ADYEN_HPP_FORM_DETAILS_FAILED:
      return _extends({}, state, {
        adyen: _extends({}, state.adyen, {
          formDetailsError: action.err.message
        })
      });

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR:
      return _extends({}, state, {
        adyen: _extends({}, state.adyen, {
          isConnected: false,
          connectionError: action.err.message,
          systemError: true
        })
      });

    default:
      return state;
  }
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = adminAlert;

var _adminAlert = __webpack_require__(460);

var initialState = {
  text: ''
};

function adminAlert() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _adminAlert.FETCH_ADMIN_ALERT_SUCCESS:
      return _extends({}, state, {
        text: action.payload.text
      });
    default:
      return state;
  }
}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = audienceSizer;

var _audienceSizer = __webpack_require__(201);

var initialState = {
  hasEstimate: false,
  fetchError: false,
  bucketPercent: -1,
  overflow: false,
  bucket: -1
};

function audienceSizer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _audienceSizer.FETCH_AUDIENCE_SIZE_SUCCESS:
      return _extends({}, state, {
        fetchError: false
      }, action.payload, {
        hasEstimate: true
      });
    case _audienceSizer.FETCH_AUDIENCE_SIZE_FAILED:
      return _extends({}, initialState, {
        fetchError: true
      });
    case _audienceSizer.CLEAR_AUDIENCE_SIZE_ESTIMATE:
      return _extends({}, initialState);
    default:
      return state;
  }
}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = routes;

var _routes = __webpack_require__(387);

var initialState = exports.initialState = {
  prevRoute: '',
  currentRoute: ''
};

function routes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _routes.SAVE_CURRENT_ROUTE:
      return _extends({}, state, {
        prevRoute: state.currentRoute,
        currentRoute: action.payload.route
      });
    default:
      return state;
  }
}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createHistory;

var _reactRouter = __webpack_require__(58);

var _reactRouterRedux = __webpack_require__(60);

function createHistory(store) {
  return (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
}

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1094);


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AppContainer = __webpack_require__(1095);

module.exports = function warnAboutIncorrectUsage(arg) {
  if (this && this.callback) {
    throw new Error('React Hot Loader: The Webpack loader is now exported separately. ' + 'If you use Babel, we recommend that you remove "react-hot-loader" ' + 'from the "loaders" section of your Webpack configuration altogether, ' + 'and instead add "react-hot-loader/babel" to the "plugins" section ' + 'of your .babelrc file. ' + 'If you prefer not to use Babel, replace "react-hot-loader" or ' + '"react-hot" with "react-hot-loader/webpack" in the "loaders" section ' + 'of your Webpack configuration.');
  } else if (arg && arg.types && arg.types.IfStatement) {
    throw new Error('React Hot Loader: The Babel plugin is exported separately. ' + 'Replace "react-hot-loader" with "react-hot-loader/babel" ' + 'in the "plugins" section of your .babelrc file. ' + 'While we recommend the above, if you prefer not to use Babel, ' + 'you may remove "react-hot-loader" from the "plugins" section of ' + 'your .babelrc file altogether, and instead add ' + '"react-hot-loader/webpack" to the "loaders" section of your Webpack ' + 'configuration.');
  } else {
    throw new Error('React Hot Loader does not have a default export. ' + 'If you use the import statement, make sure to include the ' + 'curly braces: import { AppContainer } from "react-hot-loader". ' + 'If you use CommonJS, make sure to read the named export: ' + 'require("react-hot-loader").AppContainer.');
  }
};

module.exports.AppContainer = AppContainer;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1096);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ })
],[512]);


// WEBPACK FOOTER //
// app.1edb85136999cc41c5a4.js